(function() {
  'use strict';

  angular
    .module('coherentPaDemo', ['ngAnimate', 'ngCookies', 'ngTouch', 'ngSanitize', 'ngMessages', 'ngAria', 'ngResource', 'ui.router', 'ui.bootstrap', 'toastr', 'ngFileUpload', 'pascalprecht.translate']);

})();

(function() {
  'use strict';

  angular
      .module('coherentPaDemo')
      .service('webDevTec', webDevTec);

  /** @ngInject */
  function webDevTec() {
    var data = [
      {
        'title': 'AngularJS',
        'url': 'https://angularjs.org/',
        'description': 'HTML enhanced for web apps!',
        'logo': 'angular.png'
      },
      {
        'title': 'BrowserSync',
        'url': 'http://browsersync.io/',
        'description': 'Time-saving synchronised browser testing.',
        'logo': 'browsersync.png'
      },
      {
        'title': 'GulpJS',
        'url': 'http://gulpjs.com/',
        'description': 'The streaming build system.',
        'logo': 'gulp.png'
      },
      {
        'title': 'Jasmine',
        'url': 'http://jasmine.github.io/',
        'description': 'Behavior-Driven JavaScript.',
        'logo': 'jasmine.png'
      },
      {
        'title': 'Karma',
        'url': 'http://karma-runner.github.io/',
        'description': 'Spectacular Test Runner for JavaScript.',
        'logo': 'karma.png'
      },
      {
        'title': 'Protractor',
        'url': 'https://github.com/angular/protractor',
        'description': 'End to end test framework for AngularJS applications built on top of WebDriverJS.',
        'logo': 'protractor.png'
      },
      {
        'title': 'Bootstrap',
        'url': 'http://getbootstrap.com/',
        'description': 'Bootstrap is the most popular HTML, CSS, and JS framework for developing responsive, mobile first projects on the web.',
        'logo': 'bootstrap.png'
      },
      {
        'title': 'Angular UI Bootstrap',
        'url': 'http://angular-ui.github.io/bootstrap/',
        'description': 'Bootstrap components written in pure AngularJS by the AngularUI Team.',
        'logo': 'ui-bootstrap.png'
      },
      {
        'title': 'Sass (Node)',
        'url': 'https://github.com/sass/node-sass',
        'description': 'Node.js binding to libsass, the C version of the popular stylesheet preprocessor, Sass.',
        'logo': 'node-sass.png'
      }
    ];

    this.getTec = getTec;

    function getTec() {
      return data;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .directive('range', drctv);

  /** @ngInject */
  function drctv() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/range/range.html',
      scope: {
        min: '=',
        max: '=',
        model: '=',
        disabled: '=',
        change: '&'
      },
      link: linkFunc,
      controller: ctrl,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    function linkFunc(scope, el, attr, vm) {
      var watcher;

      var update = _.debounce(vm.change, 500);

      watcher = scope.$watch('vm.model', function () {
        el[0].children[0].style.backgroundSize = ((vm.model - vm.min) / (vm.max - vm.min) * 100) + '% 100%';
        el[0].children[0].value = vm.model;

        update();
      });

      scope.$on('$destroy', function () {
        watcher();
      });
    }

    /** @ngInject */
    function ctrl() {
      var vm = this;

      return vm;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .directive('navbar', navbar);

  /** @ngInject */
  function navbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html',
      scope: {
      },
      controller: NavbarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function NavbarController($state) {
      var vm = this;

      vm.$state = $state;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .factory('githubContributor', githubContributor);

  /** @ngInject */
  function githubContributor($log, $http) {
    var apiHost = 'https://api.github.com/repos/Swiip/generator-gulp-angular';

    var service = {
      apiHost: apiHost,
      getContributors: getContributors
    };

    return service;

    function getContributors(limit) {
      if (!limit) {
        limit = 30;
      }

      return $http.get(apiHost + '/contributors?per_page=' + limit)
        .then(getContributorsComplete)
        .catch(getContributorsFailed);

      function getContributorsComplete(response) {
        return response.data;
      }

      function getContributorsFailed(error) {
        $log.error('XHR Failed for getContributors.\n' + angular.toJson(error.data, true));
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .directive('acmeMalarkey', acmeMalarkey);

  /** @ngInject */
  function acmeMalarkey(malarkey) {
    var directive = {
      restrict: 'E',
      scope: {
        extraValues: '='
      },
      template: '&nbsp;',
      link: linkFunc,
      controller: MalarkeyController,
      controllerAs: 'vm'
    };

    return directive;

    function linkFunc(scope, el, attr, vm) {
      var watcher;
      var typist = malarkey(el[0], {
        typeSpeed: 40,
        deleteSpeed: 40,
        pauseDelay: 800,
        loop: true,
        postfix: ' '
      });

      el.addClass('acme-malarkey');

      angular.forEach(scope.extraValues, function(value) {
        typist.type(value).pause().delete();
      });

      watcher = scope.$watch('vm.contributors', function() {
        angular.forEach(vm.contributors, function(contributor) {
          typist.type(contributor.login).pause().delete();
        });
      });

      scope.$on('$destroy', function () {
        watcher();
      });
    }

    /** @ngInject */
    function MalarkeyController($log, githubContributor) {
      var vm = this;

      vm.contributors = [];

      activate();

      function activate() {
        return getContributors().then(function() {
          $log.info('Activated Contributors View');
        });
      }

      function getContributors() {
        return githubContributor.getContributors(10).then(function(data) {
          vm.contributors = data;

          return vm.contributors;
        });
      }
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .directive('loader', loader);

  /** @ngInject */
  function loader() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/loader/loader.html',
      controller: LoaderController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function LoaderController($rootScope, $scope) {
      var vm = this;

      vm.loading = false;

      $scope.$watch('$root.loading', function() {
        vm.loading = $rootScope.loading;
      });
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .directive('footer', footer);

  /** @ngInject */
  function footer() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/footer/footer.html',
      scope: {
      },
      controller: FooterController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function FooterController($translate) {
      var vm = this;

      vm.translate = function(language) {
        $translate.use(language);
      }
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .directive('backNavbar', backNavbar);

  /** @ngInject */
  function backNavbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/backNavbar/backNavbar.html',
      scope: {
          content: '@',
          icon: '@',
          link: '@',
          removeMargin: '@'
      },
      controller: BackNavbarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function BackNavbarController($scope, $state, $window) {
      var vm = this;

      vm.back = function() {
        if(vm.link) {
          $state.go(vm.link);
        } else {
          $window.history.back();
        }
      };

      vm.content = $scope.content;
      vm.icon = $scope.icon;
      vm.link = $scope.link;
      vm.removeMargin = angular.isDefined($scope.removeMargin) && $scope.removeMargin;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .service('PurchaseService', PurchaseService);

  /** @ngInject */
  function PurchaseService($http, $log) {
    var vm = this;

    vm.plan1 = {};
    vm.plan2 = {};
    vm.plan3 = {};

    vm.ProductCode = 'TermCI';
    vm.FolderName = 'coherent';
    vm.policy = {};
    vm.insuranceDate = '';
    vm.planCategory = {};
    vm.planType = {};
    vm.email = '';
    vm.information1 = {};
    vm.information2 = {};
    vm.insuredType = '';
    vm.polNo = '';
    vm.signIn = true;
    vm.signedIn = false;
    vm.upsell = [];
    vm.ProductType = 'Policy';
    vm.quote_id = '';
    vm.QuoteData = {};
    vm.DefaultCurrency = 'SGD';
    vm.SelectedPromo = '';
    vm.SelectedOccupation = '';
    vm.SelectedPaymentFreq = '';
    vm.RatingFactors = [];
    
    vm.policyMessage = {
      "receiver": 'zTROulxv/tJnnhb6mSR1/w==',
      "type":"rich_media",
      "min_api_version":7,
      "rich_media":{
        "Type":"rich_media",
        "ButtonsGroupColumns":6,
        "ButtonsGroupRows":7,
        "BgColor":"#FFFFFF",
        "Buttons":[{
          "Columns":6,
          "Rows":3,
          "ActionType":"open-url",
          "ActionBody":"",
          "Image":"https://ellwood.technology/docs/bike.jpg"
        },
        {
          "Columns":6,
          "Rows":2,
          "Text":"<font color=#323232><b>Your Bicycle Cover is now Active</font>",
          "ActionType":"open-url",
          "ActionBody":"",
          "TextSize":"medium",
          "TextVAlign":"middle",
          "TextHAlign":"left"
        },
        {
          "Columns":6,
          "Rows":1,
          "ActionType":"open-url",
          "ActionBody":"/policies-1/",
          "Text":"<font color=#8367db>My Cover</font>",
          "TextSize":"large",
          "TextVAlign":"middle",
          "TextHAlign":"middle"
        },
        {
          "Columns":6,
          "Rows":1,
          "ActionType":"open-url",
          "ActionBody":"",
          "Text":"<font color=#8367db></font>",
          "TextSize":"small",
          "TextVAlign":"middle",
          "TextHAlign":"middle"
        },{
          "Columns":6,
          "Rows":3,
          "ActionType":"open-url",
          "ActionBody":"https://www.google.com",
          "Image":"https://ellwood.technology/docs/bikespanner.png"
        },
        {
          "Columns":6,
          "Rows":2,
          "Text":"<font color=#323232><b>Alter Your Cover <br> Tailor Your Benefits to meet your needs</font>",
          "ActionType":"open-url",
          "ActionBody":"https://www.google.com",
          "TextSize":"medium",
          "TextVAlign":"middle",
          "TextHAlign":"left"
        },
        {
          "Columns":6,
          "Rows":1,
          "ActionType":"open-url",
          "ActionBody":"https://ellwood.technology/ebenefit?polno=1940e5d0-7b63-4d76-b320-6f0dc9bbce17",
          "Text":"<font color=#8367db>Update My Cover</font>",
          "TextSize":"large",
          "TextVAlign":"middle",
          "TextHAlign":"middle"
        },
        {
          "Columns":6,
          "Rows":1,
          "ActionType":"open-url",
          "ActionBody":"",
          "Text":"<font color=#8367db></font>",
          "TextSize":"small",
          "TextVAlign":"middle",
          "TextHAlign":"middle"
        },{
          "Columns":6,
          "Rows":3,
          "ActionType":"open-url",
          "ActionBody":"https://www.google.com",
          "Image":"https://ellwood.technology/docs/leg.png"
        },
        {
          "Columns":6,
          "Rows":2,
          "Text":"<font color=#323232><b>Add Accident Cover <br> Protect against a Bicycle Accident</font>",
          "ActionType":"open-url",
          "ActionBody":"https://www.google.com",
          "TextSize":"medium",
          "TextVAlign":"middle",
          "TextHAlign":"left"
        },
        {
          "Columns":6,
          "Rows":1,
          "ActionType":"open-url",
          "ActionBody":"https://ellwood.technology/ciaddrisk?polno=1940e5d0-7b63-4d76-b320-6f0dc9bbce17&rtyp=PA",
          "Text":"<font color=#8367db>Add Accident Cover</font>",
          "TextSize":"large",
          "TextVAlign":"middle",
          "TextHAlign":"middle"
        },
        {
          "Columns":6,
          "Rows":1,
          "ActionType":"open-url",
          "ActionBody":"",
          "Text":"<font color=#8367db></font>",
          "TextSize":"small",
          "TextVAlign":"middle",
          "TextHAlign":"middle"
        },{
          "Columns":6,
          "Rows":3,
          "ActionType":"open-url",
          "ActionBody":"https://www.google.com",
          "Image":"https://ellwood.technology/docs/Claim.png"
        },
        {
          "Columns":6,
          "Rows":2,
          "Text":"<font color=#323232><b>Make a Claim <br> Use this link to make a claim</font>",
          "ActionType":"open-url",
          "ActionBody":"https://www.google.com",
          "TextSize":"medium",
          "TextVAlign":"middle",
          "TextHAlign":"left"
        },
        {
          "Columns":6,
          "Rows":1,
          "ActionType":"open-url",
          "ActionBody":"https://ellwood.technology/bclaim?polno=1940e5d0-7b63-4d76-b320-6f0dc9bbce17&rtyp=PA",
          "Text":"<font color=#8367db>Make a Claim</font>",
          "TextSize":"large",
          "TextVAlign":"middle",
          "TextHAlign":"middle"
        },
        {
          "Columns":6,
          "Rows":1,
          "ActionType":"open-url",
          "ActionBody":"",
          "Text":"<font color=#8367db></font>",
          "TextSize":"small",
          "TextVAlign":"middle",
          "TextHAlign":"middle"
        }
        ]
      }
    }

    vm.SparkTemplate = {
      "Inputs": {
        "Channel": "Agent_2",
        "ClaimAmount": [
          {
            "Benefit": "A2",
            "Amount": 7878,
            "EventStart": null,
            "EventDate": null,
            "Claimant": null
          },
          {
            "Benefit": null,
            "Amount": null,
            "EventStart": null,
            "EventDate": null,
            "Claimant": null
          },
          {
            "Benefit": null,
            "Amount": null,
            "EventStart": null,
            "EventDate": null,
            "Claimant": null
          },
          {
            "Benefit": null,
            "Amount": null,
            "EventStart": null,
            "EventDate": null,
            "Claimant": null
          },
          {
            "Benefit": null,
            "Amount": null,
            "EventStart": null,
            "EventDate": null,
            "Claimant": null
          },
          {
            "Benefit": null,
            "Amount": null,
            "EventStart": null,
            "EventDate": null,
            "Claimant": null
          },
          {
            "Benefit": null,
            "Amount": null,
            "EventStart": null,
            "EventDate": null,
            "Claimant": null
          },
          {
            "Benefit": null,
            "Amount": null,
            "EventStart": null,
            "EventDate": null,
            "Claimant": null
          },
          {
            "Benefit": null,
            "Amount": null,
            "EventStart": null,
            "EventDate": null,
            "Claimant": null
          },
          {
            "Benefit": null,
            "Amount": null,
            "EventStart": null,
            "EventDate": null,
            "Claimant": null
          },
          {
            "Benefit": null,
            "Amount": null,
            "EventStart": null,
            "EventDate": null,
            "Claimant": null
          },
          {
            "Benefit": null,
            "Amount": null,
            "EventStart": null,
            "EventDate": null,
            "Claimant": null
          },
          {
            "Benefit": null,
            "Amount": null,
            "EventStart": null,
            "EventDate": null,
            "Claimant": null
          },
          {
            "Benefit": null,
            "Amount": null,
            "EventStart": null,
            "EventDate": null,
            "Claimant": null
          },
          {
            "Benefit": null,
            "Amount": null,
            "EventStart": null,
            "EventDate": null,
            "Claimant": null
          },
          {
            "Benefit": null,
            "Amount": null,
            "EventStart": null,
            "EventDate": null,
            "Claimant": null
          },
          {
            "Benefit": null,
            "Amount": null,
            "EventStart": null,
            "EventDate": null,
            "Claimant": null
          },
          {
            "Benefit": null,
            "Amount": null,
            "EventStart": null,
            "EventDate": null,
            "Claimant": null
          },
          {
            "Benefit": null,
            "Amount": null,
            "EventStart": null,
            "EventDate": null,
            "Claimant": null
          },
          {
            "Benefit": null,
            "Amount": null,
            "EventStart": null,
            "EventDate": null,
            "Claimant": null
          }
        ],
        "ClaimHistory": [
          {
            "BenefitClaimed": null,
            "ClaimDate": null,
            "Amount": null,
            "Claimant": null
          },
          {
            "BenefitClaimed": null,
            "ClaimDate": null,
            "Amount": null,
            "Claimant": null
          },
          {
            "BenefitClaimed": null,
            "ClaimDate": null,
            "Amount": null,
            "Claimant": null
          },
          {
            "BenefitClaimed": null,
            "ClaimDate": null,
            "Amount": null,
            "Claimant": null
          },
          {
            "BenefitClaimed": null,
            "ClaimDate": null,
            "Amount": null,
            "Claimant": null
          },
          {
            "BenefitClaimed": null,
            "ClaimDate": null,
            "Amount": null,
            "Claimant": null
          },
          {
            "BenefitClaimed": null,
            "ClaimDate": null,
            "Amount": null,
            "Claimant": null
          },
          {
            "BenefitClaimed": null,
            "ClaimDate": null,
            "Amount": null,
            "Claimant": null
          },
          {
            "BenefitClaimed": null,
            "ClaimDate": null,
            "Amount": null,
            "Claimant": null
          },
          {
            "BenefitClaimed": null,
            "ClaimDate": null,
            "Amount": null,
            "Claimant": null
          },
          {
            "BenefitClaimed": null,
            "ClaimDate": null,
            "Amount": null,
            "Claimant": null
          },
          {
            "BenefitClaimed": null,
            "ClaimDate": null,
            "Amount": null,
            "Claimant": null
          },
          {
            "BenefitClaimed": null,
            "ClaimDate": null,
            "Amount": null,
            "Claimant": null
          },
          {
            "BenefitClaimed": null,
            "ClaimDate": null,
            "Amount": null,
            "Claimant": null
          },
          {
            "BenefitClaimed": null,
            "ClaimDate": null,
            "Amount": null,
            "Claimant": null
          },
          {
            "BenefitClaimed": null,
            "ClaimDate": null,
            "Amount": null,
            "Claimant": null
          },
          {
            "BenefitClaimed": null,
            "ClaimDate": null,
            "Amount": null,
            "Claimant": null
          },
          {
            "BenefitClaimed": null,
            "ClaimDate": null,
            "Amount": null,
            "Claimant": null
          },
          {
            "BenefitClaimed": null,
            "ClaimDate": null,
            "Amount": null,
            "Claimant": null
          },
          {
            "BenefitClaimed": null,
            "ClaimDate": null,
            "Amount": null,
            "Claimant": null
          },
          {
            "BenefitClaimed": null,
            "ClaimDate": null,
            "Amount": null,
            "Claimant": null
          },
          {
            "BenefitClaimed": null,
            "ClaimDate": null,
            "Amount": null,
            "Claimant": null
          },
          {
            "BenefitClaimed": null,
            "ClaimDate": null,
            "Amount": null,
            "Claimant": null
          },
          {
            "BenefitClaimed": null,
            "ClaimDate": null,
            "Amount": null,
            "Claimant": null
          },
          {
            "BenefitClaimed": null,
            "ClaimDate": null,
            "Amount": null,
            "Claimant": null
          },
          {
            "BenefitClaimed": null,
            "ClaimDate": null,
            "Amount": null,
            "Claimant": null
          },
          {
            "BenefitClaimed": null,
            "ClaimDate": null,
            "Amount": null,
            "Claimant": null
          },
          {
            "BenefitClaimed": null,
            "ClaimDate": null,
            "Amount": null,
            "Claimant": null
          },
          {
            "BenefitClaimed": null,
            "ClaimDate": null,
            "Amount": null,
            "Claimant": null
          },
          {
            "BenefitClaimed": null,
            "ClaimDate": null,
            "Amount": null,
            "Claimant": null
          },
          {
            "BenefitClaimed": null,
            "ClaimDate": null,
            "Amount": null,
            "Claimant": null
          },
          {
            "BenefitClaimed": null,
            "ClaimDate": null,
            "Amount": null,
            "Claimant": null
          },
          {
            "BenefitClaimed": null,
            "ClaimDate": null,
            "Amount": null,
            "Claimant": null
          },
          {
            "BenefitClaimed": null,
            "ClaimDate": null,
            "Amount": null,
            "Claimant": null
          },
          {
            "BenefitClaimed": null,
            "ClaimDate": null,
            "Amount": null,
            "Claimant": null
          },
          {
            "BenefitClaimed": null,
            "ClaimDate": null,
            "Amount": null,
            "Claimant": null
          },
          {
            "BenefitClaimed": null,
            "ClaimDate": null,
            "Amount": null,
            "Claimant": null
          }
        ],
        "ClaimToDate": [
          {
            "Benefit": null,
            "ClaimToDate": null,
            "PolicyToDate": null,
            "Count": null
          },
          {
            "Benefit": null,
            "ClaimToDate": null,
            "PolicyToDate": null,
            "Count": null
          },
          {
            "Benefit": null,
            "ClaimToDate": null,
            "PolicyToDate": null,
            "Count": null
          },
          {
            "Benefit": null,
            "ClaimToDate": null,
            "PolicyToDate": null,
            "Count": null
          },
          {
            "Benefit": null,
            "ClaimToDate": null,
            "PolicyToDate": null,
            "Count": null
          },
          {
            "Benefit": null,
            "ClaimToDate": null,
            "PolicyToDate": null,
            "Count": null
          },
          {
            "Benefit": null,
            "ClaimToDate": null,
            "PolicyToDate": null,
            "Count": null
          },
          {
            "Benefit": null,
            "ClaimToDate": null,
            "PolicyToDate": null,
            "Count": null
          },
          {
            "Benefit": null,
            "ClaimToDate": null,
            "PolicyToDate": null,
            "Count": null
          },
          {
            "Benefit": null,
            "ClaimToDate": null,
            "PolicyToDate": null,
            "Count": null
          },
          {
            "Benefit": null,
            "ClaimToDate": null,
            "PolicyToDate": null,
            "Count": null
          },
          {
            "Benefit": null,
            "ClaimToDate": null,
            "PolicyToDate": null,
            "Count": null
          },
          {
            "Benefit": null,
            "ClaimToDate": null,
            "PolicyToDate": null,
            "Count": null
          },
          {
            "Benefit": null,
            "ClaimToDate": null,
            "PolicyToDate": null,
            "Count": null
          },
          {
            "Benefit": null,
            "ClaimToDate": null,
            "PolicyToDate": null,
            "Count": null
          },
          {
            "Benefit": null,
            "ClaimToDate": null,
            "PolicyToDate": null,
            "Count": null
          },
          {
            "Benefit": null,
            "ClaimToDate": null,
            "PolicyToDate": null,
            "Count": null
          },
          {
            "Benefit": null,
            "ClaimToDate": null,
            "PolicyToDate": null,
            "Count": null
          },
          {
            "Benefit": null,
            "ClaimToDate": null,
            "PolicyToDate": null,
            "Count": null
          },
          {
            "Benefit": null,
            "ClaimToDate": null,
            "PolicyToDate": null,
            "Count": null
          },
          {
            "Benefit": null,
            "ClaimToDate": null,
            "PolicyToDate": null,
            "Count": null
          },
          {
            "Benefit": null,
            "ClaimToDate": null,
            "PolicyToDate": null,
            "Count": null
          },
          {
            "Benefit": null,
            "ClaimToDate": null,
            "PolicyToDate": null,
            "Count": null
          },
          {
            "Benefit": null,
            "ClaimToDate": null,
            "PolicyToDate": null,
            "Count": null
          },
          {
            "Benefit": null,
            "ClaimToDate": null,
            "PolicyToDate": null,
            "Count": null
          },
          {
            "Benefit": null,
            "ClaimToDate": null,
            "PolicyToDate": null,
            "Count": null
          },
          {
            "Benefit": null,
            "ClaimToDate": null,
            "PolicyToDate": null,
            "Count": null
          },
          {
            "Benefit": null,
            "ClaimToDate": null,
            "PolicyToDate": null,
            "Count": null
          },
          {
            "Benefit": null,
            "ClaimToDate": null,
            "PolicyToDate": null,
            "Count": null
          },
          {
            "Benefit": null,
            "ClaimToDate": null,
            "PolicyToDate": null,
            "Count": null
          },
          {
            "Benefit": null,
            "ClaimToDate": null,
            "PolicyToDate": null,
            "Count": null
          },
          {
            "Benefit": null,
            "ClaimToDate": null,
            "PolicyToDate": null,
            "Count": null
          },
          {
            "Benefit": null,
            "ClaimToDate": null,
            "PolicyToDate": null,
            "Count": null
          },
          {
            "Benefit": null,
            "ClaimToDate": null,
            "PolicyToDate": null,
            "Count": null
          },
          {
            "Benefit": null,
            "ClaimToDate": null,
            "PolicyToDate": null,
            "Count": null
          },
          {
            "Benefit": null,
            "ClaimToDate": null,
            "PolicyToDate": null,
            "Count": null
          },
          {
            "Benefit": null,
            "ClaimToDate": null,
            "PolicyToDate": null,
            "Count": null
          }
        ],
        "Cover_Start_Date": "2028-07-09",
        "Coverage": "Insured_1",
        "DOB": "1980-01-01",
        "Gender": "F",
        "Optional_Benefits": [
          {
            "Option": "Insured_1",
            "Included": "Y"
          }
        ],
        "Plan": "Plan_1",
        "Policy_Cover_QuoteDate": "2021-07-01",
        "PostalCode": "064-0806",
        "PromoCode": "",
        "Ratings": [
          {
            "RatingFactor": "RakutenPoints",
            "Value": 20
          },
          {
            "RatingFactor": null,
            "Value": null
          },
          {
            "RatingFactor": null,
            "Value": null
          },
          {
            "RatingFactor": null,
            "Value": null
          },
          {
            "RatingFactor": null,
            "Value": null
          },
          {
            "RatingFactor": null,
            "Value": null
          },
          {
            "RatingFactor": null,
            "Value": null
          },
          {
            "RatingFactor": null,
            "Value": null
          },
          {
            "RatingFactor": null,
            "Value": null
          },
          {
            "RatingFactor": null,
            "Value": null
          },
          {
            "RatingFactor": null,
            "Value": null
          },
          {
            "RatingFactor": null,
            "Value": null
          },
          {
            "RatingFactor": null,
            "Value": null
          },
          {
            "RatingFactor": null,
            "Value": null
          },
          {
            "RatingFactor": null,
            "Value": null
          }
        ],
        "Term": 1,
        "Underwriting_Response": [
          {
            "UWSurveyCode": "PA_UW_1",
            "UWSurveyResponse": "Y"
          },
          {
            "UWSurveyCode": "PA_UW_2",
            "UWSurveyResponse": "Y"
          },
          {
            "UWSurveyCode": "PA_UW_3",
            "UWSurveyResponse": null
          },
          {
            "UWSurveyCode": "PA_UW_4",
            "UWSurveyResponse": null
          },
          {
            "UWSurveyCode": "PA_UW_5",
            "UWSurveyResponse": null
          },
          {
            "UWSurveyCode": "PA_UW_6",
            "UWSurveyResponse": null
          },
          {
            "UWSurveyCode": "PA_UW_7",
            "UWSurveyResponse": null
          },
          {
            "UWSurveyCode": "PA_UW_8",
            "UWSurveyResponse": null
          },
          {
            "UWSurveyCode": "PA_UW_9",
            "UWSurveyResponse": null
          },
          {
            "UWSurveyCode": "PA_UW_10",
            "UWSurveyResponse": null
          },
          {
            "UWSurveyCode": "PA_UW_11",
            "UWSurveyResponse": null
          },
          {
            "UWSurveyCode": "PA_UW_12",
            "UWSurveyResponse": null
          },
          {
            "UWSurveyCode": "PA_UW_13",
            "UWSurveyResponse": null
          },
          {
            "UWSurveyCode": "PA_UW_14",
            "UWSurveyResponse": null
          },
          {
            "UWSurveyCode": "PA_UW_15",
            "UWSurveyResponse": null
          },
          {
            "UWSurveyCode": "PA_UW_16",
            "UWSurveyResponse": null
          },
          {
            "UWSurveyCode": "PA_UW_17",
            "UWSurveyResponse": null
          },
          {
            "UWSurveyCode": "PA_UW_18",
            "UWSurveyResponse": null
          },
          {
            "UWSurveyCode": "PA_UW_19",
            "UWSurveyResponse": null
          },
          {
            "UWSurveyCode": "PA_UW_20",
            "UWSurveyResponse": null
          }
        ]
      },
      "TransactionDate": "2021-07-24T09:47:26.499Z",
      "EngineType": "Type1",
      "Solves": [],
      "ServiceName": "",
      "Description": "",
      "RequestedOutPut": "",
      "EndPoint": "https://excelengine.demo.sonic.dev.coherent.global/api/v1/product/coherent/engines/Execute/PA",
      "IsRichJson": false,
      "ServiceCategories": [
        "Claim",
        "Options",
        "Refund"
      ],
      "RequestedServiceCategory": "",
      "ShouldExecuteInputs": false
    }

    vm.QuoteTemplate = {
      "ContID": "",
      "Product": "HSBC_PoC:PA_Demo",
      "CPF": "4-5678-98790-70-7",
      "Currency": {
          "Code": "SGD",
          "Descr": "SGD"
      },
      "BilledAt": "Master",
      "Term": 1,
      "InvokeType": "Q",
      "StartDate": "2022-03-21T00:00:00.000+05:30",
      "EndDate": "2023-03-20T00:00:00.000+05:30",
      "Status": "NewQuotation",
      "PaymentFrequency": 1,
      "PaymentMethod": "CreditCard",
      "UWStatus": "Pass",
      "Agent": "10001",
      "AgentID": "AG12389",
      "Channel": "Agent_2",
      "SaveQuoteAs": "New",
      "Email": "miyoshi@example.com",
      "InstallmentPremium": 5170,
      "Mandate": {
            "BankAccount": {
                "AccountName": "",
                "AccountNo": "",
                "AccountType": "",
                "BankBranch": "",
                "BankName": "",
                "OtherRef": ""
            },
            "CreditCard": {
                "BankRefNum": "",
                "CardNumber": "••••-••••-••••-9282",
                "CardType": "Visa",
                "ExpiryMonth": "10",
                "ExpityYear": "30"
            },
            "MandateRefNo": "764A1234",
            "MandateStatus": "Pending"
        },
      "OldPolicyID": "",
      "Owner": {
            "Contact": {
                "Add": {
                    "Add1": "Yoyogi 1-1-1, Shibuya",
                    "Add2": "",
                    "Add3": "",
                    "Add4": "",
                    "City": "",
                    "Country": "Japan",
                    "Pcode": "2723321"
                },
                "Email": "yamadataro@email.com",
                "Phone": "08012341234",
                "Typ": "V"
            },
            "Dob": "1980-10-10",
            "Gender": "M",
            "Givenname": "",
            "ID": [
                {
                    "ExpiryDate": "",
                    "IDNumber": "",
                    "IDType": "",
                    "IssueDate": "",
                    "IssuingAgency": ""
                }
            ],
            "Name": "Taro Yamada",
            "Nationality": "Japanese",
            "Occupation": "Software",
            "Race": "Japanese",
            "Smoker": "No",
            "Title": ""
        },
      "EntityInfo": {},
      "Contacts": [],
      "Plans": {},
      "PremiumTotals": {
          "GrossAnnualPrem": 30388,
          "NetAnnualPremium": 0,
          "ModalPremium": 0,
          "Gst": 0,
          "GroupDiscount": 0
      },
      "Members": [],
      "Data": {
          "MatchBudget": "43453545",
          "UploadedDocs": []
      },
      "Notes": null,
      "SubsidiaryInfo": []
    }

    vm.Home_pf_payload = {"Inputs":{"AllocatePremium":null,"BillPeriodEnd":"2022-07-27","BillPeriodStart":"2021-07-28","BrokerID":"ARN-00003","CancelAllocatedPremium":4810.26,"CancellationDate":"2021-07-28","CancelRef":"customer-not required","Channel":null,"ClaimAmount":[{"Sno":1,"Benefit":"A3","Amount":7500,"EventStart":"2022-11-20","EventEnd":"2022-11-21","EventType":null,"Claimant":null,"Exgratia":null},{"Sno":2,"Benefit":"A4","Amount":3500,"EventStart":"2022-11-20","EventEnd":"2022-11-21","EventType":null,"Claimant":null,"Exgratia":null}],"ClaimApproveAmount":400000,"ClaimHistory":[],"ClaimRef":"CLM0001","ClaimRejectAmount":400000,"ClaimStatus":"initiate","ClaimToDate":[],"ClmStatus":"initiate","Cover_Start_Date":"2022-06-01","Data":[{"RefundLevy":10}],"EventDate":null,"InputType":[],"LevyType":null,"NumberOfCovers":null,"Optional_Benefits":[{"Option":"Building","Descr":"Building Cover","Included":"Y","SumInsured":300000},{"Option":"Contents","Descr":"Contents Cover","Included":"Y","SumInsured":60000},{"Option":"AO1","Descr":"Ww Perso Belongings ","Included":"N","SumInsured":90000},{"Option":"AO2","Descr":"Pet Insurance ","Included":"N","SumInsured":400},{"Option":"AO3","Descr":"Cyber Protector ","Included":"N","SumInsured":500},{"Option":"AO4","Descr":"Bicycle ","Included":"N","SumInsured":120000},{"Option":"AO5","Descr":"Ww Family PA ","Included":"N","SumInsured":100},{"Option":"AO6","Descr":"Ww Perso Liability","Included":"N","SumInsured":30000}],"OwnerType":null,"PaymentFrequency":1,"Plan":"Named Perils","PolicyNo":"P-HOM-123456","PreferredLanguage":null,"PremiumBilled":null,"ProductType":null,"PromoCode":null,"Puchase_Date":"2022-01-01","Ratings":[{"RatingFactor":"Endorsement Type","Value":"NB"},{"RatingFactor":"Property Type","Value":"Landed"},{"RatingFactor":"Number of Rooms","Value":">5"},{"RatingFactor":"Occupancy status","Value":"Owner"}],"Reference2":"6fddd26a7e2bb49a074bc0f77269d","Term":1,"UWQuestions":[{"UWSurveyCode":"Home_UW_1","UWSurveyResponse":2016}]},"TransactionDate":"2022-06-19T07:16:28.380Z","EngineType":"Type3","Images":[],"Reports":[],"Solves":[]}

    vm.PlansList = {};

    vm.setInsuranceDate = function (insuranceDate) {
      vm.insuranceDate = insuranceDate;
    };

    vm.setPlanCategory = function (planCategory) {
      vm.planCategory = planCategory;
    };

    vm.setPlanType = function (planType) {
      vm.planType = planType;
    };

    vm.setInsuredType = function (insuredType) {
      vm.insuredType = insuredType;
    };

    vm.setInformation1 = function (information) {
      vm.information1 = information;
    };

    vm.setInformation2 = function (information) {
      vm.information2 = information;
    };

    vm.setAgentCode = function (AgentCode) {
      vm.AgentCode = AgentCode;
    };

    vm.setMsgId = function (MsgId) {
      vm.MsgId = MsgId;
    };

    vm.setPlansList = function (PlansList) {
      vm.PlansList = PlansList;
    };

    vm.setProductType = function (type) {
      vm.ProductType = type;
    }

    vm.clear = function () {
      vm.insuranceDate = '';
      vm.planCategory = {};
      vm.planType = {};
      vm.email = '';

      vm.information1 = {};
      vm.information2 = {};
      vm.ProductType = 'Policy';
      vm.quote_id = '';
      vm.QuoteData = {};
      vm.polNo = '';
      vm.DefaultCurrency = 'SGD';
      vm.SelectedPromo = '';
    };

    vm.setPlan1 = function (plan1) {
      vm.plan1 = plan1;
    };
    vm.setPlan2 = function (plan2) {
      vm.plan2 = plan2;
    };
    vm.setPlan3 = function (plan3) {
      vm.plan3 = plan3;
    };
    vm.setPolicyNumber = function (polNo) {
      vm.polNo = polNo;
    };
    vm.setSignIn = function (signIn) {
      vm.signIn = signIn;
    };
    vm.setProduct = function (ProductCode) {
      vm.ProductCode = ProductCode;
    };
    vm.setFolderName = function (FolderName) {
      vm.FolderName = FolderName;
    };
    vm.setQuoteID = function (QuoteID) {
      vm.quote_id = QuoteID;
    };
    vm.setQuoteData = function (QuoteJson) {
      vm.QuoteData = QuoteJson;
    }
    vm.isQuoteData = function() {
      return vm.quote_id && vm.QuoteData && vm.QuoteData.Cont;
    }
    vm.setCurrency = function (currency) {
      vm.DefaultCurrency = currency;
    }
    vm.setPromoCode = function (promoCode) {
      vm.SelectedPromo = promoCode;
    }
    vm.setOccupation = function (occupation) {
      vm.SelectedOccupation = occupation;
    }
    vm.setPaymentFrequency = function (paymentFreq) {
      vm.SelectedPaymentFreq = paymentFreq;
    }
    vm.setRatingFactors = function (factors) {
      vm.RatingFactors = factors;
    }

    vm.policyConfirmation = function () {
      vm.policyMessage.rich_media.Buttons[2].ActionBody = "https:///policies-1/";
      var req = {
        method: 'POST',
        url: 'https://chatapi.viber.com/pa/send_message',
        headers: {
          'X-Viber-Auth-Token': '4daf5fc268a7d0f7-c12d94b6fd4550f9-2e081452380e202a'
        },
        data: angular.toJson(vm.policyMessage)
      };
      $http(req)
        .then(function () {
        }, function () {
      });

    }

    vm.numberWithCommas = function (x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    vm.reset = function () {
      vm.policy = {
        // output
        number: null,

        // parameters
        agentCode: '10008',
        fbId: null,

        // input
        type: null,

        // accident
        specs: {},

        // travel

        email: null,
        name: null,
        birthDate: null,
        gender: null,
        postalCode1: null,
        postalCode2: null,
        address: null,
        contact: null,
        relationship: null
      };
    };

    vm.debug = function () {
      $log.debug(vm.policy);
    };
    
  }
})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .factory('PurchaseFactory', fctry);

  /** @ngInject */
  function fctry($http,
                 $q,
                 $timeout,
                 ACCIDENT_TYPE,
                 TRAVEL_TYPE,
                 configUrls,
                 environment) {
    var vm = this;

    var headers = {
      'SecretKey': '762f5692-5a8b-4f8e-a09e-a27a277c0c56',
      'x-tenant-name': 'coherent',
      authorization: ''
    };

    vm.opts = {};

    vm.opts[ACCIDENT_TYPE] = {
      title: 'purchase_personal_accident_insurance',
      confirmation: 'purchase_personal_accident_is_a_product'
    };

    vm.opts[TRAVEL_TYPE] = {
      title: 'purchase_travel_insurance',
      confirmation: 'purchase_travel_is_a_product'
    };

    vm.relationships = [{
      value: 'self',
      display: "purchase_same_as_owner"
    }];

    vm.token = function() {
      return $http({
        method: 'GET',
        url: configUrls[environment].keyCloakTokenUrl + '?apiKey=' + configUrls[environment].keyCloakApiKey + '&client=' + configUrls[environment].keyCloakPFClient,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      });
    };

    vm.get = function (type, folder, data, token) {
      headers.authorization = 'Bearer ' + token.data.access_token
      return $http({
        method: 'POST',
        url: configUrls[environment].PFUrl1 + folder + '/engines/Execute/' + type,
        // url: configUrls[environment].PFUrl1 + 'coherent/engines/Execute/Smart_Home',
        headers: headers,
        data: data
      });
    };

    vm.signIn = function (delay) {
      return $q(function(resolve) {
        $timeout(function() {
          resolve({
            name: 'Mark Banaria',
            birthDate: moment('1986-02-23'),
            gender: 'male',
            postalCode1: '1234',
            postalCode2: '4321',
            address: '12 Dove Street',
            contact: '+1291261111'
          });
        }, delay);
      });
    };

    vm.purchase = function (data) {
      // TODO: Change obj
      return $http({
        method: 'POST',
        url: configUrls[environment].createPolicy,
        data: data,
        headers: {
          'authorization': 'Bearer ' + configUrls[environment].token
        }
      });
    };

    return vm;
  }
})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')

    .constant('OPTIONS_PAYLOAD', {"Inputs":{"Options.Language":"en-HK"},"RequestedServiceCategory":"Options","TransactionDate":""})
    .constant('PURCHASE_PAYLOAD', {
      PA: {"Header":{"Product":"HSBCGI:PA","Term":1,"CPF":"4-5678-98790-70-7","Email":"admin123@dasf","Channel":"Agent_2","Agent":"10008","StartDate":"2022-03-24T12:49:16.161616Z","PaymentMethod":"CreditCard","Currency":{"Code":"SGD"},"PaymentFrequency":1,"PreferredLanguage":"E","InstallmentPremium":3000,"PaymentReference":"Ref1283i","Mandate":{"MandateRefNo":"764A1234","MandateStatus":"Pending","BankAccount":{"BankName":"","BankBranch":"","AccountType":"","AccountName":"","AccountNo":"","OtherRef":""},"CreditCard":{"BankRefNum":"","CardType":"Visa"}},"Owner":{"Title":"","Name":"Mark Banaria","Givenname":"","Dob":"1986-02-23","Smoker":"","Gender":"M","Nationality":"Japanese","Race":"Japanese","Occupation":"Software","ID":[{"IDType":"","IDNumber":"","IssueDate":"","ExpiryDate":"","IssuingAgency":""}],"Contact":{"Email":"admin123@dasf","Phone":"+1291261111","Typ":"V","Add":{"Add1":"12 Dove Street","Add2":"","Add3":"","Add4":"","City":"","Country":"Japan","Pcode":"1234-4321"},"FbId":null}},"OldPolicyID":"","Data":[{"ExtraField1":"Extra Policy Data","ExtraField2":"Extra Policy Data"}]},"Risks":[{"RiskType":"PA","RiskId":"1","Riskclass":"PA","CoverType":"HSBCGI:PA","Risk_Comm":"2022-03-24T12:49:16.161616Z","RiskBody":{"RiskType":"PA","RiskId":"1","Riskclass":"PA","Plan":"Plan1","CoverType":"HSBCGI:PA","Sum_Insured":1000,"InsuredParty":{"Name":"Mark Banaria","GivenName":"","Dob":"1986-02-23","Age":28,"Gender":"M","Kinship":"N/A","Id":{"IDType":"","IDNumber":"","IssueDate":"","ExpiryDate":"","IssuingAgency":""},"Documents":[{"Url":"","Descr":"Cycle Photo","AttachDate":"2021-07-06T13:23:45.871303Z","AttachNote":{"Dte":"2021-07-06T13:23:45.871303Z","User":"Hello","Text":"Cycle Photo"}}],"Occupation":"","Contact":{"Email":"miyoshi@example.com","Phone":"+8162-658-9795","FbId":"","Add":{"Add1":"イワテケン","Add2":"キタカミシ","Add3":"ワガチョウイワサキ","Add4":"","City":"","Country":"India","Pcode":"024-0321"}},"Data":[{"ExtraField1":"Extra Insured Data","ExtraField2":"Extra Insured Data"}]},"Options":[],"Term":1,"TermUnits":"years","Region":"Asia","Channel":"Agent_2","Payment_Frequency":"1","BasePremium":0,"EventDate":"2021-07-06T13:23:45.871303Z","Risk_Comm":"2022-03-24T12:49:16.161616Z","Data":[{"ExtraField1":"Extra Risk Body Data","ExtraField2":"Extra Risk Body Data"},{"ExtraField1":"Extra Risk Body Data","ExtraField2":"Extra Risk Body Data"}],"Ratings":[{"RatingFactor":"RakutenPoints","Value":"0"}],"PaymentFrequency":1},"Data":[{"Insured_Dob":"04-April-2021","Header_Risk_Comm":"06-July-2021","Header_EndDate":"06-July-2022"},{"ExtraField1":"Extra Risk Data","ExtraField2":"Extra Risk Data"}]}]},
      HSBCH: {"Header":{"Product":"HSBCGI:HSBCH","Term":1,"CPF":"09199979","Channel":"Broker","Agent":"7878787","Email":"","StartDate":"2022-03-23T09:40:36.940641599Z","PaymentMethod":"CreditCard","PaymentFrequency":1,"InstallmentPremium":6581.58,"PaymentReference":"Ref1283i","Mandate":{"MandateRefNo":"000546","MandateStatus":"Pending","BankAccount":{"BankName":"SCB Thailand","BankBranch":"SCB00123","AccountType":"Savings","AccountName":"K. Mark","AccountNo":"123987123987","OtherRef":"SCB10101"},"CreditCard":{"BankRefNum":"SCBCC0001","CardNumber":"127391873298172397","CardType":"VISA","ExpiryMonth":"12","ExpityYear":"23"}},"Owner":{"Name":"First Name","GivenName":"","Dob":"2020-01-08","Smoker":"","Gender":"M","Nationality":"Hong Kong","Race":"Hong Kong","Occupation":"","ID":[{"IDType":"","IDNumber":"","IssueDate":"2020-01-20","ExpiryDate":"2025-02-08","IssuingAgency":"abcd"}],"Contact":{"Email":"","Phone":"","FbId":"4774250732594389","Add":{"Add1":"","Add2":"","Add3":"","Add4":"","City":"","Country":"","Pcode":"999077"}}},"BankName":"HSBC","Name":""},"Risks":[{"RiskType":"Travel","PolicyId":"454545","RiskId":"1","Riskclass":"Travel","CoverType":"HSBCGI:HSBCH","RiskBody":{"RiskType":"Travel","RiskId":"1","Riskclass":"Travel","Plan":"Single","Planlevel":"Basic","CoverType":"HSBCGI:HSBCH","Risk_Comm":"2022-03-26T00:00:00Z","Risk_End":"2022-05-22T00:00:00Z","InsuredParty":{"Name":"","GivenName":"","Dob":"2000-03-13","Age":20,"MortalityClass":"S","Gender":"M","Id":{"IDType":"Tax","IDNumber":"1000000","IssueDate":"2020-01-20","ExpiryDate":"2025-02-08","IssuingAgency":"abcd"},"Contact":{"Email":"markbanaria@gmail.com","Phone":"","FbId":"FBID","Add":{"Add1":"","Add2":"","Add3":"","Add4":"","City":"","Country":"","Pcode":"999077"}}},"Adults":[{"GivenName":"Test 4","Name":"Test 5","Dob":"1997-03-13","Age":30,"Gender":"M","Id":{"IDType":"Tax","IDNumber":"12345","IssueDate":"2020-01-20","ExpiryDate":"2025-02-08","IssuingAgency":"abcd"},"Occupation":"Test 3","MortalityClass":"s","Contact":{"Email":"nilesh.yadav@example.com","Phone":"9876543210","FbId":"FBID","Add":{"Add1":"1 Thailand St.","Add2":"Street 2 of Bangkok","Add3":"District","Add4":"State","City":"Bangkok","Country":"Thailand","Pcode":"1016"}}}],"Self":"Y","Spouse":"N","Nchildren":0,"Nadults":0,"TermUnits":"days","Term":1,"Region":"Taiwan","Currency":"HKD","Payment_Frequency":"1","Discount":0,"Discount2":0,"Options":[{"Option":"Travel_Coverage_A1","Descr":"","Included":"Y","SumInsured":0},{"Option":"Travel_Coverage_B","Descr":"","Included":"Y","SumInsured":594337},{"Option":"Travel_Coverage_C","Descr":"","Included":"N","SumInsured":0},{"Option":"Travel_Coverage_D","Descr":"","Included":"Y","SumInsured":0},{"Option":"Travel_Coverage_D","Descr":"","Included":"Y","SumInsured":100}]},"Sum_Insured":1000,"Self":"Y","Spouse":"N","Nchildren":0,"Nadults":0,"TermUnits":"days","Term":1,"Region":"Asia","Currency":"","Payment_Frequency":"1","Discount":0,"Discount2":0,"AppliedPremium":null,"Risk_Comm":"2022-03-23T00:00:00Z","Risk_End":"2022-05-22T00:00:00Z"}]},
      Home_Demo: {"Header":{"Product":"coherent:Smart_Home","Term":1,"Channel":"Agent","Agent":"ARN-000011","AgentName":"ABC Insurance - Network Agent 01512","Email":"dan.brown@hampshire.com","StartDate":"2022-04-01T09:40:36.940641599Z","PaymentMethod":"CreditCard","PaymentFrequency":1,"InstallmentPremium":7517,"PaymentReference":"Ref1283i","PreferredLanguage":"en_HK","ReferenceCode":"JFK45HD","PromoCode":"save6","ProductType":"HOM","LevyType":"IA","Plan":"P1","EmailPreferance":"e-policy","OldPolicyID":"","Currency":{"Code":"SGD","Descr":"Singapore Dollars"},"Owner":{"Title":"","Name":"Daniel","Givenname":"","Dob":"1955-01-01","Gender":"M","ID":[{"IDType":"","IDNumber":"","IssueDate":"2020-01-20","ExpiryDate":"2025-02-08","IssuingAgency":"Government Agent"}],"Contact":{"Email":"dan.brown@hampshire.com","Phone":"855-541-30","FbId":"kCDhsokXzoV+Ibxms16Fwg==","Typ":"V","Add":{"Add1":" ","Add2":" ","Add3":" ","Add4":"","City":" ","Country":" ","Pcode":"098942"}}},"Mandate":{"MandateRefNo":"000546","MandateStatus":"Active","BankAccount":{"BankName":"SCB","BankBranch":"SCB00123","AccountType":"Savings","AccountName":"My Name","AccountNo":"123987123987","OtherRef":"SCB10101"},"CreditCard":{"BankRefNum":"SCBCC0001","CardNumber":"127391873298172397","CardType":"VISA","ExpiryMonth":"12","ExpityYear":"22"}},"Data":[{"PreferredLanguage":"zh_HK","PurchaseDate":"2022-01-01"},{"UWQuestions":"[{\"UWSurveyCode\": \"Home_UW_1\",\"UWSurveyResponse\":2016},{\"UWSurveyCode\":\"Home_UW_1_1\",\"UWSurveyResponse\":1},{\"UWSurveyCode\":\"Home_UW_2\",\"UWSurveyResponse\":2},{\"UWSurveyCode\":\"Home_UW_3\",\"UWSurveyResponse\":2},{\"UWSurveyCode\":\"Home_UW_4\",\"UWSurveyResponse\": 2}]"}]},"Risks":[{"RiskType":"PA","RiskId":"1","Riskclass":"PA","CoverType":"coherent:Smart_Home","Risk_Comm":"2022-04-01T09:40:36.940641599Z","RiskBody":{"RiskType":"PA","RiskId":"1","Riskclass":"PA","Plan":"P1","CoverType":"coherent:Smart_Home","Sum_Insured":12000,"InsuredParty":{"Name":"Daniel","GivenName":"","Dob":"1955-01-01","MortalityClass":"S","Gender":"M","Contact":{"Add":{"Add1":" ","Add2":" ","Add3":" ","Add4":"","City":" ","Country":" ","Pcode":"098942"}},"Data":[{"ExtraField1":"Extra Insured Data","ExtraField2":"Extra Insured Data"},{"ExtraField1":"Extra Insured Data","ExtraField2":"Extra Insured Data"}]},"TermUnits":"years","Term":1,"Payment_Frequency":"1","BasePremium":0,"EventDate":"2022-04-01T09:40:36.940641599Z","Risk_Comm":"2022-04-01T09:40:36.940641599Z","Options":[{"Option":"HOM1000100","Descr":"Household_Contents","Included":"Y","SumInsured":500000},{"Option":"HOM1000200","Descr":"Alternations_and_Repairs","Included":"Y","SumInsured":200000},{"Option":"HOM1000300","Descr":"Alternative_Accomodation_or_Temporary_Removal_or_Home_Removal","Included":"Y","SumInsured":50000},{"Option":"HOM1000400","Descr":"Incidental_Expenses","Included":"Y","SumInsured":60000},{"Option":"HOM1000500","Descr":"Fixtures_and_Fittings","Included":"Y","SumInsured":500000},{"Option":"HOM1100600","Descr":"Valuables_Within_Insured_Premises","Included":"Y","SumInsured":10000},{"Option":"HOM1100700","Descr":"Valuables_Outside_Insured_Premises","Included":"Y","SumInsured":10000},{"Option":"HOM2000800","Descr":"Building_Structures","Included":"Y","SumInsured":500000},{"Option":"HOM2000900","Descr":"Rental_Protection","Included":"Y","SumInsured":100000},{"Option":"HOM2001000","Descr":"Haunted_House_and_Bad_Tenant_Protection","Included":"Y","SumInsured":25000},{"Option":"HOM3001100","Descr":"Accidental_Death","Included":"Y","SumInsured":200000},{"Option":"HOM3001200","Descr":"Medical_Expenses","Included":"Y","SumInsured":50000},{"Option":"HOM3001300","Descr":"Home_Modifications_for_Elderly_or_Disabled_Household_Members_after_an_Accident","Included":"Y","SumInsured":50000},{"Option":"HOM4001400","Descr":"Third_Party_Legal_Liability","Included":"Y","SumInsured":5000000},{"Option":"HOM4001500","Descr":"Legal_Costs_for_Tenancy_Dispute","Included":"Y","SumInsured":50000},{"Option":"HOM5001600","Descr":"Purchase_Protection","Included":"Y","SumInsured":1000},{"Option":"HOM5001700","Descr":"Electronic_Fund_Transfer_Fraud","Included":"Y","SumInsured":2500},{"Option":"HOM5001800","Descr":"Online_Retail_Fraud","Included":"Y","SumInsured":1000},{"Option":"HOM5001900","Descr":"Cyber_Bullying","Included":"Y","SumInsured":1000},{"Option":"HOM5002000","Descr":"Cyber_Extortion","Included":"Y","SumInsured":1000},{"Option":"HOM5002100","Descr":"Cyber_Liability","Included":"Y","SumInsured":1000},{"Option":"HOM5002200","Descr":"Indentity_Theft","Included":"Y","SumInsured":1000},{"Option":"HOM5002300","Descr":"Restoration_Costs","Included":"Y","SumInsured":1000},{"Option":"HOM6002400","Descr":"Locksmith_Plumber_Electrician_Air_Conditioning_Engineer","Included":"Y","SumInsured":0},{"Option":"HOM6002500","Descr":"Pest_Control_House_Cleaning","Included":"Y","SumInsured":1},{"Option":"HOM6002600","Descr":"General_Repair","Included":"Y","SumInsured":0},{"Option":"HOM6002700","Descr":"Home_Nursing_Care","Included":"Y","SumInsured":0},{"Option":"HOM6002800","Descr":"Baby_Sitting_Care_Elderly_Services_Transportation_Referral","Included":"Y","SumInsured":0},{"Option":"HOM6002900","Descr":"Pet_Care","Included":"Y","SumInsured":0}],"Data":[{"ExtraField1":"Extra Risk Body Data","ExtraField2":"Extra Risk Body Data"},{"ExtraField1":"Extra Risk Body Data","ExtraField2":"Extra Risk Body Data"}]},"Data":[{"ExtraField1":"Extra Risk Data","ExtraField2":"Extra Risk Data"},{"ExtraField1":"Extra Risk Data","ExtraField2":"Extra Risk Data"}]}]},
      HSBCTravel: {"Header":{"Product":"coherent:HSBC_Travel","Term":1,"CPF":"09199979","Channel":"Broker","Agent":"10008","Email":"mark@email.com","StartDate":"2022-06-10T02:21:01.010101Z","PaymentMethod":"CreditCard","Currency":{"Code":"SGD","Descr":"Singapore Dollars"},"PaymentFrequency":1,"InstallmentPremium":721,"PaymentReference":"Ref1283i","Mandate":{"MandateRefNo":"000546","MandateStatus":"Pending","BankAccount":{"BankName":"DBS","BankBranch":"DBS00123","AccountType":"Savings","AccountName":"Mark","AccountNo":"123987123987","OtherRef":"SCB10101"},"CreditCard":{"BankRefNum":"SCBCC0001","CardType":"VISA"}},"Owner":{"Name":"John","GivenName":"","Dob":"1986-02-23","Smoker":"","Gender":"M","Nationality":"Singaporian","Race":"Singaporian","Occupation":"","ID":[{"IDType":"","IDNumber":"","IssueDate":"2020-01-20","ExpiryDate":"2025-02-08","IssuingAgency":"abcd"}],"Contact":{"Email":"john.smith@gmail.com","Phone":"+6512345678","FbId":null,"Add":{"Add1":"12 Dove Street","Add2":"","Add3":"","Add4":"","City":"","Country":"","Pcode":"1234-4321"}}},"BankName":"HSBC","Name":""},"Risks":[{"RiskType":"Travel","PolicyId":"454545","RiskId":"1","Riskclass":"Travel","CoverType":"coherent:HSBC_Travel","RiskBody":{"RiskType":"Travel","RiskId":"1","Riskclass":"Travel","Plan":"Single","Planlevel":"ESSENTIAL","CoverType":"coherent:HSBC_Travel","Risk_Comm":"2022-06-10T02:21:01.010101Z","Risk_End":"2022-06-17T12:00:00.000000Z","InsuredParty":{"Name":"John","GivenName":"","Dob":"1986-02-23","Age":20,"MortalityClass":"S","Gender":"M","Id":{"IDType":"Tax","IDNumber":"1000000","IssueDate":"2020-01-20","ExpiryDate":"2025-02-08","IssuingAgency":"abcd"},"Contact":{"Email":"john.smith@gmail.com","Phone":"","FbId":"FBID","Add":{"Add1":"","Add2":"","Add3":"","Add4":"","City":"","Country":"","Pcode":"999077"}}},"Adults":[{"GivenName":"Test 4","Name":"Test 5","Dob":"1997-03-13","Age":30,"Gender":"M","Id":{"IDType":"Tax","IDNumber":"12345","IssueDate":"2020-01-20","ExpiryDate":"2025-02-08","IssuingAgency":"abcd"},"Occupation":"Test 3","MortalityClass":"s"}],"Self":"N","Spouse":"N","Nchildren":1,"Nadults":1,"TermUnits":"days","Term":1,"Promotion":"JUN50OFF","Region":"REGIONAL","Currency":"SGD","Payment_Frequency":"1","Discount":0,"Discount2":0,"Options":[{"Option":"Rental Car Excess","Descr":"","Included":"Y","SumInsured":0},{"Option":"Sports Equipment","Descr":"","Included":"Y","SumInsured":0},{"Option":"Golf Equipment","Descr":"","Included":"N","SumInsured":0},{"Option":"Pet Care","Descr":"","Included":"N","SumInsured":0}]},"Sum_Insured":1000,"Self":"N","Spouse":"N","Nchildren":1,"Nadults":1,"TermUnits":"days","Term":1,"Region":"REGIONAL","Currency":"SGD","Payment_Frequency":"1","AppliedPremium":null,"Risk_Comm":"2022-06-10T02:21:01.010101Z","Risk_End":"2022-06-17T12:00:00.000000Z"}]},
      Smart_Home: {"Header":{"Product":"NH_Test:Smart_Home","Term":1,"Channel":"Direct","Agent":"A000001","AgentName":"Broker","Email":"dan.brown@hampshire.com","StartDate":"2022-06-01T09:40:36.940641599Z","PaymentMethod":"DebitCard","PaymentFrequency":1,"InstallmentPremium":2000,"PaymentReference":"Ref1283i","ReferenceCode":"JFK45HD","PromoCode":"","Currency":{"Code":"SGD","Descr":"Singapore Dollars"},"Owner":{"Title":"","Name":"Daniel","Givenname":"","Dob":"1955-01-01","Gender":"M","ID":[{"IDType":"","IDNumber":"","IssueDate":"2020-01-20","ExpiryDate":"2025-02-08","IssuingAgency":"Government Agent"}],"Contact":{"Email":"dan.brown@hampshire.com","Phone":"855-541-30","FbId":"kCDhsokXzoV+Ibxms16Fwg==","Typ":"V","Add":{"Add1":" ","Add2":" ","Add3":" ","Add4":"","City":" ","Country":" ","Pcode":"098942"}}},"Mandate":{"MandateRefNo":"000546","MandateStatus":"Active","BankAccount":{"BankName":"SCB","BankBranch":"SCB00123","AccountType":"Savings","AccountName":"My Name","AccountNo":"123987123987","OtherRef":"SCB10101"},"CreditCard":{"BankRefNum":"SCBCC0001","CardNumber":"127391873298172397","CardType":"VISA","ExpiryMonth":"12","ExpityYear":"22"}},"Data":[{"PreferredLanguage":"zh_HK","PurchaseDate":"2022-01-01"}]},"Risks":[{"RiskType":"PA","RiskId":"1","Riskclass":"PA","CoverType":"NH_Test:Smart_Home","Risk_Comm":"2022-06-01T09:40:36.940641599Z","RiskBody":{"RiskType":"PA","RiskId":"1","Riskclass":"PA","Plan":"All Risks","CoverType":"NH_Test:Smart_Home","Sum_Insured":1000,"InsuredParty":{"Name":"Daniel","GivenName":"","Dob":"1955-01-01","MortalityClass":"S","Gender":"M","Contact":{"Add":{"Add1":" ","Add2":" ","Add3":" ","Add4":"","City":" ","Country":" ","Pcode":"098942"}},"Data":[{"ExtraField1":"Extra Insured Data","ExtraField2":"Extra Insured Data"},{"ExtraField1":"Extra Insured Data","ExtraField2":"Extra Insured Data"}]},"TermUnits":"years","Term":1,"Payment_Frequency":"1","BasePremium":0,"EventDate":"2022-06-01T09:40:36.940641599Z","Risk_Comm":"2022-06-01T09:40:36.940641599Z","Options":[{"Option":"Building","Descr":"Building Cover","Included":"Y","SumInsured":500000},{"Option":"Contents","Descr":"Contents Cover","Included":"Y","SumInsured":90000},{"Option":"AO1","Descr":"Ww Perso Belongings","Included":"Y","SumInsured":4000},{"Option":"AO2","Descr":"Pet Insurance","Included":"N"},{"Option":"AO3","Descr":"Cyber Protector","Included":"N"},{"Option":"AO4","Descr":"Bicycle","Included":"N","SumInsured":4000},{"Option":"AO5","Descr":"Ww Family PA","Included":"N"},{"Option":"AO6","Descr":"Ww Perso Liability","Included":"N","SumInsured":1000000}],"Data":[{"ExtraField1":"Extra Risk Body Data","ExtraField2":"Extra Risk Body Data"},{"ExtraField1":"Extra Risk Body Data","ExtraField2":"Extra Risk Body Data"}],"Ratings":[{"RatingFactor":"Endorsement Type","Value":"NB"},{"RatingFactor":"Property Type","Value":"Landed"},{"RatingFactor":"Number of Rooms","Value":">5"},{"RatingFactor":"Occupancy status","Value":"Owner"}]},"Data":[{"ExtraField1":"Extra Risk Data","ExtraField2":"Extra Risk Data"},{"ExtraField1":"Extra Risk Data","ExtraField2":"Extra Risk Data"}]}]},
      HSBC_Home: {"Header":{"Product":"coherent:HSBC_Home","Term":1,"Channel":"Direct","Agent":"A000001","AgentName":"Broker","Email":"dan.brown@hampshire.com","StartDate":"2022-06-01T09:40:36.940641599Z","PaymentMethod":"DebitCard","PaymentFrequency":1,"InstallmentPremium":2000,"PaymentReference":"Ref1283i","ReferenceCode":"JFK45HD","PromoCode":"","Currency":{"Code":"SGD","Descr":"Singapore Dollars"},"Owner":{"Title":"","Name":"Daniel","Givenname":"","OwnerType":"","Dob":"1990-01-01","Gender":"M","ID":[{"IDType":"","IDNumber":"","IssueDate":"2020-01-20","ExpiryDate":"2025-02-08","IssuingAgency":"Government Agent"}],"Contact":{"Email":"dan.brown@hampshire.com","Phone":"855-541-30","FbId":"kCDhsokXzoV+Ibxms16Fwg==","Typ":"V","Add":{"Add1":" ","Add2":" ","Add3":" ","Add4":"","City":" ","Country":" ","Pcode":"098942"}}},"Mandate":{"MandateRefNo":"000546","MandateStatus":"Active","BankAccount":{"BankName":"SCB","BankBranch":"SCB00123","AccountType":"Savings","AccountName":"My Name","AccountNo":"123987123987","OtherRef":"SCB10101"},"CreditCard":{"BankRefNum":"SCBCC0001","CardNumber":"127391873298172397","CardType":"VISA","ExpiryMonth":"12","ExpityYear":"22"}},"Data":[{"PreferredLanguage":"zh_HK","PurchaseDate":"2022-01-01"}]},"Risks":[{"RiskType":"PA","RiskId":"1","Riskclass":"PA","CoverType":"coherent:HSBC_Home","Risk_Comm":"2022-06-01T09:40:36.940641599Z","RiskBody":{"RiskType":"PA","RiskId":"1","Riskclass":"PA","Plan":"All Risks","CoverType":"coherent:HSBC_Home","Sum_Insured":1000,"InsuredParty":{"Name":"Daniel","GivenName":"","Dob":"1990-01-01","MortalityClass":"S","Gender":"M","Contact":{"Add":{"Add1":" ","Add2":" ","Add3":" ","Add4":"","City":" ","Country":" ","Pcode":"098942"}},"Data":[{"ExtraField1":"Extra Insured Data","ExtraField2":"Extra Insured Data"},{"ExtraField1":"Extra Insured Data","ExtraField2":"Extra Insured Data"}]},"TermUnits":"years","Term":1,"Payment_Frequency":"1","BasePremium":0,"EventDate":"2022-06-01T09:40:36.940641599Z","Risk_Comm":"2022-06-01T09:40:36.940641599Z","Options":[{"Option":"Building","Descr":"Building Cover","Included":"Y","SumInsured":300000},{"Option":"Contents","Descr":"Contents Cover","Included":"Y","SumInsured":15000},{"Option":"AO1","Descr":"Ww Perso Belongings","Included":"Y","SumInsured":10000},{"Option":"AO2","Descr":"Pet Insurance","Included":"N","SumInsured":400},{"Option":"AO3","Descr":"Cyber Protector","Included":"N","SumInsured":500},{"Option":"AO4","Descr":"Bicycle","Included":"N","SumInsured":3000},{"Option":"AO5","Descr":"Ww Family PA","Included":"Y","SumInsured":100},{"Option":"AO6","Descr":"Ww Perso Liability","Included":"Y","SumInsured":1000000}],"Data":[{"ExtraField1":"Extra Risk Body Data","ExtraField2":"Extra Risk Body Data"},{"ExtraField1":"Extra Risk Body Data","ExtraField2":"Extra Risk Body Data"}],"Ratings":[{"RatingFactor":"Endorsement Type","Value":"NB"},{"RatingFactor":"Property Type","Value":"Landed"},{"RatingFactor":"Number of Rooms","Value":">5"},{"RatingFactor":"Occupancy status","Value":"Owner"}]},"Data":[{"ExtraField1":"Extra Risk Data","ExtraField2":"Extra Risk Data"},{"ExtraField1":"Extra Risk Data","ExtraField2":"Extra Risk Data"}]}]}
    })
    .constant('PURCHASE_MIN_BIRTH_DATE', moment().subtract(110, 'y'))
    .constant('PURCHASE_MAX_BIRTH_DATE', moment().subtract(6, 'y'));

})();

(function () {
  'use strict';

  angular
    .module('coherentPaDemo')
    .controller('PurchaseGetStartedController', PurchaseGetStartedController);

  /** @ngInject */
  function PurchaseGetStartedController(PurchaseService,
                                        $stateParams,
                                        configUrls,
                                        environment,
                                        $http,
                                        $state,
                                        AccidentPurchaseService,
                                        TravelPurchaseService) {
    var vm = this;

    vm.showPopup = false;
    vm.QuoteSearchBy = '';
    vm.QuoteSearchVal = '';
    vm.QuoteSearchResult = [];

    vm.text1_1 = 'Product:';
    vm.text1_1_product = 'PA';

    vm.text_folder = 'Folder:';
    vm.folder = 'coherent';

    vm.quote_id = '';

    vm.test = function () {
      PurchaseService.policyConfirmation();
    }

    vm.handleValueChange = function () {
      PurchaseService.setProduct(vm.text1_1_product);
    }

    vm.handleFolderChange = function () {
      PurchaseService.setFolderName(vm.folder);
    }

    vm.handleQuoteIDChange = function () {
      PurchaseService.setQuoteID(vm.quote_id);
    }

    vm.SearchQuote = function () {
      if (!vm.quote_id) {
        alert("Please enter a quote ID");
      }
      var req = {
        method: 'GET',
        url: 'https://enquiry.demo.sonic.dev.coherent.global/v1/quotation/id/' + vm.quote_id,
      };
      
      if (configUrls[environment].isAuthorizationNeeded) {
        req.headers = {
          'authorization': 'Bearer ' + configUrls[environment].token
        }
      }

      $http(req)
        .then(function (response) {
          console.log(response);
          var PolicyData = response.data;
          PurchaseService.setQuoteID(vm.quote_id);
          PurchaseService.setPolicyNumber(vm.quote_id);
          PurchaseService.setQuoteData(PolicyData);

          if (PolicyData.Cont.Risks["1"].RiskBody.RiskType == 'PA') {
            $state.go('purchase-2');
          } else if (PolicyData.Cont.Risks["1"].RiskBody.RiskType == 'Travel') {
            $state.go('travel-purchase-1');
          } else if (PolicyData.Cont.Risks["1"].RiskBody.RiskType == 'HOM') {
            $state.go('home-purchase-1');
          }
        }, function () {
        });

    }

    vm.SearchQuoteList = function () {
      if (vm.QuoteSearchBy == 'ID') {
        vm.quote_id = vm.QuoteSearchVal;
        vm.SearchQuote();
        return false;
      }
      var req = {
        method: 'GET',
        url: 'https://enquiry.demo.sonic.dev.coherent.global/v1/search/quotation/' + vm.QuoteSearchBy + '_ISQUOTATION/' + vm.QuoteSearchVal + '_Y',
      };
      
      if (configUrls[environment].isAuthorizationNeeded) {
        req.headers = {
          'authorization': 'Bearer ' + configUrls[environment].token
        }
      }

      $http(req)
        .then(function (response) {
          var QuoteList = response.data.Data;
          var QuoteListKeys = Object.keys(QuoteList);
          if (QuoteListKeys.length < 1) {
            alert('No Quotation Found !');
            return false;
          }
          angular.forEach(QuoteListKeys, function (QuoteID) {
            var qt = JSON.parse(QuoteList[QuoteID])
            if (qt.QUOTATIONID) {
              vm.QuoteSearchResult.push(qt);
            }
          });
        }, function () {
        });
    }

    vm.goToQuote = function (quoteID) {
        vm.quote_id = quoteID;
        vm.SearchQuote();
        return false;
    }

    function init() {
      TravelPurchaseService.reset();
      AccidentPurchaseService.reset();
      PurchaseService.reset();
      PurchaseService.clear();
      if ($stateParams.agent) {
        PurchaseService.setAgentCode($stateParams.agent)
      }
      if ($stateParams.vid) {
        PurchaseService.setMsgId($stateParams.vid)
      }
      PurchaseService.setProduct(vm.text1_1_product)
    }

    init();
  }
})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .controller('PurchaseEmbeddedController', PurchaseEmbeddedController);

  /** @ngInject */
  function PurchaseEmbeddedController($state, PurchaseService) {
    var vm = this;

    vm.informationTemplate = {
      "Header": {
          "Product": "HSBC_PoC:PA_Demo",
          "Term": 1,
          "CPF": "4-5678-98790-70-7",
          "Email": "mark@email.com",
          "Channel": "Agent",
          "Agent": "10008",
          "StartDate": "2021-07-06T13:23:45.871303Z",
          "PaymentMethod": "CreditCard",
          "Currency": {
            "Code": "INR"
          },
          "PaymentFrequency": 1,
          "PreferredLanguage": "English",
          "InstallmentPremium": 3000.00,
          "PaymentReference": "Ref1283i",
          "Mandate": {
              "MandateRefNo": "764A1234",
              "MandateStatus": "Pending",
              "BankAccount": {
                  "BankName": "",
                  "BankBranch": "",
                  "AccountType": "",
                  "AccountName": "",
                  "AccountNo": "",
                  "OtherRef": ""
              },
              "CreditCard": {
                  "BankRefNum": "",
                  "CardNumber": "",
                  "CardType": "Visa",
                  "ExpiryMonth": "10",
                  "ExpityYear": "0"
              }
          },
          "Owner": {
              "Title": "",
              "Name": "Mark",
              "Givenname": "",
              "Dob": "1993-02-08",
              "Smoker": "",
              "Gender": "M",
              "Nationality": "India",
              "Race": "Indian",
              "Occupation": "",
              "ID": [
                  {
                    "IDType": "",
                    "IDNumber": "",
                    "IssueDate": "",
                    "ExpiryDate": "",
                    "IssuingAgency": ""
                  }
              ],
              "Contact": {
                  "Email": "mark@email.com",
                  "Phone": "  02655597835",
                  "FbId": "",
                  "Typ": "V",
                  "Add": {
                      "Add1": "Sai Vatika, Baranpura Naka, Baranpura",
                      "Add2": "",
                      "Add3": "",
                      "Add4": "",
                      "City": " Vadodara",
                      "Country": "Gujarat, India",
                      "Pcode": "390001"
                  }
              }
          },
          "OldPolicyID": "",
          "Data": [
              {
                  "ExtraField1": "Extra Policy Data",
                  "ExtraField2": "Extra Policy Data"
              }
          ]
      },
      "Risks": [
          {
              "RiskType": "PA",
              "RiskId": "1",
              "Riskclass": "PA",
              "CoverType": "HSBC_PoC:PA_Demo",
              "Risk_Comm": "2021-07-06T13:23:45.871303Z",
              "RiskBody": {
                  "RiskType": "PA",
                  "RiskId": "1",
                  "Riskclass": "PA",
                  "Plan": "Plan_1",
                  "CoverType": "HSBC_PoC:PA_Demo",
                  "Sum_Insured": 1000,
                  "InsuredParty": {
                      "Name": "Miyoshi",
                      "GivenName": "",
                      "Dob": "1993-02-08",
                      "Age": 28,
                      "Gender": "M",
                      "Kinship": "N/A",
                      "Id": {
                        "IDType": "",
                        "IDNumber": "",
                        "IssueDate": "",
                        "ExpiryDate": "",
                        "IssuingAgency": ""
                      },
                      "Documents": [
                          {
                              "Url": "",
                              "Descr": "Cycle Photo",
                              "AttachDate": "2021-07-06T13:23:45.871303Z",
                              "AttachNote": {
                                  "Dte": "2021-07-06T13:23:45.871303Z",
                                  "User": "Hello",
                                  "Text": "Cycle Photo"
                              }
                          }
                      ],
                      "Occupation": "",
                      "Contact": {
                          "Email": "mark@email.com",
                          "Phone": "  02655597835",
                          "FbId": "",
                          "Add": {
                              "Add1": "Sai Vatika, Baranpura Naka, Baranpura",
                              "Add2": "",
                              "Add3": "",
                              "Add4": "",
                              "City": "Vadodara",
                              "Country": "  Gujarat, India",
                              "Pcode": "  390001"
                          }
                      },
                      "Data": [
                          {
                              "ExtraField1": "Extra Insured Data",
                              "ExtraField2": "Extra Insured Data"
                          }
                      ]
                  },
                  "Options": [
                      {
                          "Option": "Insured_1",
                          "Included": "Y"
                      }
                  ],
                  "Term": 1,
                  "TermUnits": "years",
                  "Region": "Asia",
                  "Channel": "Agent_2",
                  "Payment_Frequency": "1",
                  "BasePremium": 0,
                  "EventDate": "2021-07-06T13:23:45.871303Z",
                  "Risk_Comm": "2021-07-06T13:23:45.871303Z",
                  "Data": [
                      {
                          "ExtraField1": "Extra Risk Body Data",
                          "ExtraField2": "Extra Risk Body Data"
                      },
                      {
                          "ExtraField1": "Extra Risk Body Data",
                          "ExtraField2": "Extra Risk Body Data"
                      }
                  ],
                  "Ratings": [
                      {
                          "RatingFactor": "RakutenPoints",
                          "Value": "0"
                      }
                  ]
              },
              "Data": [
                  {
                      "Insured_Dob": "04-April-2021",
                      "Header_Risk_Comm": "06-July-2021",
                      "Header_EndDate": "06-July-2022"
                  },
                  {
                      "ExtraField1": "Extra Risk Data",
                      "ExtraField2": "Extra Risk Data"
                  }
              ]
          }
      ]
    }

    // vm.information = {};

    // vm.text1 = 'Full Name';
    // vm.placeholder1 = 'Your Full Name';

    // vm.text2 = 'Birth Date';
    // vm.placeholder2 = '1980 / 01 / 01';

    // vm.calendarFormat = 'yyyy / MM / dd';

    // vm.datepickerOptions = {
    //   showWeeks: false
    // };

    // vm.text3 = 'Gender';
    // vm.btn1 = 'Female';
    // vm.btn2 = 'Male';

    // vm.text4 = 'Japan Postal Code';
    // vm.placeholder3 = 'XXXX';
    // vm.placeholder4 = 'XXXX';

    // vm.text5 = 'Address';
    // vm.placeholder5 = 'Address';

    // vm.text6 = 'Primary Email';
    // vm.placeholder6 = 'Your main email address';
    // vm.text7 = 'Alternate Email';
    // vm.placeholder7 = 'Another email address';

    // vm.text8 = 'Contact number';
    // vm.placeholder8 = '+XXX XXXX';

    // vm.text9 = 'Alternate contact number';
    // vm.text10 = '(Optional)';
    // vm.placeholder9 = 'Another contact number';

    // vm.text11 = 'Would you like to receive emails from Coherent?';
    // vm.checkBox1 = 'Yes, subscribe me to the mailing list.';

    // vm.btn3 = 'Next';

    // vm.text1 = '氏名';
    // vm.placeholder1 = 'あなたの氏名';

    // vm.text2 = '生年月日';
    // vm.placeholder2 = '年 / 月 / 日';

    // vm.calendarFormat = 'yyyy / MM / dd';

    // vm.datepickerOptions = {
    //   showWeeks: false
    // };

    // vm.text3 = '性別';
    // vm.btn1 = '女性';
    // vm.btn2 = '男性';

    // vm.text4 = '郵便番号';
    // vm.placeholder3 = 'XXX';
    // vm.placeholder4 = 'XXXX';

    // vm.text5 = '住所';
    // vm.placeholder5 = '住所';

    // vm.text6 = 'メールアドレス1';
    // vm.placeholder6 = 'メインのメールアドレス';
    // vm.text7 = 'メールアドレス2（任意）';
    // vm.placeholder7 = 'メールアドレス1と異なるメールアドレス';

    // vm.text8 = '連絡先1';
    // vm.placeholder8 = '携帯電話番号を入力ください';

    // vm.text9 = '連絡先2';
    // vm.text10 = '（任意）';
    // vm.placeholder9 = '連絡先1と異なる連絡先';

    // vm.text11 = '当社からのメール案内を希望しますか？';
    // vm.checkBox1 = 'はい';

    // vm.btn3 = '次へ';

    vm.proceed = function () {
      vm.informationTemplate.Header.Owner.Name = vm.information.name;
      vm.informationTemplate.Header.Owner.Dob = moment(vm.information.birthDate).format("YYYY-MM-DD")
      vm.informationTemplate.Header.Owner.Gender = vm.information.gender;
      vm.informationTemplate.Header.Owner.Contact.Add.Pcode = vm.information.postalCode1 + vm.information.postalCode2;
      vm.informationTemplate.Header.Owner.Contact.Add.Add1 = vm.information.address
      vm.informationTemplate.Header.Owner.Contact.Email = vm.information.email
      vm.informationTemplate.Header.Owner.Contact.Phone = vm.information.contact
      vm.informationTemplate.Risks[0].RiskBody.Plan = 'Plan_' + PurchaseService.planType.id
      vm.informationTemplate.Header.StartDate = PurchaseService.insuranceDate + 'T13:23:45.871303Z'
      vm.informationTemplate.Risks[0].Risk_Comm = PurchaseService.insuranceDate + 'T13:23:45.871303Z'
      vm.informationTemplate.Risks[0].RiskBody.Risk_Comm = PurchaseService.insuranceDate + 'T13:23:45.871303Z'
      vm.informationTemplate.Header.InstallmentPremium = parseInt(PurchaseService.planType.heading.price.replace(/,/g, ''), 10)
      vm.informationTemplate.Header.Agent = PurchaseService.AgentCode
      vm.informationTemplate.Header.Owner.Contact.FbId = PurchaseService.MsgId
      PurchaseService.setInformation1(vm.informationTemplate);

      $state.go('purchase-91');
    };

    function init() {
      if(PurchaseService.signIn) {
        vm.information.name = "Mark Banaria"
        vm.information.birthDate = moment("1980-10-10")
        vm.information.gender = vm.btn2
        vm.information.postalCode1 = '272'
        vm.information.postalCode2 = '3321'
        vm.information.address = '12 Dove Street'
        vm.information.email = 'mark@email.com'
        vm.information.contact = '+1291261111'
      }
      if(!_.isEmpty(PurchaseService.information1)) {
        vm.information = PurchaseService.information1;
      } else if(!PurchaseService.planType) {
        $state.go('purchase-1');
      }
    }

    init();
  }
})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .controller('Purchase9Controller', Purchase9Controller);

  /** @ngInject */
  function Purchase9Controller(
                            $state,
                            PurchaseService,
                            ACCIDENT_TYPE,
                            TRAVEL_TYPE,
                            HOME_TYPE,
                            PurchaseFactory
                            ) {
    var vm = this;

    // "coherent:PA_Demo"
    vm.informationTemplate = {
      "Header": {
          "Product": "HSBC_PoC:PA_Demo",
          "Term": 1,
          "CPF": "4-5678-98790-70-7",
          "Email": "miyoshi@example.com",
          "Channel": "Agent_2",
          "Agent": "10001",
          "StartDate": "2021-07-06T13:23:45.871303Z",
          "PaymentMethod": "CreditCard",
          "Currency": {
            "Code": "JPY"
          },
          "PaymentFrequency": 1,
          "PreferredLanguage": "English",
          "InstallmentPremium": 3000.00,
          "PaymentReference": "Ref1283i",
          "Mandate": {
              "MandateRefNo": "764A1234",
              "MandateStatus": "Pending",
              "BankAccount": {
                  "BankName": "",
                  "BankBranch": "",
                  "AccountType": "",
                  "AccountName": "",
                  "AccountNo": "",
                  "OtherRef": ""
              },
              "CreditCard": {
                  "BankRefNum": "",
                  "CardNumber": "",
                  "CardType": "Visa",
                  "ExpiryMonth": "10",
                  "ExpityYear": "0"
              }
          },
          "Owner": {
              "Title": "",
              "Name": "Miyoshi",
              "Givenname": "",
              "Dob": "1993-02-08",
              "Smoker": "",
              "Gender": "M",
              "Nationality": "",
              "Race": "",
              "Occupation": "",
              "ID": [
                  {
                    "IDType": "",
                    "IDNumber": "",
                    "IssueDate": "",
                    "ExpiryDate": "",
                    "IssuingAgency": ""
                  }
              ],
              "Contact": {
                  "Email": "miyoshi@example.com",
                  "Phone": "(25)-3444-3534",
                  "FbId": "",
                  "Typ": "V",
                  "Add": {
                      "Add1": "",
                      "Add2": "",
                      "Add3": "",
                      "Add4": "",
                      "City": "",
                      "Country": "Japan",
                      "Pcode": "024-0321"
                  }
              }
          },
          "OldPolicyID": "",
          "Data": [
              {
                  "ExtraField1": "Extra Policy Data",
                  "ExtraField2": "Extra Policy Data"
              }
          ]
      },
      "Risks": [
          {
              "RiskType": "PA",
              "RiskId": "1",
              "Riskclass": "PA",
              "CoverType": "HSBC_PoC:PA_Demo",
              "Risk_Comm": "2021-07-06T13:23:45.871303Z",
              "RiskBody": {
                  "RiskType": "PA",
                  "RiskId": "1",
                  "Riskclass": "PA",
                  "Plan": "Plan_1",
                  "CoverType": "HSBC_PoC:PA_Demo",
                  "Sum_Insured": 1000,
                  "InsuredParty": {
                      "Name": "Miyoshi",
                      "GivenName": "",
                      "Dob": "1993-02-08",
                      "Age": 28,
                      "Gender": "M",
                      "Kinship": "N/A",
                      "Id": {
                        "IDType": "",
                        "IDNumber": "",
                        "IssueDate": "",
                        "ExpiryDate": "",
                        "IssuingAgency": ""
                      },
                      "Documents": [
                          {
                              "Url": "",
                              "Descr": "Cycle Photo",
                              "AttachDate": "2021-07-06T13:23:45.871303Z",
                              "AttachNote": {
                                  "Dte": "2021-07-06T13:23:45.871303Z",
                                  "User": "Hello",
                                  "Text": "Cycle Photo"
                              }
                          }
                      ],
                      "Occupation": "",
                      "Contact": {
                          "Email": "miyoshi@example.com",
                          "Phone": "+8162-658-9795",
                          "FbId": "",
                          "Add": {
                              "Add1": "イワテケン",
                              "Add2": "キタカミシ",
                              "Add3": "ワガチョウイワサキ",
                              "Add4": "",
                              "City": "",
                              "Country": "India",
                              "Pcode": "024-0321"
                          }
                      },
                      "Data": [
                          {
                              "ExtraField1": "Extra Insured Data",
                              "ExtraField2": "Extra Insured Data"
                          }
                      ]
                  },
                  "Options": [
                      {
                          "Option": "Insured_1",
                          "Included": "Y"
                      }
                  ],
                  "Term": 1,
                  "TermUnits": "years",
                  "Region": "Asia",
                  "Channel": "Agent_2",
                  "Payment_Frequency": "1",
                  "BasePremium": 0,
                  "EventDate": "2021-07-06T13:23:45.871303Z",
                  "Risk_Comm": "2021-07-06T13:23:45.871303Z",
                  "Data": [
                      {
                          "ExtraField1": "Extra Risk Body Data",
                          "ExtraField2": "Extra Risk Body Data"
                      },
                      {
                          "ExtraField1": "Extra Risk Body Data",
                          "ExtraField2": "Extra Risk Body Data"
                      }
                  ],
                  "Ratings": [
                      {
                          "RatingFactor": "RakutenPoints",
                          "Value": "0"
                      }
                  ]
              },
              "Data": [
                  {
                      "Insured_Dob": "04-April-2021",
                      "Header_Risk_Comm": "06-July-2021",
                      "Header_EndDate": "06-July-2022"
                  },
                  {
                      "ExtraField1": "Extra Risk Data",
                      "ExtraField2": "Extra Risk Data"
                  }
              ]
          }
      ]
    }

    vm.information = {};

    // vm.text1 = 'Full Name';
    // vm.placeholder1 = 'Your Full Name';

    // vm.text2 = 'Birth Date';
    // vm.placeholder2 = '1980 / 01 / 01';

    // vm.calendarFormat = 'yyyy / MM / dd';

    // vm.datepickerOptions = {
    //   showWeeks: false
    // };

    // vm.text3 = 'Gender';
    vm.btn1 = 'F';
    vm.btn2 = 'M';

    // vm.text4 = 'Japan Postal Code';
    // vm.placeholder3 = 'XXXX';
    // vm.placeholder4 = 'XXXX';

    // vm.text5 = 'Address';
    // vm.placeholder5 = 'Address';

    // vm.text6 = 'Primary Email';
    // vm.placeholder6 = 'Your main email address';
    // vm.text7 = 'Alternate Email';
    // vm.placeholder7 = 'Another email address';

    // vm.text8 = 'Contact number';
    // vm.placeholder8 = '+XXX XXXX';

    // vm.text9 = 'Alternate contact number';
    // vm.text10 = '(Optional)';
    // vm.placeholder9 = 'Another contact number';

    // vm.text11 = 'Would you like to receive emails from Coherent?';
    // vm.checkBox1 = 'Yes, subscribe me to the mailing list.';

    // vm.btn3 = 'Next';

    vm.text1 = '氏名';
    vm.placeholder1 = 'あなたの氏名';

    vm.text2 = '生年月日';
    vm.placeholder2 = '1980 / 10 / 10';

    vm.calendarFormat = 'yyyy / MM / dd';

    vm.datepickerOptions = {
      showWeeks: false,
      initDate: moment("1980-10-10")
    };
    vm.information.birthDate = moment("1980-10-10")

    vm.text3 = '性別';
    // vm.btn1 = '女性';
    // vm.btn2 = '男性';

    vm.text4 = '郵便番号';
    vm.placeholder3 = 'XXX';
    vm.placeholder4 = 'XXXX';

    vm.text5 = '住所';
    vm.placeholder5 = '住所';

    vm.text6 = 'メールアドレス1';
    vm.placeholder6 = 'メインのメールアドレス';
    vm.text7 = 'メールアドレス2（任意）';
    vm.placeholder7 = 'メールアドレス1と異なるメールアドレス';

    vm.text8 = '連絡先1';
    vm.placeholder8 = '携帯電話番号を入力ください';

    vm.text9 = '連絡先2';
    vm.text10 = '（任意）';
    vm.placeholder9 = '連絡先1と異なる連絡先';

    vm.text11 = '当社からのメール案内を希望しますか？';
    vm.checkBox1 = 'はい';

    vm.btn3 = '次へ';

    vm.isSmoker = false;
    vm.PFInput = {};
    vm.UWQuestionsList = [];
    vm.RatingFactorsList = [];
    vm.PFPayload = PurchaseService.SparkTemplate;

    function getUWQuestions(PFInput) {
        PurchaseFactory.token().then( function(token) {
          vm.planCategory = PurchaseService.planCategory;
          vm.planType = PurchaseService.planType;
         
          PFInput = PFInput ? PFInput : {};
          
          PurchaseFactory.get(PurchaseService.ProductCode, PurchaseService.FolderName, angular.toJson(PFInput), token).then(function (response) {
            console.log(response);
            if (JSON.stringify(vm.PFInput) === "{}") {
                vm.PFInput = response.data.data.Inputs;
                vm.UWQuestionsList = response.data.data.Outputs.UWSurveyQuestion;
                angular.forEach(vm.UWQuestionsList, function (ques) {
                    debugger;
                    if (ques.UWSurveyQuestion === 'Occupation Consideration') {
                        ques.Flag = PurchaseService.SelectedOccupation;
                    } else if (ques.UWSurveyQuestion !== 'Pre Existing Disease' && ques.UWSurveyQuestion !== 'Smoking Profile' && !ques.UWSurveyCode.includes('Term_UW_7_'))  {
                        ques.Flag = '';
                    } else {
                        ques.Flag = false;
                    }
                    
                });
                console.log(vm.UWQuestionsList);
            } else {
                var newUWQuestionsList = response.data.data.Outputs.UWSurveyQuestion;
                var tempList = [];
                angular.forEach(newUWQuestionsList, function(nq) {
                    if (nq.UWSurveyCode.includes('Term_UW_7_')) {
                        nq.Flag = false;
                    }
                    angular.forEach(vm.UWQuestionsList, function (ques) {
                        if (nq.UWSurveyQuestion === ques.UWSurveyQuestion) {
                            nq.Flag = ques.Flag;
                        }
                    });
                    tempList.push(nq);
                });
                vm.UWQuestionsList = tempList;
                console.log(vm.UWQuestionsList);
            }
            
          });
        });
    }

    vm.checkDisease = function(index, flag, desc) {
        console.log(index, flag);
        if (desc === "Smoking Profile") {
            vm.isSmoker = flag;
        }
        // if (flag === true) {
            var Ratings = [];
            angular.forEach(vm.UWQuestionsList, function (ques) {
                debugger;
                var flagValue = ques.Flag;
                if (ques.Flag === true) {
                    flagValue = 'Y';
                } else if (ques.Flag === false) {
                    flagValue = 'N';
                }
                Ratings.push({
                    "RatingFactor": ques.UWSurveyQuestion,
                    "Value": flagValue
                })
            });
            debugger;
            vm.RatingFactorsList = Ratings;
            vm.PFInput.Ratings = Ratings;
            vm.PFPayload.Inputs = vm.PFInput;
            vm.PFPayload.TransactionDate = (new Date()).toISOString();
            getUWQuestions(vm.PFPayload);
        // }
    }

    vm.setUWValues = function(val, index) {
        // console.log("this is ", value, index);
        if (vm.UWQuestionsList[index].Flag === true) {
            vm.UWQuestionsList[index].Flag = 'Y';
        } else if (vm.UWQuestionsList[index].Flag === false) {
            vm.UWQuestionsList[index].Flag = 'N';
        }
    }

    vm.proceed = function () {
        console.log(TRAVEL_TYPE);
        console.log(HOME_TYPE);
        if(PurchaseService.policy.type === TRAVEL_TYPE || PurchaseService.policy.type === HOME_TYPE) {
            PurchaseService.policy.name = vm.information.name;
            PurchaseService.policy.birthDate = moment(vm.information.birthDate).format("YYYY-MM-DD")
            PurchaseService.policy.gender = vm.information.gender;
            PurchaseService.policy.postalCode1 = vm.information.postalCode1;
            // PurchaseService.policy.postalCode2 = vm.ui.postalCode2;
            PurchaseService.policy.Country = vm.information.country;
            PurchaseService.policy.Nationality = vm.information.country;
            PurchaseService.policy.Add1 = vm.information.add1;
            PurchaseService.policy.Add2 = vm.information.add2;
            PurchaseService.policy.City = vm.information.city;
            PurchaseService.policy.Email = vm.information.email;
            PurchaseService.policy.Phone = vm.information.contact;

            PurchaseService.policy.address = vm.information.add1 + ', ' + vm.information.add2 + ', ' + vm.information.city;
            PurchaseService.policy.alternateEmail = vm.information.email;
            PurchaseService.policy.contact = vm.information.contact;
            // PurchaseService.policy.alternateContact = vm.ui.alternateContact;
        } else {
            vm.informationTemplate.Header.Product = PurchaseService.FolderName + ':' + PurchaseService.ProductCode;
            vm.informationTemplate.Risks[0].CoverType = PurchaseService.FolderName + ':' + PurchaseService.ProductCode;
            vm.informationTemplate.Risks[0].RiskBody.CoverType = PurchaseService.FolderName + ':' + PurchaseService.ProductCode;
            vm.informationTemplate.Risks[0].RiskBody.Plan = 'Plan' + PurchaseService.planType.id;
            vm.informationTemplate.Header.StartDate = PurchaseService.insuranceDate + 'T13:23:45.871303Z';
            vm.informationTemplate.Risks[0].Risk_Comm = PurchaseService.insuranceDate + 'T13:23:45.871303Z';
            vm.informationTemplate.Risks[0].RiskBody.Risk_Comm = PurchaseService.insuranceDate + 'T13:23:45.871303Z';
            vm.informationTemplate.Header.InstallmentPremium = parseInt(PurchaseService.planType.heading.price.toString().replace(/,/g, ''), 10);
            vm.informationTemplate.Header.Agent = (PurchaseService.AgentCode) ? PurchaseService.AgentCode : '10001';
            vm.informationTemplate.Header.Owner.Contact.FbId = PurchaseService.MsgId;
        }
        vm.informationTemplate.Header.Owner.Name = vm.information.name;
        vm.informationTemplate.Header.Owner.Dob = moment(vm.information.birthDate).format("YYYY-MM-DD");
        vm.informationTemplate.Header.Owner.Gender = vm.information.gender;
        vm.informationTemplate.Header.Owner.Contact.Add.Pcode = vm.information.postalCode1;
        vm.informationTemplate.Header.Owner.Contact.Add.Country = vm.information.country;
        vm.informationTemplate.Header.Owner.Nationality = vm.information.country;
        vm.informationTemplate.Header.Owner.Contact.Add.Add1 = vm.information.add1;
        vm.informationTemplate.Header.Owner.Contact.Add.Add2 = vm.information.add2;
        vm.informationTemplate.Header.Owner.Contact.Add.City = vm.information.city;
        vm.informationTemplate.Header.Owner.Contact.Email = vm.information.email;
        vm.informationTemplate.Header.Owner.Contact.Phone = vm.information.contact;
        vm.informationTemplate.Risks[0].RiskBody.InsuredParty.MortalityClass = vm.isSmoker ? 'S' : 'N';
        
        PurchaseService.setInformation1(vm.informationTemplate);
        PurchaseService.setRatingFactors(vm.RatingFactorsList);

        if (PurchaseService.policy.type === HOME_TYPE) {
          vm.informationTemplate.Risks[0].RiskBody.InsuredParty.Name = vm.informationTemplate.Header.Owner.Name
          vm.informationTemplate.Risks[0].RiskBody.InsuredParty.Dob = moment(vm.informationTemplate.Header.Owner.Dob).format("YYYY-MM-DD")
          vm.informationTemplate.Risks[0].RiskBody.InsuredParty.Gender = vm.informationTemplate.Header.Owner.Gender
          PurchaseService.setInformation2(vm.informationTemplate)
          $state.go('purchase-11')
        } else {
            $state.go('purchase-10')
        }
        
    };

    function init() {

        if(!PurchaseService.planType) {
            $state.go('purchase-1');
        }

        vm.information.name = ""; // Taro Yamada
        vm.information.birthDate = ""; // moment("1980-10-10").toDate();
        vm.information.gender = vm.btn2;
        vm.information.postalCode1 = ''; // '2723321';
        vm.information.postalCode2 = ''; // '272';
        vm.information.country = ''; // 'Japan';
        vm.information.add1 = ''; // 'Yoyogi 1-1-1';
        vm.information.add2 = ''; // 'Shibuya';
        vm.information.city = ''; // 'Tokyo';
        vm.information.email = ''; // 'yamadataro@email.com';
        vm.information.contact = ''; // '08012341234';

        if (PurchaseService.isQuoteData()) {
            var QuoteData = PurchaseService.QuoteData;
            vm.information.name = PurchaseService.isQuoteData() ? QuoteData.Cont.Owner.Name : ""; // Taro Yamada
            vm.information.birthDate = PurchaseService.isQuoteData() ? moment(QuoteData.Cont.Owner.Dob).toDate() : moment("").toDate(); // 1980-10-10
            vm.information.gender = PurchaseService.isQuoteData() ? QuoteData.Cont.Owner.Gender : vm.btn2;
            vm.information.postalCode1 = PurchaseService.isQuoteData() ? QuoteData.Cont.Owner.Contact.Add.Pcode : ''; // 2723321
            vm.information.postalCode2 = '272';
            vm.information.country = PurchaseService.isQuoteData() ? QuoteData.Cont.Owner.Contact.Add.Country : ''; // Japan
            vm.information.add1 = PurchaseService.isQuoteData() ? QuoteData.Cont.Owner.Contact.Add.Add1 : ''; // Yoyogi 1-1-1
            vm.information.add2 = PurchaseService.isQuoteData() ? QuoteData.Cont.Owner.Contact.Add.Add2 : ''; // Shibuya
            vm.information.city = PurchaseService.isQuoteData() ? QuoteData.Cont.Owner.Contact.Add.City : ''; // Tokyo
            vm.information.email = PurchaseService.isQuoteData() ? QuoteData.Cont.Owner.Contact.Email : ''; // yamadataro@email.com
            vm.information.contact = PurchaseService.isQuoteData() ? QuoteData.Cont.Owner.Contact.Phone : ''; // 08012341234
        } else if(!_.isEmpty(PurchaseService.information1) && !_.isEmpty(PurchaseService.information1.Header)) {
            // vm.information = PurchaseService.information1;
            var HeaderInfo = PurchaseService.information1.Header;
            
            vm.information.name = HeaderInfo.Owner.Name;
            vm.information.birthDate = moment(HeaderInfo.Owner.Dob).toDate();
            vm.information.gender = HeaderInfo.Owner.Gender;
            vm.information.postalCode1 = HeaderInfo.Owner.Contact.Add.Pcode;
            vm.information.country = HeaderInfo.Owner.Contact.Add.Country;
            vm.information.add1 = HeaderInfo.Owner.Contact.Add.Add1;
            vm.information.add2 = HeaderInfo.Owner.Contact.Add.Add2;
            vm.information.city = HeaderInfo.Owner.Contact.Add.City;
            vm.information.email = HeaderInfo.Owner.Contact.Email;
            vm.information.contact = HeaderInfo.Owner.Contact.Phone;
        }
        getUWQuestions();
    }

    init();
  }
})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .controller('Purchase92Controller', Purchase92Controller);

  /** @ngInject */
  function Purchase92Controller() {
    var vm = this;

    vm.title = '重要事項説明書をご確認ください';
    vm.btn1 = '重要事項説明書を確認する';

    vm.cb1 = '重要事項説明書に同意します';
    vm.btn2 = '次へ';


  }
})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .controller('Purchase91Controller', Purchase91Controller);

  /** @ngInject */
  function Purchase91Controller() {
    var vm = this;

    // vm.text1 = 'This is a particularly important matter that we ask when making a contract. Please note that you may not be able to pay the insurance if the answer you answered is not true.';
    // vm.title = 'Please check all that apply';
    // vm.cb1 = 'For all insured persons who are to receive compensation, please confirm that the amount of death / residual disability insurance and daily amount of hospitalization insurance are within the range of the table below (meaning accident insurance, accident illness insurance, mutual aid insurance, etc. Both include funded insurance.)'

    vm.panel1 = {};
    vm.panel2 = {};

    // vm.panel1.title = 'Insured is below 15 years old'

    // vm.panel1.text1 = 'Daily hospitalization insurance'
    // vm.panel1.text2 = 'The following cases:'
    // vm.panel1.text3 = 'Policy owner and insured differ'
    // vm.panel1.text4 = 'Those in a Family-type contract '
    // vm.panel1.text5 = 'who are no the insured person'
    // vm.panel1.text6 = 'Cases described below'

    // vm.panel1.price1 = '10,000'
    // vm.panel1.price2 = ''
    // vm.panel1.price3 = '500 per day'
    // vm.panel1.price4 = ''
    // vm.panel1.price5 = ''
    // vm.panel1.price6 = '500,000'

    vm.check1 = ''
    vm.check2 = ''
    vm.check3 = ''
    vm.check4 = ''
    vm.check5 = ''
    vm.check6 = ''

    vm.cb2 = 'Is the contractor (applicant) an individual who is 18 years of age or older, lives in the country, and is accessing this site from within the country?'
    vm.cb3 = 'If you are applying for the first time at our company, have you claimed or received insurance money (total of 50,000 yen or more) due to injury within the past 3 years (including other insurance companies)? '
    vm.cb4 = 'If the contractor (applicant) and the insured person is different, does the insured person agree to become the insured person of this insurance?'
    vm.cb5 = " Does the insured person's occupation not fall under any of the following?"

    vm.cb6 = 'I hereby confirm that the information provided above is accurate, correct, and complete.'

    vm.btn3 = 'Next'

    // vm.panel1 = {};
    // vm.panel2 = {};

    // vm.panel1.title = '15才未満の場合'

    // vm.panel1.text1 = '入院保険金日額'
    // vm.panel1.text2 = '死亡・後遺障害保険金額'
    // vm.panel1.text3 = '次のいずれかの場合'
    // vm.panel1.text4 = '契約者と被保険者（本人）が異なる場合'
    // vm.panel1.text5 = '家族型契約の被保険者（本人）以外'
    // vm.panel1.text6 = '上記以外の場合'

    // vm.panel1.price1 = '10,000円'
    // vm.panel1.price2 = ''
    // vm.panel1.price3 = '500万円'
    // vm.panel1.price4 = ''
    // vm.panel1.price5 = ''
    // vm.panel1.price6 = '500万円'

    // vm.cb2 = '保険契約者（お申込人）は現時点で満18才以上の個人で、日本国内に在住し、本サイトに日本国内からアクセスしていますか？'
    // vm.cb3 = '当社にてはじめてお申込みいただく場合、過去３年以内にケガで保険金（合計５万円以上）を請求または受領していないですか？（注）他の保険会社等への保険金請求を含みます。'
    // vm.cb4 = '保険契約者（お申込人）と被保険者（本人）が異なる場合、この保険の被保険者（本人）になることについて被保険者（本人）の同意がありますか？'
    // vm.cb5 = '被保険者（本人）の職業が、以下に該当していませんか？ 自転車競争選手（競輪選手）、その他自転車を用いて競技等に出場する職業'

    // vm.cb6 = '私は、上記の情報が正確で、正しく、完全であることをここに確認します。'

    // vm.btn3 = '次へ'

  }
})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .controller('Purchase8Controller', Purchase8Controller);

  /** @ngInject */
  function Purchase8Controller($state, PurchaseService, PurchaseFactory) {
    var vm = this;

    // vm.btn1 = 'ログイン';

    // vm.signIn = function () {
    //   $state.go('purchase-9');
    // };

    // vm.text2 = 'or';

    // vm.btn2 = 'Sign in with Google';
    // vm.btn3 = 'Continue as John';
    // vm.btn4 = 'Sign in with Apple';
    vm.ui = {};
    vm.ui.email = 'mark@email.com'

    vm.signIn = function () {
      PurchaseFactory.signIn(500).then(function (data) {
        PurchaseService.signedIn = true;

        PurchaseService.policy.email = vm.ui.email;

        PurchaseService.policy.name = data.name;
        PurchaseService.policy.birthDate = data.birthDate;
        PurchaseService.policy.gender = data.gender;
        PurchaseService.policy.postalCode1 = data.postalCode1;
        PurchaseService.policy.postalCode2 = data.postalCode2;
        PurchaseService.policy.address = data.address;
        PurchaseService.policy.contact = data.contact;
        
        PurchaseService.setSignIn(true)
        // $state.go('products');
        $state.go('purchase-get-started')
      });
    };

    vm.text2 = 'or';

    vm.email = "yamadataro@email.com";
    vm.password = "abc";

    vm.btn2 = 'Sign in with Google';
    vm.btn3 = 'Continue as John';
    vm.btn4 = 'Sign in with Apple';

    function init() {
      if(PurchaseService.email) {
        vm.email = PurchaseService.email;
      } else if(!PurchaseService.planType) {
        $state.go('purchase-1');
      }
    }

    init();
  }
})();

(function() {
  'use strict';

  var PFInput = {
    "Inputs": {
      "Channel": "Agent_2",
      "ClaimAmount": [
        {
          "Benefit": "A2",
          "Amount": 7878,
          "EventStart": null,
          "EventDate": null,
          "Claimant": null
        },
        {
          "Benefit": null,
          "Amount": null,
          "EventStart": null,
          "EventDate": null,
          "Claimant": null
        },
        {
          "Benefit": null,
          "Amount": null,
          "EventStart": null,
          "EventDate": null,
          "Claimant": null
        },
        {
          "Benefit": null,
          "Amount": null,
          "EventStart": null,
          "EventDate": null,
          "Claimant": null
        },
        {
          "Benefit": null,
          "Amount": null,
          "EventStart": null,
          "EventDate": null,
          "Claimant": null
        },
        {
          "Benefit": null,
          "Amount": null,
          "EventStart": null,
          "EventDate": null,
          "Claimant": null
        },
        {
          "Benefit": null,
          "Amount": null,
          "EventStart": null,
          "EventDate": null,
          "Claimant": null
        },
        {
          "Benefit": null,
          "Amount": null,
          "EventStart": null,
          "EventDate": null,
          "Claimant": null
        },
        {
          "Benefit": null,
          "Amount": null,
          "EventStart": null,
          "EventDate": null,
          "Claimant": null
        },
        {
          "Benefit": null,
          "Amount": null,
          "EventStart": null,
          "EventDate": null,
          "Claimant": null
        },
        {
          "Benefit": null,
          "Amount": null,
          "EventStart": null,
          "EventDate": null,
          "Claimant": null
        },
        {
          "Benefit": null,
          "Amount": null,
          "EventStart": null,
          "EventDate": null,
          "Claimant": null
        },
        {
          "Benefit": null,
          "Amount": null,
          "EventStart": null,
          "EventDate": null,
          "Claimant": null
        },
        {
          "Benefit": null,
          "Amount": null,
          "EventStart": null,
          "EventDate": null,
          "Claimant": null
        },
        {
          "Benefit": null,
          "Amount": null,
          "EventStart": null,
          "EventDate": null,
          "Claimant": null
        },
        {
          "Benefit": null,
          "Amount": null,
          "EventStart": null,
          "EventDate": null,
          "Claimant": null
        },
        {
          "Benefit": null,
          "Amount": null,
          "EventStart": null,
          "EventDate": null,
          "Claimant": null
        },
        {
          "Benefit": null,
          "Amount": null,
          "EventStart": null,
          "EventDate": null,
          "Claimant": null
        },
        {
          "Benefit": null,
          "Amount": null,
          "EventStart": null,
          "EventDate": null,
          "Claimant": null
        },
        {
          "Benefit": null,
          "Amount": null,
          "EventStart": null,
          "EventDate": null,
          "Claimant": null
        }
      ],
      "ClaimHistory": [
        {
          "BenefitClaimed": null,
          "ClaimDate": null,
          "Amount": null,
          "Claimant": null
        },
        {
          "BenefitClaimed": null,
          "ClaimDate": null,
          "Amount": null,
          "Claimant": null
        },
        {
          "BenefitClaimed": null,
          "ClaimDate": null,
          "Amount": null,
          "Claimant": null
        },
        {
          "BenefitClaimed": null,
          "ClaimDate": null,
          "Amount": null,
          "Claimant": null
        },
        {
          "BenefitClaimed": null,
          "ClaimDate": null,
          "Amount": null,
          "Claimant": null
        },
        {
          "BenefitClaimed": null,
          "ClaimDate": null,
          "Amount": null,
          "Claimant": null
        },
        {
          "BenefitClaimed": null,
          "ClaimDate": null,
          "Amount": null,
          "Claimant": null
        },
        {
          "BenefitClaimed": null,
          "ClaimDate": null,
          "Amount": null,
          "Claimant": null
        },
        {
          "BenefitClaimed": null,
          "ClaimDate": null,
          "Amount": null,
          "Claimant": null
        },
        {
          "BenefitClaimed": null,
          "ClaimDate": null,
          "Amount": null,
          "Claimant": null
        },
        {
          "BenefitClaimed": null,
          "ClaimDate": null,
          "Amount": null,
          "Claimant": null
        },
        {
          "BenefitClaimed": null,
          "ClaimDate": null,
          "Amount": null,
          "Claimant": null
        },
        {
          "BenefitClaimed": null,
          "ClaimDate": null,
          "Amount": null,
          "Claimant": null
        },
        {
          "BenefitClaimed": null,
          "ClaimDate": null,
          "Amount": null,
          "Claimant": null
        },
        {
          "BenefitClaimed": null,
          "ClaimDate": null,
          "Amount": null,
          "Claimant": null
        },
        {
          "BenefitClaimed": null,
          "ClaimDate": null,
          "Amount": null,
          "Claimant": null
        },
        {
          "BenefitClaimed": null,
          "ClaimDate": null,
          "Amount": null,
          "Claimant": null
        },
        {
          "BenefitClaimed": null,
          "ClaimDate": null,
          "Amount": null,
          "Claimant": null
        },
        {
          "BenefitClaimed": null,
          "ClaimDate": null,
          "Amount": null,
          "Claimant": null
        },
        {
          "BenefitClaimed": null,
          "ClaimDate": null,
          "Amount": null,
          "Claimant": null
        },
        {
          "BenefitClaimed": null,
          "ClaimDate": null,
          "Amount": null,
          "Claimant": null
        },
        {
          "BenefitClaimed": null,
          "ClaimDate": null,
          "Amount": null,
          "Claimant": null
        },
        {
          "BenefitClaimed": null,
          "ClaimDate": null,
          "Amount": null,
          "Claimant": null
        },
        {
          "BenefitClaimed": null,
          "ClaimDate": null,
          "Amount": null,
          "Claimant": null
        },
        {
          "BenefitClaimed": null,
          "ClaimDate": null,
          "Amount": null,
          "Claimant": null
        },
        {
          "BenefitClaimed": null,
          "ClaimDate": null,
          "Amount": null,
          "Claimant": null
        },
        {
          "BenefitClaimed": null,
          "ClaimDate": null,
          "Amount": null,
          "Claimant": null
        },
        {
          "BenefitClaimed": null,
          "ClaimDate": null,
          "Amount": null,
          "Claimant": null
        },
        {
          "BenefitClaimed": null,
          "ClaimDate": null,
          "Amount": null,
          "Claimant": null
        },
        {
          "BenefitClaimed": null,
          "ClaimDate": null,
          "Amount": null,
          "Claimant": null
        },
        {
          "BenefitClaimed": null,
          "ClaimDate": null,
          "Amount": null,
          "Claimant": null
        },
        {
          "BenefitClaimed": null,
          "ClaimDate": null,
          "Amount": null,
          "Claimant": null
        },
        {
          "BenefitClaimed": null,
          "ClaimDate": null,
          "Amount": null,
          "Claimant": null
        },
        {
          "BenefitClaimed": null,
          "ClaimDate": null,
          "Amount": null,
          "Claimant": null
        },
        {
          "BenefitClaimed": null,
          "ClaimDate": null,
          "Amount": null,
          "Claimant": null
        },
        {
          "BenefitClaimed": null,
          "ClaimDate": null,
          "Amount": null,
          "Claimant": null
        },
        {
          "BenefitClaimed": null,
          "ClaimDate": null,
          "Amount": null,
          "Claimant": null
        }
      ],
      "ClaimToDate": [
        {
          "Benefit": null,
          "ClaimToDate": null,
          "PolicyToDate": null,
          "Count": null
        },
        {
          "Benefit": null,
          "ClaimToDate": null,
          "PolicyToDate": null,
          "Count": null
        },
        {
          "Benefit": null,
          "ClaimToDate": null,
          "PolicyToDate": null,
          "Count": null
        },
        {
          "Benefit": null,
          "ClaimToDate": null,
          "PolicyToDate": null,
          "Count": null
        },
        {
          "Benefit": null,
          "ClaimToDate": null,
          "PolicyToDate": null,
          "Count": null
        },
        {
          "Benefit": null,
          "ClaimToDate": null,
          "PolicyToDate": null,
          "Count": null
        },
        {
          "Benefit": null,
          "ClaimToDate": null,
          "PolicyToDate": null,
          "Count": null
        },
        {
          "Benefit": null,
          "ClaimToDate": null,
          "PolicyToDate": null,
          "Count": null
        },
        {
          "Benefit": null,
          "ClaimToDate": null,
          "PolicyToDate": null,
          "Count": null
        },
        {
          "Benefit": null,
          "ClaimToDate": null,
          "PolicyToDate": null,
          "Count": null
        },
        {
          "Benefit": null,
          "ClaimToDate": null,
          "PolicyToDate": null,
          "Count": null
        },
        {
          "Benefit": null,
          "ClaimToDate": null,
          "PolicyToDate": null,
          "Count": null
        },
        {
          "Benefit": null,
          "ClaimToDate": null,
          "PolicyToDate": null,
          "Count": null
        },
        {
          "Benefit": null,
          "ClaimToDate": null,
          "PolicyToDate": null,
          "Count": null
        },
        {
          "Benefit": null,
          "ClaimToDate": null,
          "PolicyToDate": null,
          "Count": null
        },
        {
          "Benefit": null,
          "ClaimToDate": null,
          "PolicyToDate": null,
          "Count": null
        },
        {
          "Benefit": null,
          "ClaimToDate": null,
          "PolicyToDate": null,
          "Count": null
        },
        {
          "Benefit": null,
          "ClaimToDate": null,
          "PolicyToDate": null,
          "Count": null
        },
        {
          "Benefit": null,
          "ClaimToDate": null,
          "PolicyToDate": null,
          "Count": null
        },
        {
          "Benefit": null,
          "ClaimToDate": null,
          "PolicyToDate": null,
          "Count": null
        },
        {
          "Benefit": null,
          "ClaimToDate": null,
          "PolicyToDate": null,
          "Count": null
        },
        {
          "Benefit": null,
          "ClaimToDate": null,
          "PolicyToDate": null,
          "Count": null
        },
        {
          "Benefit": null,
          "ClaimToDate": null,
          "PolicyToDate": null,
          "Count": null
        },
        {
          "Benefit": null,
          "ClaimToDate": null,
          "PolicyToDate": null,
          "Count": null
        },
        {
          "Benefit": null,
          "ClaimToDate": null,
          "PolicyToDate": null,
          "Count": null
        },
        {
          "Benefit": null,
          "ClaimToDate": null,
          "PolicyToDate": null,
          "Count": null
        },
        {
          "Benefit": null,
          "ClaimToDate": null,
          "PolicyToDate": null,
          "Count": null
        },
        {
          "Benefit": null,
          "ClaimToDate": null,
          "PolicyToDate": null,
          "Count": null
        },
        {
          "Benefit": null,
          "ClaimToDate": null,
          "PolicyToDate": null,
          "Count": null
        },
        {
          "Benefit": null,
          "ClaimToDate": null,
          "PolicyToDate": null,
          "Count": null
        },
        {
          "Benefit": null,
          "ClaimToDate": null,
          "PolicyToDate": null,
          "Count": null
        },
        {
          "Benefit": null,
          "ClaimToDate": null,
          "PolicyToDate": null,
          "Count": null
        },
        {
          "Benefit": null,
          "ClaimToDate": null,
          "PolicyToDate": null,
          "Count": null
        },
        {
          "Benefit": null,
          "ClaimToDate": null,
          "PolicyToDate": null,
          "Count": null
        },
        {
          "Benefit": null,
          "ClaimToDate": null,
          "PolicyToDate": null,
          "Count": null
        },
        {
          "Benefit": null,
          "ClaimToDate": null,
          "PolicyToDate": null,
          "Count": null
        },
        {
          "Benefit": null,
          "ClaimToDate": null,
          "PolicyToDate": null,
          "Count": null
        }
      ],
      "Cover_Start_Date": "2028-07-09",
      "Coverage": "Insured_1",
      "DOB": "1980-01-01",
      "Gender": "F",
      "Optional_Benefits": [
        {
          "Option": "Insured_1",
          "Included": "Y"
        }
      ],
      "Plan": "Plan_1",
      "Policy_Cover_QuoteDate": "2021-07-01",
      "PostalCode": "064-0806",
      "PromoCode": "",
      "Ratings": [
        {
          "RatingFactor": "RakutenPoints",
          "Value": 20
        },
        {
          "RatingFactor": null,
          "Value": null
        },
        {
          "RatingFactor": null,
          "Value": null
        },
        {
          "RatingFactor": null,
          "Value": null
        },
        {
          "RatingFactor": null,
          "Value": null
        },
        {
          "RatingFactor": null,
          "Value": null
        },
        {
          "RatingFactor": null,
          "Value": null
        },
        {
          "RatingFactor": null,
          "Value": null
        },
        {
          "RatingFactor": null,
          "Value": null
        },
        {
          "RatingFactor": null,
          "Value": null
        },
        {
          "RatingFactor": null,
          "Value": null
        },
        {
          "RatingFactor": null,
          "Value": null
        },
        {
          "RatingFactor": null,
          "Value": null
        },
        {
          "RatingFactor": null,
          "Value": null
        },
        {
          "RatingFactor": null,
          "Value": null
        }
      ],
      "Term": 1,
      "Underwriting_Response": [
        {
          "UWSurveyCode": "PA_UW_1",
          "UWSurveyResponse": "Y"
        },
        {
          "UWSurveyCode": "PA_UW_2",
          "UWSurveyResponse": "Y"
        },
        {
          "UWSurveyCode": "PA_UW_3",
          "UWSurveyResponse": null
        },
        {
          "UWSurveyCode": "PA_UW_4",
          "UWSurveyResponse": null
        },
        {
          "UWSurveyCode": "PA_UW_5",
          "UWSurveyResponse": null
        },
        {
          "UWSurveyCode": "PA_UW_6",
          "UWSurveyResponse": null
        },
        {
          "UWSurveyCode": "PA_UW_7",
          "UWSurveyResponse": null
        },
        {
          "UWSurveyCode": "PA_UW_8",
          "UWSurveyResponse": null
        },
        {
          "UWSurveyCode": "PA_UW_9",
          "UWSurveyResponse": null
        },
        {
          "UWSurveyCode": "PA_UW_10",
          "UWSurveyResponse": null
        },
        {
          "UWSurveyCode": "PA_UW_11",
          "UWSurveyResponse": null
        },
        {
          "UWSurveyCode": "PA_UW_12",
          "UWSurveyResponse": null
        },
        {
          "UWSurveyCode": "PA_UW_13",
          "UWSurveyResponse": null
        },
        {
          "UWSurveyCode": "PA_UW_14",
          "UWSurveyResponse": null
        },
        {
          "UWSurveyCode": "PA_UW_15",
          "UWSurveyResponse": null
        },
        {
          "UWSurveyCode": "PA_UW_16",
          "UWSurveyResponse": null
        },
        {
          "UWSurveyCode": "PA_UW_17",
          "UWSurveyResponse": null
        },
        {
          "UWSurveyCode": "PA_UW_18",
          "UWSurveyResponse": null
        },
        {
          "UWSurveyCode": "PA_UW_19",
          "UWSurveyResponse": null
        },
        {
          "UWSurveyCode": "PA_UW_20",
          "UWSurveyResponse": null
        }
      ]
    },
    "TransactionDate": "2021-07-24T09:47:26.499Z",
    "EngineType": "Type1",
    "Solves": [],
    "ServiceName": "Bicycle_Product_v1.3",
    "Description": "",
    "RequestedOutPut": "",
    "EndPoint": "https://excelengine.demo.sonic.dev.coherent.global/api/v1/product/coherent/engines/Execute/PA",
    "IsRichJson": false,
    "ServiceCategories": [
      "Claim",
      "Options",
      "Refund"
    ],
    "RequestedServiceCategory": "",
    "ShouldExecuteInputs": false
  }

  angular
    .module('coherentPaDemo')
    .controller('Purchase7Controller', Purchase7Controller);

  /** @ngInject */
  function Purchase7Controller($state, PurchaseService, $http, configUrls, environment, PurchaseFactory) {
    var vm = this;
    vm.planType = {};
    vm.DefaultCurrency = PurchaseService.DefaultCurrency;

    vm.planTypeCategories = [
      "purchase_death_residual_disability",
      "purchase_daily_hospitalization",
      "purchase_surgical_insurance",
      "purchase_in_hospital",
      "purchase_other_than_in_hospital",
      "purchase_liability"
    ];

    vm.planTypes = [{
      id: 1,
      color: 'green',
      heading: {
        title: "purchase_basic",
        description: "purchase_one_year_insurance_period",
        price: "purchase_price_loading"
      },
      prices: [
        "purchase_price_loading",
        "purchase_price_loading",
        "purchase_price_loading",
        "purchase_price_loading",
        "purchase_price_loading"
      ]
    },{
      id: 2,
      color: 'yellow',
      heading: {
        title: "purchase_relief",
        description: "purchase_one_year_insurance_period",
        price: "purchase_price_loading"
      },
      prices: [
        "purchase_price_loading",
        "purchase_price_loading",
        "purchase_price_loading",
        "purchase_price_loading",
        "purchase_price_loading"
      ]
    },{
      id: 3,
      color: 'purple',
      heading: {
        title: "purchase_complete",
        description: "purchase_one_year_insurance_period",
        price: "purchase_price_loading"
      },
      prices: [
        "purchase_price_loading",
        "purchase_price_loading",
        "purchase_price_loading",
        "purchase_price_loading",
        "purchase_price_loading"
      ]
    }];

    vm.text4 = 'Insurance premiums can only be paid once by credit card.';
    vm.text5 = 'This contract is accompanied by a special contract regarding the automatic renewal of insurance contracts.';

    vm.select = function (planType) {
      
      vm.planType = planType;
      PurchaseService.setPlanType(planType);
      // console.log(planType);
    };

    vm.btn1 = 'Continue'; //'Select This Plan';

    vm.PlanList = {};

    function init() {
      if (PurchaseService.isQuoteData()) {
        PurchaseService.setPlanType(
          PurchaseService.QuoteData.Cont.Data.length > 0 ? PurchaseService.QuoteData.Cont.Data[0].PlanType : {}
        );
      }
      if(!_.isEmpty(PurchaseService.planType)) {
        vm.planType = PurchaseService.planType;
      } else if(!PurchaseService.insuranceDate) {
        $state.go('purchase-1');
      }
    }

    function getPlan(i) {

      PurchaseFactory.token().then( function(token) {
        PFInput.Inputs.Plan = "Plan" + i;
        PFInput.Inputs.Coverage = PurchaseService.insuredType;
        PFInput.Inputs.PromoCode = PurchaseService.SelectedPromo;

        PurchaseFactory.get(PurchaseService.ProductCode, PurchaseService.FolderName, angular.toJson(PFInput), token).then(function (response) {
          vm.PlanList["Plan" + i] = [];
            var planData = response.data.data.Outputs
            PurchaseService['setPlan' + i]
            vm.planTypes[i - 1].heading.price = planData.BasePremium;
            vm.planTypes[i - 1].prices[0] = PurchaseService.numberWithCommas(planData.BenefitLimits[0].ClaimLimit)
            vm.planTypes[i - 1].prices[1] = PurchaseService.numberWithCommas(planData.BenefitLimits[2].DailyLimit)
            vm.planTypes[i - 1].prices[2] = PurchaseService.numberWithCommas(planData.BenefitLimits[3].ClaimLimit)
            vm.planTypes[i - 1].prices[3] = PurchaseService.numberWithCommas(planData.BenefitLimits[4].ClaimLimit)
            vm.planTypes[i - 1].prices[4] = PurchaseService.numberWithCommas(planData.BenefitLimits[5].ClaimLimit)
            for (var a = 0; a < planData.BenefitLimits.length; a ++) {
              vm.PlanList["Plan" + i].push(planData.BenefitLimits[a]);
            }
            PurchaseService.setPlansList(vm.PlanList);
            vm.proceed = true
        });
      });

      // var settings = {
      //   method: 'GET',
      //   url: configUrls[environment].keyCloakTokenUrl + '?apiKey=' + configUrls[environment].keyCloakApiKey + '&client=' + configUrls[environment].keyCloakPFClient,
      //   headers: {
      //     'Content-Type': 'application/x-www-form-urlencoded'
      //   }
      // };

      // $http(settings).then(function (response) {
      //   // console.log(response);
      //   return response
      // }).then(function (tokenRes) {
      //   PFInput.Inputs.Plan = "Plan" + i;
      //   PFInput.Inputs.Coverage = PurchaseService.insuredType;
      //   PFInput.Inputs.PromoCode = PurchaseService.SelectedPromo;
      //   var req = {
      //     method: 'POST',
      //     // url: 'https://excel.sonic.dev.coherent.com.hk/api/v1/product/coherent/engines/Execute/PA',
      //     //url: 'https://excel.sonic.dev.coherent.com.hk/api/v1/product/Rakuten/engines/Execute/Bicycle',
      //     // headers: {
      //     //   'SecretKey': '762f5692-5a8b-4f8e-a09e-a27a277c0c56',
      //     //   'x-tenant-name': 'coherent'
      //     // },
      //     url: configUrls[environment].PFUrl + PurchaseService.ProductCode,          
      //     headers: {
      //       authorization: 'Bearer ' + tokenRes.data.access_token
      //     },
      //     data: angular.toJson(PFInput)
      //   };
      //   $http(req)
      //     .then(function (response) {
      //       vm.PlanList["Plan" + i] = [];
      //       var planData = response.data.data.Outputs
      //       PurchaseService['setPlan' + i]
      //       vm.planTypes[i - 1].heading.price =planData.BasePremium
      //       vm.planTypes[i - 1].prices[0] = PurchaseService.numberWithCommas(planData.BenefitLimits[0].ClaimLimit)
      //       vm.planTypes[i - 1].prices[1] = PurchaseService.numberWithCommas(planData.BenefitLimits[2].DailyLimit)
      //       vm.planTypes[i - 1].prices[2] = PurchaseService.numberWithCommas(planData.BenefitLimits[3].ClaimLimit)
      //       vm.planTypes[i - 1].prices[3] = PurchaseService.numberWithCommas(planData.BenefitLimits[4].ClaimLimit)
      //       vm.planTypes[i - 1].prices[4] = PurchaseService.numberWithCommas(planData.BenefitLimits[5].ClaimLimit)
      //       for (var a = 0; a < planData.BenefitLimits.length; a ++) {
      //         vm.PlanList["Plan" + i].push(planData.BenefitLimits[a]);
      //       }
      //       PurchaseService.setPlansList(vm.PlanList);
      //       vm.proceed = true
  
      //     }, function () {
      //   });

      // });
    }

    init();
    getPlan('1');
    getPlan('2');
    getPlan('3');
  }
})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .controller('Purchase6Controller', Purchase6Controller);

  /** @ngInject */
  function Purchase6Controller($state, PurchaseService) {
    var vm = this;

    vm.text1 = 'ファミリープラン';
    vm.text2 = '<b>ご 家族</b>をケガの補償の対象とするプラン';

    vm.text3 = 'ご契約者（お申込人）';
    vm.text4 = '現時点で満18才以上の方がお申込みいただけます。';

    vm.text5 = 'ケガの補償';
    vm.text6 = 'ケガの補償の対象となる方（被保険者）';

    vm.text6 = 'の補償の対象となる方 (被保険者)';

    vm.text7 = '被保険者（本人）';
    vm.text8 = '<ul>'
      + '<li>保険始期日時点で 満69才以下の方</li>'
      + '<li>以下の方をご指定いただけます。</li>'
        + '<ul>'
        + '<li>ご契約者</li>'
        + '<li>ご契約者の</li>'
          + '<ul>'
          + '<li>「配偶者」「子・孫」「父母・祖父母」</li>'
      + '</ul></ul></ul>';

    vm.text9 = '配偶者';
    vm.text10 = '<ul><li>被保険者（本人）の「配偶者」が対象となります。</li></ul>';

    vm.text11 = 'その他親族';
    vm.text12 = '被保険者（本人）または被保険者（本人）の配偶者の同居の親族（６親等内の血族、３親等内の姻族）および別居の未婚（婚姻歴が無いこと）の子が対象となります。';

    vm.text13 = '賠償責任の補償';
    vm.text14 = '賠償責任の補償の対象となる方（被保険者）';

    vm.coverages = [{
      title: '被保険者（本人）',
      details: [
        'ケガの補償の被保険者（本人）となる方と同じです。'
      ],
      image: '/assets/images/coverage-policy-owner.png'
    },{
      title: '配偶者',
      details: [
        '被保険者（本人）の「配偶者」が対象となります。'
      ],
      image: '/assets/images/coverage-spouse.png'
    },{
      title: 'その他親族',
      details: [
        '被保険者（本人）または被保険者（本人）の配偶者の同居の親族（６親等内の血族、３親等内の姻族）および別居の未婚（婚姻歴が無いこと）の子が対象となります。'
      ],
      image: '/assets/images/coverage-other-relatives.png'
    }];

    vm.btn1 = '「ファミリープラン」を申込む';

    vm.select = function (insuredType) {
      PurchaseService.setInsuredType(insuredType)
    }

    // function init() {
    //   if(!PurchaseService.insuranceDate) {
    //     $state.go('purchase-1');
    //   }
    // }

    //init();
  }
})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .controller('Purchase5Controller', Purchase5Controller);

  /** @ngInject */
  function Purchase5Controller($state, PurchaseService) {
    var vm = this;

    vm.text1 = 'Couple Plan'; // 'カップルプラン';
    vm.text2 = '<b>Spouse</b> Personal Accident Plan'; // '<b>ご 夫婦</b>をケガの補償の対象とするプラン';

    vm.text3 = 'Insured (Applicant)'; // 'ご契約者（お申込人）';
    vm.text4 = 'Anyone over the age of 18 can apply at this time.'; // '現時点で満18才以上の方がお申込みいただけます。';

    vm.text5 = 'Accident benefit'; // 'ケガの補償';
    vm.text6 = 'Persons eligible for compensation for injuries (insured persons)'; ///'ケガの補償の対象となる方（被保険者）';

    vm.text6 = 'Persons eligible for compensation (insured persons)' ; // 'の補償の対象となる方 (被保険者)';

    vm.text7 = 'Insured person (individual)'; // '被保険者（本人）';
    // vm.text8 = '<ul>'
    //   + '<li>保険始期日時点で 満69才以下の方</li>'
    //   + '<li>以下の方をご指定いただけます。</li>'
    //     + '<ul>'
    //     + '<li>ご契約者</li>'
    //     + '<li>ご契約者の</li>'
    //       + '<ul>'
    //       + '<li>「配偶者」「子・孫」「父母・祖父母」</li>'
    //   + '</ul></ul></ul>';

    vm.text8 = '<ul>'
      + '<li>Those who are 69 years old or younger as of the insurance start date</li>'
      + '<li>Please specify:</li>'
        + '<ul>'
        + '<li>Insured</li>'
        + '<li>Insured of</li>'
          + '<ul>'
          + '<li>"Spouse", "Children and grandchildren", "Parents and grandparents"</li>'
      + '</ul></ul></ul>';

    vm.text9 = 'spouse'; // '配偶者';
    vm.text10 = '<ul><li>The "spouse" of the insured person (the insured person) is eligible.</li></ul>'; // '<ul><li>被保険者（本人）の「配偶者」が対象となります。</li></ul>';

    vm.text11 = 'compensation for liability'; //'賠償責任の補償';
    vm.text12 = 'Person eligible for liability compensation (insured person)'; // '賠償責任の補償の対象となる方（被保険者）';

    vm.coverages = [{
      title: 'Insured person (individual)', // '被保険者（本人）',
      details: [
        'Those who are 69 years old or younger as of the insurance start date', // '保険始期日時点で 満69才以下の方',
        'It is the same as the person who becomes the insured person (the person) of compensation for injury.', // 'ケガの補償の被保険者（本人）となる方と同じです。'
      ],
      image: '/assets/images/coverage-policy-owner.png'
    },{
      title: 'spouse', //'配偶者',
      details: [
        'The "spouse" of the insured person (the insured person) is eligible.', // '被保険者（本人）の「配偶者」が対象となります。'
      ],
      image: '/assets/images/coverage-spouse.png'
    },{
      title: 'Other relatives', // 'その他親族',
      details: [
        'Relatives (blood relatives within the 6th degree, relatives by affinity within the 3rd degree) living together with the insured person (the person in question) or the spouse of the insured person (the person in question) and unmarried children living separately (no marital history) are eligible. .', // '被保険者（本人）または被保険者（本人）の配偶者の同居の親族（６親等内の血族、３親等内の姻族）および別居の未婚（婚姻歴が無いこと）の子が対象となります。'
      ],
      image: '/assets/images/coverage-other-relatives.png'
    }];

    vm.btn1 = ' Apply for "Family Plan"'; // '「ファミリープラン」を申込む';

    vm.select = function (insuredType) {
      PurchaseService.setInsuredType(insuredType)
    }
    
    function init() {
      if(!PurchaseService.insuranceDate) {
        $state.go('purchase-1');
      }
    }

    init();
  }
})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .controller('Purchase4Controller', Purchase4Controller);

  /** @ngInject */
  function Purchase4Controller($state, PurchaseService) {
    var vm = this;

    vm.coverages = [{
      title: "purchase_policy_owner",
      details: [
        "purchase_same_person_insured"
      ],
      image: '/assets/images/coverage-policy-owner.png'
    }];

    // vm.coverages = [{
    //   title: '被保険者（本人）',
    //   details: [
    //     '保険始期日時点で 満69才以下の方',
    //     'ケガの補償の被保険者（本人）となる方と同じです。'
    //   ],
    //   image: '/assets/images/coverage-policy-owner.png'
    // },{
    //   title: '配偶者',
    //   details: [
    //     '被保険者（本人）の「配偶者」が対象となります。'
    //   ],
    //   image: '/assets/images/coverage-spouse.png'
    // },{
    //   title: 'その他親族',
    //   details: [
    //     '被保険者（本人）または被保険者（本人）の配偶者の同居の親族（６親等内の血族、３親等内の姻族）および別居の未婚（婚姻歴が無いこと）の子が対象となります。'
    //   ],
    //   image: '/assets/images/coverage-other-relatives.png'
    // }];

    vm.select = function (insuredType) {
      PurchaseService.setInsuredType(insuredType)
    }

    function init() {
      if(!PurchaseService.insuranceDate) {
        $state.go('purchase-1');
      }
    }

    init();
  }
})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .controller('Purchase3Controller', Purchase3Controller);

  /** @ngInject */
  function Purchase3Controller($state, PurchaseService) {
    var vm = this;

    vm.PlanCategory = {};

    // vm.text1 = 'サイクルアシスト';

    // vm.text2 = '補償の対象となる方の範囲をお選びください。';

    // vm.text3 = '次のどのプランをお選びいただいても、<span class="text-green">「賠償責任」</span> の補償の対象となる方の 範囲は、右のとおりとなります。';

    // vm.text4 = '被保険者 (本人)';
    // vm.text5 = '被保険者 (本人) の配偶者';
    // vm.text6 = 'その他親族';

    // vm.planCategories = [{
    //   id: 'individual',
    //   title: '個人プラン',
    //   description: '<b>1 人の方</b> にケガの補償を限定するプラン',
    //   image: '/assets/images/plan-1.png',
    //   state: 'purchase-4'
    // }, {
    //   id: 'married_couple',
    //   title: 'カップルプラン',
    //   description: '<b>ご 夫婦</b> をケガの補償の対象とするプラン',
    //   image: '/assets/images/plan-2.png',
    //   state: 'purchase-5'
    // }, {
    //   id: 'family',
    //   title: 'ファミリープラン',
    //   description: '<b>ご 家族</b>をケガの補償の対象とするプラン',
    //   image: '/assets/images/plan-3.png',
    //   state: 'purchase-6'
    // }];

    // vm.text1 = 'Personal Accident';

    // vm.text2 = 'Please select the range of people who are eligible for compensation:';

    // vm.text3 = 'No matter which of the plans you choose, the scope of coverage for each liability is as shown on the right';

    // vm.text4 = 'Insured Individual (him/herself)';
    // vm.text5 = 'Insured Individual’s spouse';
    // vm.text6 = 'Insured Individual’s relatives';

    vm.planCategories = [{
      id: 'individual',
      title: "purchase_individual_plan_title",
      description: "purchase_individual_plan_description",
      image: '/assets/images/plan-1.png',
      state: 'purchase-4'
    }, {
      id: 'married_couple',
      title: "purchase_married_couple_title",
      description: "purchase_married_couple_description",
      image: '/assets/images/plan-2.png',
      state: 'purchase-5'
    }, {
      id: 'family',
      title: "purchase_family_plan_title",
      description: "purchase_family_plan_description",
      image: '/assets/images/plan-3.png',
      state: 'purchase-6'
    }];

    vm.chooseCategory = function(category) {
      vm.PlanCategory = category;

    }

    vm.proceed = function() {
      var category = vm.PlanCategory;
      PurchaseService.setPlanCategory(category);
      $state.go(category.state);
    };

    function init() {
      if (PurchaseService.isQuoteData()) {
        var cat = PurchaseService.QuoteData.Cont.Data.length > 0 ? PurchaseService.QuoteData.Cont.Data[0].PlanCategory : {};
        vm.PlanCategory = cat;
        PurchaseService.setPlanCategory(cat);
      }
      if(!PurchaseService.insuranceDate) {
        $state.go('purchase-1');
      }
    }

    init();
  }
})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .controller('Purchase2Controller', Purchase2Controller);

  /** @ngInject */
  function Purchase2Controller($state, PurchaseService, $http, configUrls, environment) {
    var vm = this;

    vm.calendarFormat = 'yyyy / MM / dd';

    vm.datepickerOptions = {
      showWeeks: false,
      //minDate: moment(),
      maxDate: moment().add(30, 'd')
    };

    vm.date = moment().toDate()
    vm.currency = 'SGD';
    vm.Currencies = [];
    vm.PromoCode = "";
    vm.PromoCodes = [];
    vm.OccupationList = [];
    vm.PaymentFreqencyList = [];
    // vm.Frequency = 1;

    vm.proceed = function() {
      PurchaseService.setInsuranceDate(moment(vm.date).format("YYYY-MM-DD"));
      PurchaseService.setCurrency(vm.currency);
      PurchaseService.setPromoCode(vm.PromoCode);
      PurchaseService.setOccupation(vm.Occupation);
      PurchaseService.setPaymentFrequency(vm.Frequency);
      $state.go('purchase-3');
    };

    function init() {
      // console.log(PurchaseService.ProductCode);
      // console.log(PurchaseService.FolderName);

      var settings = {
        method: 'GET',
        url: configUrls[environment].keyCloakTokenUrl + '?apiKey=' + configUrls[environment].keyCloakApiKey + '&client=' + configUrls[environment].keyCloakPFClient,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      };

      $http(settings).then(function (response) {
        // console.log(response);
        return response
      }).then(function (tokenRes) {
        var PFInput = {
            "Inputs": {},
            "TransactionDate": "2022-05-31T06:34:57.732Z",
            "EngineType": "Type3",
            "Solves": [],
            "RequestedServiceCategory": "Default"
        };
        var req = {
          method: 'POST',
          url: 'https://excelengine.demo.sonic.dev.coherent.global/api/v1/product/SonicConfig/engines/Execute/SonicConfig',
          // url: configUrls[environment].PFUrl + PurchaseService.ProductCode,          
          headers: {
            authorization: 'Bearer ' + tokenRes.data.access_token
          },
          data: angular.toJson(PFInput)
        };
        $http(req)
          .then(function (response) {
            vm.Currencies = response.data.data.Outputs["Country.CountryInfo"];
            vm.PromoCodes = response.data.data.Outputs["Promotion"];
            vm.OccupationList = response.data.data.Outputs["Occupation.OccupationInfo"];
            vm.PaymentFreqencyList = response.data.data.Outputs["Payment.Frequency"];


            if (!PurchaseService.insuranceDate && PurchaseService.isQuoteData()) {
              PurchaseService.setInsuranceDate(PurchaseService.QuoteData.Cont.StartDate.split('T')[0]);
              vm.PromoCode = PurchaseService.QuoteData.Cont.PromoCode;
            }
      
            if(PurchaseService.insuranceDate) {
              vm.checkbox = true;
              vm.date = moment(PurchaseService.insuranceDate).toDate();
            }
            
          }, function () {
        });

      });
      
    }

    init();
  }
})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .controller('Purchase13Controller', Purchase13Controller);

  /** @ngInject */
  function Purchase13Controller($state, PurchaseService) {
    var vm = this;

    vm.polNo = PurchaseService.polNo;
    vm.ProductType = PurchaseService.ProductType;
    vm.submit_type = '';
    // PurchaseService.clear();

    vm.proceed = function() {
      if (vm.submit_type == 'view_quote') {
        var url = "https://policy360.demo.sonic.dev.coherent.global/enquiry/policy?policyID=" + vm.polNo;
        window.open(url, '_blank');
      } else {
        $state.go('purchase-12');
      }
    }

    function init() {
      // PurchaseService.clear();
      if(_.isEmpty(PurchaseService.information2)) {
        $state.go('purchase-1');
      }
    }

    // init();
  }
})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .controller('Purchase12Controller', Purchase12Controller);

  /** @ngInject */
  function Purchase12Controller($state, PurchaseService, $http, configUrls, environment, TRAVEL_TYPE, HOME_TYPE, PURCHASE_PAYLOAD, DATE_FORMAT, TravelPurchaseService) {
    var vm = this;

    vm.payment = {};
    vm.schedule = ""

    vm.payment.name = ""; // Taro Yamada
    vm.payment.number = "••••-••••-••••-9282"
    vm.payment.expirym = "10"
    vm.payment.expiryy = "30"
    vm.schedule = "yearly"
    vm.button1 = "Confirm Payment" 
    vm.ui = {
      PlanType: 'PA'
    };

    function generatePayload() {
      var payload = angular.copy(PURCHASE_PAYLOAD[PurchaseService.policy.type]);
      var policy = PurchaseService.policy;
      payload.Header.Agent = policy.agentCode;
      payload.Header.Email = policy.Email;
      payload.Header.InstallmentPremium = policy.specs.installmentPermium;
      
      payload.Header.Mandate.CreditCard.CardNumber = vm.payment.number;
      payload.Header.Mandate.CreditCard.ExpiryMonth = vm.payment.expirym;
      payload.Header.Mandate.CreditCard.ExpityYear = vm.payment.expiryy;
      payload.Header.Owner.Contact.Add.Add1 = PurchaseService.information2.Header.Owner.Contact.Add.Add1;
      payload.Header.Owner.Contact.Add.Add2 = PurchaseService.information2.Header.Owner.Contact.Add.Add2;
      payload.Header.Owner.Contact.Add.City = PurchaseService.information2.Header.Owner.Contact.Add.City;
      payload.Header.Owner.Contact.Add.Country = PurchaseService.information2.Header.Owner.Contact.Add.Country;
      payload.Header.Owner.Contact.Add.Pcode = policy.postalCode1;
      payload.Header.Owner.Contact.Email = policy.Email;
      payload.Header.Owner.Contact.FbId = policy.fbId;
      payload.Header.Owner.Contact.Phone = policy.contact;
      payload.Header.Owner.Dob = moment(policy.birthDate).format(DATE_FORMAT);
      payload.Header.Owner.Gender = policy.gender;

      if (policy.name.indexOf(' ') > -1) {
        var firstName = policy.name.substring(0, policy.name.indexOf(' '));
        var lastName = policy.name.substring(policy.name.indexOf(' ') + 1);
      } else {
        var firstName = policy.name;
        var lastName = '';
      }
      
      payload.Header.Owner.Name = firstName;
      payload.Header.Owner.GivenName = lastName;
      // payload.Header.Owner.Givenname = lastName;
      payload.Header.StartDate = moment(policy.insuranceDate).format('YYYY-MM-DDThh:mm:ss.ssssss') + 'Z';
      payload.Risks[0].CoverType = policy.carrier + ':' + policy.type;
      payload.Risks[0].RiskBody.InsuredParty.Dob = moment(policy.birthDate).format(DATE_FORMAT);
      payload.Risks[0].RiskBody.InsuredParty.Gender = policy.gender;
      payload.Risks[0].RiskBody.InsuredParty.Name = firstName;
      payload.Risks[0].RiskBody.InsuredParty.GivenName = lastName;
      payload.Risks[0].RiskBody.Plan = policy.specs.planType;
      payload.Risks[0].RiskBody.Planlevel = policy.specs.planDetails.Option;
      payload.Risks[0].RiskBody.Risk_Comm = moment(policy.insuranceDate).format('YYYY-MM-DDThh:mm:ss.ssssss') + 'Z';
      payload.Risks[0].Risk_Comm = moment(policy.insuranceDate).format('YYYY-MM-DDThh:mm:ss.ssssss') + 'Z';
      
      if (PurchaseService.policy.type === TRAVEL_TYPE) {
        payload.Risks[0].RiskBody.Options = policy.specs.optionalBenefits ? _.map(policy.specs.optionalBenefits, function(benefit) {
          return {
            Option: benefit.name,
            Descr: benefit.label,
            Included: benefit.enabled ? 'Y' : 'N',
            SumInsured: benefit.enabled ? parseFloat(benefit.value) : 0
          };
        }) : [];
        payload.Header.PromoCode = TravelPurchaseService.policy.PromoCode;
        payload.Risks[0].RiskBody.Promotion = TravelPurchaseService.policy.PromoCode;
        payload.Header.Term = TravelPurchaseService.policy.PolicyTerm;
        payload.Risks[0].Term = TravelPurchaseService.policy.PolicyTerm;
        payload.Risks[0].RiskBody.Term = TravelPurchaseService.policy.PolicyTerm;
        payload.Risks[0].RiskBody.Self = policy.specs.myself ? 'Y' : 'N';
        payload.Risks[0].Self = policy.specs.myself ? 'Y' : 'N';
        payload.Risks[0].RiskBody.Spouse = policy.specs.spouse ? 'Y' : 'N';
        payload.Risks[0].Spouse = policy.specs.spouse ? 'Y' : 'N';
        payload.Risks[0].RiskBody.Nadults = policy.specs.totalAdults;
        payload.Risks[0].Nadults = policy.specs.totalAdults;
        payload.Risks[0].RiskBody.Nchildren = policy.specs.additionalChildren;
        payload.Risks[0].Nchildren = policy.specs.additionalChildren;
        payload.Risks[0].RiskBody.Risk_End = moment(policy.specs.arrivalDate).format('YYYY-MM-DDThh:mm:ss.ssssss') + 'Z';
        payload.Risks[0].Risk_End = moment(policy.specs.arrivalDate).format('YYYY-MM-DDThh:mm:ss.ssssss') + 'Z';

        var name = PurchaseService.information2.Risks[0].RiskBody.InsuredParty.Name;
        if (name.indexOf(' ') > -1) {
          var firstName = name.substring(0, name.indexOf(' '));
          var lastName = name.substring(name.indexOf(' ') + 1);
        } else {
          var firstName = name;
          var lastName = '';
        }

        payload.Risks[0].RiskBody.InsuredParty.Name = firstName;
        payload.Risks[0].RiskBody.InsuredParty.GivenName = lastName;
        payload.Risks[0].RiskBody.InsuredParty.Dob = moment(PurchaseService.information2.Risks[0].RiskBody.InsuredParty.Dob).format("YYYY-MM-DD");
        payload.Risks[0].RiskBody.InsuredParty.Gender = PurchaseService.information2.Risks[0].RiskBody.InsuredParty.Gender;
        payload.Risks[0].RiskBody.InsuredParty.Kinship = PurchaseService.information2.Risks[0].RiskBody.InsuredParty.Kinship;
        // payload.Risks[0].RiskBody.InsuredParty.Occupation = PurchaseService.SelectedOccupation;
        
        payload.Risks[0].RiskBody.InsuredParty.Contact.Email = PurchaseService.information2.Risks[0].RiskBody.InsuredParty.Contact.Email;
        payload.Risks[0].RiskBody.InsuredParty.Contact.Phone = PurchaseService.information2.Risks[0].RiskBody.InsuredParty.Contact.Phone;
        payload.Risks[0].RiskBody.InsuredParty.Contact.Add.Add1 = PurchaseService.information2.Risks[0].RiskBody.InsuredParty.Contact.Add.Add1;
        payload.Risks[0].RiskBody.InsuredParty.Contact.Add.Add2 = PurchaseService.information2.Risks[0].RiskBody.InsuredParty.Contact.Add.Add2;
        payload.Risks[0].RiskBody.InsuredParty.Contact.Add.City = PurchaseService.information2.Risks[0].RiskBody.InsuredParty.Contact.Add.City;
        payload.Risks[0].RiskBody.InsuredParty.Contact.Add.Country = PurchaseService.information2.Risks[0].RiskBody.InsuredParty.Contact.Add.Country;
        payload.Risks[0].RiskBody.InsuredParty.Contact.Add.Pcode = PurchaseService.information2.Risks[0].RiskBody.InsuredParty.Contact.Add.Pcode;
      }
      if (PurchaseService.policy.type === HOME_TYPE) {
        // load the yes / no ansers to the payload
        
        for(var i=0;i<PurchaseService.policy.specs.benefitSelection.length;i++) {
          // find corresponding item in payload
          // make it Included = "Y"
          var a = {}

          angular.forEach(payload.Risks[0].RiskBody.Options, function(item) {
            if(item.Option === PurchaseService.policy.specs.benefitSelection[i].Option) {
              a = item         
              if (a) {
                var b = payload.Risks[0].RiskBody.Options.indexOf(a)
                payload.Risks[0].RiskBody.Options[b].Included = PurchaseService.policy.specs.benefitSelection[i].Included
                payload.Risks[0].RiskBody.Options[b].SumInsured = parseInt(PurchaseService.policy.specs.benefitSelection[i].SumInsured)
                console.log(payload.Risks[0].RiskBody.Options[b].Option + payload.Risks[0].RiskBody.Options[b].Included + " " + PurchaseService.policy.specs.benefitSelection[i].Included)
              };
            }
          }) 
        };

        payload.Risks[0].RiskBody.Plan = PurchaseService.selectedPlan;
        
      };
      return payload;
    }

    vm.proceed = function() {
      vm.button1 = "Loading..."
      var NewPolicyPayload;
      if(PurchaseService.policy.type === TRAVEL_TYPE || PurchaseService.policy.type === HOME_TYPE) {
        NewPolicyPayload = generatePayload();
      } else {
        if(vm.schedule=="monthly") {
          PurchaseService.information2.Header.InstallmentPremium = PurchaseService.information2.Header.InstallmentPremium / 12;
          PurchaseService.information2.Header.PaymentFrequency = 12;
          PurchaseService.information2.Risks[0].RiskBody.PaymentFrequency = 12;
        } else if(vm.schedule=="yearly") {
          PurchaseService.information2.Header.PaymentFrequency = 1;
          PurchaseService.information2.Risks[0].RiskBody.PaymentFrequency = 1;
          PurchaseService.information2.Header.InstallmentPremium = PurchaseService.information2.Header.InstallmentPremium;
        }
        PurchaseService.information2.Header.Mandate.CreditCard.CardNumber = vm.payment.number
        PurchaseService.information2.Header.Mandate.CreditCard.ExpiryMonth = vm.payment.expirym
        PurchaseService.information2.Header.Mandate.CreditCard.ExpityYear = vm.payment.expiryy  
        NewPolicyPayload = PurchaseService.information2;
        NewPolicyPayload.Header.PromoCode = PurchaseService.SelectedPromo;
      }
      
      NewPolicyPayload.Header.Currency = {
          "Code": PurchaseService.DefaultCurrency,
          "Descr": PurchaseService.DefaultCurrency
      };

      NewPolicyPayload.Header.PaymentFrequency = parseInt(PurchaseService.SelectedPaymentFreq);
      NewPolicyPayload.Risks[0].RiskBody.Payment_Frequency = PurchaseService.SelectedPaymentFreq;
      NewPolicyPayload.Risks[0].RiskBody.InsuredParty.Occupation = PurchaseService.SelectedOccupation;
      NewPolicyPayload.Risks[0].RiskBody.InsuredParty.MortalityClass = PurchaseService.information2.Risks[0].RiskBody.InsuredParty.MortalityClass;
      NewPolicyPayload.Risks[0].RiskBody.Ratings = PurchaseService.RatingFactors; // PurchaseService.policy.Ratings;

      NewPolicyPayload.Header.InvokeType = "";
      NewPolicyPayload.Header.QuoteID = PurchaseService.polNo;
      vm.btn1 ='Loading...';
      var req = {
        method: 'POST',
        // url: 'https://general.sonic.dev.coherent.com.hk/general/v2/newbusiness/newpolicy',
        url: configUrls[environment].createPolicy,
        data: angular.toJson(NewPolicyPayload)
      };
      if (configUrls[environment].isAuthorizationNeeded) {
        req.headers = {
          'authorization': 'Bearer ' + configUrls[environment].token
        }
      }
      
      $http(req)
        .then(function (response) {
          var polNo = response.data.PolicyID
          PurchaseService.setPolicyNumber(polNo);
          PurchaseService.setProductType("Policy");
          $state.go('purchase-13');
        }, function () {
      });
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .controller('Purchase11Controller', Purchase11Controller);

  /** @ngInject */
  function Purchase11Controller($state, PurchaseService, configUrls, environment, $http, PurchaseFactory, ACCIDENT_TYPE, TRAVEL_TYPE, HOME_TYPE, PURCHASE_PAYLOAD, DATE_FORMAT, TravelPurchaseService) {
    var vm = this;
    vm.PFInput = PurchaseService.SparkTemplate;
    vm.planTypeCategories = [
      'purchase_death_residual_disability',
      'purchase_daily_hospitalization_insurance',
      'purchase_surgical_insurance',
      'purchase_in_hospital',
      'purchase_other_than_in_hospital',
      'purchase_liability'
    ];
    vm.ui = {
      PlanType: 'PA',
      OwnerSameAsInsured: false
    };
    vm.PlanList = PurchaseService.PlansList;
    vm.DefaultCurrency = PurchaseService.DefaultCurrency;
    vm.submit_type = '';

    function getFinalPremium() {
      PurchaseFactory.token().then( function(token) {
        vm.planCategory = PurchaseService.planCategory;
        vm.planType = PurchaseService.planType;
        var PolicyData = PurchaseService.information2;
       
        vm.PFInput.Inputs.Plan = PolicyData.Risks[0].RiskBody.Plan;
        vm.PFInput.Inputs.Coverage = 'Insured_1';
        vm.PFInput.Inputs.PromoCode = PurchaseService.SelectedPromo || PolicyData.Header.PromoCode || '';
        vm.PFInput.Inputs.Occupation = PurchaseService.SelectedOccupation || '';
        vm.PFInput.Inputs.PaymentFrequency = PurchaseService.SelectedPaymentFreq || 1;
        vm.PFInput.Inputs.MortalityClass = PurchaseService.information1.Risks[0].RiskBody.InsuredParty.MortalityClass || 'N';

        vm.PFInput.Inputs.DOB = PolicyData.Risks[0].RiskBody.InsuredParty.Dob;
        vm.PFInput.Inputs.Cover_Start_Date = PolicyData.Header.StartDate.split("T")[0];
        vm.PFInput.Inputs.Policy_Cover_QuoteDate = PolicyData.Header.StartDate.split("T")[0];
        vm.PFInput.TransactionDate = (new Date()).toISOString().split("T")[0];
        
        PurchaseFactory.get(PurchaseService.ProductCode, PurchaseService.FolderName, angular.toJson(vm.PFInput), token).then(function (response) {
          console.log(response);
          var planData = response.data.data.Outputs
          vm.planType.heading.price = planData.BasePremium;
          PolicyData.Header.InstallmentPremium = Number(planData.BasePremium);
          PurchaseService.setInformation2(PolicyData);
        });
      });
    }

    function init() {
      if(_.isEmpty(PurchaseService.information2)) {
        $state.go('purchase-1');
      }
      if (PurchaseService.policy.type === TRAVEL_TYPE) {
        vm.ui.PlanType = 'Travel';
      }
      if (PurchaseService.policy.type === HOME_TYPE) {
        vm.ui.PlanType = 'Home';
        vm.ui.HomePlanType = PurchaseService.selectedPlan;
        vm.ui.benefitSelection = PurchaseService.policy.specs.benefitSelection;
        vm.DefaultCurrency = TravelPurchaseService.policy.Currency;
        vm.ui.price = Math.round(PurchaseService.policy.specs.installmentPermium)
      }
      
      // vm.ui.optionalBenefits = PurchaseService.policy.specs.optionalBenefits;
      vm.ui.optionalBenefits = [];

      if(vm.ui.PlanType != 'PA') {
        angular.forEach(PurchaseService.policy.specs.SelectedBenefits, function(ben) {
          vm.ui.optionalBenefits.push({
            label: ben.Descr,
            value: ben.ClaimLimit,
            enabled: true
          })
        });
  
        vm.ui.planType = PurchaseService.policy.specs.planType;
        vm.ui.plan = PurchaseService.policy.specs.plan;
        vm.ui.planDetails = PurchaseService.policy.specs.planDetails;
      }
      
      //if(vm.ui.PlanType === 'PA') {
        getFinalPremium();
      // }
      vm.planCategory = PurchaseService.planCategory;
      vm.planType = PurchaseService.planType;
      vm.PolicyInfo = PurchaseService.information2;

      if (vm.PolicyInfo.Header.Owner.Name == vm.PolicyInfo.Risks[0].RiskBody.InsuredParty.Name) {
        vm.ui.OwnerSameAsInsured = true;
      }
    }

    vm.proceed = function() {
      if (vm.submit_type === 'submit') {
        $state.go('purchase-12');
      } else {
        vm.SaveQuote('New');
      }
      // PurchaseFactory.purchase(generatePayload()).then(function (data) {
      //   var policyNumber = data.data.PolicyID;
      //   PurchaseService.policy.number = policyNumber;
      //   PolicyService.policies = [{
      //     number: policyNumber
      //   }];
      //   $state.go('common-purchase-7');
      // });
    };

    function generatePayload() {
      var payload = angular.copy(PURCHASE_PAYLOAD[PurchaseService.policy.type]);
      var policy = PurchaseService.policy;

      console.log(payload)

      if(policy.agentCode) { payload.Header.Agent = policy.agentCode; }
      payload.Header.Email = policy.Email;
      payload.Header.InstallmentPremium = policy.specs.installmentPermium;
      payload.Header.Mandate.CreditCard.CardNumber = vm.ui.cardNumber;
      payload.Header.Mandate.CreditCard.ExpiryMonth = vm.ui.expiryMM;
      payload.Header.Mandate.CreditCard.ExpityYear = vm.ui.expiryYY;
      payload.Header.Owner.Contact.Add.Add1 = PurchaseService.information2.Header.Owner.Contact.Add.Add1;
      payload.Header.Owner.Contact.Add.Add2 = PurchaseService.information2.Header.Owner.Contact.Add.Add2;
      payload.Header.Owner.Contact.Add.City = PurchaseService.information2.Header.Owner.Contact.Add.City;
      payload.Header.Owner.Contact.Add.Country = PurchaseService.information2.Header.Owner.Contact.Add.Country;
      payload.Header.Owner.Contact.Add.Pcode = policy.postalCode1;
      payload.Header.Owner.Contact.Email = policy.Email;
      payload.Header.Owner.Contact.FbId = policy.fbId;
      payload.Header.Owner.Contact.Phone = policy.contact;
      payload.Header.Owner.Dob = moment(policy.birthDate).format(DATE_FORMAT);
      payload.Header.Owner.Gender = policy.gender;

      if (policy.name.indexOf(' ') > -1) {
        var firstName = policy.name.substring(0, policy.name.indexOf(' '));
        var lastName = policy.name.substring(policy.name.indexOf(' ') + 1);
      } else {
        var firstName = policy.name;
        var lastName = '';
      }
     
      payload.Header.Owner.Name = firstName;
      payload.Header.Owner.GivenName = lastName;
      // payload.Header.Owner.Givenname = lastName;
      payload.Header.StartDate = moment(policy.insuranceDate).format('YYYY-MM-DDThh:mm:ss.ssssss') + 'Z';
      payload.Risks[0].CoverType = policy.carrier + ':' + policy.type;
      payload.Risks[0].RiskBody.InsuredParty.Dob = moment(policy.birthDate).format(DATE_FORMAT);
      payload.Risks[0].RiskBody.InsuredParty.Gender = policy.gender;
      payload.Risks[0].RiskBody.InsuredParty.Name = firstName;
      payload.Risks[0].RiskBody.InsuredParty.GivenName = lastName;
      payload.Risks[0].RiskBody.Plan = policy.specs.planType
      payload.Risks[0].RiskBody.Planlevel = policy.specs.planDetails.Option;
      payload.Risks[0].RiskBody.Risk_Comm = moment(policy.insuranceDate).format('YYYY-MM-DDThh:mm:ss.ssssss') + 'Z';
      payload.Risks[0].Risk_Comm = moment(policy.insuranceDate).format('YYYY-MM-DDThh:mm:ss.ssssss') + 'Z';

      if (PurchaseService.policy.type === TRAVEL_TYPE) {
        payload.Risks[0].RiskBody.Options = policy.specs.optionalBenefits ? _.map(policy.specs.optionalBenefits, function(benefit) {
          return {
            Option: benefit.name,
            Descr: benefit.label,
            Included: benefit.enabled ? 'Y' : 'N',
            SumInsured: benefit.enabled ? parseFloat(benefit.value) : 0
          };
        }) : [];
        payload.Header.PromoCode = TravelPurchaseService.policy.PromoCode;
        payload.Risks[0].RiskBody.Promotion = TravelPurchaseService.policy.PromoCode;
        payload.Header.Term = TravelPurchaseService.policy.PolicyTerm;
        payload.Risks[0].Term = TravelPurchaseService.policy.PolicyTerm;
        payload.Risks[0].RiskBody.Term = TravelPurchaseService.policy.PolicyTerm;
        payload.Risks[0].RiskBody.Self = policy.specs.myself ? 'Y' : 'N';
        payload.Risks[0].Self = policy.specs.myself ? 'Y' : 'N';
        payload.Risks[0].RiskBody.Spouse = policy.specs.spouse ? 'Y' : 'N';
        payload.Risks[0].Spouse = policy.specs.spouse ? 'Y' : 'N';
        payload.Risks[0].RiskBody.Nadults = policy.specs.totalAdults;
        payload.Risks[0].Nadults = policy.specs.totalAdults;
        payload.Risks[0].RiskBody.Nchildren = policy.specs.additionalChildren;
        payload.Risks[0].Nchildren = policy.specs.additionalChildren;
        payload.Risks[0].RiskBody.Risk_End = moment(policy.specs.arrivalDate).format('YYYY-MM-DDThh:mm:ss.ssssss') + 'Z';
        payload.Risks[0].Risk_End = moment(policy.specs.arrivalDate).format('YYYY-MM-DDThh:mm:ss.ssssss') + 'Z';
        // payload.Risks[0].RiskBody.Payment_Frequency = PurchaseService.SelectedPaymentFreq;

        // Insured party information
        var name = PurchaseService.information2.Risks[0].RiskBody.InsuredParty.Name;
        if (name.indexOf(' ') > -1) {
          var firstName = name.substring(0, name.indexOf(' '));
          var lastName = name.substring(name.indexOf(' ') + 1);
        } else {
          var firstName = name;
          var lastName = '';
        }

        payload.Risks[0].RiskBody.InsuredParty.Name = firstName;
        payload.Risks[0].RiskBody.InsuredParty.GivenName = lastName;
        payload.Risks[0].RiskBody.InsuredParty.Dob = moment(PurchaseService.information2.Risks[0].RiskBody.InsuredParty.Dob).format("YYYY-MM-DD");
        payload.Risks[0].RiskBody.InsuredParty.Gender = PurchaseService.information2.Risks[0].RiskBody.InsuredParty.Gender;
        payload.Risks[0].RiskBody.InsuredParty.Kinship = PurchaseService.information2.Risks[0].RiskBody.InsuredParty.Kinship;
        
        payload.Risks[0].RiskBody.InsuredParty.Contact.Email = PurchaseService.information2.Risks[0].RiskBody.InsuredParty.Contact.Email;
        payload.Risks[0].RiskBody.InsuredParty.Contact.Phone = PurchaseService.information2.Risks[0].RiskBody.InsuredParty.Contact.Phone;
        payload.Risks[0].RiskBody.InsuredParty.Contact.Add.Add1 = PurchaseService.information2.Risks[0].RiskBody.InsuredParty.Contact.Add.Add1;
        payload.Risks[0].RiskBody.InsuredParty.Contact.Add.Add2 = PurchaseService.information2.Risks[0].RiskBody.InsuredParty.Contact.Add.Add2;
        payload.Risks[0].RiskBody.InsuredParty.Contact.Add.City = PurchaseService.information2.Risks[0].RiskBody.InsuredParty.Contact.Add.City;
        payload.Risks[0].RiskBody.InsuredParty.Contact.Add.Country = PurchaseService.information2.Risks[0].RiskBody.InsuredParty.Contact.Add.Country;
        payload.Risks[0].RiskBody.InsuredParty.Contact.Add.Pcode = PurchaseService.information2.Risks[0].RiskBody.InsuredParty.Contact.Add.Pcode;
      }

      if (PurchaseService.policy.type === HOME_TYPE) {
        // load the yes / no ansers to the payload
        
        for(var i=0;i<PurchaseService.policy.specs.benefitSelection.length;i++) {
          // find corresponding item in payload
          // make it Included = "Y"
          var a = {}

          angular.forEach(payload.Risks[0].RiskBody.Options, function(item) {
            if(item.Option === PurchaseService.policy.specs.benefitSelection[i].Option) {
              a = item         
              if (a) {
                var b = payload.Risks[0].RiskBody.Options.indexOf(a)
                payload.Risks[0].RiskBody.Options[b].Included = PurchaseService.policy.specs.benefitSelection[i].Included
                payload.Risks[0].RiskBody.Options[b].SumInsured = parseInt(PurchaseService.policy.specs.benefitSelection[i].SumInsured)
              };
            }
          }) 
        };

        payload.Risks[0].RiskBody.Plan = PurchaseService.selectedPlan;
        console.log(payload.Risks[0].RiskBody)
        
      };
      return payload;
    }

    vm.SaveQuote = function (quoteType) {
      console.log(quoteType);
      var PolicyData = PurchaseService.information2;
      if (PurchaseService.policy.type === TRAVEL_TYPE || PurchaseService.policy.type === HOME_TYPE) {
        var PolicyData = generatePayload();
      } else {
        PolicyData.Header.Data[0] = {
          PlanCategory: PurchaseService.planCategory,
          PlanType: PurchaseService.planType
        };
      }
      
      PolicyData.Header.Currency = {
          "Code": PurchaseService.DefaultCurrency,
          "Descr": PurchaseService.DefaultCurrency
      };

      PolicyData.Header.PaymentFrequency = parseInt(PurchaseService.SelectedPaymentFreq);
      PolicyData.Risks[0].RiskBody.Payment_Frequency = PurchaseService.SelectedPaymentFreq;
      PolicyData.Risks[0].RiskBody.InsuredParty.Occupation = PurchaseService.SelectedOccupation;
      PolicyData.Risks[0].RiskBody.InsuredParty.MortalityClass = PurchaseService.information2.Risks[0].RiskBody.InsuredParty.MortalityClass;
      PolicyData.Risks[0].RiskBody.Ratings = PurchaseService.RatingFactors; // PurchaseService.policy.Ratings;

      PolicyData.Header.InvokeType = "Q";
      PolicyData.Header.ContID = PurchaseService.polNo;
      PolicyData.Header.Status = "NewQuotation";
      PolicyData.Header.SaveQuoteAs = "New";
      PolicyData.Header.PromoCode = PurchaseService.SelectedPromo;
       
      var req = {
        method: 'POST',
        url: 'https://newbusiness.demo.sonic.dev.coherent.global/v1/newpolicy',
        // url: configUrls[environment].createPolicy,
        data: angular.toJson(PolicyData)
      };
      if (configUrls[environment].isAuthorizationNeeded) {
        req.headers = {
          'authorization': 'Bearer ' + configUrls[environment].token
        }
      }
      
      $http(req)
        .then(function (response) {
          var polNo = response.data.PolicyID
          PurchaseService.setPolicyNumber(polNo);
          PurchaseService.setProductType("Quote");
          $state.go('purchase-13');
        }, function () {
      });

    }

    init();
  }
})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .controller('Purchase10Controller', Purchase10Controller);

  /** @ngInject */
  function Purchase10Controller($state, PurchaseService, ACCIDENT_TYPE, TRAVEL_TYPE, HOME_TYPE) {
    var vm = this;

    vm.informationTemplate = PurchaseService.information1;

    vm.information = {};

    vm.relationships = [{
      value: 'self',
      display: "purchase_same_as_owner"
    },
    {
      value: 'relative',
      display: 'Other than Policy Owner'
    }
    ];
    vm.information.relationship == 'self';

    vm.placeholder1 = 'Choose relationship...';

    vm.relationshipTypes = [{
      value: 'Child',
      display: 'Child'
    },{
      value: 'Spouse',
      display: 'Spouse'
    },{
      value: 'Parent',
      display: 'Parent'
    },{
      value: 'Grandparent',
      display: 'Grandparent'
    },{
      value: 'Sibling',
      display: 'Sibling'
    }];

    vm.text3 = 'Name';
    vm.placeholder2 = '';

    vm.text4 = 'Date of Birth';
    vm.placeholder3 = 'YYY / MM / DD';

    vm.calendarFormat = 'yyyy / MM / dd';

    vm.datepickerOptions = {
      showWeeks: false
    };

    vm.text5 = 'Gender';
    vm.btn1 = 'Male';
    vm.btn2 = 'Female';

    vm.text6 = 'Are you living with the Policy Owner?';
    vm.btn3 = 'Yes';
    vm.btn4 = 'No';

    // vm.relationships = [{
    //   value: 'self',
    //   display: '契約者本人'
    // },{
    //   value: 'relative',
    //   display: '契約者の家族'
    // }];

    // vm.placeholder1 = '選択してください';

    // vm.relationshipTypes = [{
    //   value: '配偶者',
    //   display: '配偶者'
    // },{
    //   value: '子',
    //   display: '子'
    // },{
    //   value: '孫',
    //   display: '孫'
    // },{
    //   value: '父母',
    //   display: '父母'
    // },{
    //   value: '祖父母',
    //   display: '祖父母'
    // }];

    // vm.text3 = '氏名';
    // vm.placeholder2 = 'ご家族の氏名';

    // vm.text4 = '生年月日';
    // vm.placeholder3 = '年 / 月 / 日';

    // vm.calendarFormat = 'yyyy / MM / dd';

    // vm.datepickerOptions = {
    //   showWeeks: false
    // };

    // vm.text5 = '性別';
    // vm.btn1 = '女性';
    // vm.btn2 = '男性';

    // vm.text6 = '契約者と同居ですか？';
    // vm.btn3 = 'はい';
    // vm.btn4 = 'いいえ';


    vm.proceed = function () {
      if(vm.information.relationship == 'self') {
        vm.informationTemplate.Risks[0].RiskBody.InsuredParty.Name = vm.informationTemplate.Header.Owner.Name
        vm.informationTemplate.Risks[0].RiskBody.InsuredParty.Dob = moment(vm.informationTemplate.Header.Owner.Dob).format("YYYY-MM-DD")
        vm.informationTemplate.Risks[0].RiskBody.InsuredParty.Gender = vm.informationTemplate.Header.Owner.Gender
      } else if(vm.information.relationship == 'relative') {
        vm.informationTemplate.Risks[0].RiskBody.InsuredParty.Name = vm.information.name
        vm.informationTemplate.Risks[0].RiskBody.InsuredParty.Dob = moment(vm.information.birthDate).format("YYYY-MM-DD")
        vm.informationTemplate.Risks[0].RiskBody.InsuredParty.Gender = vm.information.gender;
        vm.informationTemplate.Risks[0].RiskBody.InsuredParty.Kinship = vm.information.relationshipType
        
        if (vm.information.living == 'No') {
          vm.informationTemplate.Risks[0].RiskBody.InsuredParty.Contact.Email = vm.information.email;
          vm.informationTemplate.Risks[0].RiskBody.InsuredParty.Contact.Phone = vm.information.contact;
          vm.informationTemplate.Risks[0].RiskBody.InsuredParty.Contact.Add.Add1 = vm.information.add1;
          vm.informationTemplate.Risks[0].RiskBody.InsuredParty.Contact.Add.Add2 = vm.information.add2;
          vm.informationTemplate.Risks[0].RiskBody.InsuredParty.Contact.Add.City = vm.information.city;
          vm.informationTemplate.Risks[0].RiskBody.InsuredParty.Contact.Add.Country = vm.information.country;
          vm.informationTemplate.Risks[0].RiskBody.InsuredParty.Contact.Add.Pcode = vm.information.postalCode1;
        }
      }
      PurchaseService.setInformation2(vm.informationTemplate);
      $state.go('purchase-11');
    };

    function init() {
      vm.information.name = 'Mark B';
      vm.information.birthDate = moment('1980-10-10').toDate();
      vm.information.gender = 'Male';
      vm.information.relationshipType = 'Spouse';
      vm.information.email = 'insured@insured.com';
      vm.information.contact = '+65-88886666';
      vm.information.add1 = 'Street 1';
      vm.information.add2 = 'City Center';
      vm.information.city = 'New Town';
      vm.information.country = 'My Republic';
      vm.information.postalCode1 = '347800';
      if (!_.isEmpty(PurchaseService.information2)) {
        vm.information = PurchaseService.information2;
      } else if(_.isEmpty(PurchaseService.information1)) {
        $state.go('purchase-1');
      }

      if (PurchaseService.isQuoteData()) {
        if (PurchaseService.QuoteData.Cont.Owner.Name == PurchaseService.QuoteData.Cont.Risks["1"].RiskBody.InsuredParty.Name) {
          vm.information.relationship = 'self';
        } else {
          vm.information.relationship = 'relative';
          vm.information.name = PurchaseService.QuoteData.Cont.Risks["1"].RiskBody.InsuredParty.Name;
          vm.information.birthDate = moment(PurchaseService.QuoteData.Cont.Risks["1"].RiskBody.InsuredParty.Dob).toDate();
          vm.information.gender = PurchaseService.QuoteData.Cont.Risks["1"].RiskBody.InsuredParty.Gender;
          vm.information.relationshipType = PurchaseService.QuoteData.Cont.Risks["1"].RiskBody.InsuredParty.Kinship;
          if (PurchaseService.QuoteData.Cont.Owner.Contact.Add.Add1 != PurchaseService.QuoteData.Cont.Risks["1"].RiskBody.InsuredParty.Contact.Add.Add1) {
            vm.information.living = 'No';
            vm.information.email = PurchaseService.QuoteData.Cont.Risks["1"].RiskBody.InsuredParty.Contact.Email;
            vm.information.contact = PurchaseService.QuoteData.Cont.Risks["1"].RiskBody.InsuredParty.Contact.Phone;
            vm.information.add1 = PurchaseService.QuoteData.Cont.Risks["1"].RiskBody.InsuredParty.Contact.Add.Add1;
            vm.information.add2 = PurchaseService.QuoteData.Cont.Risks["1"].RiskBody.InsuredParty.Contact.Add.Add2;
            vm.information.city = PurchaseService.QuoteData.Cont.Risks["1"].RiskBody.InsuredParty.Contact.Add.City;
            vm.information.country = PurchaseService.QuoteData.Cont.Risks["1"].RiskBody.InsuredParty.Contact.Add.Country;
            vm.information.postalCode1 = PurchaseService.QuoteData.Cont.Risks["1"].RiskBody.InsuredParty.Contact.Add.Pcode;
          }
        }
      }
    }

    init();
  }
})();

(function () {
  'use strict';

  angular
    .module('coherentPaDemo')
    .controller('Purchase1Controller', Purchase1Controller);

  /** @ngInject */
  function Purchase1Controller(PurchaseService, $stateParams, configUrls, environment, $http, $state) {
    var vm = this;

    vm.showPopup = false;
    vm.QuoteSearchBy = '';
    vm.QuoteSearchVal = '';
    vm.QuoteSearchResult = [];

    vm.text1_1 = 'Product:';
    vm.text1_1_product = 'PA';

    vm.text_folder = 'Folder:';
    vm.folder = 'coherent';

    vm.quote_id = '';

    vm.test = function () {
      PurchaseService.policyConfirmation();
    }

    vm.handleValueChange = function () {
      PurchaseService.setProduct(vm.text1_1_product);
    }

    vm.handleFolderChange = function () {
      PurchaseService.setFolderName(vm.folder);
    }

    vm.handleQuoteIDChange = function () {
      PurchaseService.setQuoteID(vm.quote_id);
    }

    vm.SearchQuote = function () {
      if (!vm.quote_id) {
        alert("Please enter a quote ID");
      }
      var req = {
        method: 'GET',
        url: 'https://enquiry.demo.sonic.dev.coherent.global/v1/quotation/id/' + vm.quote_id,
      };
      
      if (configUrls[environment].isAuthorizationNeeded) {
        req.headers = {
          'authorization': 'Bearer ' + configUrls[environment].token
        }
      }

      $http(req)
        .then(function (response) {
          console.log(response);
          PurchaseService.setQuoteID(vm.quote_id);
          PurchaseService.setPolicyNumber(vm.quote_id);
          PurchaseService.setQuoteData(response.data);
          $state.go('purchase-2');
        }, function () {
        });

    }

    vm.SearchQuoteList = function () {
      if (vm.QuoteSearchBy == 'ID') {
        vm.quote_id = vm.QuoteSearchVal;
        vm.SearchQuote();
        return false;
      }
      var req = {
        method: 'GET',
        url: 'https://enquiry.demo.sonic.dev.coherent.global/v1/search/quotation/' + vm.QuoteSearchBy + '_ISQUOTATION/' + vm.QuoteSearchVal + '_Y',
      };
      
      if (configUrls[environment].isAuthorizationNeeded) {
        req.headers = {
          'authorization': 'Bearer ' + configUrls[environment].token
        }
      }

      $http(req)
        .then(function (response) {
          var QuoteList = response.data.Data;
          var QuoteListKeys = Object.keys(QuoteList);
          if (QuoteListKeys.length < 1) {
            alert('No Quotation Found !');
            return false;
          }
          angular.forEach(QuoteListKeys, function (QuoteID) {
            var qt = JSON.parse(QuoteList[QuoteID])
            if (qt.QUOTATIONID) {
              vm.QuoteSearchResult.push(qt);
            }
          });
        }, function () {
        });
    }

    vm.goToQuote = function (quoteID) {
        vm.quote_id = quoteID;
        vm.SearchQuote();
        return false;
    }

    function init() {
      PurchaseService.clear();
      if ($stateParams.agent) {
        PurchaseService.setAgentCode($stateParams.agent)
      }
      if ($stateParams.vid) {
        PurchaseService.setMsgId($stateParams.vid)
      }
      PurchaseService.setProduct(vm.text1_1_product)
    }

    init();
  }
})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .service('TravelPurchaseService', svc);

  /** @ngInject */
  function svc($log) {
    var vm = this;

    vm.policy = {};

    vm.reset = function () {
      vm.policy = {
        tripCount: null,
        whereAreYouGoing: null,
        departuredate: null,
        arrivalDate: null,
        myself: false,
        spouse: false,
        additionalAdults: 0,
        totalAdults: 0,
        additionalChildren: 0,
        planType: '',
        defaultCoverage: 0,
        optionalBenefits: [],
        options: {}
      };
    };

    vm.debug = function () {
      $log.debug(vm.policy);
    };

  }
})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .factory('TravelPurchaseFactory', fctry);

  /** @ngInject */
  function fctry() {
    var vm = this;

    vm.planTypes = {
      basic: {
        name: 'Basic',
        title: 'travel_purchase_basic',
        description: 'travel_purchase_basic_description'
      },
      standard: {
        name: 'Standard',
        title: 'travel_purchase_standard',
        description: 'travel_purchase_standard_description'
      },
      premium: {
        name: 'Premium',
        title: 'travel_purchase_premium',
        description: 'travel_purchase_premium_description'
      },
      group: {
        name: 'Group',
        title: 'travel_purchase_group',
        description: 'travel_purchase_group_description'
      }
    };

    return vm;
  }
})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')

    .constant('TRAVEL_TYPE', 'HSBCTravel')
    .constant('TRAVEL_FOLDER', 'coherent')
    .constant('TRAVEL_PLANS_PAYLOAD', {"Inputs":{"Adults":0,"AgentCode":"ABC123","AllocatePremium":"","AppliedPremium":"","BrokerID":"ABC123","Children":0,"ClaimAmount":"[]","ClaimApproveAmount":"","ClaimBenefitLimits":"[]","ClaimHistory":"[]","ClaimHistoryNum":"[]","ClaimRef":"","ClaimRejectAmount":"","ClaimToDate":"[]","Currency":"HKD","Extra_Premium_Discount":0,"HKID":"","Insured_Person_Self":"","Insured_Person_Spouse":"","Optional_Benefits":"[]","Plan":"","Plan_Level":"","PolicyNo":"","Premium_Discount":"0%","PremiumBilled":"","PromoCode":"","Reference2":"","Region":"","Travel_End_Date":0,"Travel_Start_Date":0,"VIP":"N"},"TransactionDate":"","RequestedServiceCategory":""});

})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .controller('TravelPurchase3Controller', ctrl);

  /** @ngInject */
  function ctrl($log,
                $state,
                DATE_FORMAT,
                OPTIONS_PAYLOAD,
                TRAVEL_TYPE,
                TRAVEL_PLANS_PAYLOAD,
                TRAVEL_FOLDER,
                PurchaseFactory,
                PurchaseService,
                TravelPurchaseService) {
    var vm = this;

    vm.ui = {
      Currency: TravelPurchaseService.policy.Currency
    };

    vm.proceed = function() {
      TravelPurchaseService.policy.defaultCoverage = vm.ui.defaultCoverage;
      TravelPurchaseService.policy.optionalBenefits = vm.ui.options;
      PurchaseService.policy.type = TRAVEL_TYPE;
      PurchaseService.policy.carrier = TRAVEL_FOLDER;
      PurchaseService.policy.specs = TravelPurchaseService.policy;
      PurchaseService.policy.specs.installmentPermium = vm.ui.planType.price;
      PurchaseService.policy.specs.planDetails = angular.copy(TravelPurchaseService.policy.planType);
      PurchaseService.policy.specs.SelectedBenefits = vm.ui.SelectedBenefits;
      
      console.log(PurchaseService.policy.specs.planDetails)
      var a = TravelPurchaseService.policy.tripCount;
      var b = TravelPurchaseService.policy.planType.name;
      PurchaseService.policy.specs.planType = a;
      PurchaseService.policy.specs.planLevel = b;
      $state.go('purchase-9');
      // $state.go('common-purchase-2');
    };

    vm.getPrice = function () {
      PurchaseFactory.token().then( function(token) {
        PurchaseFactory.get(TRAVEL_TYPE, TRAVEL_FOLDER, generatePayload(), token).then(function (data) {
          var response = data.data.data.Outputs;
          vm.ui.planType.price = TravelPurchaseService.policy.planType.price = response.TotalPremium;
          vm.ui.SelectedBenefits = response.BenefitLimits;
        });
      });
    };

    function generatePayload() {
      var payload = angular.copy(TRAVEL_PLANS_PAYLOAD);

      var DATE_FORMAT = 'YYYYDDD';

      payload.Inputs.Region = TravelPurchaseService.policy.whereAreYouGoing;
      payload.Inputs.Plan_Level = TravelPurchaseService.policy.planType.Option;
      payload.Inputs.Adults = TravelPurchaseService.policy.totalAdults;
      payload.Inputs.Children = TravelPurchaseService.policy.additionalChildren;
      payload.Inputs.Insured_Person_Self = TravelPurchaseService.policy.myself ? 'Y' : 'N';
      payload.Inputs.Insured_Person_Spouse = TravelPurchaseService.policy.spouse ? 'Y' : 'N';
      payload.Inputs.Plan = TravelPurchaseService.policy.tripCount;
      // payload.Inputs.Travel_Start_Date = parseInt(moment(TravelPurchaseService.policy.departureDate).format(DATE_FORMAT), 10);
      // payload.Inputs.Travel_End_Date = parseInt(moment(TravelPurchaseService.policy.arrivalDate).format(DATE_FORMAT), 10);
      payload.Inputs.Travel_Start_Date = TravelPurchaseService.policy.departureDate;
      payload.Inputs.Travel_End_Date = TravelPurchaseService.policy.arrivalDate;
      payload.TransactionDate = moment().format('YYYY-MM-DDThh:mm:ss.ssssss') + 'Z';
      payload.Inputs.PromoCode = TravelPurchaseService.policy.PromoCode;

      payload.Inputs.Optional_Benefits = _.map(vm.ui.options, function (option) {
        return {
          Option: option.name,
          Included: option.enabled ? 'y' : 'n',
          ClaimLimit: option.enabled ? option.value : 0
        }
      });

      return payload;
    }

    function init() {
      TravelPurchaseService.debug();

      if(_.isEmpty(TravelPurchaseService.policy.planType)) {
        $log.debug('plan type is not defined. redirecting to step 1');
        $state.go('travel-purchase-1');
        return;
      }

      vm.ui.whereAreYouGoing = TravelPurchaseService.policy.whereAreYouGoing;
      vm.ui.departureDate = moment(TravelPurchaseService.policy.departureDate).format("MM/DD/YYYY");
      vm.ui.arrivalDate = moment(TravelPurchaseService.policy.arrivalDate).format("MM/DD/YYYY");
      vm.ui.totalAdults = TravelPurchaseService.policy.totalAdults;
      vm.ui.additionalChildren = TravelPurchaseService.policy.additionalChildren;
      vm.ui.planType = TravelPurchaseService.policy.planType;

      vm.ui.defaultCoverage = TravelPurchaseService.policy.defaultCoverage;
      vm.ui.minDefaultCoverage = 0;
      vm.ui.maxDefaultCoverage = 200;
      vm.ui.options = TravelPurchaseService.optionalBenefits;

      if (!TravelPurchaseService.optionalBenefits) {
        var selectedOpts = [];
        var optionsArr = [];
        if (PurchaseService.isQuoteData()) {
          var QuoteData = PurchaseService.QuoteData.Cont;
          optionsArr = QuoteData.Risks["1"].RiskBody.Options;
          angular.forEach(optionsArr, function(opt) {
            if (opt.Included == 'Y') {
              selectedOpts.push(opt.Option);
            }
          });
        } else {
          optionsArr = TravelPurchaseService.policy.optionalBenefits;
          angular.forEach(optionsArr, function(opt) {
            if (opt.enabled) {
              selectedOpts.push(opt.name);
            }
          });
        }

        

        vm.ui.options = _.map(TravelPurchaseService.policy.options.benefits, function (option) {
          return {
            name: option.Option,
            label: option.Desc,
            isCheckbox: !!option.Column1,
            type: option.Column2,
            max: option.Column5,
            min: option.Column4,
            value: option.Column3,
            enabled: (selectedOpts.includes(option.Option) ? true : false)
          };
        });

      }
    }

    init();
  }
})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .controller('TravelPurchase2Controller', ctrl);

  /** @ngInject */
  function ctrl($log,
                $state,
                DATE_FORMAT,
                TRAVEL_TYPE,
                TRAVEL_PLANS_PAYLOAD,
                TRAVEL_FOLDER,
                PurchaseFactory,
                TravelPurchaseFactory,
                TravelPurchaseService,
                PurchaseService) {
    var vm = this;

    vm.ui = {
      Currency: TravelPurchaseService.policy.Currency
    };

    vm.proceed = function () {
      // TravelPurchaseService.policy.planType = vm.ui.planType;
      angular.forEach(vm.ui.planTypes, function(plan) {
        if (plan.Option === vm.ui.planType) {
          TravelPurchaseService.policy.planType = plan;
        }
      });
      $state.go('travel-purchase-3');
    };

    function loadPlans() {
      // vm.ui.planTypes = TravelPurchaseFactory.planTypes;
      vm.ui.planTypes = TravelPurchaseService.policy.options.planLevels;
      PurchaseFactory.token().then( function(token) {
        angular.forEach(vm.ui.planTypes, function (planType) {
          PurchaseFactory.get(TRAVEL_TYPE, TRAVEL_FOLDER, generatePayload(planType), token).then(function (data) {
            planType.price = data.data.data.Outputs.TotalPremium;
          });
        });
      });
    }

    function generatePayload(planType) {
      var payload = angular.copy(TRAVEL_PLANS_PAYLOAD);

      var DATE_FORMAT = 'YYYYDDD';

      payload.Inputs.Region = TravelPurchaseService.policy.whereAreYouGoing;
      payload.Inputs.Plan_Level = planType.Option;
      payload.Inputs.Adults = TravelPurchaseService.policy.totalAdults;
      payload.Inputs.Children = TravelPurchaseService.policy.additionalChildren;
      payload.Inputs.Insured_Person_Self = TravelPurchaseService.policy.myself ? 'Y' : 'N';
      payload.Inputs.Insured_Person_Spouse = TravelPurchaseService.policy.spouse ? 'Y' : 'N';
      payload.Inputs.Plan = TravelPurchaseService.policy.tripCount;
      // payload.Inputs.Travel_Start_Date = parseInt(moment(TravelPurchaseService.policy.departureDate).format(DATE_FORMAT), 10);
      // payload.Inputs.Travel_End_Date = parseInt(moment(TravelPurchaseService.policy.arrivalDate).format(DATE_FORMAT), 10);
      payload.Inputs.Travel_Start_Date = TravelPurchaseService.policy.departureDate;
      payload.Inputs.Travel_End_Date = TravelPurchaseService.policy.arrivalDate;
      payload.Inputs.PromoCode = TravelPurchaseService.policy.PromoCode;
      payload.TransactionDate = moment().format('YYYY-MM-DDThh:mm:ss.ssssss') + 'Z';

      payload.Inputs.Optional_Benefits = _.map(TravelPurchaseService.policy.options.benefits, function (option) {
        return {
          Option: option.Option,
          Included: 'n',
          ClaimLimit: 0
        }
      });

      return payload;
    }

    function init() {
      TravelPurchaseService.debug();

      if(!TravelPurchaseService.policy.tripCount) {
        $log.debug('trip count is not defined. redirecting to step 1');
        $state.go('travel-purchase-1');
        return;
      }

      vm.ui.whereAreYouGoing = TravelPurchaseService.policy.whereAreYouGoing;
      vm.ui.departureDate = moment(TravelPurchaseService.policy.departureDate).format(DATE_FORMAT);
      vm.ui.arrivalDate = moment(TravelPurchaseService.policy.arrivalDate).format(DATE_FORMAT);
      vm.ui.totalAdults = TravelPurchaseService.policy.totalAdults;
      vm.ui.additionalChildren = TravelPurchaseService.policy.additionalChildren;

      if (PurchaseService.isQuoteData()) {
        var QuoteData = PurchaseService.QuoteData.Cont;
        vm.ui.planType = QuoteData.Risks["1"].RiskBody.Planlevel;
      } else {
        vm.ui.planType = TravelPurchaseService.policy.planType.Option;
      }

      loadPlans();
    }

    init();
  }
})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .controller('TravelPurchase1Controller', ctrl);

  /** @ngInject */
  function ctrl($state,
                CALENDAR_FORMAT,
                DATE_FORMAT,
                OPTIONS_PAYLOAD,
                TRAVEL_TYPE,
                TRAVEL_FOLDER,
                PurchaseFactory,
                TravelPurchaseFactory,
                TravelPurchaseService,
                PurchaseService) {
    var vm = this;

    vm.ui = {
      PromoCodes: [],
      PromoCode: '',
      CurrencyList: [],
      Currency: 'SGD'
    };

    vm.opts = {
      calendarFormat: CALENDAR_FORMAT,
      datepickerOptionsForDepartureDate: {
        showWeeks: false,
        minDate: moment(),
        maxDate: moment().add(275, 'days')
      },
      datepickerOptionsForArrivalDate: {
        showWeeks: false,
        minDate: moment(),
        maxDate: moment().add(275, 'days')
      },
      maxDependents: 99
    };

    vm.updateDatePickerOptions = function () {
      if (vm.ui.tripCount === 'Annual') {
        vm.ui.arrivalDate = moment(vm.ui.departureDate).add(365, 'days').format(DATE_FORMAT);
      }
      if (vm.ui.departureDate) {
        vm.opts.datepickerOptionsForArrivalDate.minDate = vm.ui.departureDate;
      }
    };

    vm.subtractAdults = function () {
      if (vm.ui.additionalAdults > 0) {
        vm.ui.additionalAdults -= 1;
      }
    };

    vm.addAdults = function () {
      if (vm.ui.additionalAdults + vm.ui.additionalChildren < vm.opts.maxDependents) {
        vm.ui.additionalAdults += 1;
      }
    };

    vm.subtractChildren = function () {
      if (vm.ui.additionalChildren > 0) {
        vm.ui.additionalChildren -= 1;
      }
    };

    vm.addChildren = function () {
      if (vm.ui.additionalAdults + vm.ui.additionalChildren < vm.opts.maxDependents) {
        vm.ui.additionalChildren += 1;
      }
    };

    vm.proceed = function () {
      TravelPurchaseService.policy.tripCount = vm.ui.tripCount;
      TravelPurchaseService.policy.whereAreYouGoing = vm.ui.whereAreYouGoing;
      TravelPurchaseService.policy.departureDate = moment(vm.ui.departureDate).format(DATE_FORMAT);
      TravelPurchaseService.policy.arrivalDate = moment(vm.ui.arrivalDate).format(DATE_FORMAT);
      TravelPurchaseService.policy.myself = vm.ui.myself;
      TravelPurchaseService.policy.spouse = vm.ui.spouse;
      TravelPurchaseService.policy.additionalAdults = vm.ui.additionalAdults;
      TravelPurchaseService.policy.totalAdults = vm.ui.myself + vm.ui.spouse + vm.ui.additionalAdults;
      TravelPurchaseService.policy.additionalChildren = vm.ui.additionalChildren;
      TravelPurchaseService.policy.PromoCode = vm.ui.PromoCode;
      TravelPurchaseService.policy.Currency = vm.ui.Currency;

      if (vm.ui.tripCount === 'Annual') {
        TravelPurchaseService.policy.PolicyTerm = 365;
      } else {
        var start = moment(vm.ui.departureDate);
        var end = moment(vm.ui.arrivalDate);
        TravelPurchaseService.policy.PolicyTerm  = ((moment.duration(start.diff(end)).asDays()) * -1) + 1;
      }
      $state.go('travel-purchase-2');
    };

    function loadOptions() {
      PurchaseFactory.token().then( function(token) {
        PurchaseFactory.get(TRAVEL_TYPE, TRAVEL_FOLDER, generatePayload(), token).then(function (data) {
          var outputs = data.data.data.Outputs;

          TravelPurchaseService.policy.options.benefits = outputs['Options.BenefitOptions'];
          TravelPurchaseService.policy.options.coverageAreas = outputs['Options.CoverageAreaOptions'];
          TravelPurchaseService.policy.options.planLevels = outputs['Options.PlanLevelOptions'];
          vm.ui.PromoCodes = outputs['Options.PromoCodeOptions'];
          vm.ui.CurrencyList = outputs['Options.CurrencyOptions'];

          vm.opts.countries = _.map(TravelPurchaseService.policy.options.coverageAreas, function (opt) {
            return {
              name: opt.Desc,
              value: opt.Option
            };
          });
        });
      });
    }

    function generatePayload() {
      var payload = angular.copy(OPTIONS_PAYLOAD);

      payload.TransactionDate = moment().format('YYYY-MM-DDThh:mm:ss.ssssss') + 'Z';
      return payload;
    }

    function init() {
      if (PurchaseService.isQuoteData()) {
        var QuoteData = PurchaseService.QuoteData.Cont;
        vm.ui.tripCount = QuoteData.Risks["1"].RiskBody.Plan;  // TravelPurchaseService.policy.tripCount;
        vm.ui.whereAreYouGoing = QuoteData.Risks["1"].RiskBody.Region;// TravelPurchaseService.policy.whereAreYouGoing;
        vm.ui.departureDate = moment(QuoteData.StartDate.split('T')[0]).toDate();
        vm.ui.arrivalDate = moment(QuoteData.EndDate.split('T')[0]).toDate();
        vm.ui.myself = QuoteData.Risks["1"].RiskBody.Self == 'Y' ? true : false;
        vm.ui.spouse = QuoteData.Risks["1"].RiskBody.Spouse == 'Y' ? true : false;
        vm.ui.additionalAdults = QuoteData.Risks["1"].RiskBody.Nadults;
        vm.ui.additionalChildren = QuoteData.Risks["1"].RiskBody.Nchildren;
        vm.ui.PromoCode = QuoteData.PromoCode;
      } else {
        vm.ui.tripCount = TravelPurchaseService.policy.tripCount;
        vm.ui.whereAreYouGoing = TravelPurchaseService.policy.whereAreYouGoing;
        vm.ui.departureDate = TravelPurchaseService.policy.departureDate && moment(TravelPurchaseService.policy.departureDate).toDate();
        vm.ui.arrivalDate = TravelPurchaseService.policy.arrivalDate && moment(TravelPurchaseService.policy.arrivalDate).toDate();
        vm.ui.myself = TravelPurchaseService.policy.myself;
        vm.ui.spouse = TravelPurchaseService.policy.spouse;
        vm.ui.additionalAdults = TravelPurchaseService.policy.additionalAdults;
        vm.ui.additionalChildren = TravelPurchaseService.policy.additionalChildren;
        vm.ui.PromoCode = TravelPurchaseService.policy.PromoCode;
      }

      PurchaseFactory.signIn(500).then(function (data) {
        PurchaseService.signedIn = true;
        PurchaseService.policy.email = vm.ui.email;
        PurchaseService.policy.name = data.name;
        PurchaseService.policy.birthDate = data.birthDate;
        PurchaseService.policy.gender = data.gender;
        PurchaseService.policy.postalCode1 = data.postalCode1;
        PurchaseService.policy.postalCode2 = data.postalCode2;
        PurchaseService.policy.address = data.address;
        PurchaseService.policy.contact = data.contact;
        loadOptions();
      });
    }

    init();
  }
})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .controller('RewardLandingController', RewardLandingController);

  /** @ngInject */
  function RewardLandingController($stateParams) {
    //var vm = this;

  }
})();
(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .controller('Reward2Controller', Reward2Controller);

  /** @ngInject */
  function Reward2Controller($stateParams) {
    //var vm = this;

  }
})();
(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .controller('Reward1Controller', Reward1Controller);

  /** @ngInject */
  function Reward1Controller($stateParams, $http, $state, configUrls, environment) {
    var vm = this;
    vm.ui = {};

    vm.opts = {
      datepickerOptions: {
        showWeeks: false
      }
    };

    vm.redeemData = {"Header":{"Product":"coherent:PA_Free","ContID":"","EndorsNo":"","EndorsDocNo":"","CPF":"","InstallmentPremium":0,"RG":"","IssuingAgency":"","DispatchDate":"0001-01-01T00:00:00Z","Term":1,"StartDate":"2021-11-01T09:37:39.377Z","EndDate":"0001-01-01T00:00:00Z","Status":"NewPolicy","PaymentFrequency":1,"PaymentMethod":"CreditCard","Currency":{"Code":"JPY","Descr":"JPY"},"Mandate":{"MandateRefNo":"","MandateStatus":"","BankAccount":{"BankName":"","BankBranch":"","AccountType":"","AccountName":"","AccountNo":"","OtherRef":""},"CreditCard":{"CardType":"","CardNumber":"","ExpiryMonth":"","ExpityYear":"","BankRefNum":""},"MandateDate":"0001-01-01T00:00:00Z","BillDay":0,"Remarks":""},"Underwriting":{"UWdate":"0001-01-01T00:00:00Z","UWUser":"","UWstatus":""},"Owner":{"Name":"John","FirstName":"","LastName":"","GivenName":"John","Gender":"M","Dob":"2000-01-22","Smoker":"","ID":[{"IDType":"HKID","IDNumber":"M12389123-9","IssueDate":"2000-01-22T09:40:36.940641599Z","ExpiryDate":"","IssuingAgency":"HK Government"}],"Contact":{"Email":"ravitheja.dhara@coherent.global","Phone":"","FbId":"","Add":{"Add1":"","Add2":"","Add3":"","Add4":"","City":"","Country":"","Pcode":""}},"Occupation":"","Nationality":"Hong Kong","Data":null},"Email":"","UWstatus":"","Agent":"10013","Channel":"Agent_1","PremiumTotals":{"GrossAnnualPrem":0,"NetAnnualPremium":0,"ModalPremium":0,"Gst":0,"GroupDiscount":0},"BilledPremium":{"GrossAnnualPrem":0,"NetAnnualPremium":0,"ModalPremium":0,"Gst":0,"GroupDiscount":0},"CoinsurancePremium":{"GrossAnnualPrem":0,"NetAnnualPremium":0,"ModalPremium":0,"Gst":0,"GroupDiscount":0},"PremiumReceipts":null,"PremiumCollection":null,"Risks":null,"ClaimList":null,"Data":null,"Notes":null,"Members":null,"Dependents":null,"PrincipalID":"","MasterPolicy":"PA-I-21-000000008","IsMasterPolicy":false,"BilledAt":"Member"},"Risks":[{"RiskType":"PA","PolicyId":"","RiskId":"1","Riskclass":"PA","Plan":"Plan_1","CoverType":"coherent:PA_Free","Sum_Insured":0,"InsuredParty":{"GivenName":"","Name":"","Dob":"","Age":0,"Gender":"","Id":{"IDType":"","IDNumber":"","IssueDate":"","ExpiryDate":"","IssuingAgency":""},"Occupation":"","MortalityClass":""},"Risk_Comm":"2021-11-01T09:37:39.377Z","Risk_End":"0001-01-01T00:00:00Z","RiskBody":{"RiskType":"PA","PolicyId":"","RiskId":"1","Plan":"Plan_1","Coverage":"Insured_1","Riskclass":"PA","MemberCount":1,"GroupClaim":15000,"CoverType":"coherent:PA_Free","EventDate":"0001-01-01T00:00:00Z","InsuredParty":{"GivenName":"John","Name":"John","Dob":"2000-01-22","Age":0,"Gender":"M","Id":{"IDType":"HKID","IDNumber":"M12389123-9","IssueDate":"2000-01-22T09:40:36.940641599Z","ExpiryDate":"","IssuingAgency":"HK Government"},"Occupation":"","MortalityClass":"N","Kinship":"","OtherPolicyInfo":null,"Documents":null,"Petinfo":{},"Contact":{"Email":"","Phone":"","FbId":"","Add":{"Add1":"","Add2":"","Add3":"","Add4":"","City":"","Country":"","Pcode":""}},"Data":null},"CoInsured":null,"TermUnits":"years","Term":1,"Payment_Frequency":"1","AdditionalCover":null,"BasePremium":0,"OptionalPremium":0,"PremiumLevy":0,"NetPremium":0,"Installment_Premium":0,"TotalPremium":0,"AppliedPremium":null,"Risk_Comm":"2021-11-01T09:37:39.377Z","Risk_End":"0001-01-01T00:00:00Z","Gst":0,"Status":"","UWStatus":"","Options":null,"Engine":"","Benefit_Limits":null,"ClaimList":null,"Beneficiaries":null,"CommissionAmount":0,"ReinsuranceTreaty":"","Data":null,"JointLife":"","RateAdjustment":0,"PremiumAdjustment":0,"StampDuty":0,"Channel":"Agent_1"},"Options":null,"ClaimList":null,"AppliedPremium":null,"TermUnits":"","Term":0,"Channel":"","Payment_Frequency":"","BasePremium":0}]}

    vm.ui.birthDate = moment('1980-10-10').toDate();
    vm.ui.name = "Yamada Taro";
    vm.ui.email = "yamadataro@email.com";
    vm.ui.contact = "08012341234";
    vm.ui.address = "Yoyogi 1-1-1, Shibuya, Tokyo";

    vm.redeemData.Header.Owner.Name = vm.ui.name;
    vm.redeemData.Header.Owner.Dob = moment(vm.ui.birthDate).format("YYYY-MM-DD");
    vm.redeemData.Header.Owner.Contact.Email = vm.ui.email;
    vm.redeemData.Header.Owner.Contact.Phone = vm.ui.contact;

    vm.redeem = function (data) {
      return $http({
        method: 'POST',
        url: configUrls[environment].createPolicy,
        data: data,
        headers: {
            'authorization': 'Bearer ' + configUrls[environment].token
        }
      });
    };

    vm.proceed = function () {
      // vm.redeem(vm.redeemData).then(function (data) {
      //   var policyNumber = data.data.PolicyID;
        $state.go('reward-2');
      // });
    };
  }
})();
(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .controller('ProductsController', ctrl);

  /** @ngInject */
  function ctrl(PurchaseService,
                AccidentPurchaseService,
                TravelPurchaseService) {
    var vm = this;

    function init() {
      TravelPurchaseService.reset();
      AccidentPurchaseService.reset();
      PurchaseService.reset();
      PurchaseService.clear();
    }

    init();

    return vm;
  }
})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .service('PolicyService', PolicyService);

  /** @ngInject */
  function PolicyService() {
    var vm = this;

    vm.PlanName = ""

    vm.setPolicyDetails = function (policyDetails) {
      vm.policyDetails = policyDetails;
    };

    vm.setPolNo = function (polNo) {
      vm.polNo = polNo;
    };

    vm.setConfirmationMessage = function (ConfirmationMessage) {
      vm.ConfirmationMessage = ConfirmationMessage;
    };

    vm.mapPlanName = function (plan) {
      switch(plan) {
        case "Plan1":
          return "Basic"
        case "Plan2":
          return "Relief"
        case "Plan3":
          return "Complete"
      }
    }

    vm.cancellationBody = {
      "PolicyID": "070910",
      "TranDate": "2021-09-22T09:40:36.940641599Z",
      "CancelDate": "2021-09-22",
      "CancelBy": "Customer",
      "CancelReason":"Cancel Reason"
    }

    vm.mapInsuredTypeName = function () {

    }
    vm.numberWithCommas = function (x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .controller('PolicyRenewController', PolicyRenewController);

  /** @ngInject */
  function PolicyRenewController($state, PolicyService, PurchaseService, $http, configUrls, environment) { 
    var vm = this;

    vm.renewBody =  {
        "PolicyID": "",
        "TranDate": (new Date()).toISOString().split("T")[0]
    }

    vm.btn1 = 'Extend This Policy'
    vm.btn2 = 'Select a New Plan'
    vm.text1 = 'How would you like to renew?'

    vm.extend = function() {   
      vm.renewBody.PolicyID = PolicyService.polNo
      vm.btn1 ='Loading';
      var headers = {};
      if (configUrls[environment].isAuthorizationNeeded) {
        headers = {
          'authorization': 'Bearer ' + configUrls[environment].token
        }
      }
      var req = {
        method: 'POST',
        url: 'https://policyservicing.demo.sonic.dev.coherent.global/v1/renewpolicy',
        headers: headers,
        data: angular.toJson(vm.renewBody)
      };
      $http(req)
        .then(function () {
          PolicyService.setConfirmationMessage('Your Policy Has Been Renewed')
          $state.go('policy-confirmation')
        }, function () {
      });
    };

    vm.new = function() {   
      $state.go('purchase-2')
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .controller('PolicyLoginController', PolicyLoginController);

  /** @ngInject */
  function PolicyLoginController($http, PolicyService, $stateParams, $state, configUrls, environment) {
    var vm = this;

    vm.signIn = function () {
      var req = {
        method: 'GET',
        // url: 'https://general.sonic.dev.coherent.com.hk/general/v2/enquiry/policy/' + vm.number
        url: configUrls[environment].enquirePolicy + vm.number,
      };
      if (configUrls[environment].isAuthorizationNeeded) {
        req.headers = {
          'authorization': 'Bearer ' + configUrls[environment].token
        }
      }
      
      $http(req)
        .then(function () {
          $state.go('policy-1', {'policyNumber': vm.number});
        }, function () {
        });
    }

    if(!_.isEmpty(PolicyService.policyDetails) || !_.isEmpty(PolicyService.polNo) ) {
      $state.go('policy-1', {'policyNumber': PolicyService.polNo});
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .controller('PolicyEditDetailController', PolicyEditDetailController);

  /** @ngInject */
  function PolicyEditDetailController($state, PolicyService, $http, configUrls, environment) {
    var vm = this;

    vm.policyDetails = {};
    // vm.updateAttachment = {
    //     "jsonrpc": "",
    //     "method": "invoke",
    //     "params": {
    //         "type": 0,
    //         "chaincodeID": {
    //             "name": ""
    //         },
    //         "ctorMsg": {
    //             "function": "UpdatePolicy",
    //             "args": [
    //                 "070910",
    //                 "2021-08-16T15:04:05Z",
    //                 "{\"Owner\": {\"Contact\": {\"Email\": \"newemail@mail.com\" } } }"
    //             ]
    //         },
    //         "secureContext": ""
    //     },
    //     "id": 0
    // }

    vm.updateAttachment = {
      "PolicyID": "PA-I-22-000000017",
      "TranDate": "2022-01-31",
      "Data": "{\"Owner\": {\"Contact\": {\"Email\": \"neha76@mail.com\" } } }",
      "User": "Test"
    }

    vm.calendarFormat = 'yyyy / MM / dd';

    vm.datepickerOptions = {
      showWeeks: false
    };

    function init() {
      if (!_.isEmpty(PolicyService.policyDetails)) {
        vm.policyDetails = PolicyService.policyDetails;

        vm.polNoText = 'Policy Number: ' + PolicyService.polNo;
        vm.plantype = PolicyService.PlanName;
        vm.price = PolicyService.numberWithCommas(PolicyService.policyDetails.Cont.Risks["1"].RiskBody.TotalPremium);

        vm.contractDate = vm.policyDetails.Cont.StartDate;
        vm.name = vm.policyDetails.Cont.Owner.Name;
        vm.dob = moment(vm.policyDetails.Cont.Owner.Dob).format("YYYY-MM-DD");
        vm.gender = vm.policyDetails.Cont.Owner.Gender;
        vm.pcode = vm.policyDetails.Cont.Owner.Contact.Add.Pcode;
        vm.add = vm.policyDetails.Cont.Owner.Contact.Add.Add1;
        vm.email = vm.policyDetails.Cont.Owner.Contact.Email;
        vm.phone = vm.policyDetails.Cont.Owner.Contact.Phone;
        vm.pcode1 = vm.pcode.substring(0, 3);
        vm.pcode2 = vm.pcode.substring(3, 8);

      } else if(_.isEmpty(PolicyService.policyDetails)) {
        $state.go('policy-1', {policyNumber: '209206'});
      }
    }
    init();

    function didChange(model, old) {
      if(!model) {return old} else {return model}
    }

    vm.proceed = function() {
      vm.btn3 ='Loading';

      // vm.updateAttachment.params.ctorMsg.args[0] = PolicyService.polNo
      // vm.updateAttachment.params.ctorMsg.args[2] = '{\"Owner\": {\"Contact\": {\"Email\": \"' + didChange(vm.information.email, vm.email) + '\",\"Phone\": \"' + didChange(vm.information.contact, vm.phone) +'\",\"Add\": {\"Add1\": \"' + didChange(vm.information.address, vm.add) + '\",\"Pcode\": \"' + didChange(vm.information.postalCode1, vm.pcode1) + didChange(vm.information.postalCode2, vm.pcode2) + '\"} } } }'
      vm.updateAttachment.PolicyID = PolicyService.polNo;
      vm.updateAttachment.Data = '{\"Owner\": {\"Contact\": {\"Email\": \"' + didChange(vm.information.email, vm.email) + '\",\"Phone\": \"' + didChange(vm.information.contact, vm.phone) +'\",\"Add\": {\"Add1\": \"' + didChange(vm.information.address, vm.add) + '\",\"Pcode\": \"' + didChange(vm.information.postalCode1, vm.pcode1) + didChange(vm.information.postalCode2, vm.pcode2) + '\"} } } }';

      var req = {
        method: 'POST',
        // url: 'https://general.sonic.dev.coherent.com.hk/general',
        url: configUrls[environment].updatePolicy,
        data: angular.toJson(vm.updateAttachment)
      };
      if (configUrls[environment].isAuthorizationNeeded) {
        req.headers = {
          'authorization': 'Bearer ' + configUrls[environment].token
        }
      }
      
      $http(req)
        .then(function () {
          PolicyService.setConfirmationMessage('Your details have been updated')
          $state.go('policy-confirmation')
        }, function () {
      });
    };

  }

})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .controller('PolicyDetailController', PolicyDetailController);

  /** @ngInject */
  function PolicyDetailController($state, PolicyService, $http, configUrls, environment) {
    var vm = this;

    vm.policyDetails = {};
    vm.cancellationBody = PolicyService.cancellationBody
    vm.panel1 = {};

    vm.polNo = PolicyService.polNo;

    vm.link1 = 'Edit';
    vm.RenewBtn = 'Renew Policy';

    vm.stopRenew = function () {
      vm.cancellationBody.PolicyID = PolicyService.polNo;
      vm.cancellationBody.TranDate = moment().format("YYYY-MM-DD");
      vm.cancellationBody.CancelDate  = moment(PolicyService.policyDetails.Cont.Risks["1"].Risk_End).format("YYYY-MM-DD");
      vm.cancellationBody.CancelReason = 'Cancellation of Renewal'
      vm.btn1 ='Loading';
      var req = {
        method: 'POST',
        // url: 'https://general.sonic.dev.coherent.com.hk/general/v2/service/cancelpolicy',
        url: configUrls[environment].cancelPolicy,
        data: angular.toJson(vm.cancellationBody)
      };

      if (configUrls[environment].isAuthorizationNeeded) {
        req.headers = {
          'authorization': 'Bearer ' + configUrls[environment].token
        }
      }
      
      $http(req)
        .then(function () {
          PolicyService.setConfirmationMessage('ご契約が' + moment(PolicyService.policyDetails.Cont.EndDate).format("YYYY-MM-DD") + 'に満了予定です')
          $state.go('policy-confirmation')
        }, function () {
      });
    }

    function init() {
      if (!_.isEmpty(PolicyService.policyDetails)) {
        vm.policyDetails = PolicyService.policyDetails;

        vm.polNo = PolicyService.polNo;
        vm.plantype = PolicyService.PlanName;
        vm.price = PolicyService.numberWithCommas(PolicyService.policyDetails.Cont.Risks["1"].RiskBody.TotalPremium);
        vm.panel1.price1 = PolicyService.numberWithCommas(PolicyService.policyDetails.Cont.Risks["1"].RiskBody.Benefit_Limits[0].PolicyLimit)
        // vm.panel1.price2 = PolicyService.numberWithCommas(PolicyService.policyDetails.Cont.Risks["1"].RiskBody.Benefit_Limits[2].DailyLimit)
        vm.panel1.price4 = PolicyService.numberWithCommas(PolicyService.policyDetails.Cont.Risks["1"].RiskBody.Benefit_Limits[3].PolicyLimit)
        vm.panel1.price5 = PolicyService.numberWithCommas(PolicyService.policyDetails.Cont.Risks["1"].RiskBody.Benefit_Limits[4].PolicyLimit)
        vm.panel1.price6 = PolicyService.numberWithCommas(PolicyService.policyDetails.Cont.Risks["1"].RiskBody.Benefit_Limits[5].PolicyLimit)

        vm.contractDate = moment(vm.policyDetails.Cont.StartDate).format("YYYY-MM-DD");
        vm.name = vm.policyDetails.Cont.Owner.Name;
        vm.dob = moment(vm.policyDetails.Cont.Owner.Dob).format("YYYY-MM-DD");
        vm.gender = vm.policyDetails.Cont.Owner.Gender;
        vm.pcode = vm.policyDetails.Cont.Owner.Contact.Add.Pcode.substring(0, 3) +'-'+ vm.policyDetails.Cont.Owner.Contact.Add.Pcode.substring(4, 8);
        vm.add = vm.policyDetails.Cont.Owner.Contact.Add.Add1;
        vm.email = vm.policyDetails.Cont.Owner.Contact.Email;
        vm.phone = vm.policyDetails.Cont.Owner.Contact.Phone;

        vm.insuredName = vm.policyDetails.Cont.Risks["1"].RiskBody.InsuredParty.Name;
        vm.insuredDob = moment(vm.policyDetails.Cont.Risks["1"].RiskBody.InsuredParty.Dob).format("YYYY-MM-DD");
        vm.insuredGender = vm.policyDetails.Cont.Risks["1"].RiskBody.InsuredParty.Gender
        vm.insuredKinship = vm.policyDetails.Cont.Risks["1"].RiskBody.InsuredParty.Kinship
        vm.paymentDetails = "•••• - •••• - •••• - " + vm.policyDetails.Cont.Mandate.CreditCard.CardNumber.substring("15", "19")

        vm.nextRenewalDate = moment(PolicyService.policyDetails.Cont.EndDate).format("YYYY-MM-DD")
        vm.ProductImg = vm.policyDetails.Cont.ProductImg;

      } else if(_.isEmpty(PolicyService.policyDetails)) {
        $state.go('policy-login');
      }
    }
    init();
  }

})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .controller('PolicyConfirmationController', PolicyConfirmationController);

  /** @ngInject */
  function PolicyConfirmationController($state, PolicyService) {
    var vm = this;
    vm.text2 = PolicyService.ConfirmationMessage
    vm.polNo = PolicyService.polNo;

    function init() {
      if(_.isEmpty(PolicyService.policyDetails)) {
        $state.go('policy-1');
      }
    }

    init();
  }
})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .controller('PolicyCancelController', PolicyCancelController);

  /** @ngInject */
  function PolicyCancelController($http, PolicyService, $stateParams, $state, PurchaseService, configUrls, environment) {
    var vm = this;

    vm.RefundBody = {
      "Inputs": {
        "CancellationDate": "2021-08-10",
        "CancelRef": "customer-",
        "Cover_End_Date_Original": "2022-07-09 16:00:00",
        "Start_Date": "2022-07-09 16:00:00",
        "BillPeriodStart": "2022-07-09 16:00:00",
        "BillPeriodEnd": "2022-07-09 16:00:00",
        "Cover_Start_Date": "2020-07-09",
        "CancelAllocatedPremium": "",
        "Channel": "Agent_2",
        "ClaimAmount": "[\n  {\n    \"Benefit\": \"A2\",\n    \"Amount\": 7878,\n    \"EventStart\": null,\n    \"EventDate\": null,\n    \"Claimant\": null\n  },\n  {\n    \"Benefit\": null,\n    \"Amount\": null,\n    \"EventStart\": null,\n    \"EventDate\": null,\n    \"Claimant\": null\n  },\n  {\n    \"Benefit\": null,\n    \"Amount\": null,\n    \"EventStart\": null,\n    \"EventDate\": null,\n    \"Claimant\": null\n  },\n  {\n    \"Benefit\": null,\n    \"Amount\": null,\n    \"EventStart\": null,\n    \"EventDate\": null,\n    \"Claimant\": null\n  },\n  {\n    \"Benefit\": null,\n    \"Amount\": null,\n    \"EventStart\": null,\n    \"EventDate\": null,\n    \"Claimant\": null\n  },\n  {\n    \"Benefit\": null,\n    \"Amount\": null,\n    \"EventStart\": null,\n    \"EventDate\": null,\n    \"Claimant\": null\n  },\n  {\n    \"Benefit\": null,\n    \"Amount\": null,\n    \"EventStart\": null,\n    \"EventDate\": null,\n    \"Claimant\": null\n  },\n  {\n    \"Benefit\": null,\n    \"Amount\": null,\n    \"EventStart\": null,\n    \"EventDate\": null,\n    \"Claimant\": null\n  },\n  {\n    \"Benefit\": null,\n    \"Amount\": null,\n    \"EventStart\": null,\n    \"EventDate\": null,\n    \"Claimant\": null\n  },\n  {\n    \"Benefit\": null,\n    \"Amount\": null,\n    \"EventStart\": null,\n    \"EventDate\": null,\n    \"Claimant\": null\n  },\n  {\n    \"Benefit\": null,\n    \"Amount\": null,\n    \"EventStart\": null,\n    \"EventDate\": null,\n    \"Claimant\": null\n  },\n  {\n    \"Benefit\": null,\n    \"Amount\": null,\n    \"EventStart\": null,\n    \"EventDate\": null,\n    \"Claimant\": null\n  },\n  {\n    \"Benefit\": null,\n    \"Amount\": null,\n    \"EventStart\": null,\n    \"EventDate\": null,\n    \"Claimant\": null\n  },\n  {\n    \"Benefit\": null,\n    \"Amount\": null,\n    \"EventStart\": null,\n    \"EventDate\": null,\n    \"Claimant\": null\n  },\n  {\n    \"Benefit\": null,\n    \"Amount\": null,\n    \"EventStart\": null,\n    \"EventDate\": null,\n    \"Claimant\": null\n  },\n  {\n    \"Benefit\": null,\n    \"Amount\": null,\n    \"EventStart\": null,\n    \"EventDate\": null,\n    \"Claimant\": null\n  },\n  {\n    \"Benefit\": null,\n    \"Amount\": null,\n    \"EventStart\": null,\n    \"EventDate\": null,\n    \"Claimant\": null\n  },\n  {\n    \"Benefit\": null,\n    \"Amount\": null,\n    \"EventStart\": null,\n    \"EventDate\": null,\n    \"Claimant\": null\n  },\n  {\n    \"Benefit\": null,\n    \"Amount\": null,\n    \"EventStart\": null,\n    \"EventDate\": null,\n    \"Claimant\": null\n  },\n  {\n    \"Benefit\": null,\n    \"Amount\": null,\n    \"EventStart\": null,\n    \"EventDate\": null,\n    \"Claimant\": null\n  }\n]",
        "ClaimHistory": "[\n  {\n    \"BenefitClaimed\": null,\n    \"ClaimDate\": null,\n    \"Amount\": null,\n    \"Claimant\": null\n  },\n  {\n    \"BenefitClaimed\": null,\n    \"ClaimDate\": null,\n    \"Amount\": null,\n    \"Claimant\": null\n  },\n  {\n    \"BenefitClaimed\": null,\n    \"ClaimDate\": null,\n    \"Amount\": null,\n    \"Claimant\": null\n  },\n  {\n    \"BenefitClaimed\": null,\n    \"ClaimDate\": null,\n    \"Amount\": null,\n    \"Claimant\": null\n  },\n  {\n    \"BenefitClaimed\": null,\n    \"ClaimDate\": null,\n    \"Amount\": null,\n    \"Claimant\": null\n  },\n  {\n    \"BenefitClaimed\": null,\n    \"ClaimDate\": null,\n    \"Amount\": null,\n    \"Claimant\": null\n  },\n  {\n    \"BenefitClaimed\": null,\n    \"ClaimDate\": null,\n    \"Amount\": null,\n    \"Claimant\": null\n  },\n  {\n    \"BenefitClaimed\": null,\n    \"ClaimDate\": null,\n    \"Amount\": null,\n    \"Claimant\": null\n  },\n  {\n    \"BenefitClaimed\": null,\n    \"ClaimDate\": null,\n    \"Amount\": null,\n    \"Claimant\": null\n  },\n  {\n    \"BenefitClaimed\": null,\n    \"ClaimDate\": null,\n    \"Amount\": null,\n    \"Claimant\": null\n  },\n  {\n    \"BenefitClaimed\": null,\n    \"ClaimDate\": null,\n    \"Amount\": null,\n    \"Claimant\": null\n  },\n  {\n    \"BenefitClaimed\": null,\n    \"ClaimDate\": null,\n    \"Amount\": null,\n    \"Claimant\": null\n  },\n  {\n    \"BenefitClaimed\": null,\n    \"ClaimDate\": null,\n    \"Amount\": null,\n    \"Claimant\": null\n  },\n  {\n    \"BenefitClaimed\": null,\n    \"ClaimDate\": null,\n    \"Amount\": null,\n    \"Claimant\": null\n  },\n  {\n    \"BenefitClaimed\": null,\n    \"ClaimDate\": null,\n    \"Amount\": null,\n    \"Claimant\": null\n  },\n  {\n    \"BenefitClaimed\": null,\n    \"ClaimDate\": null,\n    \"Amount\": null,\n    \"Claimant\": null\n  },\n  {\n    \"BenefitClaimed\": null,\n    \"ClaimDate\": null,\n    \"Amount\": null,\n    \"Claimant\": null\n  },\n  {\n    \"BenefitClaimed\": null,\n    \"ClaimDate\": null,\n    \"Amount\": null,\n    \"Claimant\": null\n  },\n  {\n    \"BenefitClaimed\": null,\n    \"ClaimDate\": null,\n    \"Amount\": null,\n    \"Claimant\": null\n  },\n  {\n    \"BenefitClaimed\": null,\n    \"ClaimDate\": null,\n    \"Amount\": null,\n    \"Claimant\": null\n  },\n  {\n    \"BenefitClaimed\": null,\n    \"ClaimDate\": null,\n    \"Amount\": null,\n    \"Claimant\": null\n  },\n  {\n    \"BenefitClaimed\": null,\n    \"ClaimDate\": null,\n    \"Amount\": null,\n    \"Claimant\": null\n  },\n  {\n    \"BenefitClaimed\": null,\n    \"ClaimDate\": null,\n    \"Amount\": null,\n    \"Claimant\": null\n  },\n  {\n    \"BenefitClaimed\": null,\n    \"ClaimDate\": null,\n    \"Amount\": null,\n    \"Claimant\": null\n  },\n  {\n    \"BenefitClaimed\": null,\n    \"ClaimDate\": null,\n    \"Amount\": null,\n    \"Claimant\": null\n  },\n  {\n    \"BenefitClaimed\": null,\n    \"ClaimDate\": null,\n    \"Amount\": null,\n    \"Claimant\": null\n  },\n  {\n    \"BenefitClaimed\": null,\n    \"ClaimDate\": null,\n    \"Amount\": null,\n    \"Claimant\": null\n  },\n  {\n    \"BenefitClaimed\": null,\n    \"ClaimDate\": null,\n    \"Amount\": null,\n    \"Claimant\": null\n  },\n  {\n    \"BenefitClaimed\": null,\n    \"ClaimDate\": null,\n    \"Amount\": null,\n    \"Claimant\": null\n  },\n  {\n    \"BenefitClaimed\": null,\n    \"ClaimDate\": null,\n    \"Amount\": null,\n    \"Claimant\": null\n  },\n  {\n    \"BenefitClaimed\": null,\n    \"ClaimDate\": null,\n    \"Amount\": null,\n    \"Claimant\": null\n  },\n  {\n    \"BenefitClaimed\": null,\n    \"ClaimDate\": null,\n    \"Amount\": null,\n    \"Claimant\": null\n  },\n  {\n    \"BenefitClaimed\": null,\n    \"ClaimDate\": null,\n    \"Amount\": null,\n    \"Claimant\": null\n  },\n  {\n    \"BenefitClaimed\": null,\n    \"ClaimDate\": null,\n    \"Amount\": null,\n    \"Claimant\": null\n  },\n  {\n    \"BenefitClaimed\": null,\n    \"ClaimDate\": null,\n    \"Amount\": null,\n    \"Claimant\": null\n  },\n  {\n    \"BenefitClaimed\": null,\n    \"ClaimDate\": null,\n    \"Amount\": null,\n    \"Claimant\": null\n  },\n  {\n    \"BenefitClaimed\": null,\n    \"ClaimDate\": null,\n    \"Amount\": null,\n    \"Claimant\": null\n  }\n]",
        "ClaimToDate": "[\n  {\n    \"Benefit\": null,\n    \"ClaimToDate\": null,\n    \"PolicyToDate\": null,\n    \"Count\": null\n  },\n  {\n    \"Benefit\": null,\n    \"ClaimToDate\": null,\n    \"PolicyToDate\": null,\n    \"Count\": null\n  },\n  {\n    \"Benefit\": null,\n    \"ClaimToDate\": null,\n    \"PolicyToDate\": null,\n    \"Count\": null\n  },\n  {\n    \"Benefit\": null,\n    \"ClaimToDate\": null,\n    \"PolicyToDate\": null,\n    \"Count\": null\n  },\n  {\n    \"Benefit\": null,\n    \"ClaimToDate\": null,\n    \"PolicyToDate\": null,\n    \"Count\": null\n  },\n  {\n    \"Benefit\": null,\n    \"ClaimToDate\": null,\n    \"PolicyToDate\": null,\n    \"Count\": null\n  },\n  {\n    \"Benefit\": null,\n    \"ClaimToDate\": null,\n    \"PolicyToDate\": null,\n    \"Count\": null\n  },\n  {\n    \"Benefit\": null,\n    \"ClaimToDate\": null,\n    \"PolicyToDate\": null,\n    \"Count\": null\n  },\n  {\n    \"Benefit\": null,\n    \"ClaimToDate\": null,\n    \"PolicyToDate\": null,\n    \"Count\": null\n  },\n  {\n    \"Benefit\": null,\n    \"ClaimToDate\": null,\n    \"PolicyToDate\": null,\n    \"Count\": null\n  },\n  {\n    \"Benefit\": null,\n    \"ClaimToDate\": null,\n    \"PolicyToDate\": null,\n    \"Count\": null\n  },\n  {\n    \"Benefit\": null,\n    \"ClaimToDate\": null,\n    \"PolicyToDate\": null,\n    \"Count\": null\n  },\n  {\n    \"Benefit\": null,\n    \"ClaimToDate\": null,\n    \"PolicyToDate\": null,\n    \"Count\": null\n  },\n  {\n    \"Benefit\": null,\n    \"ClaimToDate\": null,\n    \"PolicyToDate\": null,\n    \"Count\": null\n  },\n  {\n    \"Benefit\": null,\n    \"ClaimToDate\": null,\n    \"PolicyToDate\": null,\n    \"Count\": null\n  },\n  {\n    \"Benefit\": null,\n    \"ClaimToDate\": null,\n    \"PolicyToDate\": null,\n    \"Count\": null\n  },\n  {\n    \"Benefit\": null,\n    \"ClaimToDate\": null,\n    \"PolicyToDate\": null,\n    \"Count\": null\n  },\n  {\n    \"Benefit\": null,\n    \"ClaimToDate\": null,\n    \"PolicyToDate\": null,\n    \"Count\": null\n  },\n  {\n    \"Benefit\": null,\n    \"ClaimToDate\": null,\n    \"PolicyToDate\": null,\n    \"Count\": null\n  },\n  {\n    \"Benefit\": null,\n    \"ClaimToDate\": null,\n    \"PolicyToDate\": null,\n    \"Count\": null\n  },\n  {\n    \"Benefit\": null,\n    \"ClaimToDate\": null,\n    \"PolicyToDate\": null,\n    \"Count\": null\n  },\n  {\n    \"Benefit\": null,\n    \"ClaimToDate\": null,\n    \"PolicyToDate\": null,\n    \"Count\": null\n  },\n  {\n    \"Benefit\": null,\n    \"ClaimToDate\": null,\n    \"PolicyToDate\": null,\n    \"Count\": null\n  },\n  {\n    \"Benefit\": null,\n    \"ClaimToDate\": null,\n    \"PolicyToDate\": null,\n    \"Count\": null\n  },\n  {\n    \"Benefit\": null,\n    \"ClaimToDate\": null,\n    \"PolicyToDate\": null,\n    \"Count\": null\n  },\n  {\n    \"Benefit\": null,\n    \"ClaimToDate\": null,\n    \"PolicyToDate\": null,\n    \"Count\": null\n  },\n  {\n    \"Benefit\": null,\n    \"ClaimToDate\": null,\n    \"PolicyToDate\": null,\n    \"Count\": null\n  },\n  {\n    \"Benefit\": null,\n    \"ClaimToDate\": null,\n    \"PolicyToDate\": null,\n    \"Count\": null\n  },\n  {\n    \"Benefit\": null,\n    \"ClaimToDate\": null,\n    \"PolicyToDate\": null,\n    \"Count\": null\n  },\n  {\n    \"Benefit\": null,\n    \"ClaimToDate\": null,\n    \"PolicyToDate\": null,\n    \"Count\": null\n  },\n  {\n    \"Benefit\": null,\n    \"ClaimToDate\": null,\n    \"PolicyToDate\": null,\n    \"Count\": null\n  },\n  {\n    \"Benefit\": null,\n    \"ClaimToDate\": null,\n    \"PolicyToDate\": null,\n    \"Count\": null\n  },\n  {\n    \"Benefit\": null,\n    \"ClaimToDate\": null,\n    \"PolicyToDate\": null,\n    \"Count\": null\n  },\n  {\n    \"Benefit\": null,\n    \"ClaimToDate\": null,\n    \"PolicyToDate\": null,\n    \"Count\": null\n  },\n  {\n    \"Benefit\": null,\n    \"ClaimToDate\": null,\n    \"PolicyToDate\": null,\n    \"Count\": null\n  },\n  {\n    \"Benefit\": null,\n    \"ClaimToDate\": null,\n    \"PolicyToDate\": null,\n    \"Count\": null\n  },\n  {\n    \"Benefit\": null,\n    \"ClaimToDate\": null,\n    \"PolicyToDate\": null,\n    \"Count\": null\n  }\n]",
        "Coverage": "Insured_1",
        "DOB": "1980-01-01",
        "Gender": "F",
        "Optional_Benefits": "[\n  {\n    \"Option\": \"Insured_1\",\n    \"Included\": \"Y\"\n  }\n]",
        "Plan": "Plan_2",
        "Policy_Cover_QuoteDate": "2021-07-01",
        "PostalCode": "064-0806",
        "Promotion_Discount_Code": "",
        "Ratings": "[\n  {\n    \"RatingFactor\": \"RakutenPoints\",\n    \"Value\": 20\n  },\n  {\n    \"RatingFactor\": null,\n    \"Value\": null\n  },\n  {\n    \"RatingFactor\": null,\n    \"Value\": null\n  },\n  {\n    \"RatingFactor\": null,\n    \"Value\": null\n  },\n  {\n    \"RatingFactor\": null,\n    \"Value\": null\n  },\n  {\n    \"RatingFactor\": null,\n    \"Value\": null\n  },\n  {\n    \"RatingFactor\": null,\n    \"Value\": null\n  },\n  {\n    \"RatingFactor\": null,\n    \"Value\": null\n  },\n  {\n    \"RatingFactor\": null,\n    \"Value\": null\n  },\n  {\n    \"RatingFactor\": null,\n    \"Value\": null\n  },\n  {\n    \"RatingFactor\": null,\n    \"Value\": null\n  },\n  {\n    \"RatingFactor\": null,\n    \"Value\": null\n  },\n  {\n    \"RatingFactor\": null,\n    \"Value\": null\n  },\n  {\n    \"RatingFactor\": null,\n    \"Value\": null\n  },\n  {\n    \"RatingFactor\": null,\n    \"Value\": null\n  }\n]",
        "Term": "1",
        "Underwriting_Response": "[\n  {\n    \"UWSurveyCode\": \"PA_UW_1\",\n    \"UWSurveyResponse\": \"Y\"\n  },\n  {\n    \"UWSurveyCode\": \"PA_UW_2\",\n    \"UWSurveyResponse\": \"Y\"\n  },\n  {\n    \"UWSurveyCode\": \"PA_UW_3\",\n    \"UWSurveyResponse\": null\n  },\n  {\n    \"UWSurveyCode\": \"PA_UW_4\",\n    \"UWSurveyResponse\": null\n  },\n  {\n    \"UWSurveyCode\": \"PA_UW_5\",\n    \"UWSurveyResponse\": null\n  },\n  {\n    \"UWSurveyCode\": \"PA_UW_6\",\n    \"UWSurveyResponse\": null\n  },\n  {\n    \"UWSurveyCode\": \"PA_UW_7\",\n    \"UWSurveyResponse\": null\n  },\n  {\n    \"UWSurveyCode\": \"PA_UW_8\",\n    \"UWSurveyResponse\": null\n  },\n  {\n    \"UWSurveyCode\": \"PA_UW_9\",\n    \"UWSurveyResponse\": null\n  },\n  {\n    \"UWSurveyCode\": \"PA_UW_10\",\n    \"UWSurveyResponse\": null\n  },\n  {\n    \"UWSurveyCode\": \"PA_UW_11\",\n    \"UWSurveyResponse\": null\n  },\n  {\n    \"UWSurveyCode\": \"PA_UW_12\",\n    \"UWSurveyResponse\": null\n  },\n  {\n    \"UWSurveyCode\": \"PA_UW_13\",\n    \"UWSurveyResponse\": null\n  },\n  {\n    \"UWSurveyCode\": \"PA_UW_14\",\n    \"UWSurveyResponse\": null\n  },\n  {\n    \"UWSurveyCode\": \"PA_UW_15\",\n    \"UWSurveyResponse\": null\n  },\n  {\n    \"UWSurveyCode\": \"PA_UW_16\",\n    \"UWSurveyResponse\": null\n  },\n  {\n    \"UWSurveyCode\": \"PA_UW_17\",\n    \"UWSurveyResponse\": null\n  },\n  {\n    \"UWSurveyCode\": \"PA_UW_18\",\n    \"UWSurveyResponse\": null\n  },\n  {\n    \"UWSurveyCode\": \"PA_UW_19\",\n    \"UWSurveyResponse\": null\n  },\n  {\n    \"UWSurveyCode\": \"PA_UW_20\",\n    \"UWSurveyResponse\": null\n  }\n]"
      }
      // "TransactionDate": "2021-08-01T16:46:47.947Z",
      // "EngineType": "Type1",
      // "Solves": [],
      // "RequestedServiceCategory": "Refund",
      // "ServiceName": "Bicycle_Product_v1.3",
      // "Description": "",
      // "RequestedOutPut": "",
      // "EndPoint": "https://excel.sonic.dev.coherent.com.hk/api/v1/product/coherent/engines/Execute/PA",
      // "IsRichJson": false,
      // "ServiceCategories": [
      //   "Claim",
      //   "Options",
      //   "Refund"
      // ],
      // "ShouldExecuteInputs": false
    }

    vm.cancellationBody = PolicyService.cancellationBody;

    vm.refundInitial = '0'

    function init() {
      if (!_.isEmpty(PolicyService.policyDetails)) {
        vm.policyDetails = PolicyService.policyDetails;
        vm.polNoText = 'Policy Number: ' + PolicyService.polNo;
        vm.plantype = PolicyService.PlanName;
        vm.price = PolicyService.numberWithCommas(PolicyService.policyDetails.Cont.Risks["1"].RiskBody.Installment_Premium);
        vm.ProductImg = vm.policyDetails.Cont.ProductImg;

      } else if(_.isEmpty(PolicyService.policyDetails)) {
        $state.go('policy-1', {policyNumber: '209206'});
      }
    }
    init();

    vm.getPrice = function () {

      var settings = {
        method: 'GET',
        url: configUrls[environment].keyCloakTokenUrl + '?apiKey=' + configUrls[environment].keyCloakApiKey + '&client=' + configUrls[environment].keyCloakPFClient,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      };

      $http(settings).then(function (response) {
        console.log(response);
        return response
      }).then(function (tokenRes) {

        // ----- Existing code here ----//
        vm.RefundBody.Inputs.CancellationDate = moment(vm.cancelDate).format("YYYY-MM-DD hh:mm:ss")
        vm.RefundBody.Inputs.BillPeriodStart = moment(vm.policyDetails.Cont.StartDate).format("YYYY-MM-DD hh:mm:ss")
        // vm.RefundBody.Inputs.BillPeriodEnd = moment(vm.policyDetails.Cont.EndDate).format("YYYY-MM-DD hh:mm:ss")
        vm.RefundBody.Inputs.BillPeriodEnd = moment(vm.policyDetails.Cont.StartDate).add(1 , 'year').format("YYYY-MM-DD hh:mm:ss")
        vm.RefundBody.Inputs.CancelAllocatedPremium = vm.policyDetails.Cont.PremiumCollection[0].Premium["1"].Allocated
        vm.RefundBody.Inputs.Start_Date = moment(vm.policyDetails.Cont.StartDate).format("YYYY-MM-DD hh:mm:ss")
        vm.RefundBody.Inputs.CancelRef = vm.reason
        // vm.RefundBody.Inputs["Refund.Cover_Cancellation_Date"] =
        // vm.RefundBody.Inputs["Refund.Cover_End_Date_Original"] = moment(vm.policyDetails.Cont.EndDate).format("YYYY-MM-DD hh:mm:ss")
        // vm.RefundBody.Inputs["Refund.Cover_Start_Date"] = moment(vm.policyDetails.Cont.StartDate).format("YYYY-MM-DD hh:mm:ss")
        var req = {
          method: 'POST',
          // url: 'https://excel.sonic.dev.coherent.com.hk/api/v1/product/coherent/engines/Execute/PA',
          // headers: {
          //   'SecretKey': '762f5692-5a8b-4f8e-a09e-a27a277c0c56',
          //   'x-tenant-name': 'coherent'
          // },
          url: configUrls[environment].PFUrl + PurchaseService.ProductCode,          
          headers: {
            authorization: 'Bearer ' + tokenRes.data.access_token
          },
          data: angular.toJson(vm.RefundBody)
        };
        $http(req)
          .then(function (response) {
            vm.RefundDetails = response.data.data.Outputs
            vm.refundInitial = vm.RefundDetails.RefundPremium
            vm.refund = vm.RefundDetails.RefundPremium
          }, function () {
        });
        // ----- Existing code end ----//

      });
    }

    vm.proceed = function() {
      vm.cancellationBody.PolicyID = PolicyService.polNo
      vm.cancellationBody.TranDate = moment(vm.cancelDate).format("YYYY-MM-DD")
      vm.cancellationBody.CancelDate = moment(vm.cancelDate).format("YYYY-MM-DD")
      vm.cancellationBody.CancelReason = vm.reason
      vm.btn1 ='Loading';

      var req = {
        method: 'POST',
        // url: 'https://general.sonic.dev.coherent.com.hk/general/v2/service/cancelpolicy',
        url: configUrls[environment].cancelPolicy,
        data: angular.toJson(vm.cancellationBody)
      };
      if (configUrls[environment].isAuthorizationNeeded) {
        req.headers = {
          'authorization': 'Bearer ' + configUrls[environment].token
        }
      }
      
      $http(req)
        .then(function () {
          PolicyService.setConfirmationMessage('Your policy has been cancelled')
          $state.go('policy-confirmation')
        }, function () {
      });
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .controller('Policy1Controller', Policy1Controller);

  /** @ngInject */
  function Policy1Controller($http, PolicyService, $stateParams, $state, PurchaseService, configUrls, environment) {
    var vm = this

    // vm.text1 = 'おはようございます'
    // vm.text2 = 'John Doe'
    // vm.policyDetails = {}

    // vm.policies = [{
    //   name: 'サイクルアシスト',
    //   number: '証券番号：51000306',
    //   type: 'ファミリープラン',
    //   amount: '8,320円',
    //   color: 'green',
    //   img: 'assets/images/purple-siren.png'
    // },{
    //   name: 'トラベルアシスト',
    //   number: '証券番号. 51007779',
    //   type: 'カップルプラン',
    //   amount: '3,000円',
    //   color: 'skyblue',
    //   img: '/assets/images/l-blue-bag.png'
    // },{
    //   name: 'ドライブアシスト',
    //   number: '証券番号. 51002303',
    //   type: '個人プラン',
    //   amount: '4,770円',
    //   color: 'blue',
    //   img: '/assets/images/d-blue-car.png'
    // }];

    // vm.btn1 = 'ご契約を追加する';
    // vm.btn2 = '保険金を請求する';

    vm.text1 = 'Welcome Back,'
    vm.text2 = 'John Doe'
    vm.policyDetails = {}
    vm.policyType = '';
    vm.policySeq = 0;

    vm.cancellationBody = PolicyService.cancellationBody
    vm.panel1 = {};
    vm.polNo = PolicyService.polNo;
    vm.link1 = 'Edit';
    vm.RenewBtn = 'Renew Policy';

    vm.policies = [{
      name: 'policy_personal_accident',
      number: '51000306',
      type: 'policy_personal',
      amount: '8,320',
      color: 'purple',
      img: 'assets/images/purple-siren.png',
      riskType: ''
    },{
      name: 'policy_travel',
      number: '51007779',
      type: 'policy_family',
      amount: '3,000',
      color: 'skyblue',
      img: '/assets/images/l-blue-bag.png',
      riskType: ''
    },{
      name: 'policy_motor',
      number: '51002303',
      type: 'policy_personal',
      amount: '4,770',
      color: 'blue',
      img: '/assets/images/d-blue-car.png',
      riskType: ''
    }];

    vm.stopRenew = function () {
      vm.cancellationBody.PolicyID = PolicyService.polNo;
      vm.cancellationBody.TranDate = moment().format("YYYY-MM-DD");
      vm.cancellationBody.CancelDate  = moment(PolicyService.policyDetails.Cont.Risks["1"].Risk_End).format("YYYY-MM-DD");
      vm.cancellationBody.CancelReason = 'Cancellation of Renewal'
      vm.btn1 ='Loading';
      var req = {
        method: 'POST',
        // url: 'https://general.sonic.dev.coherent.com.hk/general/v2/service/cancelpolicy',
        url: configUrls[environment].cancelPolicy,
        data: angular.toJson(vm.cancellationBody)
      };

      if (configUrls[environment].isAuthorizationNeeded) {
        req.headers = {
          'authorization': 'Bearer ' + configUrls[environment].token
        }
      }
      
      $http(req)
        .then(function () {
          PolicyService.setConfirmationMessage('ご契約が' + moment(PolicyService.policyDetails.Cont.EndDate).format("YYYY-MM-DD") + 'に満了予定です')
          $state.go('policy-confirmation')
        }, function () {
      });
    }

    var init = function() {

      var req = {
        method: 'GET',
        // url: 'https://general.sonic.dev.coherent.com.hk/general/v2/enquiry/policy/' + $stateParams.policyNumber
        url: configUrls[environment].enquirePolicy +  $stateParams.policyNumber,
      };
      if (configUrls[environment].isAuthorizationNeeded) {
        req.headers = {
          'authorization': 'Bearer ' + configUrls[environment].token
        }
      }
      
      $http(req)
        .then(function (response) {
          vm.policyDetails = response.data;
          if (vm.policyDetails.Cont.Risks["1"].RiskBody.RiskType == 'PA') {
            vm.policySeq = 0;
          } else if (vm.policyDetails.Cont.Risks["1"].RiskBody.RiskType == 'Travel') {
            vm.policySeq = 1;
          } else if (vm.policyDetails.Cont.Risks["1"].RiskBody.RiskType == 'HOM') {
            vm.policySeq = 2;
          }
          vm.policyDetails.Cont.ProductImg = vm.policies[vm.policySeq].img;
          PolicyService.setPolicyDetails(vm.policyDetails);
          PolicyService.setPolNo($stateParams.policyNumber);
          PurchaseService.setProduct(vm.policyDetails.Cont.Product.split(':')[1]);

          vm.policies[vm.policySeq].riskType = vm.policyDetails.Cont.Risks["1"].RiskBody.RiskType;
          vm.policies[vm.policySeq].number = vm.policyDetails.Cont.ContID;

          // TODO: How to translate this?
          vm.policies[vm.policySeq].type = PolicyService.mapPlanName(vm.policyDetails.Cont.Risks["1"].RiskBody.Plan);
          PolicyService.PlanName = vm.policies[vm.policySeq].type;

          vm.policies[vm.policySeq].amount = PolicyService.numberWithCommas(vm.policyDetails.Cont.Risks["1"].RiskBody.TotalPremium);
          vm.text2 = vm.policyDetails.Cont.Owner.Name;

          if (!_.isEmpty(PolicyService.policyDetails)) {
            // vm.policyDetails = PolicyService.policyDetails;
    
            vm.polNo = PolicyService.polNo;
            vm.plantype = PolicyService.PlanName;
            vm.price = PolicyService.numberWithCommas(PolicyService.policyDetails.Cont.Risks["1"].RiskBody.TotalPremium);
            vm.panel1.price1 = PolicyService.numberWithCommas(PolicyService.policyDetails.Cont.Risks["1"].RiskBody.Benefit_Limits[0].PolicyLimit)
            // vm.panel1.price2 = PolicyService.numberWithCommas(PolicyService.policyDetails.Cont.Risks["1"].RiskBody.Benefit_Limits[2].DailyLimit)
            vm.panel1.price4 = PolicyService.numberWithCommas(PolicyService.policyDetails.Cont.Risks["1"].RiskBody.Benefit_Limits[3].PolicyLimit)
            vm.panel1.price5 = PolicyService.numberWithCommas(PolicyService.policyDetails.Cont.Risks["1"].RiskBody.Benefit_Limits[4].PolicyLimit)
            vm.panel1.price6 = PolicyService.numberWithCommas(PolicyService.policyDetails.Cont.Risks["1"].RiskBody.Benefit_Limits[5].PolicyLimit)
    
            vm.contractDate = moment(vm.policyDetails.Cont.StartDate).format("YYYY-MM-DD");
            vm.name = vm.policyDetails.Cont.Owner.Name;
            vm.dob = moment(vm.policyDetails.Cont.Owner.Dob).format("YYYY-MM-DD");
            vm.gender = vm.policyDetails.Cont.Owner.Gender;
            vm.pcode = vm.policyDetails.Cont.Owner.Contact.Add.Pcode.substring(0, 3) +'-'+ vm.policyDetails.Cont.Owner.Contact.Add.Pcode.substring(4, 8);
            vm.add = vm.policyDetails.Cont.Owner.Contact.Add.Add1;
            vm.email = vm.policyDetails.Cont.Owner.Contact.Email;
            vm.phone = vm.policyDetails.Cont.Owner.Contact.Phone;
    
            vm.insuredName = vm.policyDetails.Cont.Risks["1"].RiskBody.InsuredParty.Name;
            vm.insuredDob = moment(vm.policyDetails.Cont.Risks["1"].RiskBody.InsuredParty.Dob).format("YYYY-MM-DD");
            vm.insuredGender = vm.policyDetails.Cont.Risks["1"].RiskBody.InsuredParty.Gender
            vm.insuredKinship = vm.policyDetails.Cont.Risks["1"].RiskBody.InsuredParty.Kinship
            vm.paymentDetails = "•••• - •••• - •••• - " + vm.policyDetails.Cont.Mandate.CreditCard.CardNumber.substring("15", "19")
    
            vm.nextRenewalDate = moment(PolicyService.policyDetails.Cont.EndDate).format("YYYY-MM-DD")
            vm.ProductImg = vm.policyDetails.Cont.ProductImg;
    
          } else if(_.isEmpty(PolicyService.policyDetails)) {
            $state.go('policy-login');
          }
          
        }, function () {
          $state.go('policy-login');
      });
    }

    init();

  }
})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .controller('Policy1Controller_bk', Policy1Controller_bk);

  /** @ngInject */
  function Policy1Controller_bk($http, PolicyService, $stateParams,$state, PurchaseService, configUrls, environment) {
    var vm = this

    // vm.text1 = 'おはようございます'
    // vm.text2 = 'John Doe'
    // vm.policyDetails = {}

    // vm.policies = [{
    //   name: 'サイクルアシスト',
    //   number: '証券番号：51000306',
    //   type: 'ファミリープラン',
    //   amount: '8,320円',
    //   color: 'green',
    //   img: 'assets/images/purple-siren.png'
    // },{
    //   name: 'トラベルアシスト',
    //   number: '証券番号. 51007779',
    //   type: 'カップルプラン',
    //   amount: '3,000円',
    //   color: 'skyblue',
    //   img: '/assets/images/l-blue-bag.png'
    // },{
    //   name: 'ドライブアシスト',
    //   number: '証券番号. 51002303',
    //   type: '個人プラン',
    //   amount: '4,770円',
    //   color: 'blue',
    //   img: '/assets/images/d-blue-car.png'
    // }];

    // vm.btn1 = 'ご契約を追加する';
    // vm.btn2 = '保険金を請求する';

    vm.text1 = 'Welcome Back,'
    vm.text2 = 'John Doe'
    vm.policyDetails = {}
    vm.policyType = '';
    vm.policySeq = 0;

    vm.policies = [{
      name: 'policy_personal_accident',
      number: '51000306',
      type: 'policy_personal',
      amount: '8,320',
      color: 'purple',
      img: 'assets/images/purple-siren.png',
      riskType: ''
    },{
      name: 'policy_travel',
      number: '51007779',
      type: 'policy_family',
      amount: '3,000',
      color: 'skyblue',
      img: '/assets/images/l-blue-bag.png',
      riskType: ''
    },{
      name: 'policy_motor',
      number: '51002303',
      type: 'policy_personal',
      amount: '4,770',
      color: 'blue',
      img: '/assets/images/d-blue-car.png',
      riskType: ''
    }];

    var init = function() {
      var req = {
        method: 'GET',
        // url: 'https://general.sonic.dev.coherent.com.hk/general/v2/enquiry/policy/' + $stateParams.policyNumber
        url: configUrls[environment].enquirePolicy +  $stateParams.policyNumber,
      };
      if (configUrls[environment].isAuthorizationNeeded) {
        req.headers = {
          'authorization': 'Bearer ' + configUrls[environment].token
        }
      }
      
      $http(req)
        .then(function (response) {
          vm.policyDetails = response.data;

          if (vm.policyDetails.Cont.Risks["1"].RiskBody.RiskType == 'PA') {
            vm.policySeq = 0;
          } else if (vm.policyDetails.Cont.Risks["1"].RiskBody.RiskType == 'Travel') {
            vm.policySeq = 1;
          } else if (vm.policyDetails.Cont.Risks["1"].RiskBody.RiskType == 'HOM') {
            vm.policySeq = 2;
          }
          vm.policyDetails.Cont.ProductImg = vm.policies[vm.policySeq].img;
          PolicyService.setPolicyDetails(vm.policyDetails);
          PolicyService.setPolNo($stateParams.policyNumber);
          PurchaseService.setProduct(vm.policyDetails.Cont.Product.split(':')[1]);

          vm.policies[vm.policySeq].riskType = vm.policyDetails.Cont.Risks["1"].RiskBody.RiskType;
          vm.policies[vm.policySeq].number = vm.policyDetails.Cont.ContID;

          // TODO: How to translate this?
          vm.policies[vm.policySeq].type = PolicyService.mapPlanName(vm.policyDetails.Cont.Risks["1"].RiskBody.Plan);
          PolicyService.PlanName = vm.policies[vm.policySeq].type;

          vm.policies[vm.policySeq].amount = PolicyService.numberWithCommas(vm.policyDetails.Cont.Risks["1"].RiskBody.TotalPremium);
          vm.text2 = vm.policyDetails.Cont.Owner.Name;
          
        }, function () {
          $state.go('policy-login');
      });
    }

    init();

  }
})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .service('MicroService', MicroService);

  /** @ngInject */
  function MicroService() {
    var vm = this;

    vm.Cover = 0
    vm.PolNo = 0
    vm.PolCI = 0

    vm.addCover = function () {
      vm.Cover = vm.Cover + 25
    }

    vm.setPolNo = function (PolNo) {
      vm.PolNo = PolNo
    }

    vm.setPolNoCI = function (PolNoCI) {
      vm.PolNoCI = PolNoCI
    }

    vm.policyTemplate = 
    {
      "Header": {
        "Product": "coherent:Uber",
        "Term": 5,
        "Channel": "Broker",
        "Email": "customer.name@example.com",
        "Agent": "",
        "StartDate": "2021-10-12T09:40:36.940641599Z",
        "PaymentMethod": "CC",
        "Currency": {
          "Code": "INR",
          "Descr": "INR"
        },
        "PaymentFrequency": 1,
        "InstallmentPremium": 30547.44,
        "Mandate": {
          "MandateRefNo": "000546",
          "MandateStatus": "Active",
          "BankAccount": {
            "BankName": "SCB Thailand",
            "BankBranch": "SCB00123",
            "AccountType": "Savings",
            "AccountName": "Custome name",
            "AccountNo": "123987123987",
            "OtherRef": "SCB10101"
          },
          "CreditCard": {
            "BankRefNum": "SCBCC0001",
            "CardNumber": "127391873298172397",
            "CardType": "VISA",
            "ExpiryMonth": "12",
            "ExpityYear": "22"
          }
        },
        "Owner": {
          "Name": "Mark",
          "Dob": "1996-02-16",
          "Smoker": "",
          "Gender": "F",
          "Nationality": "",
          "Race": "Chinese",
          "Occupation": "",
          "ID": [
          {
            "IDType": "tax",
            "IDNumber": "1123123642",
            "IssueDate": "2020-10-12",
            "ExpiryDate": "2021-10-12",
            "IssuingAgency": "abcd"
          }
          ],
          "Contact": {
            "Email": "Mrk@email.com",
            "Phone": "2222",
            "FbId": "",
            "Add": {
              "Add1": "Road St.",
              "Add2": "",
              "Add3": "District 3",
              "Add4": "",
              "City": "Mumbai",
              "Country": "India",
              "Pcode": "1016"
            }
          }
        }
      },
      "Risks": [
      {
        "RiskType": "PA",
        "RiskId": "1",
        "Riskclass": "PA",
        "CoverType": "coherent:Uber",
        "Risk_Comm": "2020-10-14T09:40:36.940647435Z",
        "RiskBody": {
          "RiskType": "PA",
          "RiskId": "1",
          "Riskclass": "PA",
          "Plan": "Plan2",
          "CoverType": "coherent:Uber",
          "Sum_Insured": 1500,
          "InsuredParty": {
            "Name": "Customer2",
            "GivenName": "xyz",
            "Dob": "1996-02-16",
            "Age": 22,
            "Gender": "F",
            "Id": {
              "IDType": "tax",
              "IDNumber": "1123123642",
              "IssueDate": "2020-01-20",
              "ExpiryDate": "2025-02-08",
              "IssuingAgency": "abcd"
            },
            "OtherPolicyInfo": [
            {
              "PolicyID": "FWD128937",
              "Company": "FWD",
              "SumInsured": 1500,
              "PolicyExpiryDate": "2020-10-14T09:40:36.940647435Z",
              "PolicyIssuanceDate": "2020-10-14T09:40:36.940647435Z",
              "Status": "In-Force",
              "Remark": ""
            }
            ],
            "Documents": [
            {
              "Url": "www.docstore.com",
              "Descr": "photoid",
              "AttachDate": "2020-10-14T09:40:36.940647435Z",
              "AttachNote": {
                "Dte": "2020-10-14T09:40:36.940647435Z",
                "User": "Hello",
                "Text": "photoid"
              }
            },
            {
              "Url": "www.docstore.com",
              "Descr": "photo",
              "AttachDate": "2020-10-14T09:40:36.940647435Z",
              "AttachNote": {
                "Dte": "2020-10-14T09:40:36.940647435Z",
                "User": "Hello",
                "Text": "photoid"
              }
            }
            ],
            "Occupation": ""
          },
          "TermUnits": "years",
          "Term": 1,
          "Region": "Asia",
          "Channel": "PRU",
          "Payment_Frequency": "1",
          "BasePremium": 0,
          "EventDate": "2021-05-16T09:40:36.940641599Z",
          "Risk_Comm": "2021-05-16T12:27:41+08:00",
          "Options": [
          {
            "Option": "UB1",
            "Included": "Y",
            "SumInsured": 450
          }
          ]
        }
      }
      ]
    }

    vm.policyTemplate2 = 
    {
      "Header": {
          "Product": "coherent:PPP",
          "Term": 1,
          "Channel": "Broker",
          "Email": "customer.name@example.com",
          "Agent": "",
          "StartDate": "2021-10-19T09:40:36.940641599Z",
          "PaymentMethod": "CC",
          "PaymentFrequency": 12,
          "InstallmentPremium": 100,
          "Mandate": {
              "MandateRefNo": "000546",
              "MandateStatus": "Active",
              "BankAccount": {
                  "BankName": "SCB Thailand",
                  "BankBranch": "SCB00123",
                  "AccountType": "Savings",
                  "AccountName": "Custome name",
                  "AccountNo": "123987123987",
                  "OtherRef": "SCB10101"
              },
              "CreditCard": {
                  "BankRefNum": "SCBCC0001",
                  "CardNumber": "127391873298172397",
                  "CardType": "VISA",
                  "ExpiryMonth": "12",
                  "ExpityYear": "22"
              }
          },
          "Owner": {
              "Name": "Mark",
              "Dob": "1996-02-16",
              "Smoker": "",
              "Gender": "F",
              "Nationality": "Indian",
              "Race": "Indian",
              "Occupation": "",
              "ID": [
                  {
                      "IDType": "tax",
                      "IDNumber": "1123123642",
                      "IssueDate": "2020-01-20",
                      "ExpiryDate": "2025-02-08",
                      "IssuingAgency": "abcd"
                  }
              ],
              "Contact": {
                  "Email": "Mark@email.com",
                  "Phone": "659123123",
                  "FbId": "",
                  "Add": {
                      "Add1": "10 Road St.",
                      "Add2": "",
                      "Add3": "District 3",
                      "Add4": "",
                      "City": "Mumbai",
                      "Country": "India",
                      "Pcode": "1016"
                  }
              }
          }
      },
      "Risks": [
          {
              "RiskType": "PA",
              "RiskId": "1",
              "Riskclass": "PA",
              "CoverType": "coherent:PPP",
              "Risk_Comm": "2020-10-14T09:40:36.940647435Z",
              "RiskBody": {
                  "RiskType": "PA",
                  "RiskId": "1",
                  "Riskclass": "PA",
                  "Plan": "Comprehensive",
                  "CoverType": "coherent:PPP",
                  "Sum_Insured": 1500,
                  "InsuredParty": {
                      "Name": "Customer2",
                      "GivenName": "xyz",
                      "Dob": "1996-02-16",
                      "Age": 22,
                      "Gender": "F",
                      "Id": {
                          "IDType": "tax",
                          "IDNumber": "1123123642",
                          "IssueDate": "2020-01-20",
                          "ExpiryDate": "2025-02-08",
                          "IssuingAgency": "abcd"
                      },
                      "OtherPolicyInfo": [
                          {
                              "PolicyID": "FWD128937",
                              "Company": "FWD",
                              "SumInsured": 1500,
                              "PolicyExpiryDate": "2020-10-14T09:40:36.940647435Z",
                              "PolicyIssuanceDate": "2020-10-14T09:40:36.940647435Z",
                              "Status": "In-Force",
                              "Remark": ""
                          }
                      ],
                      "Documents": [
                          {
                              "Url": "www.docstore.com",
                              "Descr": "photoid",
                              "AttachDate": "2020-10-14T09:40:36.940647435Z",
                              "AttachNote": {
                                  "Dte": "2020-10-14T09:40:36.940647435Z",
                                  "User": "Hello",
                                  "Text": "photoid"
                              }
                          },
                          {
                              "Url": "www.docstore.com",
                              "Descr": "photo",
                              "AttachDate": "2020-10-14T09:40:36.940647435Z",
                              "AttachNote": {
                                  "Dte": "2020-10-14T09:40:36.940647435Z",
                                  "User": "Hello",
                                  "Text": "photoid"
                              }
                          }
                      ],
                      "Occupation": ""
                  },
                  "TermUnits": "years",
                  "Term": 1,
                  "Region": "Asia",
                  "Channel": "PRU",
                  "Payment_Frequency": "1",
                  "BasePremium": 0,
                  "EventDate": "2021-05-16T09:40:36.940641599Z",
                  "Risk_Comm": "2021-05-16T12:27:41+08:00",
                  "Options": [
                      {
                          "Option": "UB1",
                          "Included": "Y",
                          "SumInsured": 3000
                      }
                  ]
              }
          }
      ]
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .controller('Micro4Controller', Micro4Controller);

  /** @ngInject */
  function Micro4Controller(MicroService, $state, $http, $stateParams, PurchaseService, configUrls, environment) {
    var vm = this;

    vm.policyTemplate2 = MicroService.policyTemplate2
    vm.PolNo = MicroService.PolNo
    vm.PolNoCI = MicroService.PolNoCI
    vm.netPrice = 100
    vm.discount = 0

    vm.checkbox = false
    vm.loaded = false

    vm.mileage = 1
    vm.points = 1
    vm.renewalDate = moment().add(1, 'months').format("DD-MMM YYYY")

    vm.SparkTemplate = {
        "Inputs": {
            "Data": '[{\"Points\":99,\"Distance\":1000}]',
            "Plan": "Comprehensive"
        }
    }

    vm.appyPremiumTemplate =
    {
      "PolicyID": "RideShare-21-040900",
      "ReceiptDate": "2021-12-20T15:04:05Z",
      "Amount": 19.1,
      "Reference": "ref0993",
      "Data": [
        {
            "Points": "99",
            "Distance": "1000"
        }
      ]
    }

    vm.price = function () {

      var settings = {
        method: 'GET',
        url: configUrls[environment].keyCloakTokenUrl + '?apiKey=' + configUrls[environment].keyCloakApiKey + '&client=' + configUrls[environment].keyCloakPFClient,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      };

      $http(settings).then(function (response) {
        console.log(response);
        return response
      }).then(function (tokenRes) {

        // ----- Existing code here ----//
        vm.SparkTemplate.Inputs.Data = '[{\"Points\":' + vm.points + ',\"Distance\":' + vm.mileage + '}]'
        var req = {
          method: 'POST',
          // url: 'https://excel.sonic.dev.coherent.com.hk/api/v1/product/coherent/engines/Execute/PPP',
          url: configUrls[environment].PFUrl + PurchaseService.ProductCode,          
          headers: {
            authorization: 'Bearer ' + tokenRes.data.access_token
          },
          data: angular.toJson(vm.SparkTemplate),
          // headers: {
          //   'SecretKey': '762f5692-5a8b-4f8e-a09e-a27a277c0c56',
          //   'x-tenant-name': 'coherent'
          // }
        };
        $http(req)
          .then(function (response) {
            console.log(response)
            vm.discount = Math.round(100 - response.data.data.Outputs.InstallmentPremium)
            // vm.netPrice = Math.round(response.data.data.Outputs.InstallmentPremium)
            vm.netPrice = response.data.data.Outputs.InstallmentPremium;
          }, function () {
        });
        // ----- Existing code here ----//

      });
    }

    vm.renew = function () {
      vm.appyPremiumTemplate.PolicyID = vm.PolNoCI
      vm.appyPremiumTemplate.Data[0].Points = vm.points
      vm.appyPremiumTemplate.Data[0].Distance = vm.mileage
      vm.appyPremiumTemplate.ReceiptDate = moment(vm.renewalDate).format("YYYY-MM-DD") + "T15:04:05Z"
      vm.appyPremiumTemplate.Amount = vm.netPrice
      var req = {
        method: 'POST',
        // url: 'https://general.sonic.dev.coherent.com.hk/general/v2/service/applypremium',
        url: configUrls[environment].applyPremium,
        data: angular.toJson(vm.appyPremiumTemplate)
      };
      if (configUrls[environment].isAuthorizationNeeded) {
        req.headers = {
          'authorization': 'Bearer ' + configUrls[environment].token
        }
      }

      $http(req)
        .then(function (response) {
          vm.renewalDate = moment(vm.renewalDate).add(1, 'months').format("DD-MMM YYYY")
          vm.mileage = 0//Math.round(Math.random() * 20000)
          vm.points = 0//Math.round(Math.random() * 100)
          vm.price()
        }, function () {
      });
    }

    vm.newPolicy = function () {
      //vm.loading = true
      var req = {
        method: 'POST',
        // url: 'https://general.sonic.dev.coherent.com.hk/general/v2/newbusiness/newpolicy',
        url: configUrls[environment].createPolicy,
        data: angular.toJson(vm.policyTemplate2)
      };
      if (configUrls[environment].isAuthorizationNeeded) {
        req.headers = {
          'authorization': 'Bearer ' + configUrls[environment].token
        }
      }

      $http(req)
        .then(function (response) {
          $state.go('micro-4', {'policyNumberCI': response.data.PolicyID});
        }, function () {
      });
    }

    vm.loadPolicy = function (PolNoCI) {
      if(vm.checkbox) {
        if(PolNoCI) {
          vm.getPolicy(PolNoCI)
          console.log('load')
        } else {
          console.log('new')
          vm.newPolicy()
        }
      }
    }

    vm.getPolicy = function (PolNoCI) {
      //vm.loading = true
      var req = {
        method: 'GET',
        // url: 'https://general.sonic.dev.coherent.com.hk/general/v2/enquiry/policy/' + PolNoCI
        url: configUrls[environment].enquirePolicy +  PolNoCI
      };
      if (configUrls[environment].isAuthorizationNeeded) {
        req.headers = {
          'authorization': 'Bearer ' + configUrls[environment].token
        }
      }
      
      $http(req)
        .then(function (response) {
          vm.loading = false
          vm.loaded = true
          vm.cover = response.data.Cont.Risks["1"].RiskBody.Options[0].SumInsured
        }, function () {
      });
    }

    function init() {
      if($stateParams.policyNumberCI=="new") {
        vm.checkbox = false
      } else if($stateParams.policyNumberCI) {
        MicroService.setPolNoCI($stateParams.policyNumberCI)
        vm.checkbox = true
        vm.PolNoCI = $stateParams.policyNumberCI
        vm.loadPolicy(vm.PolNoCI)
        vm.price()
      }
    }

    init();

  }
})();
(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .controller('Micro3Controller', Micro3Controller);

  /** @ngInject */
  function Micro3Controller(MicroService, $state) {
    var vm = this;
    vm.a = ''

  }
})();
(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .controller('Micro2Controller', Micro2Controller);

  /** @ngInject */
  function Micro2Controller(MicroService, $state, $http, configUrls, environment) {
    var vm = this;

    vm.TopUpTemplate = {
      "PolicyID": MicroService.PolNo,
      "ReceiptDate": "2021-08-18T15:04:05Z",
      "Amount": 0.3,
      "Reference": "TopUp1",
      "Data": [{"Plan":"Plan2"}]
    }

    vm.addCover = function () {
      vm.loading = true
      var req = {
        method: 'POST',
        // url: 'https://general.sonic.dev.coherent.com.hk/general/v2/service/topuppremium',
        url: configUrls[environment].topupPremium,
        data: angular.toJson(vm.TopUpTemplate)
      };
      if (configUrls[environment].isAuthorizationNeeded) {
        req.headers = {
          'authorization': 'Bearer ' + configUrls[environment].token
        }
      }
      
      $http(req)
        .then(function (response) {
          vm.modal = true
          var a = response
        }, function () {
      });
    }

    vm.viewPolicy = function () {
      $state.go('micro-1', {'policyNumber': MicroService.PolNo});
    }

  }
})();
(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .controller('Micro1Controller', Micro1Controller);

  /** @ngInject */
  function Micro1Controller(MicroService, $stateParams, $http, $state, configUrls, environment) {
    var vm = this;

    vm.policyTemplate = MicroService.policyTemplate
    vm.PolNo = MicroService.PolNo

    vm.policyNumber = '12312312'
    vm.policyCover = '$' + MicroService.Cover

    vm.loading = false
    vm.checkbox = false
    vm.loaded = false

    vm.loadPolicy = function (PolNo) {
      if(vm.checkbox) {
        if(PolNo) {
          vm.getPolicy(PolNo)
          console.log('load')
        } else {
          console.log('new')
          vm.newPolicy()
        }
      }
    }

    vm.newPolicy = function () {
      //vm.loading = true
      var req = {
        method: 'POST',
        // url: 'https://general.sonic.dev.coherent.com.hk/general/v2/newbusiness/newpolicy',
        url: configUrls[environment].createPolicy,
        data: angular.toJson(vm.policyTemplate)
      };
      if (configUrls[environment].isAuthorizationNeeded) {
        req.headers = {
          'authorization': 'Bearer ' + configUrls[environment].token
        }
      }

      $http(req)
        .then(function (response) {
          $state.go('micro-1', {'policyNumber': response.data.PolicyID});
        }, function () {
      });
    }

    vm.getPolicy = function (PolNo) {
      //vm.loading = true
      var req = {
        method: 'GET',
        // url: 'https://general.sonic.dev.coherent.com.hk/general/v2/enquiry/policy/' + PolNo
        url: configUrls[environment].enquirePolicy +  PolNo,
      };
      if (configUrls[environment].isAuthorizationNeeded) {
        req.headers = {
          'authorization': 'Bearer ' + configUrls[environment].token
        }
      }
      
      $http(req)
        .then(function (response) {
          vm.loading = false
          vm.loaded = true
          vm.cover = response.data.Cont.Risks["1"].RiskBody.Options[0].SumInsured
        }, function () {
      });
    }

    function init() {
      if($stateParams.policyNumber=="new") {
        vm.checkbox = false
      } else if($stateParams.policyNumber) {
        MicroService.setPolNo($stateParams.policyNumber)
        vm.checkbox = true
        vm.PolNo = $stateParams.policyNumber
        vm.loadPolicy(vm.PolNo)
      }
    }

    init();

  }
})();
(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController($timeout, webDevTec, toastr) {
    var vm = this;

    vm.awesomeThings = [];
    vm.classAnimation = '';
    vm.creationDate = 1627099227167;
    vm.showToastr = showToastr;

    activate();

    function activate() {
      getWebDevTec();
      $timeout(function() {
        vm.classAnimation = 'rubberBand';
      }, 4000);
    }

    function showToastr() {
      toastr.info('Fork <a href="https://github.com/Swiip/generator-gulp-angular" target="_blank"><b>generator-gulp-angular</b></a>');
      vm.classAnimation = '';
    }

    function getWebDevTec() {
      vm.awesomeThings = webDevTec.getTec();

      angular.forEach(vm.awesomeThings, function(awesomeThing) {
        awesomeThing.rank = Math.random();
      });
    }
  }
})();


(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .controller('HomePurchase2Controller', ctrl);

  /** @ngInject */
  function ctrl($state,
                CALENDAR_FORMAT,
                DATE_FORMAT,
                HOME_TYPE,
                HOME_FOLDER,
                PurchaseFactory,
                HomePurchaseService,
                PurchaseService,
                HOME_SPARK_PAYLOAD,
                HOME_PLANS_PAYLOAD) {
    var vm = this;

    vm.ui = {
      DefaultCurrency: PurchaseService.DefaultCurrency,
      BenefitSummary: [],
      OccupancyStatus: '',
      PropertyType: '',
      NumberOfRooms: '',
      EndorsementType: '',
      OccupancyStatusList: [],
      PropertyTypeList: [],
      NumberOfRoomsList: [],
      EndorsementTypeList: []
    };
    vm.ui.benefitSelection = HomePurchaseService.policy.benefitSelection;
    vm.ui.BenefitList = [];
    vm.pfPayload = PurchaseService.Home_pf_payload;
    vm.Ratings = [];
    vm.UpdatePfPayload = {};
    vm.ui.benefitSelection = [
      {
        enabled: false,
        Desc: "test des",
        AggLimit_Default: '33',
        AggLimit_Var: 'Y',
        LimitPP_Var: 'Y',
        SubLimit_Var: 'Y'
      }
    ];
    vm.selectedPlan = 'All Risks'

    vm.proceed = function () {
      PurchaseService.policy.type = HOME_TYPE;
      PurchaseService.policy.carrier = HOME_FOLDER;
      PurchaseService.policy.specs = HomePurchaseService.policy;
      PurchaseService.policy.specs.planDetails = {
        title: PurchaseService.policy.specs.plan.title,
        price: vm.ui.price
      }
      PurchaseService.policy.specs.installmentPermium = vm.ui.price
      var BenList = [];
      angular.forEach(vm.ui.BenefitList, function(ben) {
        BenList.push({
          Desc: ben.Option + " - " + ben.Desc,
          SumInsured: ben.LimitDefault,
          Premium: ben.Premium,
          Included: ben.IncludeBenefit,
          Show: ben.IncludeOnUI,
          Option: ben.Option
        })
      });
      PurchaseService.selectedPlan = vm.selectedPlan
      PurchaseService.policy.specs.benefitSelection = BenList;
      PurchaseService.policy.Ratings = vm.Ratings;
      $state.go('purchase-9');
      // $state.go('common-purchase-1');
    };


    function generateInputPayload(benefitIndex, SIValue, benefitOption) {
      var payload = angular.copy(vm.pfPayload);
      if (Object.keys(vm.UpdatePfPayload).length != 0) {
        var payload = angular.copy(vm.UpdatePfPayload);
      }
      // var payload = angular.copy(vm.UpdatePfPayload);
      if (benefitIndex != undefined) {
        angular.forEach(payload.Inputs.Optional_Benefits, function (ben) {
          if (ben.Option === benefitOption) {
            ben.SumInsured = Number(SIValue);
          }
        })
      }
      payload.TransactionDate = (new Date()).toISOString();
      if (Object.keys(vm.UpdatePfPayload).length != 0) {
        vm.UpdatePfPayload = payload;
      }
      for(var i=0;i<vm.ui.BenefitList.length;i++) {
        var a = {}
        angular.forEach(payload.Inputs.Optional_Benefits, function(item) {
          if(item.Option === vm.ui.BenefitList[i].Option) {
            a = item
            if (a) {
              var b = payload.Inputs.Optional_Benefits.indexOf(a)
              payload.Inputs.Optional_Benefits[b].Included = vm.ui.BenefitList[i].enabled ? 'Y' : 'N';
              vm.ui.BenefitList[i].IncludeBenefit = payload.Inputs.Optional_Benefits[b].Included
            }
          }
        })
      }

      angular.forEach(payload.Inputs.Ratings, function(rating) {
        if (rating.RatingFactor == "Endorsement Type" && vm.ui.EndorsementType) {
          rating.Value = vm.ui.EndorsementType;
        } else if (rating.RatingFactor == "Property Type" && vm.ui.PropertyType) {
          rating.Value = vm.ui.PropertyType;
        } else if (rating.RatingFactor == "Number of Rooms" && vm.ui.NumberOfRooms) {
          rating.Value = vm.ui.NumberOfRooms;
        } else if (rating.RatingFactor == "Occupancy status" && vm.ui.OccupancyStatus) {
          rating.Value = vm.ui.OccupancyStatus;
        }
      });

      vm.Ratings = payload.Inputs.Ratings;

      payload.Inputs.Plan = vm.selectedPlan;
      PurchaseService.selectedPlan = vm.selectedPlan;

      return payload;
    }


    function loadOptions(benefitIndex, SIValue, benefitOption) {
      PurchaseFactory.token().then( function(token) {
        PurchaseFactory.get(HOME_TYPE, HOME_FOLDER, generateInputPayload(benefitIndex, SIValue, benefitOption), token).then(function (data) {
          var outputs = data.data.data.Outputs;
          var benefitLimits = [];
          for (var a = 0; a < outputs['NewBusinessUI'].length; a++) {
            var benefitObj = outputs['NewBusinessUI'][a];
            if (benefitObj.LimitInterval) {
              benefitLimits.push({
                Descr: benefitObj.Desc,
                Included: benefitObj.IncludeBenefit,
                Option: benefitObj.Option,
                SumInsured: benefitObj.LimitDefault
              });
              benefitObj.LimitDefault = benefitObj.LimitDefault.toString();
            }
            if(outputs['NewBusinessUI'][a].IncludeBenefit=='Y') {benefitObj.enabled = true} else {benefitObj.enabled = false};
          }
          if (Object.keys(vm.UpdatePfPayload).length == 0) {
            vm.UpdatePfPayload = vm.pfPayload;
            vm.UpdatePfPayload.Inputs.Optional_Benefits = benefitLimits;
          }
          vm.ui.BenefitList = outputs['NewBusinessUI'];

          if (benefitIndex != undefined) {
            // payload.Inputs.Optional_Benefits[benefitIndex].SumInsured = Number(SIValue);
            angular.forEach(vm.ui.BenefitList, function(ben, index) {
              angular.forEach(vm.UpdatePfPayload.Inputs.Optional_Benefits, function(updatedBen, indexIn) {
                if (ben.Option === updatedBen.Option) {
                  vm.ui.BenefitList[index].LimitDefault = updatedBen.SumInsured.toString();
                }
              })
            })
          }
          
          var summary = outputs['NewBusinessUI2'][0];
          var BenefitSummary = []
          angular.forEach(Object.keys(summary), function(sum) {
            if (sum == 'Total Premium') {
              vm.ui.price = summary[sum];
            }
            BenefitSummary.push({
              title: sum,
              value: summary[sum]
            })
          });
          vm.ui.BenefitSummary = BenefitSummary;

          var RatingData = outputs["RatingsDropDown"];
          vm.ui.OccupancyStatusList = [];
          vm.ui.PropertyTypeList = [];
          vm.ui.NumberOfRoomsList = [];
          vm.ui.EndorsementTypeList = [];
          angular.forEach(RatingData, function(rating) {
            if (rating["Occupancy status"]) {
              vm.ui.OccupancyStatusList.push(rating["Occupancy status"]);
            }
            if (rating["Property Type"]) {
              vm.ui.PropertyTypeList.push(rating["Property Type"]);
            }
            if (rating["Number of Rooms"]) {
              vm.ui.NumberOfRoomsList.push(rating["Number of Rooms"]);
            }
            if (rating["Endorsement Type"]) {
              vm.ui.EndorsementTypeList.push(rating["Endorsement Type"]);
            }
          });

          // HomePurchaseService.policy.benefitSelection = outputs['Options.Benefit_Selection'];
          // for(var i=0;i<HomePurchaseService.policy.benefitSelection.length;i++) {
          //   HomePurchaseService.policy.benefitSelection[i].enabled = true
          // }
          // vm.ui.benefitSelection = HomePurchaseService.policy.benefitSelection
          // vm.loadPrice();
          
        });
      });
    }    

    vm.loadPrice = function() {
      PurchaseFactory.token().then( function(token) {
        PurchaseFactory.get(HOME_TYPE, HOME_FOLDER, generateInputPayload(), token).then(function (data) {
          var outputs2 = data.data.data.Outputs;
          HomePurchaseService.policy.price = outputs2.InstallmentPremium;
          vm.ui.price = HomePurchaseService.policy.price
        });
      });
    }

    vm.handleSIChange = function(benefitIndex, SIValue, benefitOption) {
      console.log(benefitIndex, SIValue, benefitOption);
      loadOptions(benefitIndex, SIValue, benefitOption);
    }

    function init() {

      angular.forEach(vm.pfPayload.Inputs.Ratings, function(rating) {
        if (rating.RatingFactor == "Endorsement Type") {
          vm.ui.EndorsementType = rating.Value;
        } else if (rating.RatingFactor == "Property Type") {
          vm.ui.PropertyType = rating.Value;
        } else if (rating.RatingFactor == "Number of Rooms") {
          vm.ui.NumberOfRooms = rating.Value;
        } else if (rating.RatingFactor == "Occupancy status") {
          vm.ui.OccupancyStatus = rating.Value;
        }
      });

      loadOptions();
    }

    init();
  }
})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .controller('HomePurchase1Controller', ctrl);

  /** @ngInject */
  function ctrl($state,
                CALENDAR_FORMAT,
                DATE_FORMAT,
                PurchaseFactory,
                HomePurchaseService,
                PurchaseService) {
    var vm = this;

    vm.ui = {};
    vm.ui.propertyAddress = {
      unitNumber: '',
      streetAddress: '',
      postCode: ''
    }

    vm.opts = {
      calendarFormat: CALENDAR_FORMAT,
      datepickerOptionsForInsuranceDate: {
        showWeeks: false,
        minDate: moment(),
        maxDate: moment().add(275, 'days')
      }
    }

    vm.proceed = function () {
      HomePurchaseService.policy.insuranceDate = moment(vm.ui.insuranceDate).format(DATE_FORMAT)
      HomePurchaseService.policy.propertyOwnership = vm.ui.propertyOwnership
      HomePurchaseService.policy.propertyAddress.unitNumber = vm.ui.propertyAddress.unitNumber
      HomePurchaseService.policy.propertyAddress.streetAddress = vm.ui.propertyAddress.streetAddress
      HomePurchaseService.policy.propertyAddress.postCode = vm.ui.propertyAddress.postCode
      PurchaseService.policy.insuranceDate = moment(vm.ui.insuranceDate).format(DATE_FORMAT)
      $state.go('home-purchase-2');
    };

    function init() {
      vm.ui.propertyAddress.unitNumber = '12-02' ;
      vm.ui.propertyAddress.streetAddress = '12 Dove Street';
      vm.ui.propertyAddress.postCode = '2332-2331';
    }

    init();
  }
})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .service('HomePurchaseService', svc);

  /** @ngInject */
  function svc($log) {
    var vm = this;

    vm.policy = {
      insuranceDate: null,
      planType: 'Home Plan P1',
      plan: { title: 'Home Plan P1'},
      defaultCoverage: 0,
      benefitSelection: [],
      propertyAddress: {
        postCode: '',
        unitNumber: '',
        streetAddress: ''
      },
      propertyOwnership: ''
    };

    vm.reset = function () {
      vm.policy = {
        insuranceDate: null,
        planType: 'Home Plan P1',
        defaultCoverage: 0,
        benefitSelection: [],
        propertyAddress: {
          postCode: '',
          unitNumber: '',
          streetAddress: ''
        },
        propertyOwnership: ''
      };
    };

    vm.debug = function () {
      $log.debug(vm.policy);
    };

  }
})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .factory('HomePurchaseFactory', fctry);

  /** @ngInject */
  function fctry() {
    var vm = this;

    return vm;
  }
})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')

    .constant('HOME_TYPE', 'HSBC_Home')
    .constant('HOME_FOLDER', 'coherent')
    .constant('HOME_SPARK_PAYLOAD', {"Inputs":{},"TransactionDate":"2022-03-24T15:09:20.616Z","EngineType":"Type3","Solves":[],"RequestedServiceCategory":"Options"})
    .constant('HOME_PLANS_PAYLOAD', {"Inputs":{"AllocatePremium":null,"BillPeriodEnd":"2022-07-27","BillPeriodStart":"2021-07-28","BrokerID":"ARN-00003","CancelAllocatedPremium":4810.26,"CancellationDate":"2021-07-28","CancelRef":"customer-not required","Channel":null,"ClaimAmount":[{"Sno":1,"Benefit":"A3","Amount":7500,"EventStart":"2022-11-20","EventEnd":"2022-11-21","EventType":null,"Claimant":null,"Exgratia":null},{"Sno":2,"Benefit":"A4","Amount":3500,"EventStart":"2022-11-20","EventEnd":"2022-11-21","EventType":null,"Claimant":null,"Exgratia":null}],"ClaimApproveAmount":400000,"ClaimHistory":[],"ClaimRef":"CLM0001","ClaimRejectAmount":400000,"ClaimStatus":"initiate","ClaimToDate":[],"ClmStatus":"initiate","Cover_Start_Date":"2022-06-01","Data":[{"RefundLevy":10}],"EventDate":null,"InputType":[],"LevyType":null,"NumberOfCovers":null,"Optional_Benefits":[{"Option":"Building","Descr":"Building Cover","Included":"Y","SumInsured":300000},{"Option":"Contents","Descr":"Contents Cover","Included":"Y","SumInsured":60000},{"Option":"AO1","Descr":"Ww Perso Belongings ","Included":"N","SumInsured":90000},{"Option":"AO2","Descr":"Pet Insurance ","Included":"N","SumInsured":400},{"Option":"AO3","Descr":"Cyber Protector ","Included":"N","SumInsured":500},{"Option":"AO4","Descr":"Bicycle ","Included":"N","SumInsured":120000},{"Option":"AO5","Descr":"Ww Family PA ","Included":"N","SumInsured":100},{"Option":"AO6","Descr":"Ww Perso Liability","Included":"N","SumInsured":30000}],"OwnerType":null,"PaymentFrequency":1,"Plan":"All Risks","PolicyNo":"P-HOM-123456","PreferredLanguage":null,"PremiumBilled":null,"ProductType":null,"PromoCode":null,"Puchase_Date":"2022-01-01","Ratings":[{"RatingFactor":"Endorsement Type","Value":"NB"},{"RatingFactor":"Property Type","Value":"Landed"},{"RatingFactor":"Number of Rooms","Value":">5"},{"RatingFactor":"Occupancy status","Value":"Owner"}],"Reference2":"6fddd26a7e2bb49a074bc0f77269d","Term":1,"UWQuestions":[{"UWSurveyCode":"Home_UW_1","UWSurveyResponse":2016}]},"TransactionDate":"2022-06-19T06:24:54.576Z","EngineType":"Type3","Solves":[],"ServiceName":"HSBC_Home","Version":"e1011e5d-fcb4-401f-addc-d8b056f4984c","Revision":"1.2.0","Description":"","RequestedOutPut":"","EndPoint":"https://excelengine.demo.sonic.dev.coherent.global/api/v1/product/coherent/engines/Execute/HSBC_Home","IsRichJson":false,"ServiceCategories":["Claims"],"RequestedServiceCategory":"","ShouldExecuteInputs":false});

})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .controller('LandingController', ctrl);

  /** @ngInject */
  function ctrl($state,
                EmbeddedService,
                EmbeddedFactory,
                $http, configUrls, environment) {
    var vm = this;
    vm.data = {};
    vm.allPlans = [];
    vm.recommendedPlans = [];
    vm.planObject = {
      premium: 0,
      name: ''
    };
    vm.discount = 1;
    vm.personas = EmbeddedService.personas
    vm.activePersona = ""

    vm.setPersona = function (index) {
      EmbeddedService.PFInput.request_data.inputs["Prm_Age"] = EmbeddedService.personas[index-1]["Prm_Age"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Gender"] = EmbeddedService.personas[index-1]["Prm_Gender"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Income"] = EmbeddedService.personas[index-1]["Prm_Income"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Postcode"] = EmbeddedService.personas[index-1]["Prm_Postcode"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Occupation"] = EmbeddedService.personas[index-1]["Prm_Occupation"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Industry"] = EmbeddedService.personas[index-1]["Prm_Industry"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Marital_Status"] = EmbeddedService.personas[index-1]["Prm_Marital_Status"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Dependents"] = EmbeddedService.personas[index-1]["Prm_Dependents"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Education"] = EmbeddedService.personas[index-1]["Prm_Education"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Residency"] = EmbeddedService.personas[index-1]["Prm_Residency"]
      EmbeddedService.PFInput.request_data.inputs["Prm_CreditBalance"] = EmbeddedService.personas[index-1]["Prm_CreditBalance"]
      EmbeddedService.PFInput.request_data.inputs["Prm_CreditArrear"] = EmbeddedService.personas[index-1]["Prm_CreditArrear"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Loan"] = EmbeddedService.personas[index-1]["Prm_Loan"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Health"] = EmbeddedService.personas[index-1]["Prm_Health"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Child"] = EmbeddedService.personas[index-1]["Prm_Child"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Insurance"] = EmbeddedService.personas[index-1]["Prm_Insurance"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Travel"] = EmbeddedService.personas[index-1]["Prm_Travel"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Luxury"] = EmbeddedService.personas[index-1]["Prm_Luxury"]
      EmbeddedService.PFInput.request_data.inputs["Prm_E-commerce"] = EmbeddedService.personas[index-1]["Prm_E-commerce"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Active_Lifestyle"] = EmbeddedService.personas[index-1]["Prm_Active_Lifestyle"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Grocery"] = EmbeddedService.personas[index-1]["Prm_Grocery"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Home"] = EmbeddedService.personas[index-1]["Prm_Home"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Currency"] = EmbeddedService.personas[index-1]["Prm_Currency"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Automotive"] = EmbeddedService.personas[index-1]["Prm_Automotive"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Bar"] = EmbeddedService.personas[index-1]["Prm_Bar"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Food"] = EmbeddedService.personas[index-1]["Prm_Food"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Gaming"] = EmbeddedService.personas[index-1]["Prm_Gaming"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Hair"] = EmbeddedService.personas[index-1]["Prm_Hair"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Helper"] = EmbeddedService.personas[index-1]["Prm_Helper"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Movies"] = EmbeddedService.personas[index-1]["Prm_Movies"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Petrol"] = EmbeddedService.personas[index-1]["Prm_Petrol"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Rent"] = EmbeddedService.personas[index-1]["Prm_Rent"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Retail_shopping"] = EmbeddedService.personas[index-1]["Prm_Retail_shopping"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Transport"] = EmbeddedService.personas[index-1]["Prm_Transport"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Utility"] = EmbeddedService.personas[index-1]["Prm_Utility"]
      EmbeddedService.PFInput.request_data.inputs["Prm_AMZNPRIMESG"] = EmbeddedService.personas[index-1]["Prm_AMZNPRIMESG"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Mortgage"] = EmbeddedService.personas[index-1]["Prm_Mortgage"]
      EmbeddedService.PFInput.request_data.inputs["Prm_CreditScore"] = EmbeddedService.personas[index-1]["Prm_CreditScore"]
      EmbeddedService.PFInput.request_data.inputs["Prm_LateSleeper"] = EmbeddedService.personas[index-1]["Prm_LateSleeper"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Location"] = EmbeddedService.personas[index-1]["Prm_Location"]
      EmbeddedService.PFInput.request_meta = {
          "version_id": "75997ebc-cbde-45d2-ad47-002d5c71458b",
          "transaction_date": "2022-03-21T14:50:46.542Z",
          "call_purpose": "Spark - API Tester",
          "source_system": "SPARK",
          "correlation_id": "",
          "requested_output": "",
          "service_category": "",
          "compiler_type": "Type3"
      }
      vm.balance = Math.round(EmbeddedService.personas[index-1]["Prm_Income"] * 0.112)
      vm.txn1 = EmbeddedService.PFInput.request_data.inputs["Prm_Health"]
      vm.txn2 = EmbeddedService.PFInput.request_data.inputs["Prm_Child"]
      vm.txn3 = EmbeddedService.PFInput.request_data.inputs["Prm_Retail_shopping"]
      vm.txn4 = EmbeddedService.PFInput.request_data.inputs["Prm_Automotive"]
      vm.txn5 = EmbeddedService.PFInput.request_data.inputs["Prm_Rent"]
      vm.txn6 = EmbeddedService.PFInput.request_data.inputs["Prm_Travel"]
      vm.txn7 = EmbeddedService.PFInput.request_data.inputs["Prm_Currency"]

      vm.activePersona = EmbeddedService.personas[index-1].Name
      console.log(EmbeddedService.personas[index-1].Prm_CreditBalance);
      getPlan();
    }

    function getPlan() {
      vm.recommendedPlans = []
      EmbeddedService.recommendedPlans =[]
      console.log(EmbeddedService.PFInput)
      var settings = {
        method: 'GET',
        url: configUrls[environment].keyCloakTokenUrl + '?apiKey=' + configUrls[environment].keyCloakApiKey + '&client=' + configUrls[environment].keyCloakPFClient,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      };

      $http(settings).then(function (response) {
        // console.log(response);
        return response
      }).then(function (tokenRes) {
        var req = {
          method: 'POST',
          url: 'https://excel.sit.coherent.global/coherent/api/v3/folders/Flex/services/Controller%20File/Execute',
          // url: configUrls[environment].PFUrl1 + 'Flex/engines/Execute/Controller%20File',
          headers: {
            // authorization: 'Bearer ' + tokenRes.data.access_token,
            'SecretKey': '737e0b6e-1539-4d8d-acf2-8e0f9d5b83a5',
            'x-tenant-name': 'coherent'
          },
          data: EmbeddedService.PFInput
        };
        $http(req).then(function (response) {
          // vm.data = response.data.data.Outputs;
          vm.data = response.data.response_data.outputs;
          var rc = vm.data.Recommended_Products;
          // EmbeddedService.PFOutput = response.data.data.Outputs;
          EmbeddedService.PFOutput = response.data.response_data.outputs;
          console.log(vm.data.UI_Options[0].Product);
  
          var _loop = function _loop(i) {
            a = {};
            a.premium = vm.data.Premium_Detail.find(function (x) {
              return x.ID === rc[i].ID;
            }).Gross_Premium_before_Discount;
            a.cover = vm.data.Recommended_Products.find(function (x) {
              return x.ID === rc[i].ID;
            })["Recommend Coverage"];
            a.name = vm.data.UI_Options.find(function (x) {
              return x.ID === rc[i].ID;
            }).Product;
            a.Default = vm.data.UI_Options.find(function (x) {
              return x.ID === rc[i].ID;
            }).Default;
            a.Min = vm.data.UI_Options.find(function (x) {
              return x.ID === rc[i].ID;
            }).Min;
            a.Max = vm.data.UI_Options.find(function (x) {
              return x.ID === rc[i].ID;
            }).Max;
            a.Step = vm.data.UI_Options.find(function (x) {
              return x.ID === rc[i].ID;
            }).Step;
            a.ID = vm.data.UI_Options.find(function (x) {
              return x.ID === rc[i].ID;
            }).ID;
            vm.recommendedPlans.push(a);
            vm.discount = Math.round(EmbeddedService.PFOutput["02a_Discount_Multi_Pct"] * 100);
            console.log(vm.recommendedPlans);
            EmbeddedService.recommendedPlans = vm.recommendedPlans;
          }
  
          for (var i = 0; i < rc.length; i++) {
            var a;
  
            _loop(i);
          }
        }, function () {});
      });
      
    }

    vm.setPersona(1)

    return vm;
  }
})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .service('EmbeddedService', EmbeddedService);

  /** @ngInject */
  function EmbeddedService() {
    var vm = this;

    vm.controllerPayload = {
      "response_data": {
        "outputs": {
          "01_Gross_Prem_before_discount": 120.13,
          "02a_Discount_Multi_Pct": 0.02,
          "02b_Code_Discount_Pct": 0,
          "02c_Code_Discount_amt": 0,
          "02d_Code_Discount_Product": "null",
          "02e_Code_Discount_Error_Msg": "null",
          "02g_Gross_Prem_after_discount": 117.73,
          "02h_Total_Discount": 2.40000000000001,
          "03_Comm": 26.8,
          "04_Tax": 5.88,
          "05_Net_Prem": 90.93,
          "06_Gross_Prem_inc_Tax": 123.61,
          "API_Discount": "{\"message\":null,\"data\":{\"Inputs\":{\"Discount_Code\":null,\"Product_cnt\":4},\"Outputs\":{\"02a_Discount_Multi_Pct\":0.02,\"02b_Code_Discount_Pct\":null,\"02c_Code_Discount_Amt\":null,\"02d_Code_Discount_Product\":null,\"02e_Code_Discount_Error_Msg\":null},\"Errors\":[],\"FetchTimeUTC\":\"2022-01-23T17:22:34.7794676Z\",\"EngineID\":\"9e42502e-c827-4a6a-97dd-e24fd1e7234e\",\"ServiceName\":\"Discount Table\",\"EngineType\":\"Type3\",\"Revision\":\"1.0.0\",\"Version\":\"0aef11c7-466b-4011-83e2-c6b5e92238ab\",\"ReleaseDate\":\"2022-01-12 09:11:11\",\"Description\":null,\"EngineHash\":\"BC267AFC560050E1D3738C3B22FBA794\",\"CalcTime\":2.0,\"TotalTime\":29,\"SolveInputs\":[],\"SolveOutputs\":[],\"ProductName\":\"Embedded\",\"EffectiveStartDate\":\"2010-01-01T00:00:00Z\",\"EffectiveEndDate\":\"2120-01-01T00:00:00Z\",\"CallGUID\":\"2c250e48-17c2-47ce-b8a5-73cdebb7e0ac\"},\"errorCode\":null,\"status\":\"Success\"}",
          "API_Postcode": "{\"IsSuccess\":false,\"ErrorCode\":\"-21\",\"ErrorDetails\":\"Unauthorized postcode for demo plan.\",\"Postcodes\":[]}",
          "API_Recommender": "{\"message\":null,\"data\":{\"Inputs\":{\"Factors\":[{\"Variables\":\"Age\",\"Value\":30},{\"Variables\":\"Gender\",\"Value\":\"Female\"},{\"Variables\":\"Income\",\"Value\":27000},{\"Variables\":\"Postcode\",\"Value\":300821},{\"Variables\":\"Occupation\",\"Value\":\"I.T.\"},{\"Variables\":\"Industry\",\"Value\":\"Insurance\"},{\"Variables\":\"Marital Status\",\"Value\":\"Single\"},{\"Variables\":\"Dependents\",\"Value\":0},{\"Variables\":\"Education\",\"Value\":\"A Levels\"},{\"Variables\":\"Residency\",\"Value\":\"Employment Pass\"},{\"Variables\":\"CreditBalance\",\"Value\":8302},{\"Variables\":\"CreditArrear\",\"Value\":0},{\"Variables\":\"Loan\",\"Value\":0},{\"Variables\":\"Health\",\"Value\":-161},{\"Variables\":\"Child\",\"Value\":-472},{\"Variables\":\"Insurance\",\"Value\":\"NA\"},{\"Variables\":\"Travel\",\"Value\":-345},{\"Variables\":\"Luxury\",\"Value\":\"NA\"},{\"Variables\":\"E-commerce\",\"Value\":-528},{\"Variables\":\"Active Lifestyle\",\"Value\":\"NA\"},{\"Variables\":\"Grocery\",\"Value\":-535},{\"Variables\":\"Home\",\"Value\":\"NA\"},{\"Variables\":\"Currency\",\"Value\":\"NA\"},{\"Variables\":\"Automotive\",\"Value\":-628},{\"Variables\":\"Bar\",\"Value\":-71},{\"Variables\":\"Food\",\"Value\":-1999},{\"Variables\":\"Gaming\",\"Value\":-7},{\"Variables\":\"Hair\",\"Value\":-66},{\"Variables\":\"Helper\",\"Value\":-444},{\"Variables\":\"Movies\",\"Value\":-29},{\"Variables\":\"Petrol\",\"Value\":-99},{\"Variables\":\"Rent\",\"Value\":-5156},{\"Variables\":\"Retail shopping\",\"Value\":-473},{\"Variables\":\"Transport\",\"Value\":-366},{\"Variables\":\"Utility\",\"Value\":-218},{\"Variables\":\"AMZNPRIMESG\",\"Value\":-1},{\"Variables\":\"Mortgage\",\"Value\":\"NA\"},{\"Variables\":\"CreditScore\",\"Value\":\"NA\"},{\"Variables\":\"LateSleeper\",\"Value\":\"NA\"},{\"Variables\":\"Location\",\"Value\":\"NA\"}]},\"Outputs\":{\"Results\":[{\"ID\":1,\"Model\":\"Term Life\",\"Prob\":0.0022378485212763335,\"Offer_Flag\":\"Y\",\"Rank\":9},{\"ID\":2,\"Model\":\"Accidental PPD\",\"Prob\":0.768524783499018,\"Offer_Flag\":\"Y\",\"Rank\":7},{\"ID\":3,\"Model\":\"Critical Illness\",\"Prob\":0.574442516811659,\"Offer_Flag\":\"Y\",\"Rank\":8},{\"ID\":4,\"Model\":\"Medical Expenses\",\"Prob\":0,\"Offer_Flag\":\"Y\",\"Rank\":11},{\"ID\":5,\"Model\":\"Hospital Cash\",\"Prob\":0.995033198349943,\"Offer_Flag\":\"Y\",\"Rank\":3},{\"ID\":6,\"Model\":\"Travel\",\"Prob\":0.930861579656653,\"Offer_Flag\":\"Y\",\"Rank\":6},{\"ID\":7,\"Model\":\"Home Emergency Assistance\",\"Prob\":0,\"Offer_Flag\":\"Y\",\"Rank\":12},{\"ID\":8,\"Model\":\"Cyber\",\"Prob\":0.999647462162129,\"Offer_Flag\":\"Y\",\"Rank\":2},{\"ID\":9,\"Model\":\"Home Contents\",\"Prob\":0.994779874306442,\"Offer_Flag\":\"Y\",\"Rank\":4},{\"ID\":10,\"Model\":\"Unemployment*\",\"Prob\":0,\"Offer_Flag\":\"N\",\"Rank\":13},{\"ID\":11,\"Model\":\"Event Cancellation\",\"Prob\":0,\"Offer_Flag\":\"Y\",\"Rank\":14},{\"ID\":12,\"Model\":\"Item\",\"Prob\":0.999981542106704,\"Offer_Flag\":\"Y\",\"Rank\":1},{\"ID\":13,\"Model\":\"Shipping Insurance\",\"Prob\":0,\"Offer_Flag\":null,\"Rank\":15},{\"ID\":14,\"Model\":\"Sports coverage for physical injury\",\"Prob\":0,\"Offer_Flag\":\"Y\",\"Rank\":16},{\"ID\":15,\"Model\":\"Competition / Race coverage\",\"Prob\":0,\"Offer_Flag\":\"Y\",\"Rank\":17},{\"ID\":16,\"Model\":\"Gimmicky \\\"prize\\\" insurance\",\"Prob\":0,\"Offer_Flag\":\"Y\",\"Rank\":18},{\"ID\":17,\"Model\":\"Education\",\"Prob\":0.0021930915508508067,\"Offer_Flag\":\"Y\",\"Rank\":10},{\"ID\":18,\"Model\":\"Crypto\",\"Prob\":0.993940198508416,\"Offer_Flag\":\"Y\",\"Rank\":5}]},\"Errors\":[],\"FetchTimeUTC\":\"2022-01-23T17:22:32.2092966Z\",\"EngineID\":\"e28a656f-310d-44ae-a56c-ba65012cca7a\",\"ServiceName\":\"Recommender\",\"EngineType\":\"Type3\",\"Revision\":\"1.0.0\",\"Version\":\"e0fa9c4f-9081-439e-bd3f-3e17685bc221\",\"ReleaseDate\":\"2022-01-12 09:10:49\",\"Description\":null,\"EngineHash\":\"078330208EA652991F08C052BE222CFC\",\"CalcTime\":183.0,\"TotalTime\":19597,\"SolveInputs\":[],\"SolveOutputs\":[],\"ProductName\":\"Embedded\",\"EffectiveStartDate\":\"2010-01-01T00:00:00Z\",\"EffectiveEndDate\":\"2120-01-01T00:00:00Z\",\"CallGUID\":\"78e0932a-34eb-496b-81e0-f3db8ee62fe9\"},\"errorCode\":null,\"status\":\"Success\"}",
          "API_Res1": null,
          "API_Res10": null,
          "API_Res2": null,
          "API_Res3": null,
          "API_Res4": "{\"message\":null,\"data\":{\"Inputs\":{\"Promotion_Code\":null,\"Quote_Date\":null,\"Sum_Assured\":1},\"Outputs\":{\"Commission\":0,\"Commission_Rate\":0.2,\"Decline_Flag\":null,\"Decline_Reason\":null,\"Gross_Premium\":3.51,\"Net_Premium\":3.51,\"Tax\":0,\"Tax_Rate\":0},\"Errors\":[],\"Warnings\":[{\"Key\":\"Default Values\",\"Value\":[\"Input parameter(s) missing. API request using the Default Values.\"]}],\"FetchTimeUTC\":\"2022-01-23T17:22:33.0100391Z\",\"EngineID\":\"c744135e-6fc8-4115-a6b8-597984977fe5\",\"ServiceName\":\"04_Cyber Product Engine\",\"EngineType\":\"Type3\",\"Revision\":\"1.0.0\",\"Version\":\"09a6bdfc-7a0d-4d12-8b86-7df0993588b2\",\"ReleaseDate\":\"2022-01-12 09:09:23\",\"Description\":null,\"EngineHash\":\"98E5C7318E7E52789E01175354783037\",\"CalcTime\":4.0,\"TotalTime\":69,\"SolveInputs\":[],\"SolveOutputs\":[],\"ProductName\":\"Embedded\",\"EffectiveStartDate\":\"2010-01-01T00:00:00Z\",\"EffectiveEndDate\":\"2120-01-01T00:00:00Z\",\"CallGUID\":\"c458c37c-e500-4aa6-b53a-2434b8b68b8d\"},\"errorCode\":null,\"status\":\"Success\"}",
          "API_Res5": null,
          "API_Res6": "{\"message\":null,\"data\":{\"Inputs\":{\"Content_SI\":400,\"Floor_Size\":1999,\"Payment_Options\":null,\"Postal_Code\":18979,\"Promotion_Code\":null,\"Property_Type\":\"Flat\",\"Quote_Date\":\"2021-11-23 T03:00:00Z\",\"Year_Built\":1980},\"Outputs\":{\"Commission\":20,\"Commission_Rate\":0.2,\"Decline_Flag\":0,\"Decline_Reason\":null,\"Gross_Premium\":100,\"Net_Premium\":80,\"Tax\":6,\"Tax_Rate\":0.06},\"Errors\":[],\"Warnings\":[{\"Key\":\"Default Values\",\"Value\":[\"Input parameter(s) missing. API request using the Default Values.\"]}],\"FetchTimeUTC\":\"2022-01-23T17:22:33.4711202Z\",\"EngineID\":\"50cd5041-3d6f-48c8-89d2-c0d06b9306cc\",\"ServiceName\":\"06_Home Content Product Engine Details\",\"EngineType\":\"Type3\",\"Revision\":\"1.0.0\",\"Version\":\"d175d039-1c15-4c87-9548-5177b5cda93f\",\"ReleaseDate\":\"2022-01-12 09:09:40\",\"Description\":null,\"EngineHash\":\"BB05CC34C615575782FE2CA68AC4EB66\",\"CalcTime\":25.0,\"TotalTime\":89,\"SolveInputs\":[],\"SolveOutputs\":[],\"ProductName\":\"Embedded\",\"EffectiveStartDate\":\"2010-01-01T00:00:00Z\",\"EffectiveEndDate\":\"2120-01-01T00:00:00Z\",\"CallGUID\":\"3b8aa8bd-9c59-4b6b-b3b7-ec99310383f2\"},\"errorCode\":null,\"status\":\"Success\"}",
          "API_Res7": "{\"message\":null,\"data\":{\"Inputs\":{\"Promotion_Code\":null,\"Quote_Date\":null,\"Sum_Assured\":100},\"Outputs\":{\"Commission\":0,\"Commission_Rate\":0.4,\"Decline_Flag\":null,\"Decline_Reason\":null,\"Gross_Premium\":16.55,\"Net_Premium\":16.55,\"Tax\":0,\"Tax_Rate\":0},\"Errors\":[],\"Warnings\":[{\"Key\":\"Default Values\",\"Value\":[\"Input parameter(s) missing. API request using the Default Values.\"]}],\"FetchTimeUTC\":\"2022-01-23T17:22:33.9939716Z\",\"EngineID\":\"e0910ed9-5604-4232-bfd8-3402c0a723fc\",\"ServiceName\":\"07_Hospital Cash Product Engine\",\"EngineType\":\"Type3\",\"Revision\":\"1.0.0\",\"Version\":\"a56c7fae-e10c-4b03-811e-3c9e10d33787\",\"ReleaseDate\":\"2022-01-12 09:09:48\",\"Description\":null,\"EngineHash\":\"77E31DA771334DD9A4A77F2645A9FA57\",\"CalcTime\":0.0,\"TotalTime\":41,\"SolveInputs\":[],\"SolveOutputs\":[],\"ProductName\":\"Embedded\",\"EffectiveStartDate\":\"2010-01-01T00:00:00Z\",\"EffectiveEndDate\":\"2120-01-01T00:00:00Z\",\"CallGUID\":\"1da84606-af59-4857-9061-4d373385f8cb\"},\"errorCode\":null,\"status\":\"Success\"}",
          "API_Res8": "{\"message\":null,\"data\":{\"Inputs\":{\"Promotion_Code\":null,\"Quote_Date\":null,\"Sum_Assured\":200},\"Outputs\":{\"Commission\":0,\"Commission_Rate\":0.3,\"Decline_Flag\":null,\"Decline_Reason\":null,\"Gross_Premium\":0.07,\"Net_Premium\":0.07,\"Tax\":0,\"Tax_Rate\":0},\"Errors\":[],\"Warnings\":[{\"Key\":\"Default Values\",\"Value\":[\"Input parameter(s) missing. API request using the Default Values.\"]}],\"FetchTimeUTC\":\"2022-01-23T17:22:34.3150226Z\",\"EngineID\":\"0e6974d4-c448-4b25-a0ca-e5745b312d35\",\"ServiceName\":\"08_Item Product Engine\",\"EngineType\":\"Type3\",\"Revision\":\"1.0.0\",\"Version\":\"71e7becc-5a64-4a94-af5d-812d77d9878a\",\"ReleaseDate\":\"2022-01-12 09:09:55\",\"Description\":null,\"EngineHash\":\"723386664DB6BE4C3C8CECEEFEEC6033\",\"CalcTime\":1.0,\"TotalTime\":25,\"SolveInputs\":[],\"SolveOutputs\":[],\"ProductName\":\"Embedded\",\"EffectiveStartDate\":\"2010-01-01T00:00:00Z\",\"EffectiveEndDate\":\"2120-01-01T00:00:00Z\",\"CallGUID\":\"d8f0e068-2f45-40db-a705-524c019eabb0\"},\"errorCode\":null,\"status\":\"Success\"}",
          "API_Res9": null,
          "API_UWQ": "{\"message\":null,\"data\":{\"Inputs\":{\"Selected_Products\":[{\"ID\":1,\"Selected\":\"N\"},{\"ID\":2,\"Selected\":\"N\"},{\"ID\":3,\"Selected\":\"N\"},{\"ID\":4,\"Selected\":\"Y\"},{\"ID\":5,\"Selected\":\"N\"},{\"ID\":6,\"Selected\":\"Y\"},{\"ID\":7,\"Selected\":\"Y\"},{\"ID\":8,\"Selected\":\"Y\"},{\"ID\":9,\"Selected\":\"N\"},{\"ID\":10,\"Selected\":\"N\"}],\"UW_Response\":[{\"ID\":2,\"Response\":\"N\"},{\"ID\":3,\"Response\":\"N\"},{\"ID\":4,\"Response\":\"N\"}]},\"Outputs\":{\"Question_Sets\":[{\"ID\":1,\"Value\":\"Has any of your life insurance application been declined before?\",\"Response\":\"Yes;No;\",\"Referral_Response\":\"Yes\",\"Display\":\"N\"},{\"ID\":2,\"Value\":\"Have you had a home insurance policy cancelled, declined, refused to renew or had special terms and conditions imposed upon a policy, or have made or reported a home insurance claim in the past 3 years ?\",\"Response\":\"Yes;No;\",\"Referral_Response\":\"Yes\",\"Display\":\"Y\"},{\"ID\":3,\"Value\":\"Have you ever had, or been told that you have, or are you currently under investigation for diabetes, cancer, heart attack, stroke, AIDS or HIV infection, carcinoma in situ, tumour, lump or polyp?\",\"Response\":\"Yes;No;\",\"Referral_Response\":\"Yes\",\"Display\":\"Y\"},{\"ID\":4,\"Value\":\"In the past 2  years, have you had any abnormal results in a pap smear, mammogram, breast ultrasound, prostate examinination or tumour market blood test?\",\"Response\":\"Yes;No;\",\"Referral_Response\":\"Yes\",\"Display\":\"Y\"},{\"ID\":5,\"Value\":\"In the last 12 months, has the proposed insured smoked any cigarette, cigars, electronic cigarettes, vaporizers or waterpipe tobacco?\",\"Response\":\"Yes;No;\",\"Referral_Response\":\"\",\"Display\":\"Y\"}],\"Referral_Flag\":\"Quote\"},\"Errors\":[],\"FetchTimeUTC\":\"2022-01-23T17:22:35.1440014Z\",\"EngineID\":\"5c5c375e-6059-4a80-bd6a-e8ba7c91fa4c\",\"ServiceName\":\"UW Questions\",\"EngineType\":\"Type3\",\"Revision\":\"1.0.0\",\"Version\":\"78ed5a03-83eb-40a3-9f1a-1a1b43898826\",\"ReleaseDate\":\"2022-01-12 09:11:19\",\"Description\":null,\"EngineHash\":\"A0D046FD13D0D2135F6C3FA9D82CB7B5\",\"CalcTime\":4.0,\"TotalTime\":43,\"SolveInputs\":[],\"SolveOutputs\":[],\"ProductName\":\"Embedded\",\"EffectiveStartDate\":\"2010-01-01T00:00:00Z\",\"EffectiveEndDate\":\"2120-01-01T00:00:00Z\",\"CallGUID\":\"1afb7255-9697-4aaf-b140-064cfe16c806\"},\"errorCode\":null,\"status\":\"Success\"}",
          "Postcode_Out1": "ErrValue",
          "Postcode_Out2": "ErrValue",
          "Postcode_Out3": "ErrValue",
          "Postcode_Out4": "ErrValue",
          "Premium_Detail": [
            {
              "ID": 1,
              "Gross_Premium_before_Discount": "",
              "Gross_Premium_after_Discount": "",
              "Commission": "",
              "Tax": "",
              "Net_Premium": "",
              "Gross_Premium_inc_Tax": ""
            },
            {
              "ID": 2,
              "Gross_Premium_before_Discount": "",
              "Gross_Premium_after_Discount": "",
              "Commission": "",
              "Tax": "",
              "Net_Premium": "",
              "Gross_Premium_inc_Tax": ""
            },
            {
              "ID": 3,
              "Gross_Premium_before_Discount": "",
              "Gross_Premium_after_Discount": "",
              "Commission": "",
              "Tax": "",
              "Net_Premium": "",
              "Gross_Premium_inc_Tax": ""
            },
            {
              "ID": 4,
              "Gross_Premium_before_Discount": 3.51,
              "Gross_Premium_after_Discount": 3.44,
              "Commission": 0.69,
              "Tax": 0,
              "Net_Premium": 2.75,
              "Gross_Premium_inc_Tax": 3.44
            },
            {
              "ID": 5,
              "Gross_Premium_before_Discount": "",
              "Gross_Premium_after_Discount": "",
              "Commission": "",
              "Tax": "",
              "Net_Premium": "",
              "Gross_Premium_inc_Tax": ""
            },
            {
              "ID": 6,
              "Gross_Premium_before_Discount": 100,
              "Gross_Premium_after_Discount": 98,
              "Commission": 19.6,
              "Tax": 5.88,
              "Net_Premium": 78.4,
              "Gross_Premium_inc_Tax": 103.88
            },
            {
              "ID": 7,
              "Gross_Premium_before_Discount": 16.55,
              "Gross_Premium_after_Discount": 16.22,
              "Commission": 6.49,
              "Tax": 0,
              "Net_Premium": 9.73,
              "Gross_Premium_inc_Tax": 16.22
            },
            {
              "ID": 8,
              "Gross_Premium_before_Discount": 0.07,
              "Gross_Premium_after_Discount": 0.07,
              "Commission": 0.02,
              "Tax": 0,
              "Net_Premium": 0.05,
              "Gross_Premium_inc_Tax": 0.07
            },
            {
              "ID": 9,
              "Gross_Premium_before_Discount": "",
              "Gross_Premium_after_Discount": "",
              "Commission": "",
              "Tax": "",
              "Net_Premium": "",
              "Gross_Premium_inc_Tax": ""
            },
            {
              "ID": 10,
              "Gross_Premium_before_Discount": "",
              "Gross_Premium_after_Discount": "",
              "Commission": "",
              "Tax": "",
              "Net_Premium": "",
              "Gross_Premium_inc_Tax": ""
            }
          ],
          "Question_Sets": [
            {
              "ID": 1,
              "Value": "Has any of your life insurance application been declined before?",
              "Response": "Yes;No;",
              "Referral_Response": "Yes",
              "Display": "N"
            },
            {
              "ID": 2,
              "Value": "Have you had a home insurance policy cancelled, declined, refused to renew or had special terms and conditions imposed upon a policy, or have made or reported a home insurance claim in the past 3 years ?",
              "Response": "Yes;No;",
              "Referral_Response": "Yes",
              "Display": "Y"
            },
            {
              "ID": 3,
              "Value": "Have you ever had, or been told that you have, or are you currently under investigation for diabetes, cancer, heart attack, stroke, AIDS or HIV infection, carcinoma in situ, tumour, lump or polyp?",
              "Response": "Yes;No;",
              "Referral_Response": "Yes",
              "Display": "Y"
            },
            {
              "ID": 4,
              "Value": "In the past 2  years, have you had any abnormal results in a pap smear, mammogram, breast ultrasound, prostate examinination or tumour market blood test?",
              "Response": "Yes;No;",
              "Referral_Response": "Yes",
              "Display": "Y"
            },
            {
              "ID": 5,
              "Value": "In the last 12 months, has the proposed insured smoked any cigarette, cigars, electronic cigarettes, vaporizers or waterpipe tobacco?",
              "Response": "Yes;No;",
              "Referral_Response": "",
              "Display": "Y"
            }
          ],
          "Recommended_Products": [
            {
              "ID": 8,
              "Product": "Item",
              "Recommend Coverage": 200
            },
            {
              "ID": 4,
              "Product": "Cyber",
              "Recommend Coverage": 1
            },
            {
              "ID": 7,
              "Product": "Hospital Cash",
              "Recommend Coverage": 100
            },
            {
              "ID": 6,
              "Product": "Home Contents",
              "Recommend Coverage": 400
            }
          ],
          "Referral_Flag": "Quote",
          "UI_Options": [
            {
              "ID": 1,
              "Product": "Accidental PPD",
              "Eligibility": "Y",
              "Default": 40000,
              "Min": 0,
              "Max": 200000,
              "Step": 20000
            },
            {
              "ID": 2,
              "Product": "Critical Illness",
              "Eligibility": "Y",
              "Default": 20000,
              "Min": 0,
              "Max": 200000,
              "Step": 20000
            },
            {
              "ID": 3,
              "Product": "Crypto",
              "Eligibility": "Y",
              "Default": 2000,
              "Min": 0,
              "Max": 20000,
              "Step": 2000
            },
            {
              "ID": 4,
              "Product": "Cyber",
              "Eligibility": "Y",
              "Default": 1,
              "Min": 0,
              "Max": 1,
              "Step": 1
            },
            {
              "ID": 5,
              "Product": "Education",
              "Eligibility": "Y",
              "Default": 200,
              "Min": 0,
              "Max": 20000,
              "Step": 2000
            },
            {
              "ID": 6,
              "Product": "Home Contents",
              "Eligibility": "Y",
              "Default": 400,
              "Min": 0,
              "Max": 10000,
              "Step": 1000
            },
            {
              "ID": 7,
              "Product": "Hospital Cash",
              "Eligibility": "Y",
              "Default": 100,
              "Min": 0,
              "Max": 200,
              "Step": 20
            },
            {
              "ID": 8,
              "Product": "Item",
              "Eligibility": "Y",
              "Default": 200,
              "Min": 0,
              "Max": 10000,
              "Step": 1000
            },
            {
              "ID": 9,
              "Product": "Term Life",
              "Eligibility": "Y",
              "Default": 100000,
              "Min": 0,
              "Max": 200000,
              "Step": 20000
            },
            {
              "ID": 10,
              "Product": "Travel",
              "Eligibility": "Y",
              "Default": 200,
              "Min": 0,
              "Max": 2000,
              "Step": 200
            }
          ]
        },
        "warnings": [],
        "errors": [],
        "service_chain": []
      },
      "response_meta": {
        "service_id": "4b59e498-b6dd-492f-a27b-f3f5dca4c1cc",
        "version_id": "19dbe817-d620-4fe4-b2b1-996591077eb4",
        "version": "1.8.0",
        "process_time": 20,
        "call_id": "c5e43978-5052-45f1-888b-c8f1231b4b57",
        "compiler_type": "Type3",
        "compiler_version": "1.0.0",
        "source_hash": null,
        "engine_id": "D751AA0B8417648EAFC14A7AAB34A4C5",
        "correlation_id": "",
        "system": "SPARK",
        "request_timestamp": "2022-01-23, 17:24:18 GMT+00:00"
      }
        }

    vm.investInput = {
      "request_data": {
        "inputs": {
          "Discount_Code": null,
          "Limit1": null,
          "Limit10": null,
          "Limit2": null,
          "Limit3": null,
          "Limit4": null,
          "Limit5": null,
          "Limit6": null,
          "Limit7": null,
          "Limit8": null,
          "Limit9": null,
          "No_Products": 9,
          "Prm_Active_Lifestyle": "NA",
          "Prm_Age": 30,
          "Prm_AMZNPRIMESG": -1,
          "Prm_Automotive": -628,
          "Prm_Bar": -71,
          "Prm_Child": -472,
          "Prm_CreditArrear": 0,
          "Prm_CreditBalance": 8302,
          "Prm_CreditScore": "NA",
          "Prm_Currency": "NA",
          "Prm_Dependents": 0,
          "Prm_E_commerce": -528,
          "Prm_Education": "A Levels",
          "Prm_Food": -1999,
          "Prm_Gaming": -7,
          "Prm_Gender": "Female",
          "Prm_Grocery": -535,
          "Prm_Hair": -66,
          "Prm_Health": -161,
          "Prm_Helper": -444,
          "Prm_Home": "NA",
          "Prm_Income": 27000,
          "Prm_Industry": "Insurance",
          "Prm_Insurance": "NA",
          "Prm_LateSleeper": "NA",
          "Prm_Loan": 0,
          "Prm_Location": "NA",
          "Prm_Luxury": "NA",
          "Prm_Marital_Status": "Single",
          "Prm_Mortgage": "NA",
          "Prm_Movies": -29,
          "Prm_Occupation": "I.T.",
          "Prm_Petrol": -99,
          "Prm_Postcode": 560727,
          "Prm_ProfileName": "Cassandra",
          "Prm_Rent": -5156,
          "Prm_Residency": "Employment Pass",
          "Prm_Retail_shopping": -473,
          "Prm_Transport": -366,
          "Prm_Travel": -345,
          "Prm_Utility": -218,
          "Selection": "Customise",
          "UW_Response": [
            {
              "ID": 2,
              "Response": "N"
            },
            {
              "ID": 3,
              "Response": "N"
            },
            {
              "ID": 4,
              "Response": "N"
            }
          ]
        }
      },
      "request_meta": {
        "version_id": "4dc2b6ec-8f48-409b-be24-c898a627a895",
        "transaction_date": "2022-03-02T11:12:59.507Z",
        "call_purpose": "Spark - API Tester",
        "source_system": "SPARK",
        "correlation_id": "",
        "requested_output": "",
        "service_category": "",
        "compiler_type": "Type3"
      }
    }

    vm.PFInput = {
      "request_data": {
        "inputs": {
          "Discount_Code": null,
          "Limit1": null,
          "Limit10": null,
          "Limit2": null,
          "Limit3": null,
          "Limit4": null,
          "Limit5": null,
          "Limit6": null,
          "Limit7": null,
          "Limit8": null,
          "Limit9": null,
          "No_Products": 4,
          "Prm_Active_Lifestyle": "NA",
          "Prm_Age": 30,
          "Prm_AMZNPRIMESG": -1,
          "Prm_Automotive": -628,
          "Prm_Bar": -71,
          "Prm_Child": -472,
          "Prm_CreditArrear": 0,
          "Prm_CreditBalance": 8302,
          "Prm_CreditScore": "NA",
          "Prm_Currency": "NA",
          "Prm_Dependents": 0,
          "Prm_E_commerce": -528,
          "Prm_Education": "A Levels",
          "Prm_Food": -1999,
          "Prm_Gaming": -7,
          "Prm_Gender": "Female",
          "Prm_Grocery": -535,
          "Prm_Hair": -66,
          "Prm_Health": -161,
          "Prm_Helper": -444,
          "Prm_Home": "NA",
          "Prm_Income": 27000,
          "Prm_Industry": "Insurance",
          "Prm_Insurance": "NA",
          "Prm_LateSleeper": "NA",
          "Prm_Loan": 0,
          "Prm_Location": "NA",
          "Prm_Luxury": "NA",
          "Prm_Marital_Status": "Single",
          "Prm_Mortgage": "NA",
          "Prm_Movies": -29,
          "Prm_Occupation": "I.T.",
          "Prm_Petrol": -99,
          "Prm_Postcode": 300821,
          "Prm_Rent": -5156,
          "Prm_Residency": "Employment Pass",
          "Prm_Retail_shopping": -473,
          "Prm_Transport": -366,
          "Prm_Travel": -345,
          "Prm_Utility": -218,
          "Selection": "Recommended",
          "UW_Response": [
            {
              "ID": 2,
              "Response": "N"
            },
            {
              "ID": 3,
              "Response": "N"
            },
            {
              "ID": 4,
              "Response": "N"
            }
          ]
        }
      },
      "request_meta": {
        "version_id": "07a5fae2-3032-4ff1-8160-e5cfaf4394ff",
        "transaction_date": "2022-03-02T11:13:33.390Z",
        "call_purpose": "Spark - API Tester",
        "source_system": "SPARK",
        "correlation_id": "",
        "requested_output": "",
        "service_category": "",
        "compiler_type": "Type3"
      }
    }

    vm.PFOutput = {
      "response_data": {
        "outputs": {
          "01_Gross_Prem_before_discount": 89.35,
          "02a_Discount_Multi_Pct": 0.16,
          "02b_Code_Discount_Pct": 0,
          "02c_Code_Discount_amt": 0,
          "02d_Code_Discount_Product": "null",
          "02e_Code_Discount_Error_Msg": "null",
          "02g_Gross_Prem_after_discount": 75.05,
          "02h_Total_Discount": 14.3,
          "03_Comm": 18.65,
          "04_Tax": 3.16,
          "05_Net_Prem": 56.4,
          "06_Gross_Prem_inc_Tax": 78.21,
          "API_Discount": "{\"metadata\":{\"name\":\"EMBBEDED_Discount\",\"calltype\":\"EXTERNALXMLAPIBYNAME\",\"status\":\"200\",\"error_code\":\"\",\"response_time\":\"637\"},\"data\":{\"message\":null,\"data\":{\"Inputs\":{\"Discount_Code\":null,\"Product_cnt\":4,\"DateTime\":44621.02690667824},\"Outputs\":{\"02a_Discount_Multi_Pct\":0.16,\"02b_Code_Discount_Pct\":null,\"02c_Code_Discount_Amt\":null,\"02d_Code_Discount_Product\":null,\"02e_Code_Discount_Error_Msg\":null,\"DateTime\":44621.02690667824},\"Errors\":[],\"FetchTimeUTC\":\"2022-03-01T00:38:45.3731048Z\",\"EngineID\":\"ca9671c9-13ef-4d7c-8a84-19d43aa5e62d\",\"ServiceName\":\"Discount Table\",\"EngineType\":\"Type3\",\"Revision\":\"1.54.0\",\"Version\":\"4b807af6-7084-4422-b8fd-28628972fb56\",\"ReleaseDate\":\"2022-02-17 06:12:31\",\"Description\":null,\"EngineHash\":\"C737DF30DF5B3455C0A81841599819AB\",\"CalcTime\":0.0,\"TotalTime\":28,\"SolveInputs\":[],\"SolveOutputs\":[],\"ProductName\":\"Flex\",\"EffectiveStartDate\":\"2010-01-01T00:00:00Z\",\"EffectiveEndDate\":\"2120-01-01T00:00:00Z\",\"CallGUID\":\"c473a4a7-dca5-41e5-8de0-4a6a1b19a073\"},\"errorCode\":null,\"status\":\"Success\"}}",
          "API_Postcode": "{\"metadata\":{\"name\":\"SGLOCATE_POSTCODE\",\"calltype\":\"EXTERNALXMLAPIBYNAME\",\"status\":\"200\",\"error_code\":\"\",\"response_time\":\"0\"},\"data\":{\"metadata\":{\"name\":\"SGLOCATE_POSTCODE\",\"calltype\":\"EXTERNALXMLAPIBYNAME\",\"status\":\"200\",\"error_code\":\"\",\"response_time\":\"252\"},\"data\":{\"IsSuccess\":false,\"ErrorCode\":\"-21\",\"ErrorDetails\":\"Unauthorized postcode for demo plan.\",\"Postcodes\":[]}}}",
          "API_Recommender": "{\"metadata\":{\"name\":\"EMBBEDED_Recommender\",\"calltype\":\"EXTERNALXMLAPIBYNAME\",\"status\":\"200\",\"error_code\":\"\",\"response_time\":\"937\"},\"data\":{\"message\":null,\"data\":{\"Inputs\":{\"Factors\":[{\"Variables\":\"Age\",\"Value\":30},{\"Variables\":\"Gender\",\"Value\":\"Female\"},{\"Variables\":\"Income\",\"Value\":27000},{\"Variables\":\"Postcode\",\"Value\":300821},{\"Variables\":\"Occupation\",\"Value\":\"I.T.\"},{\"Variables\":\"Industry\",\"Value\":\"Insurance\"},{\"Variables\":\"Marital Status\",\"Value\":\"Single\"},{\"Variables\":\"Dependents\",\"Value\":0},{\"Variables\":\"Education\",\"Value\":\"A Levels\"},{\"Variables\":\"Residency\",\"Value\":\"Employment Pass\"},{\"Variables\":\"CreditBalance\",\"Value\":8302},{\"Variables\":\"CreditArrear\",\"Value\":0},{\"Variables\":\"Loan\",\"Value\":0},{\"Variables\":\"Health\",\"Value\":-161},{\"Variables\":\"Child\",\"Value\":-472},{\"Variables\":\"Insurance\",\"Value\":\"NA\"},{\"Variables\":\"Travel\",\"Value\":-345},{\"Variables\":\"Luxury\",\"Value\":\"NA\"},{\"Variables\":\"E-commerce\",\"Value\":-528},{\"Variables\":\"Active Lifestyle\",\"Value\":\"NA\"},{\"Variables\":\"Grocery\",\"Value\":-535},{\"Variables\":\"Home\",\"Value\":\"NA\"},{\"Variables\":\"Currency\",\"Value\":\"NA\"},{\"Variables\":\"Automotive\",\"Value\":-628},{\"Variables\":\"Bar\",\"Value\":-71},{\"Variables\":\"Food\",\"Value\":-1999},{\"Variables\":\"Gaming\",\"Value\":-7},{\"Variables\":\"Hair\",\"Value\":-66},{\"Variables\":\"Helper\",\"Value\":-444},{\"Variables\":\"Movies\",\"Value\":-29},{\"Variables\":\"Petrol\",\"Value\":-99},{\"Variables\":\"Rent\",\"Value\":-5156},{\"Variables\":\"Retail shopping\",\"Value\":-473},{\"Variables\":\"Transport\",\"Value\":-366},{\"Variables\":\"Utility\",\"Value\":-218},{\"Variables\":\"AMZNPRIMESG\",\"Value\":-1},{\"Variables\":\"Mortgage\",\"Value\":\"NA\"},{\"Variables\":\"CreditScore\",\"Value\":\"NA\"},{\"Variables\":\"LateSleeper\",\"Value\":\"NA\"},{\"Variables\":\"Location\",\"Value\":\"NA\"}],\"DateTime\":44621.02689101852},\"Outputs\":{\"Results\":[{\"ID\":1,\"Model\":\"Term Life\",\"Prob\":0.004496273160941,\"Manual Offer Flag\":\"Y\",\"Calc Offer Flag\":\"Y\",\"Offer_Flag\":\"Y\",\"Probability\":0.004496273160941,\"Rank\":8},{\"ID\":2,\"Model\":\"Accidental PPD\",\"Prob\":0.768524783499018,\"Manual Offer Flag\":\"Y\",\"Calc Offer Flag\":\"Y\",\"Offer_Flag\":\"Y\",\"Probability\":0.768524783499018,\"Rank\":5},{\"ID\":3,\"Model\":\"Critical Illness\",\"Prob\":0.574442516811659,\"Manual Offer Flag\":\"Y\",\"Calc Offer Flag\":\"Y\",\"Offer_Flag\":\"Y\",\"Probability\":0.574442516811659,\"Rank\":6},{\"ID\":4,\"Model\":\"Medical Expenses\",\"Prob\":0,\"Manual Offer Flag\":\"Y\",\"Calc Offer Flag\":\"Y\",\"Offer_Flag\":\"Y\",\"Probability\":0.0,\"Rank\":10},{\"ID\":5,\"Model\":\"Hospital Cash\",\"Prob\":0.995033198349943,\"Manual Offer Flag\":\"Y\",\"Calc Offer Flag\":\"Y\",\"Offer_Flag\":\"Y\",\"Probability\":0.995033198349943,\"Rank\":2},{\"ID\":6,\"Model\":\"Travel\",\"Prob\":0.930861579656653,\"Manual Offer Flag\":\"Y\",\"Calc Offer Flag\":\"Y\",\"Offer_Flag\":\"Y\",\"Probability\":0.930861579656653,\"Rank\":4},{\"ID\":7,\"Model\":\"Home Emergency Assistance\",\"Prob\":0,\"Manual Offer Flag\":\"Y\",\"Calc Offer Flag\":\"Y\",\"Offer_Flag\":\"Y\",\"Probability\":0.0,\"Rank\":11},{\"ID\":8,\"Model\":\"Cyber\",\"Prob\":0.999647462162129,\"Manual Offer Flag\":\"N\",\"Calc Offer Flag\":\"Y\",\"Offer_Flag\":\"N\",\"Probability\":0.0,\"Rank\":9},{\"ID\":9,\"Model\":\"Home Contents\",\"Prob\":0.994779874306442,\"Manual Offer Flag\":\"Y\",\"Calc Offer Flag\":\"Y\",\"Offer_Flag\":\"Y\",\"Probability\":0.994779874306442,\"Rank\":3},{\"ID\":10,\"Model\":\"Unemployment*\",\"Prob\":0,\"Manual Offer Flag\":\"Y\",\"Calc Offer Flag\":\"N\",\"Offer_Flag\":\"Y\",\"Probability\":0.0,\"Rank\":13},{\"ID\":11,\"Model\":\"Event Cancellation\",\"Prob\":0,\"Manual Offer Flag\":\"Y\",\"Calc Offer Flag\":\"N\",\"Offer_Flag\":\"Y\",\"Probability\":0.0,\"Rank\":14},{\"ID\":12,\"Model\":\"Item\",\"Prob\":0.999981542106704,\"Manual Offer Flag\":\"Y\",\"Calc Offer Flag\":\"Y\",\"Offer_Flag\":\"Y\",\"Probability\":0.999981542106704,\"Rank\":1},{\"ID\":13,\"Model\":\"Shipping Insurance\",\"Prob\":0,\"Manual Offer Flag\":\"Y\",\"Calc Offer Flag\":\"N\",\"Offer_Flag\":\"Y\",\"Probability\":0.0,\"Rank\":15},{\"ID\":14,\"Model\":\"Sports coverage for physical injury\",\"Prob\":0,\"Manual Offer Flag\":\"Y\",\"Calc Offer Flag\":\"N\",\"Offer_Flag\":\"Y\",\"Probability\":0.0,\"Rank\":16},{\"ID\":15,\"Model\":\"Competition / Race coverage\",\"Prob\":0,\"Manual Offer Flag\":\"Y\",\"Calc Offer Flag\":\"N\",\"Offer_Flag\":\"Y\",\"Probability\":0.0,\"Rank\":17},{\"ID\":16,\"Model\":\"Gimmicky \\\"prize\\\" insurance\",\"Prob\":0,\"Manual Offer Flag\":\"Y\",\"Calc Offer Flag\":\"N\",\"Offer_Flag\":\"Y\",\"Probability\":0.0,\"Rank\":18},{\"ID\":17,\"Model\":\"Education\",\"Prob\":0.004406347697722,\"Manual Offer Flag\":\"Y\",\"Calc Offer Flag\":\"Y\",\"Offer_Flag\":\"Y\",\"Probability\":0.004406347697722,\"Rank\":9},{\"ID\":18,\"Model\":\"Crypto\",\"Prob\":0.52497918747894,\"Manual Offer Flag\":\"Y\",\"Calc Offer Flag\":\"Y\",\"Offer_Flag\":\"Y\",\"Probability\":0.52497918747894,\"Rank\":7}],\"DateTime\":44621.02689101852},\"Errors\":[],\"FetchTimeUTC\":\"2022-03-01T00:38:44.315657Z\",\"EngineID\":\"149bc281-78cd-4a73-ae06-3f6954a558d8\",\"ServiceName\":\"Recommender\",\"EngineType\":\"Type3\",\"Revision\":\"1.13.0\",\"Version\":\"b64d1690-5e0b-4776-b21d-dcad5787c3b4\",\"ReleaseDate\":\"2022-02-24 03:18:06\",\"Description\":null,\"EngineHash\":\"DCF5F4F71650966C5FFC6B2ED7CA023D\",\"CalcTime\":243.0,\"TotalTime\":267,\"SolveInputs\":[],\"SolveOutputs\":[],\"ProductName\":\"Flex\",\"EffectiveStartDate\":\"2010-01-01T00:00:00Z\",\"EffectiveEndDate\":\"2120-01-01T00:00:00Z\",\"CallGUID\":\"f4e8a5a1-e7ae-4671-91f4-2b152033c46c\"},\"errorCode\":null,\"status\":\"Success\"}}",
          "API_Res1": null,
          "API_Res10": "{\"metadata\":{\"name\":\"EMBBEDED_10_Product\",\"calltype\":\"EXTERNALXMLAPIBYNAME\",\"status\":\"200\",\"error_code\":\"\",\"response_time\":\"0\"},\"data\":{\"metadata\":{\"name\":\"EMBBEDED_10_Product\",\"calltype\":\"EXTERNALXMLAPIBYNAME\",\"status\":\"200\",\"error_code\":\"\",\"response_time\":\"566\"},\"data\":{\"message\":null,\"data\":{\"Inputs\":{\"Promotion_Code\":null,\"Quote_Date\":null,\"Sum_Assured\":200},\"Outputs\":{\"Commission\":0,\"Commission_Rate\":0.3,\"Decline_Flag\":null,\"Decline_Reason\":null,\"Gross_Premium\":10.11,\"Net_Premium\":10.11,\"Tax\":0,\"Tax_Rate\":0},\"Errors\":[],\"Warnings\":[{\"Key\":\"Default Values\",\"Value\":[\"Input parameter(s) missing. API request using the Default Values.\"]}],\"FetchTimeUTC\":\"2022-03-01T00:34:34.4308968Z\",\"EngineID\":\"9479a708-ff71-45d0-9a21-5dab0258be7f\",\"ServiceName\":\"10_Travel Product Engine\",\"EngineType\":\"Type3\",\"Revision\":\"1.0.0\",\"Version\":\"2232627f-dbc1-43c2-9c8a-a0d5b069d451\",\"ReleaseDate\":\"2022-01-26 05:55:18\",\"Description\":null,\"EngineHash\":\"1E1C47AEE1D4A91AD1606DAD068712D5\",\"CalcTime\":0.0,\"TotalTime\":38,\"SolveInputs\":[],\"SolveOutputs\":[],\"ProductName\":\"Product Engine General Insurance\",\"EffectiveStartDate\":\"2010-01-01T00:00:00Z\",\"EffectiveEndDate\":\"2120-01-01T00:00:00Z\",\"CallGUID\":\"8b64f098-cb5f-4802-a6ab-e4ddf18a8a18\"},\"errorCode\":null,\"status\":\"Success\"}}}",
          "API_Res2": null,
          "API_Res3": null,
          "API_Res4": null,
          "API_Res5": null,
          "API_Res6": "{\"metadata\":{\"name\":\"EMBBEDED_06_Product\",\"calltype\":\"EXTERNALXMLAPIBYNAME\",\"status\":\"200\",\"error_code\":\"\",\"response_time\":\"403\"},\"data\":{\"message\":null,\"data\":{\"Inputs\":{\"Content_SI\":400,\"Floor_Size\":1999,\"Payment_Options\":null,\"Postal_Code\":18979,\"Promotion_Code\":null,\"Property_Type\":\"Flat\",\"Quote_Date\":\"2021-11-23 T03:00:00Z\",\"Year_Built\":1980,\"DateTime\":44621.02690193287},\"Outputs\":{\"Commission\":12.52,\"Commission_Rate\":0.2,\"Decline_Flag\":0,\"Decline_Reason\":null,\"Gross_Premium\":62.62,\"Net_Premium\":50.1,\"Tax\":3.76,\"Tax_Rate\":0.060044714148834,\"DateTime\":44621.02690193287},\"Errors\":[],\"Warnings\":[{\"Key\":\"Default Values\",\"Value\":[\"Input parameter(s) missing. API request using the Default Values.\"]}],\"FetchTimeUTC\":\"2022-03-01T00:38:44.7256002Z\",\"EngineID\":\"f2298058-60ee-44c7-ab68-6699527c9786\",\"ServiceName\":\"06_Home Content Product Engine Details\",\"EngineType\":\"Type3\",\"Revision\":\"1.6.0\",\"Version\":\"2112747e-b704-4f74-a2f6-360ef82a37dd\",\"ReleaseDate\":\"2022-02-17 02:25:40\",\"Description\":null,\"EngineHash\":\"A7B948C677A3B7C3F848043CA662C1B9\",\"CalcTime\":1.0,\"TotalTime\":40,\"SolveInputs\":[],\"SolveOutputs\":[],\"ProductName\":\"Product Engine General Insurance\",\"EffectiveStartDate\":\"2010-01-01T00:00:00Z\",\"EffectiveEndDate\":\"2120-01-01T00:00:00Z\",\"CallGUID\":\"4cfed0c5-c151-40d3-9859-b948d757c7ba\"},\"errorCode\":null,\"status\":\"Success\"}}",
          "API_Res7": "{\"metadata\":{\"name\":\"EMBBEDED_07_Product\",\"calltype\":\"EXTERNALXMLAPIBYNAME\",\"status\":\"200\",\"error_code\":\"\",\"response_time\":\"0\"},\"data\":{\"metadata\":{\"name\":\"EMBBEDED_07_Product\",\"calltype\":\"EXTERNALXMLAPIBYNAME\",\"status\":\"200\",\"error_code\":\"\",\"response_time\":\"518\"},\"data\":{\"message\":null,\"data\":{\"Inputs\":{\"Promotion_Code\":null,\"Quote_Date\":null,\"Sum_Assured\":100},\"Outputs\":{\"Commission\":0,\"Commission_Rate\":0.4,\"Decline_Flag\":null,\"Decline_Reason\":null,\"Gross_Premium\":16.55,\"Net_Premium\":16.55,\"Tax\":0,\"Tax_Rate\":0},\"Errors\":[],\"Warnings\":[{\"Key\":\"Default Values\",\"Value\":[\"Input parameter(s) missing. API request using the Default Values.\"]}],\"FetchTimeUTC\":\"2022-03-01T00:34:33.3378237Z\",\"EngineID\":\"4f01723c-7f63-4804-9a86-94f21e398e9a\",\"ServiceName\":\"07_Hospital Cash Product Engine\",\"EngineType\":\"Type3\",\"Revision\":\"1.0.0\",\"Version\":\"b96d92fd-c179-4ed4-bfff-20cf8e194b57\",\"ReleaseDate\":\"2022-01-26 05:47:05\",\"Description\":null,\"EngineHash\":\"9D41B7D38066D29C5B36DE6E010ECB6A\",\"CalcTime\":0.0,\"TotalTime\":36,\"SolveInputs\":[],\"SolveOutputs\":[],\"ProductName\":\"Product Engine Life and Health\",\"EffectiveStartDate\":\"2010-01-01T00:00:00Z\",\"EffectiveEndDate\":\"2120-01-01T00:00:00Z\",\"CallGUID\":\"139369a5-960b-460c-8bc6-1f65e739e61d\"},\"errorCode\":null,\"status\":\"Success\"}}}",
          "API_Res8": "{\"metadata\":{\"name\":\"EMBBEDED_08_Product\",\"calltype\":\"EXTERNALXMLAPIBYNAME\",\"status\":\"200\",\"error_code\":\"\",\"response_time\":\"0\"},\"data\":{\"metadata\":{\"name\":\"EMBBEDED_08_Product\",\"calltype\":\"EXTERNALXMLAPIBYNAME\",\"status\":\"200\",\"error_code\":\"\",\"response_time\":\"518\"},\"data\":{\"message\":null,\"data\":{\"Inputs\":{\"Promotion_Code\":null,\"Quote_Date\":null,\"Sum_Assured\":200},\"Outputs\":{\"Commission\":0,\"Commission_Rate\":0.3,\"Decline_Flag\":null,\"Decline_Reason\":null,\"Gross_Premium\":0.07,\"Net_Premium\":0.07,\"Tax\":0,\"Tax_Rate\":0},\"Errors\":[],\"Warnings\":[{\"Key\":\"Default Values\",\"Value\":[\"Input parameter(s) missing. API request using the Default Values.\"]}],\"FetchTimeUTC\":\"2022-03-01T00:34:33.8626535Z\",\"EngineID\":\"8ce8e4dc-6b85-46d7-98f3-1950da08141c\",\"ServiceName\":\"08_Item Product Engine\",\"EngineType\":\"Type3\",\"Revision\":\"1.0.0\",\"Version\":\"d6a0795d-75fd-45a8-9943-83b73a968f79\",\"ReleaseDate\":\"2022-01-26 05:55:06\",\"Description\":null,\"EngineHash\":\"FCDCEAA7E7903C94755673FA05A5AD0D\",\"CalcTime\":0.0,\"TotalTime\":21,\"SolveInputs\":[],\"SolveOutputs\":[],\"ProductName\":\"Product Engine General Insurance\",\"EffectiveStartDate\":\"2010-01-01T00:00:00Z\",\"EffectiveEndDate\":\"2120-01-01T00:00:00Z\",\"CallGUID\":\"b248d1a6-b42b-4907-b6ad-d65c5641a5ef\"},\"errorCode\":null,\"status\":\"Success\"}}}",
          "API_Res9": null,
          "API_UWQ": "{\"metadata\":{\"name\":\"EMBBEDED_UWQuestions\",\"calltype\":\"EXTERNALXMLAPIBYNAME\",\"status\":\"200\",\"error_code\":\"\",\"response_time\":\"731\"},\"data\":{\"message\":null,\"data\":{\"Inputs\":{\"Selected_Products\":[{\"ID\":1,\"Selected\":\"N\"},{\"ID\":2,\"Selected\":\"N\"},{\"ID\":3,\"Selected\":\"N\"},{\"ID\":4,\"Selected\":\"N\"},{\"ID\":5,\"Selected\":\"N\"},{\"ID\":6,\"Selected\":\"Y\"},{\"ID\":7,\"Selected\":\"Y\"},{\"ID\":8,\"Selected\":\"Y\"},{\"ID\":9,\"Selected\":\"N\"},{\"ID\":10,\"Selected\":\"Y\"}],\"UW_Response\":[{\"ID\":2,\"Response\":\"N\"},{\"ID\":3,\"Response\":\"N\"},{\"ID\":4,\"Response\":\"N\"}],\"DateTime\":44621.026914155096},\"Outputs\":{\"Question_Sets\":[{\"ID\":1,\"Value\":\"Has any of your life insurance application been declined before?\",\"Response\":\"Yes;No;\",\"Referral_Response\":\"Yes\",\"Display\":\"N\"},{\"ID\":2,\"Value\":\"Have you had a home insurance policy cancelled, declined, refused to renew or had special terms and conditions imposed upon a policy, or have made or reported a home insurance claim in the past 3 years ?\",\"Response\":\"Yes;No;\",\"Referral_Response\":\"Yes\",\"Display\":\"Y\"},{\"ID\":3,\"Value\":\"Have you ever had, or been told that you have, or are you currently under investigation for diabetes, cancer, heart attack, stroke, AIDS or HIV infection, carcinoma in situ, tumour, lump or polyp?\",\"Response\":\"Yes;No;\",\"Referral_Response\":\"Yes\",\"Display\":\"Y\"},{\"ID\":4,\"Value\":\"In the past 2  years, have you had any abnormal results in a pap smear, mammogram, breast ultrasound, prostate examinination or tumour market blood test?\",\"Response\":\"Yes;No;\",\"Referral_Response\":\"Yes\",\"Display\":\"Y\"},{\"ID\":5,\"Value\":\"In the last 12 months, has the proposed insured smoked any cigarette, cigars, electronic cigarettes, vaporizers or waterpipe tobacco?\",\"Response\":\"Yes;No;\",\"Referral_Response\":\"\",\"Display\":\"Y\"}],\"Referral_Flag\":\"Quote\",\"DateTime\":44621.026914155096},\"Errors\":[],\"FetchTimeUTC\":\"2022-03-01T00:38:46.1104987Z\",\"EngineID\":\"0e7ef5f8-af6f-465b-87b9-dd115fd83cbd\",\"ServiceName\":\"UW Questions\",\"EngineType\":\"Type3\",\"Revision\":\"1.15.0\",\"Version\":\"a6105790-ad39-4d97-9593-eee9b360b1a3\",\"ReleaseDate\":\"2022-02-23 13:11:40\",\"Description\":null,\"EngineHash\":\"6CCC083D2BA7398E655674B8814E5483\",\"CalcTime\":3.0,\"TotalTime\":35,\"SolveInputs\":[],\"SolveOutputs\":[],\"ProductName\":\"Flex\",\"EffectiveStartDate\":\"2010-01-01T00:00:00Z\",\"EffectiveEndDate\":\"2120-01-01T00:00:00Z\",\"CallGUID\":\"7c316d8b-d219-4430-b17d-0580fb3bde18\"},\"errorCode\":null,\"status\":\"Success\"}}",
          "Postcode_Out1": "ErrValue",
          "Postcode_Out2": "ErrValue",
          "Postcode_Out3": "ErrValue",
          "Postcode_Out4": "ErrValue",
          "Premium_Detail": [
            {
              "ID": 1,
              "Gross_Premium_before_Discount": "",
              "Gross_Premium_after_Discount": "",
              "Commission": "",
              "Tax": "",
              "Net_Premium": "",
              "Gross_Premium_inc_Tax": ""
            },
            {
              "ID": 2,
              "Gross_Premium_before_Discount": "",
              "Gross_Premium_after_Discount": "",
              "Commission": "",
              "Tax": "",
              "Net_Premium": "",
              "Gross_Premium_inc_Tax": ""
            },
            {
              "ID": 3,
              "Gross_Premium_before_Discount": "",
              "Gross_Premium_after_Discount": "",
              "Commission": "",
              "Tax": "",
              "Net_Premium": "",
              "Gross_Premium_inc_Tax": ""
            },
            {
              "ID": 4,
              "Gross_Premium_before_Discount": "",
              "Gross_Premium_after_Discount": "",
              "Commission": "",
              "Tax": "",
              "Net_Premium": "",
              "Gross_Premium_inc_Tax": ""
            },
            {
              "ID": 5,
              "Gross_Premium_before_Discount": "",
              "Gross_Premium_after_Discount": "",
              "Commission": "",
              "Tax": "",
              "Net_Premium": "",
              "Gross_Premium_inc_Tax": ""
            },
            {
              "ID": 6,
              "Gross_Premium_before_Discount": 62.62,
              "Gross_Premium_after_Discount": 52.6,
              "Commission": 10.52,
              "Tax": 3.16,
              "Net_Premium": 42.08,
              "Gross_Premium_inc_Tax": 55.76
            },
            {
              "ID": 7,
              "Gross_Premium_before_Discount": 16.55,
              "Gross_Premium_after_Discount": 13.9,
              "Commission": 5.56,
              "Tax": 0,
              "Net_Premium": 8.34,
              "Gross_Premium_inc_Tax": 13.9
            },
            {
              "ID": 8,
              "Gross_Premium_before_Discount": 0.07,
              "Gross_Premium_after_Discount": 0.06,
              "Commission": 0.02,
              "Tax": 0,
              "Net_Premium": 0.04,
              "Gross_Premium_inc_Tax": 0.06
            },
            {
              "ID": 9,
              "Gross_Premium_before_Discount": "",
              "Gross_Premium_after_Discount": "",
              "Commission": "",
              "Tax": "",
              "Net_Premium": "",
              "Gross_Premium_inc_Tax": ""
            },
            {
              "ID": 10,
              "Gross_Premium_before_Discount": 10.11,
              "Gross_Premium_after_Discount": 8.49,
              "Commission": 2.55,
              "Tax": 0,
              "Net_Premium": 5.94,
              "Gross_Premium_inc_Tax": 8.49
            }
          ],
          "Question_Sets": [
            {
              "ID": 1,
              "Value": "Has any of your life insurance application been declined before?",
              "Response": "Yes;No;",
              "Referral_Response": "Yes",
              "Display": "N"
            },
            {
              "ID": 2,
              "Value": "Have you had a home insurance policy cancelled, declined, refused to renew or had special terms and conditions imposed upon a policy, or have made or reported a home insurance claim in the past 3 years ?",
              "Response": "Yes;No;",
              "Referral_Response": "Yes",
              "Display": "Y"
            },
            {
              "ID": 3,
              "Value": "Have you ever had, or been told that you have, or are you currently under investigation for diabetes, cancer, heart attack, stroke, AIDS or HIV infection, carcinoma in situ, tumour, lump or polyp?",
              "Response": "Yes;No;",
              "Referral_Response": "Yes",
              "Display": "Y"
            },
            {
              "ID": 4,
              "Value": "In the past 2  years, have you had any abnormal results in a pap smear, mammogram, breast ultrasound, prostate examinination or tumour market blood test?",
              "Response": "Yes;No;",
              "Referral_Response": "Yes",
              "Display": "Y"
            },
            {
              "ID": 5,
              "Value": "In the last 12 months, has the proposed insured smoked any cigarette, cigars, electronic cigarettes, vaporizers or waterpipe tobacco?",
              "Response": "Yes;No;",
              "Referral_Response": "",
              "Display": "Y"
            }
          ],
          "Recommended_Products": [
            {
              "ID": 8,
              "Product": "Item",
              "Recommend Coverage": 200
            },
            {
              "ID": 7,
              "Product": "Hospital Cash",
              "Recommend Coverage": 100
            },
            {
              "ID": 6,
              "Product": "Home Contents",
              "Recommend Coverage": 400
            },
            {
              "ID": 10,
              "Product": "Travel",
              "Recommend Coverage": 200
            }
          ],
          "Referral_Flag": "Quote,DateTime:44621.026914155096",
          "UI_Options": [
            {
              "ID": 1,
              "Product": "Accidental PPD",
              "Eligibility": "Y",
              "Default": 40000,
              "Min": 0,
              "Max": 200000,
              "Step": 20000
            },
            {
              "ID": 2,
              "Product": "Critical Illness",
              "Eligibility": "Y",
              "Default": 20000,
              "Min": 0,
              "Max": 200000,
              "Step": 20000
            },
            {
              "ID": 3,
              "Product": "Crypto",
              "Eligibility": "Y",
              "Default": 2000,
              "Min": 0,
              "Max": 20000,
              "Step": 2000
            },
            {
              "ID": 4,
              "Product": "Cyber",
              "Eligibility": "Y",
              "Default": 1,
              "Min": 0,
              "Max": 1,
              "Step": 1
            },
            {
              "ID": 5,
              "Product": "Education",
              "Eligibility": "Y",
              "Default": 200,
              "Min": 0,
              "Max": 20000,
              "Step": 2000
            },
            {
              "ID": 6,
              "Product": "Home Contents",
              "Eligibility": "Y",
              "Default": 400,
              "Min": 0,
              "Max": 10000,
              "Step": 1000
            },
            {
              "ID": 7,
              "Product": "Hospital Cash",
              "Eligibility": "Y",
              "Default": 100,
              "Min": 0,
              "Max": 200,
              "Step": 20
            },
            {
              "ID": 8,
              "Product": "Item",
              "Eligibility": "Y",
              "Default": 200,
              "Min": 0,
              "Max": 10000,
              "Step": 1000
            },
            {
              "ID": 9,
              "Product": "Term Life",
              "Eligibility": "Y",
              "Default": 100000,
              "Min": 0,
              "Max": 200000,
              "Step": 20000
            },
            {
              "ID": 10,
              "Product": "Travel",
              "Eligibility": "Y",
              "Default": 200,
              "Min": 0,
              "Max": 2000,
              "Step": 200
            }
          ]
        },
        "warnings": [],
        "errors": [],
        "service_chain": []
      },
      "response_meta": {
        "service_id": null,
        "version_id": "0bdfbd7d-31b7-4821-8971-856110e180de",
        "version": "1.2.0",
        "process_time": 2747,
        "call_id": "261886fe-b2ff-4283-9d38-5ab2d20e2cce",
        "compiler_type": "Type3",
        "compiler_version": "1.0.0",
        "source_hash": null,
        "engine_id": "F5802C4B510681F7B6396B84B5B9E5F5",
        "correlation_id": "",
        "system": "SPARK",
        "request_timestamp": "2022-03-01, 00:38:43 GMT+00:00"
      }
    }

    vm.recommendedPlans = [
        {
            "premium": "",
            "cover": 200,
            "name": "Item",
            "Default": 200,
            "Min": 0,
            "Max": 10000,
            "Step": 1000,
            "ID": 8
        },
        {
            "premium": "",
            "cover": 100,
            "name": "Hospital Cash",
            "Default": 100,
            "Min": 0,
            "Max": 200,
            "Step": 20,
            "ID": 7
        },
        {
            "premium": 10.11,
            "cover": 200,
            "name": "Travel",
            "Default": 200,
            "Min": 0,
            "Max": 2000,
            "Step": 200,
            "ID": 10
        },
        {
            "premium": "",
            "cover": 400,
            "name": "Home Contents",
            "Default": 400,
            "Min": 0,
            "Max": 10000,
            "Step": 1000,
            "ID": 6
        }
    ]

    vm.PFToken = '955bf3c5-458d-44d6-b0e8-f356e408a2bc'

    vm.activeProduct = ''
    vm.productData = []

    vm.setActiveProduct = function (activeProduct) {
      vm.activeProduct = activeProduct;
    }
    vm.setProductData = function (productData) {
      vm.productData = productData;
    }

    vm.plansSamples = [
        {
            "premium": 3.44,
            "name": "Cyber",
            "Default": 1,
            "Min": 0,
            "Max": 1,
            "Step": 1,
            "ID": 4
        },
        {
            "premium": 98,
            "name": "Home Contents",
            "Default": 400,
            "Min": 0,
            "Max": 10000,
            "Step": 1000,
            "ID": 6
        },
        {
            "premium": 16.22,
            "name": "Hospital Cash",
            "Default": 100,
            "Min": 0,
            "Max": 200,
            "Step": 20,
            "ID": 7
        },
        {
            "premium": 0.07,
            "name": "Item",
            "Default": 200,
            "Min": 0,
            "Max": 10000,
            "Step": 1000,
            "ID": 8
        }
    ];
    vm.customCoverages = []

    vm.personas = [
     {
       "Persona_ID": 1,
       "Name": "Cassandra",
       "Prm_Age": 30,
       "Prm_Gender": "Female",
       "Prm_Income": 27000,
       "Prm_Postcode": 300821,
       "Prm_Occupation": "I.T.",
       "Prm_Industry": "Insurance",
       "Prm_Marital_Status": "Single",
       "Prm_Dependents": 0,
       "Prm_Education": "A Levels",
       "Prm_Residency": "Employment Pass",
       "Prm_CreditBalance": 8302,
       "Prm_CreditArrear": 0,
       "Prm_Loan": 0,
       "Prm_Health": 0,
       "Prm_Child": -470,
       "Prm_Insurance": "NA",
       "Prm_Travel": -345,
       "Prm_Luxury": "NA",
       "Prm_E-commerce": -200,
       "Prm_Active_Lifestyle": "NA",
       "Prm_Grocery": -535,
       "Prm_Home": "NA",
       "Prm_Currency": 0,
       "Prm_Automotive": -600,
       "Prm_Bar": 0,
       "Prm_Food": 0,
       "Prm_Gaming": 0,
       "Prm_Hair": 0,
       "Prm_Helper": 0,
       "Prm_Movies": 0,
       "Prm_Petrol": 0,
       "Prm_Rent": -3000,
       "Prm_Retail_shopping": -555,
       "Prm_Transport": 0,
       "Prm_Utility": 0,
       "Prm_AMZNPRIMESG": 0,
       "Prm_Mortgage": "NA",
       "Prm_CreditScore": "NA",
       "Prm_LateSleeper": "NA",
       "Prm_Location": "NA"
     },
     {
       "Persona_ID": 2,
       "Name": "Cristine",
       "Prm_Age": 23,
       "Prm_Gender": "Female",
       "Prm_Income": 10909,
       "Prm_Postcode": 768100,
       "Prm_Occupation": "Lawyer",
       "Prm_Industry": "Insurance",
       "Prm_Marital_Status": "Single",
       "Prm_Dependents": 0,
       "Prm_Education": "Bachelor Degree",
       "Prm_Residency": "Singaporean/ PR",
       "Prm_CreditBalance": 0,
       "Prm_CreditArrear": 0,
       "Prm_Loan": "NA",
       "Prm_Health": 0,
       "Prm_Child": 0,
       "Prm_Insurance": "NA",
       "Prm_Travel": -7447,
       "Prm_Luxury": "NA",
       "Prm_E-commerce": -319,
       "Prm_Active_Lifestyle": "NA",
       "Prm_Grocery": "NA",
       "Prm_Home": "NA",
       "Prm_Currency": 0,
       "Prm_Automotive": 0,
       "Prm_Bar": "NA",
       "Prm_Food": -52.8840975,
       "Prm_Gaming": "NA",
       "Prm_Hair": "NA",
       "Prm_Helper": "NA",
       "Prm_Movies": "NA",
       "Prm_Petrol": "NA",
       "Prm_Rent": -7000,
       "Prm_Retail_shopping": -271,
       "Prm_Transport": -42,
       "Prm_Utility": "NA",
       "Prm_AMZNPRIMESG": 0,
       "Prm_Mortgage": "NA",
       "Prm_CreditScore": "NA",
       "Prm_LateSleeper": "NA",
       "Prm_Location": "NA"
     },
     {
       "Persona_ID": 3,
       "Name": "Charlie",
       "Prm_Age": 30,
       "Prm_Gender": "Male",
       "Prm_Income": 20500,
       "Prm_Postcode": 428975,
       "Prm_Occupation": "Business owner",
       "Prm_Industry": "Education",
       "Prm_Marital_Status": "Married",
       "Prm_Dependents": 1,
       "Prm_Education": "Bachelor Degree",
       "Prm_Residency": "Singaporean/ PR",
       "Prm_CreditBalance": 5100,
       "Prm_CreditArrear": 0,
       "Prm_Loan": "NA",
       "Prm_Health": -120,
       "Prm_Child": -712,
       "Prm_Insurance": "NA",
       "Prm_Travel": 0,
       "Prm_Luxury": 0,
       "Prm_E-commerce": -20,
       "Prm_Active_Lifestyle": -255,
       "Prm_Grocery": "NA",
       "Prm_Home": "NA",
       "Prm_Currency": -19845,
       "Prm_Automotive": 0,
       "Prm_Bar": "NA",
       "Prm_Food": "NA",
       "Prm_Gaming": 0,
       "Prm_Hair": "NA",
       "Prm_Helper": "NA",
       "Prm_Movies": "NA",
       "Prm_Petrol": "NA",
       "Prm_Rent": -100,
       "Prm_Retail_shopping": 0,
       "Prm_Transport": -10,
       "Prm_Utility": "NA",
       "Prm_AMZNPRIMESG": -1,
       "Prm_Mortgage": 0,
       "Prm_CreditScore": "Grade A",
       "Prm_LateSleeper": "Y",
       "Prm_Location": "Local"
     },
     {
       "Persona_ID": 4,
       "Name": "Avril",
       "Prm_Age": 30,
       "Prm_Gender": "Male",
       "Prm_Income": 20500,
       "Prm_Postcode": 428975,
       "Prm_Occupation": "Business owner",
       "Prm_Industry": "Education",
       "Prm_Marital_Status": "Married",
       "Prm_Dependents": 1,
       "Prm_Education": "Bachelor Degree",
       "Prm_Residency": "Singaporean/ PR",
       "Prm_CreditBalance": 5100,
       "Prm_CreditArrear": 0,
       "Prm_Loan": "NA",
       "Prm_Health": -120,
       "Prm_Child": -8712,
       "Prm_Insurance": "NA",
       "Prm_Travel": 0,
       "Prm_Luxury": -55,
       "Prm_E-commerce": -20,
       "Prm_Active_Lifestyle": -255,
       "Prm_Grocery": "NA",
       "Prm_Home": "NA",
       "Prm_Currency": -845,
       "Prm_Automotive": 0,
       "Prm_Bar": "NA",
       "Prm_Food": "NA",
       "Prm_Gaming": -630,
       "Prm_Hair": "NA",
       "Prm_Helper": "NA",
       "Prm_Movies": "NA",
       "Prm_Petrol": "NA",
       "Prm_Rent": -100,
       "Prm_Retail_shopping": -74,
       "Prm_Transport": -10,
       "Prm_Utility": "NA",
       "Prm_AMZNPRIMESG": -1,
       "Prm_Mortgage": 0,
       "Prm_CreditScore": "Grade A",
       "Prm_LateSleeper": "Y",
       "Prm_Location": "Local"
     },
     {
       "Persona_ID": 5,
       "Name": "Adam",
       "Prm_Age": 30,
       "Prm_Gender": "Male",
       "Prm_Income": 20500,
       "Prm_Postcode": 428975,
       "Prm_Occupation": "Business owner",
       "Prm_Industry": "Education",
       "Prm_Marital_Status": "Married",
       "Prm_Dependents": 1,
       "Prm_Education": "Bachelor Degree",
       "Prm_Residency": "Singaporean/ PR",
       "Prm_CreditBalance": 5100,
       "Prm_CreditArrear": 0,
       "Prm_Loan": "NA",
       "Prm_Health": -120,
       "Prm_Child": -8712,
       "Prm_Insurance": "NA",
       "Prm_Travel": 0,
       "Prm_Luxury": -55,
       "Prm_E-commerce": -20,
       "Prm_Active_Lifestyle": -255,
       "Prm_Grocery": "NA",
       "Prm_Home": "NA",
       "Prm_Currency": -845,
       "Prm_Automotive": 0,
       "Prm_Bar": "NA",
       "Prm_Food": "NA",
       "Prm_Gaming": -630,
       "Prm_Hair": "NA",
       "Prm_Helper": "NA",
       "Prm_Movies": "NA",
       "Prm_Petrol": "NA",
       "Prm_Rent": -100,
       "Prm_Retail_shopping": -74,
       "Prm_Transport": -10,
       "Prm_Utility": "NA",
       "Prm_AMZNPRIMESG": -1,
       "Prm_Mortgage": 0,
       "Prm_CreditScore": "Grade A",
       "Prm_LateSleeper": "Y",
       "Prm_Location": "Local"
     }
    ]

  }
})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .factory('EmbeddedFactory', fctry);

  /** @ngInject */
  function fctry($http,
                 $q,
                 $timeout) {
    var vm = this;

    return vm;
  }
})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')

    .constant('ACCIDENT_TYPE', 'PA')
    .constant('ACCIDENT_PLANS_PAYLOAD', {"Description":"","EndPoint":"https://excel.sonic.dev.coherent.com.hk/api/v1/product/coherent/engines/Execute/PA","EngineType":"Type1","Inputs":{"Channel":"Agent_2","ClaimAmount":[{"Amount":7878,"Benefit":"A2","Claimant":null,"EventDate":null,"EventStart":null},{"Amount":null,"Benefit":null,"Claimant":null,"EventDate":null,"EventStart":null},{"Amount":null,"Benefit":null,"Claimant":null,"EventDate":null,"EventStart":null},{"Amount":null,"Benefit":null,"Claimant":null,"EventDate":null,"EventStart":null},{"Amount":null,"Benefit":null,"Claimant":null,"EventDate":null,"EventStart":null},{"Amount":null,"Benefit":null,"Claimant":null,"EventDate":null,"EventStart":null},{"Amount":null,"Benefit":null,"Claimant":null,"EventDate":null,"EventStart":null},{"Amount":null,"Benefit":null,"Claimant":null,"EventDate":null,"EventStart":null},{"Amount":null,"Benefit":null,"Claimant":null,"EventDate":null,"EventStart":null},{"Amount":null,"Benefit":null,"Claimant":null,"EventDate":null,"EventStart":null},{"Amount":null,"Benefit":null,"Claimant":null,"EventDate":null,"EventStart":null},{"Amount":null,"Benefit":null,"Claimant":null,"EventDate":null,"EventStart":null},{"Amount":null,"Benefit":null,"Claimant":null,"EventDate":null,"EventStart":null},{"Amount":null,"Benefit":null,"Claimant":null,"EventDate":null,"EventStart":null},{"Amount":null,"Benefit":null,"Claimant":null,"EventDate":null,"EventStart":null},{"Amount":null,"Benefit":null,"Claimant":null,"EventDate":null,"EventStart":null},{"Amount":null,"Benefit":null,"Claimant":null,"EventDate":null,"EventStart":null},{"Amount":null,"Benefit":null,"Claimant":null,"EventDate":null,"EventStart":null},{"Amount":null,"Benefit":null,"Claimant":null,"EventDate":null,"EventStart":null},{"Amount":null,"Benefit":null,"Claimant":null,"EventDate":null,"EventStart":null}],"ClaimHistory":[{"Amount":null,"BenefitClaimed":null,"ClaimDate":null,"Claimant":null},{"Amount":null,"BenefitClaimed":null,"ClaimDate":null,"Claimant":null},{"Amount":null,"BenefitClaimed":null,"ClaimDate":null,"Claimant":null},{"Amount":null,"BenefitClaimed":null,"ClaimDate":null,"Claimant":null},{"Amount":null,"BenefitClaimed":null,"ClaimDate":null,"Claimant":null},{"Amount":null,"BenefitClaimed":null,"ClaimDate":null,"Claimant":null},{"Amount":null,"BenefitClaimed":null,"ClaimDate":null,"Claimant":null},{"Amount":null,"BenefitClaimed":null,"ClaimDate":null,"Claimant":null},{"Amount":null,"BenefitClaimed":null,"ClaimDate":null,"Claimant":null},{"Amount":null,"BenefitClaimed":null,"ClaimDate":null,"Claimant":null},{"Amount":null,"BenefitClaimed":null,"ClaimDate":null,"Claimant":null},{"Amount":null,"BenefitClaimed":null,"ClaimDate":null,"Claimant":null},{"Amount":null,"BenefitClaimed":null,"ClaimDate":null,"Claimant":null},{"Amount":null,"BenefitClaimed":null,"ClaimDate":null,"Claimant":null},{"Amount":null,"BenefitClaimed":null,"ClaimDate":null,"Claimant":null},{"Amount":null,"BenefitClaimed":null,"ClaimDate":null,"Claimant":null},{"Amount":null,"BenefitClaimed":null,"ClaimDate":null,"Claimant":null},{"Amount":null,"BenefitClaimed":null,"ClaimDate":null,"Claimant":null},{"Amount":null,"BenefitClaimed":null,"ClaimDate":null,"Claimant":null},{"Amount":null,"BenefitClaimed":null,"ClaimDate":null,"Claimant":null},{"Amount":null,"BenefitClaimed":null,"ClaimDate":null,"Claimant":null},{"Amount":null,"BenefitClaimed":null,"ClaimDate":null,"Claimant":null},{"Amount":null,"BenefitClaimed":null,"ClaimDate":null,"Claimant":null},{"Amount":null,"BenefitClaimed":null,"ClaimDate":null,"Claimant":null},{"Amount":null,"BenefitClaimed":null,"ClaimDate":null,"Claimant":null},{"Amount":null,"BenefitClaimed":null,"ClaimDate":null,"Claimant":null},{"Amount":null,"BenefitClaimed":null,"ClaimDate":null,"Claimant":null},{"Amount":null,"BenefitClaimed":null,"ClaimDate":null,"Claimant":null},{"Amount":null,"BenefitClaimed":null,"ClaimDate":null,"Claimant":null},{"Amount":null,"BenefitClaimed":null,"ClaimDate":null,"Claimant":null},{"Amount":null,"BenefitClaimed":null,"ClaimDate":null,"Claimant":null},{"Amount":null,"BenefitClaimed":null,"ClaimDate":null,"Claimant":null},{"Amount":null,"BenefitClaimed":null,"ClaimDate":null,"Claimant":null},{"Amount":null,"BenefitClaimed":null,"ClaimDate":null,"Claimant":null},{"Amount":null,"BenefitClaimed":null,"ClaimDate":null,"Claimant":null},{"Amount":null,"BenefitClaimed":null,"ClaimDate":null,"Claimant":null},{"Amount":null,"BenefitClaimed":null,"ClaimDate":null,"Claimant":null}],"ClaimToDate":[{"Benefit":null,"ClaimToDate":null,"Count":null,"PolicyToDate":null},{"Benefit":null,"ClaimToDate":null,"Count":null,"PolicyToDate":null},{"Benefit":null,"ClaimToDate":null,"Count":null,"PolicyToDate":null},{"Benefit":null,"ClaimToDate":null,"Count":null,"PolicyToDate":null},{"Benefit":null,"ClaimToDate":null,"Count":null,"PolicyToDate":null},{"Benefit":null,"ClaimToDate":null,"Count":null,"PolicyToDate":null},{"Benefit":null,"ClaimToDate":null,"Count":null,"PolicyToDate":null},{"Benefit":null,"ClaimToDate":null,"Count":null,"PolicyToDate":null},{"Benefit":null,"ClaimToDate":null,"Count":null,"PolicyToDate":null},{"Benefit":null,"ClaimToDate":null,"Count":null,"PolicyToDate":null},{"Benefit":null,"ClaimToDate":null,"Count":null,"PolicyToDate":null},{"Benefit":null,"ClaimToDate":null,"Count":null,"PolicyToDate":null},{"Benefit":null,"ClaimToDate":null,"Count":null,"PolicyToDate":null},{"Benefit":null,"ClaimToDate":null,"Count":null,"PolicyToDate":null},{"Benefit":null,"ClaimToDate":null,"Count":null,"PolicyToDate":null},{"Benefit":null,"ClaimToDate":null,"Count":null,"PolicyToDate":null},{"Benefit":null,"ClaimToDate":null,"Count":null,"PolicyToDate":null},{"Benefit":null,"ClaimToDate":null,"Count":null,"PolicyToDate":null},{"Benefit":null,"ClaimToDate":null,"Count":null,"PolicyToDate":null},{"Benefit":null,"ClaimToDate":null,"Count":null,"PolicyToDate":null},{"Benefit":null,"ClaimToDate":null,"Count":null,"PolicyToDate":null},{"Benefit":null,"ClaimToDate":null,"Count":null,"PolicyToDate":null},{"Benefit":null,"ClaimToDate":null,"Count":null,"PolicyToDate":null},{"Benefit":null,"ClaimToDate":null,"Count":null,"PolicyToDate":null},{"Benefit":null,"ClaimToDate":null,"Count":null,"PolicyToDate":null},{"Benefit":null,"ClaimToDate":null,"Count":null,"PolicyToDate":null},{"Benefit":null,"ClaimToDate":null,"Count":null,"PolicyToDate":null},{"Benefit":null,"ClaimToDate":null,"Count":null,"PolicyToDate":null},{"Benefit":null,"ClaimToDate":null,"Count":null,"PolicyToDate":null},{"Benefit":null,"ClaimToDate":null,"Count":null,"PolicyToDate":null},{"Benefit":null,"ClaimToDate":null,"Count":null,"PolicyToDate":null},{"Benefit":null,"ClaimToDate":null,"Count":null,"PolicyToDate":null},{"Benefit":null,"ClaimToDate":null,"Count":null,"PolicyToDate":null},{"Benefit":null,"ClaimToDate":null,"Count":null,"PolicyToDate":null},{"Benefit":null,"ClaimToDate":null,"Count":null,"PolicyToDate":null},{"Benefit":null,"ClaimToDate":null,"Count":null,"PolicyToDate":null},{"Benefit":null,"ClaimToDate":null,"Count":null,"PolicyToDate":null}],"Cover_Start_Date":"2028-07-09","Coverage":"Insured_1","DOB":"1980-01-01","Gender":"F","Optional_Benefits":[{"Included":"Y","Option":"Insured_1"}],"Plan":"Plan_1","Policy_Cover_QuoteDate":"2021-07-01","PostalCode":"064-0806","Promotion_Discount_Code":null,"Ratings":[{"RatingFactor":"RakutenPoints","Value":20},{"RatingFactor":null,"Value":null},{"RatingFactor":null,"Value":null},{"RatingFactor":null,"Value":null},{"RatingFactor":null,"Value":null},{"RatingFactor":null,"Value":null},{"RatingFactor":null,"Value":null},{"RatingFactor":null,"Value":null},{"RatingFactor":null,"Value":null},{"RatingFactor":null,"Value":null},{"RatingFactor":null,"Value":null},{"RatingFactor":null,"Value":null},{"RatingFactor":null,"Value":null},{"RatingFactor":null,"Value":null},{"RatingFactor":null,"Value":null}],"Term":1,"Underwriting_Response":[{"UWSurveyCode":"PA_UW_1","UWSurveyResponse":"Y"},{"UWSurveyCode":"PA_UW_2","UWSurveyResponse":"Y"},{"UWSurveyCode":"PA_UW_3","UWSurveyResponse":null},{"UWSurveyCode":"PA_UW_4","UWSurveyResponse":null},{"UWSurveyCode":"PA_UW_5","UWSurveyResponse":null},{"UWSurveyCode":"PA_UW_6","UWSurveyResponse":null},{"UWSurveyCode":"PA_UW_7","UWSurveyResponse":null},{"UWSurveyCode":"PA_UW_8","UWSurveyResponse":null},{"UWSurveyCode":"PA_UW_9","UWSurveyResponse":null},{"UWSurveyCode":"PA_UW_10","UWSurveyResponse":null},{"UWSurveyCode":"PA_UW_11","UWSurveyResponse":null},{"UWSurveyCode":"PA_UW_12","UWSurveyResponse":null},{"UWSurveyCode":"PA_UW_13","UWSurveyResponse":null},{"UWSurveyCode":"PA_UW_14","UWSurveyResponse":null},{"UWSurveyCode":"PA_UW_15","UWSurveyResponse":null},{"UWSurveyCode":"PA_UW_16","UWSurveyResponse":null},{"UWSurveyCode":"PA_UW_17","UWSurveyResponse":null},{"UWSurveyCode":"PA_UW_18","UWSurveyResponse":null},{"UWSurveyCode":"PA_UW_19","UWSurveyResponse":null},{"UWSurveyCode":"PA_UW_20","UWSurveyResponse":null}]},"IsRichJson":false,"RequestedOutPut":"","RequestedServiceCategory":"","ServiceCategories":["Claim","Options","Refund"],"ServiceName":"Bicycle_Product_v1.3","ShouldExecuteInputs":false,"Solves":[],"TransactionDate":"2021-07-24T09:47:26.499Z"});

})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .controller('EmbeddedFlexInvestController', EmbeddedFlexInvestController);

  /** @ngInject */
  function EmbeddedFlexInvestController($state, EmbeddedService, $http, configUrls, environment) {
    var vm = this;
    vm.data = {};
    vm.allPlans = [];
    vm.recommendedPlans = [];
    vm.planObject = {
      premium: 0,
      name: ''
    };
    vm.discount = 1;
    vm.personas = EmbeddedService.personas
    vm.activePersona = ""

    vm.equity = 0
    vm.fixedIncome = 0
    vm.recommendedEquity = []

    vm.checkbox = {};
    vm.slider = {};

    vm.setPersona = function (index) {
      EmbeddedService.PFInput.request_data.inputs["Prm_Age"] = EmbeddedService.personas[index-1]["Prm_Age"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Gender"] = EmbeddedService.personas[index-1]["Prm_Gender"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Income"] = EmbeddedService.personas[index-1]["Prm_Income"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Postcode"] = EmbeddedService.personas[index-1]["Prm_Postcode"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Occupation"] = EmbeddedService.personas[index-1]["Prm_Occupation"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Industry"] = EmbeddedService.personas[index-1]["Prm_Industry"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Marital_Status"] = EmbeddedService.personas[index-1]["Prm_Marital_Status"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Dependents"] = EmbeddedService.personas[index-1]["Prm_Dependents"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Education"] = EmbeddedService.personas[index-1]["Prm_Education"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Residency"] = EmbeddedService.personas[index-1]["Prm_Residency"]
      EmbeddedService.PFInput.request_data.inputs["Prm_CreditBalance"] = EmbeddedService.personas[index-1]["Prm_CreditBalance"]
      EmbeddedService.PFInput.request_data.inputs["Prm_CreditArrear"] = EmbeddedService.personas[index-1]["Prm_CreditArrear"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Loan"] = EmbeddedService.personas[index-1]["Prm_Loan"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Health"] = EmbeddedService.personas[index-1]["Prm_Health"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Child"] = EmbeddedService.personas[index-1]["Prm_Child"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Insurance"] = EmbeddedService.personas[index-1]["Prm_Insurance"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Travel"] = EmbeddedService.personas[index-1]["Prm_Travel"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Luxury"] = EmbeddedService.personas[index-1]["Prm_Luxury"]
      EmbeddedService.PFInput.request_data.inputs["Prm_E-commerce"] = EmbeddedService.personas[index-1]["Prm_E-commerce"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Active_Lifestyle"] = EmbeddedService.personas[index-1]["Prm_Active_Lifestyle"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Grocery"] = EmbeddedService.personas[index-1]["Prm_Grocery"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Home"] = EmbeddedService.personas[index-1]["Prm_Home"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Currency"] = EmbeddedService.personas[index-1]["Prm_Currency"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Automotive"] = EmbeddedService.personas[index-1]["Prm_Automotive"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Bar"] = EmbeddedService.personas[index-1]["Prm_Bar"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Food"] = EmbeddedService.personas[index-1]["Prm_Food"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Gaming"] = EmbeddedService.personas[index-1]["Prm_Gaming"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Hair"] = EmbeddedService.personas[index-1]["Prm_Hair"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Helper"] = EmbeddedService.personas[index-1]["Prm_Helper"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Movies"] = EmbeddedService.personas[index-1]["Prm_Movies"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Petrol"] = EmbeddedService.personas[index-1]["Prm_Petrol"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Rent"] = EmbeddedService.personas[index-1]["Prm_Rent"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Retail_shopping"] = EmbeddedService.personas[index-1]["Prm_Retail_shopping"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Transport"] = EmbeddedService.personas[index-1]["Prm_Transport"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Utility"] = EmbeddedService.personas[index-1]["Prm_Utility"]
      EmbeddedService.PFInput.request_data.inputs["Prm_AMZNPRIMESG"] = EmbeddedService.personas[index-1]["Prm_AMZNPRIMESG"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Mortgage"] = EmbeddedService.personas[index-1]["Prm_Mortgage"]
      EmbeddedService.PFInput.request_data.inputs["Prm_CreditScore"] = EmbeddedService.personas[index-1]["Prm_CreditScore"]
      EmbeddedService.PFInput.request_data.inputs["Prm_LateSleeper"] = EmbeddedService.personas[index-1]["Prm_LateSleeper"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Location"] = EmbeddedService.personas[index-1]["Prm_Location"]
      vm.balance = Math.round(EmbeddedService.personas[index-1]["Prm_Income"] * 0.112)
      vm.txn1 = EmbeddedService.PFInput.request_data.inputs["Prm_Health"]
      vm.txn2 = EmbeddedService.PFInput.request_data.inputs["Prm_Child"]
      vm.txn3 = EmbeddedService.PFInput.request_data.inputs["Prm_Retail_shopping"]
      vm.txn4 = EmbeddedService.PFInput.request_data.inputs["Prm_Automotive"]
      vm.txn5 = EmbeddedService.PFInput.request_data.inputs["Prm_Rent"]
      vm.txn6 = EmbeddedService.PFInput.request_data.inputs["Prm_Travel"]
      vm.txn7 = EmbeddedService.PFInput.request_data.inputs["Prm_Currency"]
      vm.psn1 = EmbeddedService.PFInput.request_data.inputs["Prm_Age"]
      vm.psn2 = EmbeddedService.PFInput.request_data.inputs["Prm_Gender"]
      vm.psn3 = EmbeddedService.PFInput.request_data.inputs["Prm_Marital_Status"]
      vm.psn4 = EmbeddedService.PFInput.request_data.inputs["Prm_Income"]

      vm.activePersona = EmbeddedService.personas[index-1].Name
      var settings = {
        method: 'GET',
        url: configUrls[environment].keyCloakTokenUrl + '?apiKey=' + configUrls[environment].keyCloakApiKey + '&client=' + configUrls[environment].keyCloakPFClient,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      };

      $http(settings).then(function (response) {
        // console.log(response);
        return response
      }).then(function (tokenRes) {
        getPlan(tokenRes);
        getInvest(EmbeddedService.personas[index-1]["Name"], tokenRes);
      });      
    }

    function getPlan(tokenRes) {
      vm.recommendedPlans = []
      EmbeddedService.recommendedPlans =[]
      console.log(EmbeddedService.PFInput)
      var req = {
        method: 'POST',
        // url: 'https://excel.staging.coherent.global/coherentflex/api/v3/folders/Flex/services/Controller File/Execute/',
        url: configUrls[environment].PFUrl1 + 'Flex/engines/Execute/Controller%20File',
        headers: {
          authorization: 'Bearer ' + tokenRes.data.access_token
        },
        data: EmbeddedService.PFInput
      };
      $http(req).then(function (response) {
        vm.data = response.data.response_data.outputs;
        var rc = vm.data.Recommended_Products;
        EmbeddedService.PFOutput = response.data.response_data.outputs;
        console.log(vm.data.UI_Options[0].Product);

        var _loop = function _loop(i) {
          a = {};
          a.premium = vm.data.Premium_Detail.find(function (x) {
            return x.ID === rc[i].ID;
          }).Gross_Premium_before_Discount;
          a.cover = vm.data.Recommended_Products.find(function (x) {
            return x.ID === rc[i].ID;
          })["Recommend Coverage"];
          a.name = vm.data.UI_Options.find(function (x) {
            return x.ID === rc[i].ID;
          }).Product;
          a.Default = vm.data.UI_Options.find(function (x) {
            return x.ID === rc[i].ID;
          }).Default;
          a.Min = vm.data.UI_Options.find(function (x) {
            return x.ID === rc[i].ID;
          }).Min;
          a.Max = vm.data.UI_Options.find(function (x) {
            return x.ID === rc[i].ID;
          }).Max;
          a.Step = vm.data.UI_Options.find(function (x) {
            return x.ID === rc[i].ID;
          }).Step;
          a.ID = vm.data.UI_Options.find(function (x) {
            return x.ID === rc[i].ID;
          }).ID;
          vm.recommendedPlans.push(a);
          vm.discount = Math.round(EmbeddedService.PFOutput["02a_Discount_Multi_Pct"] * 100);
          console.log(vm.recommendedPlans);
          EmbeddedService.recommendedPlans = vm.recommendedPlans;
        }

        for (var i = 0; i < rc.length; i++) {
          var a;

          _loop(i);
        }
        vm.recommendedPlans = EmbeddedService.recommendedPlans;
        vm.totalPrice = EmbeddedService.PFOutput["02g_Gross_Prem_after_discount"];
        vm.PFInput = EmbeddedService.PFInput
        vm.oldprice = EmbeddedService.PFOutput["01_Gross_Prem_before_discount"];
        vm.discount = Math.round(EmbeddedService.PFOutput["02a_Discount_Multi_Pct"] * 100);
        for (var i = 0; i < vm.recommendedPlans.length; i++) {
          var aid = vm.recommendedPlans[i].ID;
          vm.checkbox[aid] = true;
          vm.slider[aid] = {}
          vm.slider[aid].cover = vm.recommendedPlans[i].cover;
          vm.slider[aid].convertedcover = vm.recommendedPlans[i].cover;
          vm.slider[aid].convertedmin = vm.recommendedPlans[i].Min;
          vm.slider[aid].convertedmax = vm.recommendedPlans[i].Max;
          vm.slider[aid].convertedstep = vm.recommendedPlans[i].Step;
        }
      }, function () {});
    }

    function getInvest(name, tokenRes) {
      EmbeddedService.investInput.request_data.inputs.Prm_ProfileName = name
      var req = {
        method: 'POST',
        // url: 'https://excel.staging.coherent.global/coherentflex/api/v3/folders/Asset Allocation Demo/services/Controller File/Execute',
        url: configUrls[environment].PFUrl1 + 'Flex/engines/Execute/Controller%20File',
        headers: {
          authorization: 'Bearer ' + tokenRes.data.access_token
        },
        data: EmbeddedService.investInput
      };
      $http(req).then(function (response) {
        vm.data = response.data.data.Outputs;
        var rc = vm.data.Recommended_Products;
        EmbeddedService.InvestOutput = response.data.data.Outputs;
        vm.equity = vm.data.Recommended_Asset[0]["Recommend Coverage"] * 100
        vm.fixedIncome = vm.data.Recommended_Asset[1]["Recommend Coverage"] * 100
        vm.recommendedEquity = vm.data.Recommended_Products
        console.log(vm.data);
      }, function () {});
    }

    vm.customize = function () {
      var ee = document.getElementById("totprice-animate")
      ee.classList.remove("text-is-updated")
      var ff = document.getElementById("discount-animate")
      ff.classList.remove("text-is-updated")
      vm.PFInput.request_data.inputs.Selection = "Customise";
      EmbeddedService.customCoverages = [];

      for (var i = 0; i < vm.recommendedPlans.length; i++) {
        var a = {};
        a.ID = vm.recommendedPlans[i].ID;

        if (vm.checkbox[vm.recommendedPlans[i].ID] == false) {
          a.value = null;
        } else {
          a.value = parseInt(vm.slider[vm.recommendedPlans[i].ID].convertedcover) ;
        }

        EmbeddedService.customCoverages.push(a);
        vm.PFInput.request_data.inputs["Limit" + vm.recommendedPlans[i].ID] = EmbeddedService.customCoverages.find(function (x) {
          return x.ID === vm.recommendedPlans[i].ID;
        }).value;
      }

      console.log(EmbeddedService.customCoverages);
      console.log(vm.PFInput);
      var req = {
        method: 'POST',
        // url: 'https://excel.staging.coherent.global/coherentflex/api/v3/folders/Flex/services/Controller File/Execute',
        url: configUrls[environment].PFUrl1 + 'Flex/engines/Execute/Controller%20File/Execute/',
        headers: {
          'SecretKey': EmbeddedService.PFToken,
          'x-tenant-name': 'coherentflex'
        },
        data: vm.PFInput
      };
      $http(req).then(function (response) {
        vm.data = response.data.data.Outputs;
        console.log(vm.data);
        if (vm.totalPrice != vm.data["02g_Gross_Prem_after_discount"]) {
          ee = document.getElementById("totprice-animate")
          ee.classList.add("text-is-updated")
        }
        // if (vm.discount != vm.data["02a_Discount_Multi_Pct"]) {
        //   var ff = document.getElementById("discount-animate")
        //   ff.classList.add("text-is-updated")
        // }
        vm.totalPrice = vm.data["02g_Gross_Prem_after_discount"];
        vm.oldprice = vm.data["01_Gross_Prem_before_discount"];
        vm.discount = vm.data["02a_Discount_Multi_Pct"] * 100;
        var rc = vm.recommendedPlans;
        EmbeddedService.PFOutput = response.data.data.Outputs;

        for (var i = 0; i < rc.length; i++) {
          if (vm.checkbox[vm.recommendedPlans[i].ID] == true) {
            vm.slider[vm.recommendedPlans[i].ID].cover = EmbeddedService.customCoverages.find(function (x) {
              return x.ID === rc[i].ID;
            }).value;
            vm.slider[vm.recommendedPlans[i].ID].convertedcover = EmbeddedService.customCoverages.find(function (x) {
              return x.ID === rc[i].ID;
            }).value;
            vm.recommendedPlans[i].premium = vm.data.Premium_Detail.find(function (x) {
              return x.ID === rc[i].ID;
            }).Gross_Premium_before_Discount;
          }
        }
      }, function () {});
    }

    function numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    vm.setPersona(1);

    return vm;


  }
})();

(function () {
  'use strict';

  angular.module('coherentPaDemo').controller('EmbeddedFlex3Controller', EmbeddedFlex3Controller);
  /** @ngInject */

  function EmbeddedFlex3Controller($state, EmbeddedService, $http) {
    var vm = this;
    
    vm.totalPrice = EmbeddedService.PFOutput["02g_Gross_Prem_after_discount"];
    vm.oldprice = EmbeddedService.PFOutput["01_Gross_Prem_before_discount"];
    vm.discount = Math.round(EmbeddedService.PFOutput["02a_Discount_Multi_Pct"] * 100);
    vm.UWquestions = EmbeddedService.PFOutput.Question_Sets
    console.log(EmbeddedService.PFOutput)
    console.log(EmbeddedService.PFOutput.Question_Sets)

  }
})();
(function () {
  'use strict';

  angular.module('coherentPaDemo').controller('EmbeddedFlex2Controller', EmbeddedFlex2Controller);
  /** @ngInject */

  function EmbeddedFlex2Controller($state, EmbeddedService, $http, configUrls, environment) {
    var vm = this;
    vm.checkbox = {};
    vm.slider = {};
    vm.recommendedPlans = EmbeddedService.recommendedPlans;
    vm.totalPrice = EmbeddedService.PFOutput["02g_Gross_Prem_after_discount"];
    vm.PFInput = EmbeddedService.PFInput;
    vm.PFInput.request_meta = {
        "version_id": "75997ebc-cbde-45d2-ad47-002d5c71458b",
        "transaction_date": "2022-03-21T14:50:46.542Z",
        "call_purpose": "Spark - API Tester",
        "source_system": "SPARK",
        "correlation_id": "",
        "requested_output": "",
        "service_category": "",
        "compiler_type": "Type3"
    };
    
    vm.oldprice = EmbeddedService.PFOutput["01_Gross_Prem_before_discount"];
    vm.discount = Math.round(EmbeddedService.PFOutput["02a_Discount_Multi_Pct"] * 100);
    for (var i = 0; i < vm.recommendedPlans.length; i++) {
      var aid = vm.recommendedPlans[i].ID;
      vm.checkbox[aid] = true;
      vm.slider[aid] = {}
      vm.slider[aid].cover = vm.recommendedPlans[i].cover;
      vm.slider[aid].convertedcover = vm.recommendedPlans[i].cover;
      vm.slider[aid].convertedmin = vm.recommendedPlans[i].Min;
      vm.slider[aid].convertedmax = vm.recommendedPlans[i].Max;
      vm.slider[aid].convertedstep = vm.recommendedPlans[i].Step;
    }

    vm.customize = function () {
      var ee = document.getElementById("totprice-animate")
      ee.classList.remove("text-is-updated")
      var ff = document.getElementById("discount-animate")
      ff.classList.remove("text-is-updated")
      vm.PFInput.request_data.inputs.Selection = "Customise";
      EmbeddedService.customCoverages = [];

      for (var i = 0; i < vm.recommendedPlans.length; i++) {
        var a = {};
        a.ID = vm.recommendedPlans[i].ID;

        if (vm.checkbox[vm.recommendedPlans[i].ID] == false) {
          a.value = null;
        } else {
          a.value = parseInt(vm.slider[vm.recommendedPlans[i].ID].convertedcover) ;
        }

        EmbeddedService.customCoverages.push(a);
        vm.PFInput.request_data.inputs["Limit" + vm.recommendedPlans[i].ID] = EmbeddedService.customCoverages.find(function (x) {
          return x.ID === vm.recommendedPlans[i].ID;
        }).value;
      }

      console.log(EmbeddedService.customCoverages);
      console.log(vm.PFInput);
      var req = {
        method: 'POST',
        url: 'https://excel.sit.coherent.global/coherent/api/v3/folders/Flex/services/Controller%20File/Execute',
        // url: configUrls[environment].PFUrl1 + 'Flex/engines/Execute/Controller%20File/Execute/',
        headers: {
          'SecretKey': '737e0b6e-1539-4d8d-acf2-8e0f9d5b83a5',
          'x-tenant-name': 'coherent'
        },
        data: vm.PFInput
      };
      $http(req).then(function (response) {
        vm.data = response.data.response_data.outputs;
        console.log(vm.data);
        if (vm.totalPrice != vm.data["02g_Gross_Prem_after_discount"]) {
          ee = document.getElementById("totprice-animate")
          ee.classList.add("text-is-updated")
        }
        // if (vm.discount != vm.data["02a_Discount_Multi_Pct"]) {
        //   var ff = document.getElementById("discount-animate")
        //   ff.classList.add("text-is-updated")
        // }
        vm.totalPrice = vm.data["02g_Gross_Prem_after_discount"];
        vm.oldprice = vm.data["01_Gross_Prem_before_discount"];
        vm.discount = vm.data["02a_Discount_Multi_Pct"] * 100;
        var rc = vm.recommendedPlans;
        EmbeddedService.PFOutput = response.data.response_data.outputs;

        for (var i = 0; i < rc.length; i++) {
          if (vm.checkbox[vm.recommendedPlans[i].ID] == true) {
            vm.slider[vm.recommendedPlans[i].ID].cover = EmbeddedService.customCoverages.find(function (x) {
              return x.ID === rc[i].ID;
            }).value;
            vm.slider[vm.recommendedPlans[i].ID].convertedcover = EmbeddedService.customCoverages.find(function (x) {
              return x.ID === rc[i].ID;
            }).value;
            vm.recommendedPlans[i].premium = vm.data.Premium_Detail.find(function (x) {
              return x.ID === rc[i].ID;
            }).Gross_Premium_before_Discount;
          }
        }
      }, function () {});
    };

    vm.hello = function () {
      console.log('hello');
    }
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('coherentPaDemo').controller('EmbeddedFlex1Controller', EmbeddedFlex1Controller);
  /** @ngInject */

  function EmbeddedFlex1Controller($state, EmbeddedService, $http, configUrls, environment) {
    var vm = this;
    vm.data = {};
    vm.allPlans = [];
    vm.recommendedPlans = [];
    vm.planObject = {
      premium: 0,
      name: ''
    };
    vm.discount = 1;
    vm.personas = EmbeddedService.personas
    vm.activePersona = ""

    vm.setPersona = function (index) {
      EmbeddedService.PFInput.request_data = {"request_data":{"inputs":{"Discount_Code":null,"Limit1":null,"Limit10":null,"Limit2":null,"Limit3":null,"Limit4":null,"Limit5":null,"Limit6":null,"Limit7":null,"Limit8":null,"Limit9":null,"No_Products":4,"Prm_Active_Lifestyle":"NA","Prm_Age":30,"Prm_AMZNPRIMESG":-1,"Prm_Automotive":-628,"Prm_Bar":-71,"Prm_Child":-472,"Prm_CreditArrear":0,"Prm_CreditBalance":8302,"Prm_CreditScore":"NA","Prm_Currency":"NA","Prm_Dependents":0,"Prm_E_commerce":-528,"Prm_Education":"A Levels","Prm_Food":-1999,"Prm_Gaming":-7,"Prm_Gender":"Female","Prm_Grocery":-535,"Prm_Hair":-66,"Prm_Health":-161,"Prm_Helper":-444,"Prm_Home":"NA","Prm_Income":27000,"Prm_Industry":"Insurance","Prm_Insurance":"NA","Prm_LateSleeper":"NA","Prm_Loan":0,"Prm_Location":"NA","Prm_Luxury":"NA","Prm_Marital_Status":"Single","Prm_Mortgage":"NA","Prm_Movies":-29,"Prm_Occupation":"I.T.","Prm_Petrol":-99,"Prm_Postcode":300821,"Prm_Rent":-5156,"Prm_Residency":"Employment Pass","Prm_Retail_shopping":-473,"Prm_Transport":-366,"Prm_Travel":-345,"Prm_Utility":-218,"Selection":"Recommended","UW_Response":[{"ID":2,"Response":"N"},{"ID":3,"Response":"N"},{"ID":4,"Response":"N"}]}},"request_meta":{"version_id":"64f79261-1e6c-4f8b-992f-6a2ca947d76b","transaction_date":"2022-02-02T18:22:26.084Z","call_purpose":"Spark - API Tester","source_system":"SPARK","correlation_id":"","requested_output":"","service_category":"","compiler_type":"Type3"}}
      EmbeddedService.PFInput.request_data.inputs["Prm_Age"] = EmbeddedService.personas[index-1]["Prm_Age"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Gender"] = EmbeddedService.personas[index-1]["Prm_Gender"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Income"] = EmbeddedService.personas[index-1]["Prm_Income"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Postcode"] = EmbeddedService.personas[index-1]["Prm_Postcode"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Occupation"] = EmbeddedService.personas[index-1]["Prm_Occupation"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Industry"] = EmbeddedService.personas[index-1]["Prm_Industry"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Marital_Status"] = EmbeddedService.personas[index-1]["Prm_Marital_Status"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Dependents"] = EmbeddedService.personas[index-1]["Prm_Dependents"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Education"] = EmbeddedService.personas[index-1]["Prm_Education"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Residency"] = EmbeddedService.personas[index-1]["Prm_Residency"]
      EmbeddedService.PFInput.request_data.inputs["Prm_CreditBalance"] = EmbeddedService.personas[index-1]["Prm_CreditBalance"]
      EmbeddedService.PFInput.request_data.inputs["Prm_CreditArrear"] = EmbeddedService.personas[index-1]["Prm_CreditArrear"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Loan"] = EmbeddedService.personas[index-1]["Prm_Loan"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Health"] = EmbeddedService.personas[index-1]["Prm_Health"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Child"] = EmbeddedService.personas[index-1]["Prm_Child"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Insurance"] = EmbeddedService.personas[index-1]["Prm_Insurance"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Travel"] = EmbeddedService.personas[index-1]["Prm_Travel"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Luxury"] = EmbeddedService.personas[index-1]["Prm_Luxury"]
      EmbeddedService.PFInput.request_data.inputs["Prm_E-commerce"] = EmbeddedService.personas[index-1]["Prm_E-commerce"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Active_Lifestyle"] = EmbeddedService.personas[index-1]["Prm_Active_Lifestyle"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Grocery"] = EmbeddedService.personas[index-1]["Prm_Grocery"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Home"] = EmbeddedService.personas[index-1]["Prm_Home"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Currency"] = EmbeddedService.personas[index-1]["Prm_Currency"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Automotive"] = EmbeddedService.personas[index-1]["Prm_Automotive"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Bar"] = EmbeddedService.personas[index-1]["Prm_Bar"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Food"] = EmbeddedService.personas[index-1]["Prm_Food"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Gaming"] = EmbeddedService.personas[index-1]["Prm_Gaming"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Hair"] = EmbeddedService.personas[index-1]["Prm_Hair"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Helper"] = EmbeddedService.personas[index-1]["Prm_Helper"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Movies"] = EmbeddedService.personas[index-1]["Prm_Movies"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Petrol"] = EmbeddedService.personas[index-1]["Prm_Petrol"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Rent"] = EmbeddedService.personas[index-1]["Prm_Rent"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Retail_shopping"] = EmbeddedService.personas[index-1]["Prm_Retail_shopping"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Transport"] = EmbeddedService.personas[index-1]["Prm_Transport"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Utility"] = EmbeddedService.personas[index-1]["Prm_Utility"]
      EmbeddedService.PFInput.request_data.inputs["Prm_AMZNPRIMESG"] = EmbeddedService.personas[index-1]["Prm_AMZNPRIMESG"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Mortgage"] = EmbeddedService.personas[index-1]["Prm_Mortgage"]
      EmbeddedService.PFInput.request_data.inputs["Prm_CreditScore"] = EmbeddedService.personas[index-1]["Prm_CreditScore"]
      EmbeddedService.PFInput.request_data.inputs["Prm_LateSleeper"] = EmbeddedService.personas[index-1]["Prm_LateSleeper"]
      EmbeddedService.PFInput.request_data.inputs["Prm_Location"] = EmbeddedService.personas[index-1]["Prm_Location"]
      vm.balance = Math.round(EmbeddedService.personas[index-1]["Prm_Income"] * 0.112)
      vm.txn1 = EmbeddedService.PFInput.request_data.inputs["Prm_Health"]
      vm.txn2 = EmbeddedService.PFInput.request_data.inputs["Prm_Child"]
      vm.txn3 = EmbeddedService.PFInput.request_data.inputs["Prm_Retail_shopping"]
      vm.txn4 = EmbeddedService.PFInput.request_data.inputs["Prm_Automotive"]
      vm.txn5 = EmbeddedService.PFInput.request_data.inputs["Prm_Rent"]
      vm.txn6 = EmbeddedService.PFInput.request_data.inputs["Prm_Travel"]

      vm.activePersona = EmbeddedService.personas[index-1].Name
      console.log(EmbeddedService.personas[index-1].Prm_CreditBalance)
      getPlan();
    }

    function getPlan() {
      vm.recommendedPlans = []
      EmbeddedService.recommendedPlans =[]
      console.log(EmbeddedService.PFInput)
      var req = {
        method: 'POST',
        // url: 'https://excel.staging.coherent.global/coherentflex/api/v3/folders/Flex/services/Controller File/Execute/',
        url: configUrls[environment].PFUrl1 + 'Flex/engines/Execute/Controller%20File',
        headers: {
          'SecretKey': EmbeddedService.PFToken,
          'x-tenant-name': 'coherentflex'
        },
        data: EmbeddedService.PFInput
      };
      $http(req).then(function (response) {
        vm.data = response.data.response_data.outputs;
        var rc = vm.data.Recommended_Products;
        EmbeddedService.PFOutput = response.data.response_data.outputs;
        console.log(vm.data.UI_Options[0].Product);

        var _loop = function _loop(i) {
          a = {};
          a.premium = vm.data.Premium_Detail.find(function (x) {
            return x.ID === rc[i].ID;
          }).Gross_Premium_before_Discount;
          a.cover = vm.data.Recommended_Products.find(function (x) {
            return x.ID === rc[i].ID;
          })["Recommend Coverage"];
          a.name = vm.data.UI_Options.find(function (x) {
            return x.ID === rc[i].ID;
          }).Product;
          a.Default = vm.data.UI_Options.find(function (x) {
            return x.ID === rc[i].ID;
          }).Default;
          a.Min = vm.data.UI_Options.find(function (x) {
            return x.ID === rc[i].ID;
          }).Min;
          a.Max = vm.data.UI_Options.find(function (x) {
            return x.ID === rc[i].ID;
          }).Max;
          a.Step = vm.data.UI_Options.find(function (x) {
            return x.ID === rc[i].ID;
          }).Step;
          a.ID = vm.data.UI_Options.find(function (x) {
            return x.ID === rc[i].ID;
          }).ID;
          vm.recommendedPlans.push(a);
          vm.discount = Math.round(EmbeddedService.PFOutput["02a_Discount_Multi_Pct"] * 100);
          console.log(vm.recommendedPlans);
          EmbeddedService.recommendedPlans = vm.recommendedPlans;
        }

        for (var i = 0; i < rc.length; i++) {
          var a;

          _loop(i);
        }
      }, function () {});
    }

    vm.setPersona(1)

  }
})();
(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .controller('EmbeddedDBS2Controller', EmbeddedDBS2Controller);

  /** @ngInject */
  function EmbeddedDBS2Controller($state, EmbeddedService) {
    var vm = this;

    vm.activeProduct = EmbeddedService.activeProduct
    vm.productData = EmbeddedService.productData

    console.log(vm.productData)

    vm.title = vm.productData[vm.activeProduct + '_Title']
    vm.desc = vm.productData[vm.activeProduct + '_Desc']
    vm.CTAURL = vm.productData[vm.activeProduct + '_CTAURL']
    vm.Disclaimer = vm.productData[vm.activeProduct + '_Disclaimer']
    vm.Premium = vm.productData[vm.activeProduct + '_Premium']


  }
})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .controller('EmbeddedDBS1Controller', EmbeddedDBS1Controller);

  /** @ngInject */
  function EmbeddedDBS1Controller($state, $http, EmbeddedService, configUrls, environment) {
    var vm = this;

    vm.PFInput = {
      "Inputs": {},
      "TransactionDate": "2021-09-13T23:39:21.036Z",
      "EngineType": "Type3",
      "Images": [],
      "Reports": [],
      "Solves": []
    }

    vm.productTiles = [
      {
        title: 'Loading...',
        desc: 'Loading...'
      }
    ];

    vm.text1 = 'asdf'


    function init() {
      var req = {
        method: 'POST',
        // url: 'https://excel.staging.coherent.global/api/v1/product/DBS/engines/Execute/dbs-product-admin',
        url: configUrls[environment].PFUrl1 + 'Flex/engines/Execute/Controller%20File/Execute/',
        headers: {
          'SecretKey': '97b489ef-39e1-4c65-9149-d8d6655a2ac1',
          'x-tenant-name': 'coherent'
        },
        data: angular.toJson(vm.PFInput)
      }
      $http(req)
        .then(function (response) {
          var data = response.data.data.Outputs
          console.log(data)
          getProducts(data)
          EmbeddedService.setProductData(data)
        }, function () {
      });
    }

    function getProducts(data) {
      vm.productTiles = []
      console.log(data.ProductList)
      var list = data.ProductList
      for(var i=0;i<list.length;i++) {
        var aa = {}
        aa.title = data[list[i].Name + '_Title']
        aa.desc = data[list[i].Name + '_Desc']
        aa.name = list[i].Name
        vm.productTiles.push(aa)
      }
      console.log(vm.productTiles)
    }

    vm.learnMore = function (name) {
      EmbeddedService.setActiveProduct(name)
      $state.go('embedded-dbs-2');
    }

    init();

  }
})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .controller('ClaimQuickClaimController', ClaimQuickClaimController);

  /** @ngInject */
  function ClaimQuickClaimController($state, ClaimService, PolicyService, $http, PurchaseService, configUrls, environment) {
    var vm = this;

    ClaimService.setPolicyDetails(PolicyService.policyDetails)
    ClaimService.setPolNo(PolicyService.polNo)

    vm.polNo = ClaimService.polNo
    vm.policyDetails = ClaimService.policyDetails
    vm.SparkTemplate = ClaimService.SparkTemplate
    vm.ClaimBody = ClaimService.ClaimBody
    vm.ClaimItemBody = ClaimService.ClaimItemBody

    vm.input7 = {}
    vm.input4 = {}
    vm.responses = {
      tpAmt: 0
    }

    vm.datepickerOptions1 = {
      showWeeks: false,
      maxDate: moment()
    };

    vm.datepickerOptions2 = {
      showWeeks: false
    };
    vm.datepickerOptions3 = {
      showWeeks: false,
      minDate: moment(vm.responses.hospStart)
    };

    vm.datepickerOptions4 = {
      showWeeks: false
    };

    vm.setMinHospStart = function () {
      //vm.datepickerOptions2.minDate = moment(vm.responses.date)
      vm.showHospStart = true
    }
    vm.setMinHospEnd = function () {
      vm.datepickerOptions3.minDate = moment(vm.responses.hospStart)
      vm.showHospEnd = true
    }
    vm.setSurg = function () {
      vm.datepickerOptions4.minDate = moment(vm.responses.hospStart)
      vm.showSurg = true
    }

    vm.validate = function () {

      vm.SparkTemplate.Inputs["Claim.Cover_StartDate"] = moment(vm.policyDetails.Cont.StartDate).format('YYYY-MM-DD hh:mm')
      vm.SparkTemplate.Inputs["Claim.Cover_Start_Date"] = moment(vm.policyDetails.Cont.StartDate).format('YYYY-MM-DD hh:mm')
      vm.SparkTemplate.Inputs["Claim.Cover_EndDate"] = moment(vm.policyDetails.Cont.EndDate).format('YYYY-MM-DD hh:mm')
      vm.SparkTemplate.Inputs["Claim.Insured_Name"] = vm.policyDetails.Cont.Risks["1"].RiskBody.InsuredParty.Name

      vm.SparkTemplate.Inputs["Claim.Insured_Name"] = vm.policyDetails.Cont.Risks["1"].RiskBody.InsuredParty.Name

      if (ClaimService.policyDetails.Cont.Risks["1"].RiskBody.Benefit_Limits) {
        vm.SparkTemplate.Inputs["Claim.Policy_Limit"][0].Limit = ClaimService.policyDetails.Cont.Risks["1"].RiskBody.Benefit_Limits[0].PolicyLimit
        if (ClaimService.policyDetails.Cont.Risks["1"].RiskBody.Benefit_Limits.length > 1)
        vm.SparkTemplate.Inputs["Claim.Policy_Limit"][1].Limit = ClaimService.policyDetails.Cont.Risks["1"].RiskBody.Benefit_Limits[1].PolicyLimit
        if (ClaimService.policyDetails.Cont.Risks["1"].RiskBody.Benefit_Limits.length > 2)
        vm.SparkTemplate.Inputs["Claim.Policy_Limit"][2].Limit = ClaimService.policyDetails.Cont.Risks["1"].RiskBody.Benefit_Limits[2].PolicyLimit
        vm.SparkTemplate.Inputs["Claim.Policy_Limit"][2].Limit_Daily = ClaimService.policyDetails.Cont.Risks["1"].RiskBody.Benefit_Limits[2].DailyLimit
        if (ClaimService.policyDetails.Cont.Risks["1"].RiskBody.Benefit_Limits.length > 3)
        vm.SparkTemplate.Inputs["Claim.Policy_Limit"][3].Limit =  ClaimService.policyDetails.Cont.Risks["1"].RiskBody.Benefit_Limits[3].PolicyLimit
        if (ClaimService.policyDetails.Cont.Risks["1"].RiskBody.Benefit_Limits.length > 4)
        vm.SparkTemplate.Inputs["Claim.Policy_Limit"][4].Limit =  ClaimService.policyDetails.Cont.Risks["1"].RiskBody.Benefit_Limits[4].PolicyLimit
        if (ClaimService.policyDetails.Cont.Risks["1"].RiskBody.Benefit_Limits.length > 5)
        vm.SparkTemplate.Inputs["Claim.Policy_Limit"][5].Limit = ClaimService.policyDetails.Cont.Risks["1"].RiskBody.Benefit_Limits[5].PolicyLimit
      }
      

      vm.SparkTemplate.Inputs["Claim.AccDate"] = moment(vm.responses.date).format('YYYY-MM-DD') + ' 23:59'
      vm.SparkTemplate.Inputs["Claim.PH_Name"] = ClaimService.policyDetails.Cont.Owner.Name
      vm.SparkTemplate.Inputs["Claim.Claimant_Name"] = vm.policyDetails.Cont.Risks["1"].RiskBody.InsuredParty.Name
      if(vm.responses.hospStart) {
        vm.SparkTemplate.Inputs["Claim.Hospital_EntryDate"] = moment(vm.responses.hospStart).format('YYYY-MM-DD hh:mm')
      }
      if(vm.responses.hospEnd) {
        vm.SparkTemplate.Inputs["Claim.Hospital_ExitDate"] = moment(vm.responses.hospEnd).format('YYYY-MM-DD hh:mm')
      }
      vm.SparkTemplate.Inputs["Claim.Hospital_Status"] = vm.responses.hospStatus
      if(vm.responses.surgery) {
        vm.SparkTemplate.Inputs["Claim.Surgery_Date"] = moment(vm.responses.surgery).format('YYYY-MM-DD hh:mm')
      }
      vm.SparkTemplate.Inputs["Claim.TP_Amt"] = vm.responses.tpAmt

      console.log(vm.SparkTemplate)

      var settings = {
        method: 'GET',
        url: configUrls[environment].keyCloakTokenUrl + '?apiKey=' + configUrls[environment].keyCloakApiKey + '&client=' + configUrls[environment].keyCloakPFClient,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      };

      $http(settings).then(function (response) {
        console.log(response);
        return response
      }).then(function (tokenRes) {

        // ----- Existing code here ----//
        var req = {
          method: 'POST',
          // url: 'https://excel.sonic.dev.coherent.com.hk/api/v1/product/coherent/engines/Execute/PA',
          // headers: {
          //   'SecretKey': '762f5692-5a8b-4f8e-a09e-a27a277c0c56',
          //   'x-tenant-name': 'coherent'
          // },
          url: configUrls[environment].PFUrl + PurchaseService.ProductCode,          
          headers: {
            authorization: 'Bearer ' + tokenRes.data.access_token
          },
          data: angular.toJson(vm.SparkTemplate)
        };
        $http(req)
          .then(function (response) {
            var claimValidation = response.data.data.Outputs
            console.log(claimValidation)
            //policy ID
            vm.ClaimBody.Header.Contid = ClaimService.policyDetails.Cont.ContID
            //Claim Date
            vm.ClaimBody.Header.TransDate = moment().format('YYYY-MM-DD') + 'T00:00:00.000000Z'
            vm.ClaimBody.Header.ClaimDate = moment().format('YYYY-MM-DD') + 'T00:00:00.000000Z'
            //Insured
            vm.ClaimBody.Header.Insured.Name = vm.policyDetails.Cont.Risks["1"].RiskBody.InsuredParty.Name
            vm.ClaimBody.Header.Insured.Dob = moment(vm.policyDetails.Cont.Risks["1"].RiskBody.InsuredParty.Dob).format('YYYY-MM-DD')
            vm.ClaimBody.Header.Insured.Gender = vm.policyDetails.Cont.Risks["1"].RiskBody.InsuredParty.Gender
            //Claim Notes
            var aa = []
            if (claimValidation["Claim.Warning_Message"] && claimValidation["Claim.Warning_Message"].length > 0) {
              for(var i=0;i<claimValidation["Claim.Warning_Message"].length;i++) {
                aa.push(
                  {
                      "Dte": "2021-05-14T00:00:00Z",
                      "User": "AutoProcessing",
                      "Text": claimValidation["Claim.Warning_Message"][i]["ワーニングNo."] + " " + claimValidation["Claim.Warning_Message"][i]["ワーニング文言"]
                      // ClaimService.mapErrors(claimValidation["Claim.Warning_Message"][i]["ワーニングNo."])
                  })
              }
            }
            vm.ClaimBody.Header.Notes = aa
            //Payee: Acc name, Acc, Bank, Branch
            //insured name
            //claim items 2,3,4,5
            var bb = []
            var cc = []
  
            _.each(claimValidation["Claim.Gross_Payable"], function (cv) {
              if(cv["Gross_Payable"] > 0) {
                cc.push(angular.fromJson("{\"BenefitName\":\""+cv["Benefit"]+"\",\"GrossPayable\":\""+cv["Gross_Payable"]+"\"}"))
                //benefit
                // dd.Benefit = cv["Benefit"]
                // //date
                // dd.ClaimDate = moment().format('YYYY-MM-DD') + 'T13:23:45.871303Z'
                // //amount
                // dd.ClaimedAmount = cv["Gross_Payable"]
                //event - start, end
                if(cv["Benefit"] == "A3") {
                  bb.push("{\"Itemref\":\"\",\"Benefit\":\"" + cv["Benefit"] + "\",\"ClaimDate\":\"" + moment().format('YYYY-MM-DD') + 'T13:23:45.871303Z' + "\",\"ClaimedAmount\":"+cv["Gross_Payable"]+",\"ClaimEvent\":{\"EventType\":\"" + vm.responses.hospStatus + "\",\"EventStart\":\""+ moment(vm.responses.hospStart).format('YYYY-MM-DD') + 'T13:23:45.871303Z' +"\",\"EventEnd\":\"" + moment(vm.responses.hospEnd).format('YYYY-MM-DD') + 'T13:23:45.871303Z' + "\",\"EventDesc\":\"\"},\"Data\":null,\"Attachments\":[],\"AutoStatus\":\"\",\"Claimant\":{\"PersonalDets\":{\"Name\":\""+ vm.policyDetails.Cont.Owner.Name +"\",\"GivenName\":\"\",\"Dob\":\""+ vm.policyDetails.Cont.Owner.Dob +"\",\"MaritalStatus\":\"\",\"Gender\":\"" + vm.policyDetails.Cont.Owner.Gender + "\",\"Id\":\"\",\"LegalRep\":{\"RepresentativeId\":\"\",\"RepDets\":null,\"Relationship\":\"\"},\"Nationality\":\"Japanese\",\"Occupation\":\"\",\"Contact\":{\"Email\":\"\",\"Phone\":\"\",\"FbId\":\"\",\"Add\":{\"Add1\":\"test\",\"Add2\":\"test\",\"Add3\":\"test\",\"Add4\":\"test\",\"City\":\"test\",\"Country\":\"test\",\"Pcode\":\"487938\"}}},\"Relationship\":\"Self\"},\"Status\":\"Initiate\",\"Notes\":null,\"Payee\":{\"AccountName\":\"Acc1\",\"Bank\":\"Bank1\",\"Branch\":\"Branch1\",\"Account\":\"Acc1\",\"IBAN\":\"1234\",\"Address\":{\"Add1\":\"Add1\",\"Add2\":\"Add2\",\"Add3\":\"Add3\",\"Add4\":\"Add4\",\"City\":\"City\",\"Country\":\"Japan\",\"Pcode\":\"1234-222\"}}}");
                  // dd.EventStart = moment(vm.responses.hospStart).format('YYYY-MM-DD')
                  // dd.EventEnd = moment(vm.responses.hospEnd).format('YYYY-MM-DD')
                  // dd.EventType = vm.responses.hospStatus
                } else if(cv["Benefit"] == "A4_a" || cv["Benefit"] == "A4_b") {
                  bb.push("{\"Itemref\":\"\",\"Benefit\":\"" + cv["Benefit"] + "\",\"ClaimDate\":\"" + moment().format('YYYY-MM-DD') + 'T13:23:45.871303Z' + "\",\"ClaimedAmount\": " + cv["Gross_Payable"] + " ,\"ClaimEvent\":{\"EventType\":\"Surgery\",\"EventStart\":\""+ moment(vm.responses.surgery).format('YYYY-MM-DD') + 'T13:23:45.871303Z'  +"\",\"EventEnd\":\"" + moment(vm.responses.surgery).format('YYYY-MM-DD') + 'T13:23:45.871303Z' + "\",\"EventDesc\":\"\"},\"Data\":null,\"Attachments\":[],\"AutoStatus\":\"\",\"Claimant\":{\"PersonalDets\":{\"Name\":\""+ vm.policyDetails.Cont.Owner.Name +"\",\"GivenName\":\"\",\"Dob\":\""+ vm.policyDetails.Cont.Owner.Dob +"\",\"MaritalStatus\":\"\",\"Gender\":\"" + vm.policyDetails.Cont.Owner.Gender + "\",\"Id\":\"\",\"LegalRep\":{\"RepresentativeId\":\"\",\"RepDets\":null,\"Relationship\":\"\"},\"Nationality\":\"Japanese\",\"Occupation\":\"\",\"Contact\":{\"Email\":\"\",\"Phone\":\"\",\"FbId\":\"\",\"Add\":{\"Add1\":\"test\",\"Add2\":\"test\",\"Add3\":\"test\",\"Add4\":\"test\",\"City\":\"test\",\"Country\":\"test\",\"Pcode\":\"487938\"}}},\"Relationship\":\"Self\"},\"Status\":\"Initiate\",\"Notes\":null,\"Payee\":{\"AccountName\":\"Acc1\",\"Bank\":\"Bank1\",\"Branch\":\"Branch1\",\"Account\":\"Acc1\",\"IBAN\":\"1234\",\"Address\":{\"Add1\":\"Add1\",\"Add2\":\"Add2\",\"Add3\":\"Add3\",\"Add4\":\"Add4\",\"City\":\"City\",\"Country\":\"Japan\",\"Pcode\":\"1234-222\"}}}");
                  // dd.EventStart = moment(vm.responses.surgery).format('YYYY-MM-DD')
                  // dd.EventEnd = moment(vm.responses.surgery).format('YYYY-MM-DD')
                  // dd.EventType = "Surgery"
                } else {
                  bb.push("{\"Itemref\":\"\",\"Benefit\":\"" + cv["Benefit"] + "\",\"ClaimDate\":\"" + moment().format('YYYY-MM-DD') + 'T13:23:45.871303Z' + "\",\"ClaimedAmount\":" + cv["Gross_Payable"] + " ,\"ClaimEvent\":{\"EventType\":\"\",\"EventStart\":\""+ moment(vm.responses.date).format('YYYY-MM-DD')  + 'T13:23:45.871303Z' +"\",\"EventEnd\":\"" + moment(vm.responses.date).format('YYYY-MM-DD')  + 'T13:23:45.871303Z' + "\",\"EventDesc\":\"\"},\"Data\":null,\"Attachments\":[],\"AutoStatus\":\"\",\"Claimant\":{\"PersonalDets\":{\"Name\":\""+ vm.policyDetails.Cont.Owner.Name +"\",\"GivenName\":\"\",\"Dob\":\""+ vm.policyDetails.Cont.Owner.Dob +"\",\"MaritalStatus\":\"\",\"Gender\":\"" + vm.policyDetails.Cont.Owner.Gender + "\",\"Id\":\"\",\"LegalRep\":{\"RepresentativeId\":\"\",\"RepDets\":null,\"Relationship\":\"\"},\"Nationality\":\"Japanese\",\"Occupation\":\"\",\"Contact\":{\"Email\":\"\",\"Phone\":\"\",\"FbId\":\"\",\"Add\":{\"Add1\":\"test\",\"Add2\":\"test\",\"Add3\":\"test\",\"Add4\":\"test\",\"City\":\"test\",\"Country\":\"test\",\"Pcode\":\"487938\"}}},\"Relationship\":\"Self\"},\"Status\":\"Initiate\",\"Notes\":null,\"Payee\":{\"AccountName\":\"Acc1\",\"Bank\":\"Bank1\",\"Branch\":\"Branch1\",\"Account\":\"Acc1\",\"IBAN\":\"1234\",\"Address\":{\"Add1\":\"Add1\",\"Add2\":\"Add2\",\"Add3\":\"Add3\",\"Add4\":\"Add4\",\"City\":\"City\",\"Country\":\"Japan\",\"Pcode\":\"1234-222\"}}}");
                  // dd.EventStart = moment(vm.responses.date).format('YYYY-MM-DD')
                  // dd.EventEnd = moment(vm.responses.date).format('YYYY-MM-DD')
                }
                //Claimant - name dob gender
                // dd.Name = vm.policyDetails.Cont.Owner.Name
                // dd.Dob = vm.policyDetails.Cont.Owner.Dob
                // dd.Gender = vm.policyDetails.Cont.Owner.Gender
                //cv["Gross_Payable"]
              }
              //bb.push(cc(dd));
            });
            //parse claim items
  
            vm.ClaimBody.Header.ClaimItems = bb;
  
            _.each(vm.ClaimBody.Header.ClaimItems, function (ci, idx) {
              vm.ClaimBody.Header.ClaimItems[idx] = angular.fromJson(ci);
            });
  
            console.log(vm.ClaimBody)
            ClaimService.setClaimBody(vm.ClaimBody)
            ClaimService.setPayable(cc)
  
            $state.go('claim-7');
  
          }, function () {
        });
        // ----- Existing code end ----//

      });
    }

    function init() {
      if (!_.isEmpty(ClaimService.policyDetails)) {
        ClaimService.clear();
        vm.SparkTemplate = ClaimService.SparkTemplate
        vm.ClaimBody = ClaimService.ClaimBody
        vm.ClaimItemBody = ClaimService.ClaimItemBody
      } else {
        $state.go('policy-login');
      }
    }

    init();
  }
})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .service('ClaimService', ClaimService);

  /** @ngInject */
  function ClaimService() {
    var vm = this;

    vm.claims = [];

    vm.ClaimBodyTemplate = angular.toJson({
        "Header": {
            "Contid": "070910",
            "RiskId": "1",
            "ClaimRef": "",
            "ClaimItems": [
                {
                    "Itemref": "",
                    "Benefit": "A1",
                    "ClaimDate": "2021-05-14T00:00:00Z",
                    "ClaimedAmount": 600,
                    "ClaimEvent": {
                        "EventType": "OPD",
                        "EventStart": "2021-05-10T00:00:00Z",
                        "EventEnd": "2021-05-05T00:00:00Z",
                        "EventDesc": ""
                    },
                    "Data": null,
                    "Attachments": [
                        {
                            "Url": "https://sonic-data-store.s3-ap-southeast-1.amazonaws.com/S3UplodeFolder/cycle_20210726023812726.jpg",
                            "Descr": "Bike Image",
                            "AttachDate": "2021-05-10T00:00:00Z",
                            "AttachNote": {
                                "Dte": "2021-05-10T00:00:00Z",
                                "User": "User1",
                                "Text": "test notes"
                            }
                        }
                    ],
                    "AutoStatus": "",
                    "Claimant": {
                        "PersonalDets": {
                            "Name": "Hiro",
                            "GivenName": "Satoshi",
                            "Dob": "2000-02-13",
                            "MaritalStatus": "S",
                            "Gender": "Male",
                            "Id": "",
                            "LegalRep": {
                                "RepresentativeId": "",
                                "RepDets": null,
                                "Relationship": ""
                            },
                            "Nationality": "Japanese",
                            "Occupation": "",
                            "Contact": {
                                "Email": "test@test.com",
                                "Phone": "9844309035",
                                "FbId": "",
                                "Add": {
                                    "Add1": "test",
                                    "Add2": "test",
                                    "Add3": "test",
                                    "Add4": "test",
                                    "City": "test",
                                    "Country": "test",
                                    "Pcode": "487938"
                                }
                            }
                        },
                        "Relationship": "Self"
                    },
                    "Payee": {
                      "AccountName": "Acc1",
                      "Bank": "Bank1",
                      "Branch": "Branch1",
                      "Account": "Acc1",
                      "IBAN": "1234",
                      "Address": {
                          "Add1": "Add1",
                          "Add2": "Add2",
                          "Add3": "Add3",
                          "Add4": "Add4",
                          "City": "City",
                          "Country": "Japan",
                          "Pcode": "1234-222"
                      }
                    },
                    "Status": "Initiate",
                    "Notes": null
                }
            ],
            "Status": "Initiate",
            "AutoStatus": "",
            "Submitter": {
                "Name": "",
                "GivenName": null,
                "Gender": "",
                "Dob": "",
                "Smoker": "",
                "Id": null,
                "Contact": {
                    "Email": "",
                    "Phone": "",
                    "FbId": "",
                    "Add": {
                        "Add1": "",
                        "Add2": "",
                        "Add3": "",
                        "Add4": "",
                        "City": "",
                        "Country": "",
                        "Pcode": ""
                    }
                },
                "Occupation": "",
                "Data": null,
                "Idnumber": "",
                "Maritalstatus": "",
                "Kycfna": ""
            },
            "ClaimDate": "",
            "CloseDate": "0001-01-01T00:00:00Z",
            "Approvals": null,
            "Data": null,
            "Notes": [],
            "Communications": null,
            "Payee": {
              "AccountName": "Acc1",
              "Bank": "Bank1",
              "Branch": "Branch1",
              "Account": "Acc1",
              "IBAN": "1234",
              "Address": {
                  "Add1": "Add1",
                  "Add2": "Add2",
                  "Add3": "Add3",
                  "Add4": "Add4",
                  "City": "City",
                  "Country": "Japan",
                  "Pcode": "1234-222"
              }
            },
            "Insured": {
                "GivenName": "",
                "Name": "",
                "Dob": "",
                "Age": 0,
                "Gender": "",
                "Id": {
                    "ExpiryDate": "",
                    "IDNumber": "",
                    "IDType": "",
                    "IssueDate": "",
                    "IssuingAgency": ""
                },
                "Occupation": "",
                "MortalityClass": "",
                "OtherPolicyInfo": null,
                "Kinship": "",
                "Contact": {
                    "Email": "",
                    "Phone": "",
                    "FbId": "",
                    "Add": {
                        "Add1": "",
                        "Add2": "",
                        "Add3": "",
                        "Add4": "",
                        "City": "",
                        "Country": "",
                        "Pcode": ""
                    }
                }
            }
        }
    })

    vm.ClaimItemBodyTemplate = angular.toJson({
        "Itemref": "",
        "Benefit": "A1",
        "ClaimDate": "2021-05-14T00:00:00Z",
        "ClaimedAmount": 600,
        "ClaimEvent": {
            "EventType": "",
            "EventStart": "2021-05-10T00:00:00Z",
            "EventEnd": "2021-05-05T00:00:00Z",
            "EventDesc": ""
        },
        "Data": null,
        "Attachments": [
        ],
        "AutoStatus": "",
        "Claimant": {
            "PersonalDets": {
                "Name": "",
                "GivenName": "",
                "Dob": "",
                "MaritalStatus": "",
                "Gender": "",
                "Id": "",
                "LegalRep": {
                    "RepresentativeId": "",
                    "RepDets": null,
                    "Relationship": ""
                },
                "Nationality": "Japanese",
                "Occupation": "",
                "Contact": {
                    "Email": "",
                    "Phone": "",
                    "FbId": "",
                    "Add": {
                        "Add1": "test",
                        "Add2": "test",
                        "Add3": "test",
                        "Add4": "test",
                        "City": "test",
                        "Country": "test",
                        "Pcode": "487938"
                    }
                }
            },
            "Relationship": "Self"
        },
        "Status": "Initiate",
        "Notes": null
    })

    vm.ClaimAttachmentBodyTemplate = angular.toJson({
      "Url": "",
      "Descr": "Bike Image",
      "AttachDate": "2021-05-10T00:00:00Z",
      "AttachNote": {
          "Dte": "2021-05-10T00:00:00Z",
          "User": "User1",
          "Text": "test notes"
      }
    })

    vm.SparkTemplateBlank = angular.toJson({
      "Inputs": {
        "Claim.AccDate": "2022-05-08 17:00",
        "Claim.Claim_Validation": [
          {
            "ID": "CF1",
            "Response": "Y"
          },
          {
            "ID": "CF2",
            "Response": "Y"
          },
          {
            "ID": "CF3",
            "Response": "Y"
          }
        ],
        "Claim.Claimant_Name": "",
        "Claim.Cover_EndDate": "",
        "Claim.Cover_StartDate": "",
        "Claim.Hospital_EntryDate": "",
        "Claim.Hospital_ExitDate": "",
        "Claim.Hospital_Status": "",
        "Claim.Insured_Name": "",
        "Claim.PH_Name": "",
        "Claim.Policy_Limit": [
          {
            "Benefit": "A1",
            "Limit": 10000000,
            "Limit_Daily": 0
          },
          {
            "Benefit": "A2",
            "Limit": 10000000,
            "Limit_Daily": 0
          },
          {
            "Benefit": "A3",
            "Limit": 1800000,
            "Limit_Daily": 10000
          },
          {
            "Benefit": "A4_a",
            "Limit": 100000,
            "Limit_Daily": 0
          },
          {
            "Benefit": "A4_b",
            "Limit": 50000,
            "Limit_Daily": 0
          },
          {
            "Benefit": "B1",
            "Limit": 100000000,
            "Limit_Daily": 0
          }
        ],
        "Claim.Surgery_Date": "",
        "Claim.TP_Amt": 0,
        "Claim.Channel": "Agent_2",
        "Claim.Cover_Start_Date": "",
        "Claim.Coverage": "Insured_1",
        "Claim.DOB": "1980-01-01",
        "Claim.Gender": "F",
        "Claim.Optional_Benefits": "[\n  {\n    \"Option\": \"Insured_1\",\n    \"Included\": \"Y\"\n  }\n]",
        "Claim.Plan": "Plan2",
        "Claim.Policy_Cover_QuoteDate": "2021-07-01",
        "Claim.PostalCode": "064-0806",
        "Claim.Promotion_Discount_Code": "",
        "Claim.Ratings": "[\n  {\n    \"RatingFactor\": \"RakutenPoints\",\n    \"Value\": 20\n  },\n  {\n    \"RatingFactor\": null,\n    \"Value\": null\n  },\n  {\n    \"RatingFactor\": null,\n    \"Value\": null\n  },\n  {\n    \"RatingFactor\": null,\n    \"Value\": null\n  },\n  {\n    \"RatingFactor\": null,\n    \"Value\": null\n  },\n  {\n    \"RatingFactor\": null,\n    \"Value\": null\n  },\n  {\n    \"RatingFactor\": null,\n    \"Value\": null\n  },\n  {\n    \"RatingFactor\": null,\n    \"Value\": null\n  },\n  {\n    \"RatingFactor\": null,\n    \"Value\": null\n  },\n  {\n    \"RatingFactor\": null,\n    \"Value\": null\n  },\n  {\n    \"RatingFactor\": null,\n    \"Value\": null\n  },\n  {\n    \"RatingFactor\": null,\n    \"Value\": null\n  },\n  {\n    \"RatingFactor\": null,\n    \"Value\": null\n  },\n  {\n    \"RatingFactor\": null,\n    \"Value\": null\n  },\n  {\n    \"RatingFactor\": null,\n    \"Value\": null\n  }\n]",
        "Claim.Term": "1",
        "Claim.Underwriting_Response": "[\n  {\n    \"UWSurveyCode\": \"PA_UW_1\",\n    \"UWSurveyResponse\": \"Y\"\n  },\n  {\n    \"UWSurveyCode\": \"PA_UW_2\",\n    \"UWSurveyResponse\": \"Y\"\n  },\n  {\n    \"UWSurveyCode\": \"PA_UW_3\",\n    \"UWSurveyResponse\": null\n  },\n  {\n    \"UWSurveyCode\": \"PA_UW_4\",\n    \"UWSurveyResponse\": null\n  },\n  {\n    \"UWSurveyCode\": \"PA_UW_5\",\n    \"UWSurveyResponse\": null\n  },\n  {\n    \"UWSurveyCode\": \"PA_UW_6\",\n    \"UWSurveyResponse\": null\n  },\n  {\n    \"UWSurveyCode\": \"PA_UW_7\",\n    \"UWSurveyResponse\": null\n  },\n  {\n    \"UWSurveyCode\": \"PA_UW_8\",\n    \"UWSurveyResponse\": null\n  },\n  {\n    \"UWSurveyCode\": \"PA_UW_9\",\n    \"UWSurveyResponse\": null\n  },\n  {\n    \"UWSurveyCode\": \"PA_UW_10\",\n    \"UWSurveyResponse\": null\n  },\n  {\n    \"UWSurveyCode\": \"PA_UW_11\",\n    \"UWSurveyResponse\": null\n  },\n  {\n    \"UWSurveyCode\": \"PA_UW_12\",\n    \"UWSurveyResponse\": null\n  },\n  {\n    \"UWSurveyCode\": \"PA_UW_13\",\n    \"UWSurveyResponse\": null\n  },\n  {\n    \"UWSurveyCode\": \"PA_UW_14\",\n    \"UWSurveyResponse\": null\n  },\n  {\n    \"UWSurveyCode\": \"PA_UW_15\",\n    \"UWSurveyResponse\": null\n  },\n  {\n    \"UWSurveyCode\": \"PA_UW_16\",\n    \"UWSurveyResponse\": null\n  },\n  {\n    \"UWSurveyCode\": \"PA_UW_17\",\n    \"UWSurveyResponse\": null\n  },\n  {\n    \"UWSurveyCode\": \"PA_UW_18\",\n    \"UWSurveyResponse\": null\n  },\n  {\n    \"UWSurveyCode\": \"PA_UW_19\",\n    \"UWSurveyResponse\": null\n  },\n  {\n    \"UWSurveyCode\": \"PA_UW_20\",\n    \"UWSurveyResponse\": null\n  }\n]"
      },
      "TransactionDate": "2021-07-31T19:34:31.020Z",
      "EngineType": "Type1",
      "Solves": [],
      "RequestedServiceCategory": "Claim"
    })

    vm.ClaimBody = angular.fromJson(vm.ClaimBodyTemplate)
    vm.ClaimItemBody = angular.fromJson(vm.ClaimItemBodyTemplate)
    vm.ClaimAttachmentBody = angular.fromJson(vm.ClaimAttachmentBodyTemplate)
    vm.SparkTemplate = angular.fromJson(vm.SparkTemplateBlank)

    // // TODO: REMOVE TEST DATA
    // vm.claims = [
    //     {
    //         "benefit": {
    //           display: 'Medical expenses',
    //           value: 'medical_expenses'
    //         },
    //         "name": "123",
    //         "date": new Date("2021-07-20T16:00:00.000Z"),
    //         "location": "Seibo Hospital",
    //         "how": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    //         "amount": "123",
    //         "receivingTreatment": "Yes",
    //         "hospitalizationStartDate": new Date("2021-07-07T16:00:00.000Z"),
    //         "hospitalizationEndDate": new Date("2021-07-15T16:00:00.000Z"),
    //         "treatment": "surgery 1",
    //         "surgery": "surgery 1",
    //         "surgeryDate": new Date("2021-07-02T16:00:00.000Z"),
    //         "files": [
    //             {
    //                 "name": "Group - Copy (3).png",
    //                 "url": "https://www.google.com",
    //                 "description": "abcd"
    //             },
    //             {
    //                 "name": "Group - Copy (4).png",
    //                 "url": "https://www.google.com",
    //                 "description": "abc"
    //             },
    //             {
    //                 "name": "Group - Copy.png",
    //                 "url": "https://www.google.com",
    //                 "description": "ab"
    //             },
    //             {
    //                 "name": "Group.png",
    //                 "url": "https://www.google.com",
    //                 "description": "a"
    //             }
    //         ]
    //     }
    // ];
    // // TODO: REMOVE TEST DATA

    vm.setPolicyDetails = function (policyDetails) {
      vm.policyDetails = policyDetails;
    };

    vm.setPolNo = function (polNo) {
      vm.polNo = polNo;
    };    

    vm.setClaimBody = function (ClaimBody) {
      vm.ClaimBody = ClaimBody;
    };

    vm.setBenefit = function(benefit, idx) {
      if (angular.isDefined(idx) && parseInt(idx, 10) >= 0) {
        vm.claims[idx].benefit = benefit;
      } else {
        vm.claims.push({
          benefit: benefit
        });
      }
    };

    vm.setClaimRef = function (ClaimRef) {
      vm.ClaimRef = ClaimRef;
    }

    vm.setPayable = function (Payable) {
      vm.Payable = Payable;
    }

    vm.mapBenefits = function (benefitCode) {
      switch(benefitCode) {
        case "A1": 
          return "死亡保険金"
        case "A2": 
          return "後遺保険金"
        case "A3": 
          return "入院保険金"
        case "A4_a": 
          return "手術保険金(入院中)"
        case "A4_b": 
          return "手術保険金(それ以外)"
        case "B1": 
          return "賠償責任"
      }
    }    

    vm.mapErrors = function (errorCode) {
      switch(errorCode) {
        case "C1": 
          return "Insured name equal to injury person name"
        case "C2": 
          return "Check Accident occurred within the cover period"
        case "C3": 
          return "Validate accident can be classified as traffic accidents"
        case "C4": 
          return "Check Hospitalisation start date within 180 days after accident"
        case "C5": 
          return "Flag up if treatment not completed and potential further payments"
        case "C6": 
          return "Check surgery type covered within the policy term"
        case "C7": 
          return "Check surgery date within 180 days after accident"
        case "C8": 
          return "If surgery operate outside hospitalisation period"
        case "C9": 
          return "Confirm third party claimants not live with policyholder"
        case "C10": 
          return "Third Party liability amount exceed limit"
      }
    }

    vm.updateInformation = function(information, idx) {
      if(idx > -1) {
        vm.claims[idx] = _.extend(vm.claims[idx], information);
      } else {
        vm.claims[vm.claims.length - 1] = _.extend(vm.claims[vm.claims.length - 1], information);
      }
    };

    vm.setsparkTemplate = function(SparkTemplate) {
      vm.SparkTemplate = SparkTemplate;
    }

    vm.clear = function() {
      vm.ClaimBody = angular.fromJson(vm.ClaimBodyTemplate)
      vm.ClaimItemBody = angular.fromJson(vm.ClaimItemBodyTemplate)
      vm.ClaimAttachmentBody = angular.fromJson(vm.ClaimAttachmentBodyTemplate)
      vm.SparkTemplate = angular.fromJson(vm.SparkTemplateBlank)
    };
    
    vm.numberWithCommas = function (x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .controller('Claim9Controller', Claim9Controller);

  /** @ngInject */
  function Claim9Controller(ClaimService) {
    var vm = this;

    vm.reference = ClaimService.ClaimRef;

    vm.Payable = ClaimService.Payable;
  }
})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .controller('Claim8Controller', Claim8Controller);

  /** @ngInject */
  function Claim8Controller($state, $stateParams, ClaimService) {
    var vm = this;

    vm.information = {};

    vm.text1 = 'Confirm details';
    vm.text2 = 'Hospital Receipt';
    vm.text3 = 'Claim for';
    vm.text4 = '円'
    vm.btn1 = 'Confirm';

    vm.proceed = function() {
      $state.go('claim-3');
    };

    function init() {
      if($stateParams.id) {
        if(ClaimService.claims[parseInt($stateParams.id, 10)]) {
          vm.information = ClaimService.claims[parseInt($stateParams.id, 10)];

          if(_.isEmpty(vm.information.files)) {
            $state.go('claim-1');
          }
        } else {
          $state.go('claim-1');
        }
      } else if(!_.isEmpty(ClaimService.claims)) {
        vm.information = ClaimService.claims[ClaimService.claims.length - 1];

        if(_.isEmpty(vm.information.files)) {
          $state.go('claim-1');
        }
      } else {
        $state.go('claim-1');
      }

      vm.startDate = moment(vm.information.hospitalizationStartDate).format('DD MMMM YYYY');
      vm.endDate = moment(vm.information.hospitalizationEndDate).format('DD MMMM YYYY');
    }

    init();
  }
})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .controller('Claim7Controller', Claim7Controller);

  /** @ngInject */
  function Claim7Controller($state, $stateParams, ClaimService, Upload, configUrls, environment) {
    var vm = this;

    vm.information = {
      files: []
    };
    vm.ClaimBody = ClaimService.ClaimBody

    vm.text1 = '';
    vm.text2 = 'Document';
    vm.placeholder1 = 'Document description (eg accident proof, injury or illness proof document, etc.)';
    vm.text3 = 'No documents have been added yet. Click here to add documents.';
    vm.text4 = 'Add documents';

    vm.btn1 = 'Next: Claim Payment Details';

    // vm.text1 = '添付書類をアップロードする';
    // vm.text2 = '書類';
    // vm.placeholder1 = '書類の説明（例：事故証明、ケガまたは疾病を証明する書類、等）';
    // vm.text3 = 'まだ書類が追加されていません。書類を追加するにはここをクリックしてください。';
    // vm.text4 = '書類を追加する';

    // vm.btn1 = '次へすすむ';


    vm.uploadFiles = function (files) {
      if (files && files.length) {
        for (var i = 0; i < files.length; i++) {
          var file = files[i];
          Upload.upload({
            // url: 'https://general.sonic.dev.coherent.com.hk/general/v2/s3/fileupload',
            url: configUrls[environment].fileUpload,
            headers: {
              'Authorization': 'Bearer ' + configUrls[environment].token
            },
            data: {
              myFile: files[i]
            }
          }).then(function (resp) {
            var url = resp.data;
            vm.information.files.push(_.merge(_.pick(file, 'name', 'description'), {
              url: url
            }));
            var aa = []
            for(var i=0;i<vm.information.files.length;i++) {
              // console.log(vm.information.files[i].url)
              // console.log(vm.information.files[i].name)
              // console.log("{\"Url\":\"" + vm.information.files[i].url + "\",\"Descr\":\"" + vm.information.files[i].name + "\",\"AttachDate\":\"2020-07-28T09:40:36.940647435Z\",\"AttachNote\":{\"Dte\":\"2020-10-14T09:40:36.940647435Z\",\"User\":\"Hello\",\"Text\":\"claim add item doc attached\"}}")
              aa.push(angular.fromJson("{\"Url\":\"" + vm.information.files[i].url + "\",\"Descr\":\"" + vm.information.files[i].name + "\",\"AttachDate\":\"2020-07-28T09:40:36.940647435Z\",\"AttachNote\":{\"Dte\":\"2020-10-14T09:40:36.940647435Z\",\"User\":\"Hello\",\"Text\":\"claim add item doc attached\"}}"))
            }
            //console.log(vm.ClaimBody.Header.ClaimItems[0])
            vm.ClaimBody.Header.ClaimItems[0].Attachments = aa
            //console.log(vm.ClaimBody.Header.ClaimItems[0])
          }, function () {
            //console.log('error')
          }, function () {
            // progress handler
          });
        }
      }
    }

    vm.proceed = function() {
      ClaimService.setClaimBody(vm.ClaimBody)
      $state.go('claim-51');
    };

    // function init() {
    //   if($stateParams.id) {
    //     if(ClaimService.claims[parseInt($stateParams.id, 10)]) {
    //       vm.information = ClaimService.claims[parseInt($stateParams.id, 10)];
    //     } else {
    //       $state.go('claim-1');
    //     }
    //   } else if(!_.isEmpty(ClaimService.claims)) {
    //     vm.information = ClaimService.claims[ClaimService.claims.length - 1];

    //     vm.information.files = vm.information.files ? vm.information.files : [];
    //   } else {
    //     $state.go('claim-1');
    //   }
    // }

    // init();    
    function init() {
      if (!_.isEmpty(ClaimService.policyDetails)) {
          ClaimService.clear();
        } else {
          $state.go('policy-login');
        }
    }

    init();
  }
})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .controller('Claim6Controller', Claim6Controller);

  /** @ngInject */
  function Claim6Controller($state, $stateParams, ClaimService) {
    var vm = this;


    vm.a = ClaimService.ClaimBody

    vm.information = {};

    vm.text1 = 'Is the injured currently receiving treatment?';
    vm.btn1 = 'Yes';
    vm.btn2 = 'No';

    vm.text2 = 'Period of Hospitalization';
    vm.placeholder1 = '年 / 月 / 日';
    vm.placeholder3 = '年 / 月 / 日';

    vm.calendarFormat = 'yyyy / MM / dd';

    vm.maxHospitalDays = Math.round(ClaimService.policyDetails.Cont.Risks["1"].RiskBody.Benefit_Limits[2].PolicyLimit / 10000);

    vm.datepickerOptions1 = {
      showWeeks: false,
      minDate: moment(ClaimService.ClaimBody.Header.ClaimItems[0].ClaimEvent.EventStart).format('YYYY-MM-DD'),
      maxDate: moment()  
    };

    vm.datepickerOptions2 = {
      showWeeks: false,
      minDate: moment(vm.information.hospitalizationStartDate).format('YYYY-MM-DD'),
      maxDate: moment(vm.information.hospitalizationStartDate).add(vm.maxHospitalDays,'d').format('YYYY-MM-DD')  
    };

    vm.datepickerOptions3 = {
      showWeeks: false,
      minDate: vm.information.hospitalizationStartDate,
      maxDate: vm.information.hospitalizationEndDate 
    };

    vm.text3 = 'What treatment is the status of your treatment?';
    vm.treatments = [{
      display: 'Still in hospitalization',
      value: 'surgery 1'
    }, {
      display: 'Receiving outpatient treatment',
      value: 'surgery 2'
    }, {
      display: 'Treatment Completed',
      value: 'others'
    }];

    vm.text4 = 'What surgery did the injured get?';
    vm.placeholder4 = 'Choose surgery...';
    vm.surgeries = [{
      display: 'Surgery 1',
      value: 'surgery 1'
    }, {
      display: 'Surgery 2',
      value: 'surgery 2'
    }, {
      display: 'Others',
      value: 'others'
    }];

    vm.text5 = 'When was the surgery conducted?'
    vm.placeholder5 = '年 / 月 / 日';

    vm.btn3 = 'Continue';

    vm.setEndDateOptions = function () {
      vm.datepickerOptions2.minDate = moment(vm.information.hospitalizationStartDate).format('YYYY-MM-DD')
      vm.datepickerOptions2.maxDate = moment(vm.information.hospitalizationStartDate).add(vm.maxHospitalDays,'d').format('YYYY-MM-DD')
    }    

    vm.setSurgDateOptions = function () {
      vm.datepickerOptions3.minDate = moment(vm.information.hospitalizationStartDate).format('YYYY-MM-DD')
      vm.datepickerOptions3.maxDate = moment(vm.information.hospitalizationEndDate).format('YYYY-MM-DD')
      if (0 >= moment(vm.information.surgery).diff(moment(vm.information.hospitalizationEndDate))) {
        vm.information.surgery = vm.information.hospitalizationEndDate
      }
    }

    vm.proceed = function() {
      vm.a.Header.ClaimItems[0].ClaimEvent.EventStart = moment(vm.information.hospitalizationStartDate).format('YYYY-MM-DD')  + 'T13:23:45.871303Z'
      vm.a.Header.ClaimItems[0].ClaimEvent.EventEnd = moment(vm.information.hospitalizationEndDate).format('YYYY-MM-DD') + 'T13:23:45.871303Z'
      ClaimService.updateInformation(vm.information, $stateParams.id);
      ClaimService.setClaimBody(vm.a);

      $state.go('claim-7');
    };

    function init() {
      if($stateParams.id) {
        if(ClaimService.claims[parseInt($stateParams.id, 10)]) {
          vm.information = ClaimService.claims[parseInt($stateParams.id, 10)];
        } else {
          $state.go('claim-1');
        }
      } else if(!_.isEmpty(ClaimService.claims)) {
        vm.information = ClaimService.claims[ClaimService.claims.length - 1];
      } else {
        $state.go('claim-1');
      }
    }

    init();

  }
})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .controller('Claim5Controller', Claim5Controller);

  /** @ngInject */
  function Claim5Controller($state, $stateParams, ClaimService) {
    var vm = this;

    vm.polNo = ClaimService.polNo
    vm.information = {};
    vm.claimbody = ClaimService.ClaimBody;
    vm.policyDetails = ClaimService.policyDetails

    vm.text1 = 'To whom did this happen?';
    vm.placeholder1 = 'Name of injured person';
    vm.text2 = 'When did the accident/injury occur?';
    vm.placeholder2 = '年 / 月 / 日';

    vm.calendarFormat = 'YYYY-MM-DD';

    vm.datepickerOptions = {
      showWeeks: false,
      minDate: moment(ClaimService.policyDetails.Cont.StartDate),
      maxDate: moment()
    };

    vm.value1 = vm.policyDetails.Cont.Risks["1"].RiskBody.InsuredParty.Name;

    vm.text3 = 'Where did this happen?';
    vm.placeholder3 = 'Hospital or medical center';

    vm.text4 = 'What happened?';
    vm.placeholder4 = 'Describe the accident';

    vm.text5 = 'How much would you want to claim for?';
    vm.placeholder5 = 'Amount';

    vm.btn1 = 'Continue';

    vm.proceed = function() {
      ClaimService.updateInformation(vm.information, $stateParams.id);
      vm.claimbody.Header.ClaimItems[0].Claimant.PersonalDets.Name = vm.information.name;
      vm.claimbody.Header.ClaimItems[0].ClaimDate = moment().format("YYYY-MM-DD") + 'T13:23:45.871303Z';
      vm.claimbody.Header.ClaimItems[0].ClaimEvent.EventStart = moment(vm.information.date).format("YYYY-MM-DD") + 'T13:23:45.871303Z';
      vm.claimbody.Header.ClaimItems[0].ClaimEvent.EventDesc = "Location: " + vm.information.location + ", Description: " + vm.information.how;
      vm.claimbody.Header.ClaimItems[0].ClaimedAmount = vm.information.amount;

      $state.go('claim-6');
    };

    // function init() {
    //   if($stateParams.id) {
    //     if(ClaimService.claims[parseInt($stateParams.id, 10)]) {
    //       vm.information = ClaimService.claims[parseInt($stateParams.id, 10)];
    //     } else {
    //       $state.go('claim-2');
    //     }
    //   } else if(!_.isEmpty(ClaimService.claims)) {
    //     vm.information = ClaimService.claims[ClaimService.claims.length - 1];
    //   } else {
    //     $state.go('claim-2');
    //   }
    // }

    // init();
  }
})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .controller('Claim51Controller', Claim51Controller);

  /** @ngInject */
  function Claim51Controller($state, $stateParams, ClaimService, $http, configUrls, environment) {
    var vm = this;

    vm.claimbody = ClaimService.ClaimBody;
    vm.responses = {};

    vm.refundInitial = '0';

    vm.responses.bankName = 'SMBC'
    vm.responses.branchName = 'Shibuya'
    vm.responses.accountName = 'Taro Yamada'
    vm.responses.accountNumber = '1231234'
    vm.bankType = "bankType1"


    vm.button1 = "Submit Claim"

    vm.proceed = function() {
      vm.button1 = "Loading..."
      vm.claimbody.Header.Payee.Bank = vm.responses.bankName;
      vm.claimbody.Header.Payee.Branch = vm.responses.branchName;
      vm.claimbody.Header.Payee.AccountName = vm.responses.accountName;
      vm.claimbody.Header.Payee.Account = vm.responses.accountNumber;

      for (var a = 0; a < vm.claimbody.Header.ClaimItems.length; a++) {
        vm.claimbody.Header.ClaimItems[a].Payee.Bank = vm.responses.bankName;
        vm.claimbody.Header.ClaimItems[a].Payee.Branch = vm.responses.branchName;
        vm.claimbody.Header.ClaimItems[a].Payee.AccountName = vm.responses.accountName;
        vm.claimbody.Header.ClaimItems[a].Payee.Account = vm.responses.accountNumber;
      }

      vm.claimbody = vm.claimbody.Header;
      vm.btn1 ='Loading...'; 
      var req = {
        method: 'POST',
        // url: 'https://general.sonic.dev.coherent.com.hk/general/v2/claim/initiate',
        url: configUrls[environment].claimInitiate,
        data: angular.toJson(vm.claimbody)
      };
      if (configUrls[environment].isAuthorizationNeeded) {
        req.headers = {
          'authorization': 'Bearer ' + configUrls[environment].token
        }
      }
      
      $http(req)
        .then(function (response) {
          ClaimService.setClaimRef(response.data.data);
          $state.go('claim-9');
        }, function () {
      });

    }

    function init() {
      if (!_.isEmpty(ClaimService.policyDetails)) {
          ClaimService.clear();
        } else {
          $state.go('policy-login');
        }
    }

    init();
  }
})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .controller('Claim4Controller', Claim4Controller);

  /** @ngInject */
  function Claim4Controller($state, $stateParams, ClaimService) {
    var vm = this;

    vm.claimBodyTemplate = ClaimService.ClaimBody

    vm.benefit = '';

    vm.benefits = [
      {
        display: 'Death benefit',
        value: 'A1'
      },
      {
        display: 'Permanent disability insurance benefit',
        value: 'A2'
      },
      {
        display: 'Hospitalization insurance benefit',
        value: 'A3'
      },
      {
        display: 'Surgery insurance benefit (during hospitalization)',
        value: 'A4_a'
      },
      {
        display: 'Surgery insurance benefit (other)',
        value: 'A4_b'
      },
      {
        display: 'Personal Liability',
        value: 'B1'
      }
    ];

    vm.btn1 = 'Continue';

    vm.proceed = function() {
      ClaimService.setBenefit(_.find(vm.benefits, function(b)  {
        return b.value === vm.benefit;
      }), $stateParams.id);
      vm.claimBodyTemplate.Header.Contid = ClaimService.policyDetails.Cont.ContID;
      vm.claimBodyTemplate.Header.ClaimItems[0].Benefit = ClaimService.claims[0].benefit.value;
      ClaimService.setClaimBody(vm.claimBodyTemplate)

      $state.go('claim-5');
    };

    function init() {
      if($stateParams.id >= 0) {
        if(ClaimService.claims[parseInt($stateParams.id, 10)]) {
          vm.benefit = ClaimService.claims[parseInt($stateParams.id, 10)].benefit.value;
        } else {
          $state.go('claim-1');
        }
      } else if($stateParams.id !== '-1') {
        $state.go('claim-1');
      }
    }

    init();
  }
})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .controller('Claim3Controller', Claim3Controller);

  /** @ngInject */
  function Claim3Controller($state, ClaimService, $http, configUrls, environment) {
    var vm = this;

    vm.polNo = ClaimService.polNo
    vm.claims = [];

    vm.text1 = 'Personal Accident';
    vm.text2 =  'Policy no. ' + vm.polNo;

    vm.text3 = 'What would you like to claim for?';

    vm.text4 = 'No benefits have been added yet. Click here to add benefits.';

    vm.text5 = '+ Add a benefit';
    vm.btn1 = 'Complete';

    vm.edit = function(id) {
      $state.go('claim-4', {id: id})
    };

    vm.add = function () {
      $state.go('claim-4', {id: -1});
    };

    vm.proceed = function() {
      vm.btn1 ='Loading...'; 
      var attachment = ClaimService.ClaimBody;
      attachment.Header.ClaimItems[0].ClaimedAmount = parseInt(attachment.Header.ClaimItems[0].ClaimedAmount);
      attachment = attachment.Header;
      var req = {
        method: 'POST',
        // url: 'https://general.sonic.dev.coherent.com.hk/general/v2/claim/initiate',
        url: configUrls[environment].claimInitiate,
        data: attachment
      };
      if (configUrls[environment].isAuthorizationNeeded) {
        req.headers = {
          'authorization': 'Bearer ' + configUrls[environment].token
        }
      }
      $http(req)
        .then(function (response) {
          ClaimService.setClaimRef(response.data.ClaimRef);
          $state.go('claim-9');
        }, function () {
      });

    }

    function init() {
      if(ClaimService.claims.length > 0) {
        vm.claims = ClaimService.claims;
      }
    }

    init();
  }
})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .controller('Claim2Controller', Claim2Controller);

  /** @ngInject */
  function Claim2Controller($state, ClaimService, PolicyService) {
    var vm = this;

    ClaimService.setPolicyDetails(PolicyService.policyDetails)
    ClaimService.setPolNo(PolicyService.polNo)

    vm.polNo = ClaimService.polNo
    vm.policyDetails = ClaimService.policyDetails

    vm.policies = [{
      name: 'Personal Accident',
      number: 'Policy no. ' + vm.polNo,
      type: 'Family Plan',
      amount: '8,320円 monthly',
      color: 'green',
      img: 'assets/images/purple-siren.png',
      code: 'cycle'
    },{
      name: 'Travel',
      number: 'Policy no. 51007779',
      type: 'Couple Plan',
      amount: '3,000円 monthly',
      color: 'skyblue',
      img: '/assets/images/l-blue-bag.png',
      code: 'travel'
    },{
      name: 'Motor Insurance',
      number: 'Policy no. 51002303',
      type: 'Individual Plan',
      amount: '4,770円 monthly',
      color: 'blue',
      img: '/assets/images/d-blue-car.png',
      code: 'motor'
    }];

    vm.btn1 = 'Continue'

    function init() {
      if (!_.isEmpty(ClaimService.policyDetails)) {
        ClaimService.clear();
      } else {
        $state.go('policy-login');
      }
    }

    init();
  }
})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .controller('CommonPurchase7Controller', ctrl);

  /** @ngInject */
  function ctrl($log,
                $state,
                PurchaseService) {
    var vm = this;

    vm.ui = {};

    function init() {
      if (!PurchaseService.policy.number) {
        $log.debug('policy number is not defined. redirecting to step 1');
        $state.go('products');
        return;
      }

      vm.ui.policyNumber = PurchaseService.policy.number;
    }

    init();

    return vm;
  }
})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .controller('CommonPurchase6Controller', ctrl);

  /** @ngInject */
  function ctrl($log,
                $state,
                ACCIDENT_TYPE,
                HOME_TYPE,
                DATE_FORMAT,
                PURCHASE_PAYLOAD,
                TRAVEL_TYPE,
                PurchaseFactory,
                PurchaseService,
                PolicyService) {
    var vm = this;

    vm.ui = {
      cardName: 'Scott Miller',
      cardNumber: '5467-4675-0090-3434',
      cardExpiryMM: '11',
      cardExpiryYY: '25'
    };

    vm.proceed = function() {
      PurchaseFactory.purchase(generatePayload()).then(function (data) {
        var policyNumber = data.data.PolicyID;
        PurchaseService.policy.number = policyNumber;
        PolicyService.policies = [{
          number: policyNumber
        }];
        $state.go('common-purchase-7');
      });
    };

    function generatePayload() {
      var payload = angular.copy(PURCHASE_PAYLOAD[PurchaseService.policy.type]);
      var policy = PurchaseService.policy;

      payload.Header.Agent = policy.agentCode;
      payload.Header.Email = policy.email;
      payload.Header.InstallmentPremium = policy.specs.installmentPermium;
      payload.Header.Mandate.CreditCard.CardNumber = vm.ui.cardNumber;
      payload.Header.Mandate.CreditCard.ExpiryMonth = vm.ui.expiryMM;
      payload.Header.Mandate.CreditCard.ExpityYear = vm.ui.expiryYY;
      payload.Header.Owner.Contact.Add.Add1 = policy.address;
      payload.Header.Owner.Contact.Add.Pcode = policy.postalCode1 + '-' + policy.postalCode2;
      payload.Header.Owner.Contact.Email = policy.email;
      payload.Header.Owner.Contact.FbId = policy.fbId;
      payload.Header.Owner.Contact.Phone = policy.contact;
      payload.Header.Owner.Dob = moment(policy.birthDate).format(DATE_FORMAT);
      payload.Header.Owner.Gender = policy.gender;
      payload.Header.Owner.Name = policy.name;
      payload.Header.StartDate = moment(policy.insuranceDate).format('YYYY-MM-DDThh:mm:ss.ssssss') + 'Z';
      payload.Risks[0].CoverType = policy.carrier + ':' + policy.type;
      payload.Risks[0].RiskBody.InsuredParty.Dob = moment(policy.birthDate).format(DATE_FORMAT);
      payload.Risks[0].RiskBody.InsuredParty.Gender = policy.gender;
      payload.Risks[0].RiskBody.InsuredParty.Name = policy.name;
      payload.Risks[0].RiskBody.Plan = policy.specs.planType
      payload.Risks[0].RiskBody.Planlevel = policy.specs.planLevel;
      payload.Risks[0].RiskBody.Risk_Comm = moment(policy.insuranceDate).format('YYYY-MM-DDThh:mm:ss.ssssss') + 'Z';
      payload.Risks[0].Risk_Comm = moment(policy.insuranceDate).format('YYYY-MM-DDThh:mm:ss.ssssss') + 'Z';
      if (PurchaseService.policy.type === TRAVEL_TYPE) {
        payload.Risks[0].RiskBody.Options = policy.specs.optionalBenefits ? _.map(policy.specs.optionalBenefits, function(benefit) {
          return {
            Option: benefit.name,
            Descr: benefit.label,
            Included: benefit.enabled ? 'Y' : 'N',
            SumInsured: benefit.enabled ? parseFloat(benefit.value) : 0
          };
        }) : [];
        payload.Risks[0].RiskBody.Self = policy.specs.myself ? 'Y' : 'N';
        payload.Risks[0].Self = policy.specs.myself ? 'Y' : 'N';
        payload.Risks[0].RiskBody.Spouse = policy.specs.spouse ? 'Y' : 'N';
        payload.Risks[0].Spouse = policy.specs.spouse ? 'Y' : 'N';
        payload.Risks[0].RiskBody.Nadults = policy.specs.totalAdults;
        payload.Risks[0].Nadults = policy.specs.totalAdults;
        payload.Risks[0].RiskBody.Nchildren = policy.specs.additionalChildren;
        payload.Risks[0].Nchildren = policy.specs.additionalChildren;
        payload.Risks[0].RiskBody.Risk_End = moment(policy.specs.arrivalDate).format('YYYY-MM-DDThh:mm:ss.ssssss') + 'Z';
        payload.Risks[0].Risk_End = moment(policy.specs.arrivalDate).format('YYYY-MM-DDThh:mm:ss.ssssss') + 'Z';
      }
      if (PurchaseService.policy.type === HOME_TYPE) {
        // load the yes / no ansers to the payload
        
        for(var i=0;i<PurchaseService.policy.specs.benefitSelection.length;i++) {
          // find corresponding item in payload
          // make it Included = "Y"
          var a = payload.Risks[0].RiskBody.Options.find(function(o) { o.Option === PurchaseService.policy.specs.benefitSelection[i].Option_Name });
          
          
          
          var b = payload.Risks[0].RiskBody.Options.indexOf(a);
          
          
          
          if (a) {
            payload.Risks[0].RiskBody.Options[b].Included = PurchaseService.policy.specs.benefitSelection[i].enabled ? 'Y' : 'N'
          };
        };
        
      };
      return payload;
    }

    function init() {
      PurchaseService.debug();
      if (!PurchaseService.policy.type) {
        $log.debug('policy type is not defined. redirecting to step 1');
        // $state.go('products');
        // return;
      } else if (PurchaseService.policy.type === ACCIDENT_TYPE && !PurchaseService.policy.relationship) {
        $log.debug('relationship is not defined. redirecting to step 1');
        // $state.go('products');
        // return;
      } else if (PurchaseService.policy.type === TRAVEL_TYPE && !PurchaseService.policy.email) {
        $log.debug('email is not defined. redirecting to products');
        // $state.go('products');
        // return;
      }
    }

    init();

    return vm;
  }
})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .controller('CommonPurchase5Controller', ctrl);

  /** @ngInject */
  function ctrl($log,
                $state,
                ACCIDENT_TYPE,
                TRAVEL_TYPE,
                HOME_TYPE,
                PurchaseFactory,
                PurchaseService) {
    var vm = this;

    vm.ui = {};

    vm.opts = {
      ACCIDENT_TYPE: ACCIDENT_TYPE,
      TRAVEL_TYPE: TRAVEL_TYPE
    };

    vm.proceed = function() {
      $state.go('common-purchase-6');
    };

    function init() {
      PurchaseService.debug();
      vm.ui.type = PurchaseService.policy.type;
      console.log(vm.ui.type === HOME_TYPE)
      if (!vm.ui.type) {
        $log.debug('type is not defined. redirecting to products');
        // $state.go('products');
        // return;
      }

      if (vm.ui.type === ACCIDENT_TYPE) {
        if (!PurchaseService.policy.relationship) {
          $log.debug('relationship is not defined. redirecting to products');
          // $state.go('products');
          // return;
        }
      }

      if (vm.ui.type === TRAVEL_TYPE) {
        if (!PurchaseService.policy.email) {
          $log.debug('email is not defined. redirecting to products');
          // $state.go('products');
          // return;
        }

        vm.ui.optionalBenefits = PurchaseService.policy.specs.optionalBenefits;
      }

      if (vm.ui.type === HOME_TYPE) {
        vm.ui.benefitSelection = PurchaseService.policy.specs.benefitSelection;
      }

      vm.ui.planType = PurchaseService.policy.specs.planType;
      vm.ui.plan = PurchaseService.policy.specs.plan;
      vm.ui.planDetails = PurchaseService.policy.specs.planDetails;

      vm.opts = _.merge(vm.opts, PurchaseFactory.opts[PurchaseService.policy.type]);
    }

    init();

    return vm;
  }
})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .controller('CommonPurchase4Controller', ctrl);

  /** @ngInject */
  function ctrl($log,
                $state,
                CALENDAR_FORMAT,
                PurchaseFactory,
                PurchaseService) {
    var vm = this;

    vm.ui = {};

    vm.relationships = PurchaseFactory.relationships;

    vm.opts = {
      calendarFormat: CALENDAR_FORMAT,
      datepickerOptions: {
        showWeeks: false
      }
    };

    vm.proceed = function () {
      PurchaseService.policy.relationship = vm.ui.relationship;
      $state.go('common-purchase-5');
    };

    function init() {
      if (!PurchaseService.policy.email) {
        $log.debug('email is not defined. redirecting to products');
        $state.go('products');
        return;
      }
    }

    init();
  }
})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .controller('CommonPurchase3Controller', ctrl);

  /** @ngInject */
  function ctrl($log,
                $state,
                PurchaseService) {
    var vm = this;

    vm.proceed = function () {
      $state.go('common-purchase-4')
    };

    function init() {
      PurchaseService.debug();

      if(!PurchaseService.policy.email) {
        $log.debug('email is not defined. redirecting to products');
        $state.go('products');
        return;
      }
    }

    init();

    return vm;
  }
})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .controller('CommonPurchase2Controller', ctrl);

  /** @ngInject */
  function ctrl($log,
                $state,
                ACCIDENT_TYPE,
                TRAVEL_TYPE,
                HOME_TYPE,
                CALENDAR_FORMAT,
                PURCHASE_MIN_BIRTH_DATE,
                PURCHASE_MAX_BIRTH_DATE,
                PurchaseService) {
    var vm = this;

    vm.ui = {};

    vm.opts = {
      calendarFormat: CALENDAR_FORMAT,
      datepickerOptions: {
        showWeeks: false,
        minDate: PURCHASE_MIN_BIRTH_DATE,
        maxDate: PURCHASE_MAX_BIRTH_DATE
      }
    };

    vm.proceed = function () {
      if (!PurchaseService.signedIn) {
        PurchaseService.policy.email = vm.ui.email;
      }

      PurchaseService.policy.name = vm.ui.name;
      PurchaseService.policy.birthDate = vm.ui.birthDate;
      PurchaseService.policy.gender = vm.ui.gender;
      PurchaseService.policy.postalCode1 = vm.ui.postalCode1;
      PurchaseService.policy.postalCode2 = vm.ui.postalCode2;
      PurchaseService.policy.address = vm.ui.address;
      PurchaseService.policy.alternateEmail = vm.ui.alternateEmail;
      PurchaseService.policy.contact = vm.ui.contact;
      PurchaseService.policy.alternateContact = vm.ui.alternateContact;
      if(PurchaseService.policy.type === ACCIDENT_TYPE) {
        $state.go('common-purchase-3');
      } else if(PurchaseService.policy.type === TRAVEL_TYPE) {
        $state.go('common-purchase-5');
      } else if(PurchaseService.policy.type === HOME_TYPE) {
        $state.go('common-purchase-5');
      }
    };

    function init() {
      PurchaseService.debug();
      if(!PurchaseService.policy.specs.planType) {
        $log.debug('plan type is not defined. redirecting to products');
        $state.go('products');
        return;
      }

      vm.ui.signedIn = PurchaseService.signedIn;

      vm.ui.name = PurchaseService.policy.name;
      vm.ui.birthDate = PurchaseService.policy.birthDate && moment(PurchaseService.policy.birthDate).toDate();
      vm.ui.gender = PurchaseService.policy.gender;
      vm.ui.postalCode1 = PurchaseService.policy.postalCode1;
      vm.ui.postalCode2 = PurchaseService.policy.postalCode2;
      vm.ui.address = PurchaseService.policy.address;
      vm.ui.email = PurchaseService.policy.email;
      vm.ui.contact = PurchaseService.policy.contact;
      vm.ui.gender = 'M';
    }

    init();

    return vm;
  }
})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .controller('CommonPurchase1Controller', ctrl);

  /** @ngInject */
  function ctrl($log,
                $state,
                PurchaseFactory,
                PurchaseService) {
    var vm = this;

    vm.ui = {};

    vm.ui.email = 'mark@email.com'

    vm.signIn = function () {
      PurchaseFactory.signIn(500).then(function (data) {
        PurchaseService.signedIn = true;

        PurchaseService.policy.email = vm.ui.email;

        PurchaseService.policy.name = data.name;
        PurchaseService.policy.birthDate = data.birthDate;
        PurchaseService.policy.gender = data.gender;
        PurchaseService.policy.postalCode1 = data.postalCode1;
        PurchaseService.policy.postalCode2 = data.postalCode2;
        PurchaseService.policy.address = data.address;
        PurchaseService.policy.contact = data.contact;

        $state.go('common-purchase-2');
      });
    };

    vm.skip = function () {
      $state.go('common-purchase-2');
    };

    function init() {
      PurchaseService.debug();

      if(!PurchaseService.policy.specs.planType) {
        $log.debug('plan type is not defined. redirecting to step 1');
        $state.go('products');
        return;
      };

      if(!PurchaseService.policy.email) { 
        vm.ui.email = PurchaseService.policy.email; 
      };
      vm.ui.email = 'mark@email.com'
    }

    init();

    return vm;
  }
})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .service('CommonPurchaseService', svc);

  /** @ngInject */
  function svc($log) {
    var vm = this;

    vm.signedIn = false;

    vm.policy = {};

    vm.reset = function () {
      vm.policy = {
        // output
        number: null,

        // parameters
        agentCode: '10008',
        fbId: null,

        // input
        type: null,

        // accident
        specs: {},

        // travel

        email: null,
        name: null,
        birthDate: null,
        gender: null,
        postalCode1: null,
        postalCode2: null,
        address: null,
        contact: null,
        relationship: null
      };
    };

    vm.debug = function () {
      $log.debug(vm.policy);
    };

    return vm;
  }
})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .controller('AccidentPurchase4Controller', ctrl);

  /** @ngInject */
  function ctrl($log,
                $state,
                ACCIDENT_TYPE,
                ACCIDENT_FOLDER,
                ACCIDENT_PLANS_PAYLOAD,
                AccidentPurchaseFactory,
                AccidentPurchaseService,
                PurchaseFactory,
                PurchaseService) {
    var vm = this;

    vm.ui = {};

    vm.select = function (planType) {
      vm.ui.planTypeId = planType.id;
      vm.ui.planType = planType;
    };

    vm.proceed = function () {
      PurchaseService.policy.type = ACCIDENT_TYPE;
      PurchaseService.policy.carrier = ACCIDENT_FOLDER;
      PurchaseService.policy.specs = AccidentPurchaseService.policy;
      PurchaseService.policy.specs.planType = vm.ui.planType.code
      PurchaseService.policy.specs.planDetails = vm.ui.planType
      console.log(PurchaseService.policy.specs.planDetails)
      PurchaseService.policy.specs.installmentPermium = vm.ui.planType.price
      //AccidentPurchaseService.policy.planType = vm.ui.planType;

      $state.go('purchase-1');
    };

    function loadPlans() {
      vm.ui.planType = AccidentPurchaseService.policy.planType;
      vm.ui.planTypes = _.map(AccidentPurchaseFactory.planTypes, function (planType) {
        planType.components = angular.copy(AccidentPurchaseFactory.planTypeComponents);
        return planType;
      });

      PurchaseFactory.token().then( function(token) {
        angular.forEach(vm.ui.planTypes, function (planType, idx) {
          PurchaseFactory.get(ACCIDENT_TYPE, ACCIDENT_FOLDER, generatePayload(planType.code), token).then(function (data) {
            var prices = data.data.data.Outputs;
            vm.ui.planTypes[idx].price = prices.BasePremium;
            vm.ui.planTypes[idx].components[0].price = prices.BenefitLimits[0].ClaimLimit;
            vm.ui.planTypes[idx].components[1].price = prices.BenefitLimits[1].ClaimLimit;
            vm.ui.planTypes[idx].components[2].price = prices.BenefitLimits[2].DailyLimit;
            vm.ui.planTypes[idx].components[3].subComponents[0].price = prices.BenefitLimits[3].ClaimLimit;
            vm.ui.planTypes[idx].components[3].subComponents[1].price = prices.BenefitLimits[4].ClaimLimit;
            vm.ui.planTypes[idx].components[4].price = prices.BenefitLimits[5].ClaimLimit;
          });
        });
      });
    }

    function generatePayload(code) {
      var payload = angular.copy(ACCIDENT_PLANS_PAYLOAD);
      payload.Inputs.Plan = code;
      payload.Inputs.Coverage = 'Insured_' + AccidentPurchaseService.policy.plan.coverage;
      return payload;
    }

    function init() {
      AccidentPurchaseService.debug();

      if(!AccidentPurchaseService.policy.plan) {
        $log.debug('plan is not defined. redirecting to step 1');
        $state.go('accident-purchase-1');
        return;
      }

      loadPlans();
    }

    init();

    return vm;
  }
})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .controller('AccidentPurchase3Controller', ctrl);

  /** @ngInject */
  function ctrl($log,
                $state,
                AccidentPurchaseFactory,
                AccidentPurchaseService) {
    var vm = this;

    vm.ui = {};

    vm.isString = angular.isString;
    vm.isObject = angular.isObject;

    vm.proceed = function () {
      $state.go('accident-purchase-4');
    };

    function init() {
      AccidentPurchaseService.debug();

      if(!AccidentPurchaseService.policy.plan) {
        $log.debug('plan is not defined. redirecting to step 1');
        $state.go('accident-purchase-1');
        return;
      }

      vm.ui.plan = AccidentPurchaseService.policy.plan;
    }

    init();

    return vm;
  }
})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .controller('AccidentPurchase2Controller', ctrl);

  /** @ngInject */
  function ctrl($state,
                $log,
                AccidentPurchaseFactory,
                AccidentPurchaseService) {
    var vm = this;

    vm.plans = AccidentPurchaseFactory.plans;

    vm.proceed = function(plan) {
      AccidentPurchaseService.policy.plan = plan;

      $state.go('accident-purchase-3');
    };

    function init() {
      AccidentPurchaseService.debug();

      if(!AccidentPurchaseService.policy.insuranceDate) {
        $log.debug('insurance date is not defined. redirecting to step 1');
        $state.go('accident-purchase-1');
        return;
      }
    }

    init();

    return vm;
  }
})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .controller('AccidentPurchase1Controller', AccidentPurchase1Controller);

  /** @ngInject */
  function AccidentPurchase1Controller($log, $state, ACCIDENT_TYPE, CALENDAR_FORMAT, DATE_FORMAT, AccidentPurchaseService) {
    var vm = this;

    vm.ui = {};

    vm.opts = {
      calendarFormat: CALENDAR_FORMAT,
      datepickerOptions: {
        showWeeks: false,
        minDate: moment(),
        maxDate: moment().add(30, 'd')
      }
    };

    vm.proceed = function() {
      AccidentPurchaseService.policy.insuranceDate = moment(vm.ui.insuranceDate).format(DATE_FORMAT);

      $state.go('accident-purchase-2');
    };

    function init() {
      AccidentPurchaseService.debug();

      vm.ui.checkbox = !!AccidentPurchaseService.policy.insuranceDate;
      vm.ui.insuranceDate = AccidentPurchaseService.policy.insuranceDate && moment(AccidentPurchaseService.policy.insuranceDate).toDate();
    }

    init();

    return vm;
  }
})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .service('AccidentPurchaseService', AccidentPurchaseService);
  
  /** @ngInject */
  function AccidentPurchaseService($log) {
    var vm = this;

    vm.policy = {};

    vm.reset = function () {
      vm.policy = {
        insuranceDate: null,
        plan: null,
        planType: null
      };
    };

    vm.debug = function () {
      $log.debug(vm.policy);
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .factory('AccidentPurchaseFactory', AccidentPurchaseFactory);

  /** @ngInject */
  function AccidentPurchaseFactory() {
    var vm = this;

    vm.plans = {
      individual: {
        title: 'purchase_individual_plan_title',
        description: 'purchase_individual_plan_description',
        image: '/assets/images/accident/individual-plan-1.png',
        injuryGuaranteeCoverages: [{
          title: 'purchase_themselves',
          descriptions: {
            'purchase_themselves_under_69_years': [],
            'purchase_themselves_any_of_their': [
              'purchase_policy_owner',
              'purchase_spouse',
              'purchase_child',
              'purchase_parent_grandparent'
            ]
          }
        }],
        guaranteeLiabilityCoverages: [{
          title: 'purchase_policy_owner',
          details: [
            'purchase_same_person_insured'
          ],
          image: '/assets/images/coverage-policy-owner.png'
        }],
        apply: 'purchase_apply_for_individual_plan',
        coverage: 1
      },
      marriedCouple: {
        title: 'purchase_married_couple_title',
        description: 'purchase_married_couple_description',
        image: '/assets/images/accident/married-couple-plan-1.png',
        injuryGuaranteeCoverages: [{
          title: 'purchase_themselves',
          descriptions: {
            'purchase_themselves_under_69_years': [],
            'purchase_themselves_any_of_their': [
              'purchase_policy_owner',
              'purchase_spouse',
              'purchase_child',
              'purchase_parent_grandparent'
            ]
          }
        },{
          title: 'purchase_spouse',
          descriptions: {
            'purchase_spouse_insured': []
          }
        }],
        guaranteeLiabilityCoverages: [{
          title: 'purchase_policy_owner',
          details: [
            'purchase_same_person_insured'
          ],
          image: '/assets/images/coverage-policy-owner.png'
        },{
          title: 'purchase_spouse',
          details: [
            'purchase_spouse_insured'
          ],
          image: '/assets/images/coverage-spouse.png'
        }],
        apply: 'purchase_apply_for_married_plan',
        coverage: 2
      },
      family: {
        title: 'purchase_family_plan_title',
        description: 'purchase_family_plan_description',
        image: '/assets/images/accident/family-plan-1.png',
        injuryGuaranteeCoverages: [{
          title: 'purchase_themselves',
          descriptions: {
            'purchase_themselves_under_69_years': [],
            'purchase_themselves_any_of_their': [
              'purchase_policy_owner',
              'purchase_spouse',
              'purchase_child',
              'purchase_parent_grandparent'
            ]
          }
        },{
          title: 'purchase_spouse',
          descriptions: {
            'purchase_spouse_insured': []
          }
        },{
          title: 'purchase_insured_individuals_relatives',
          descriptions: {
            'purchase_family_insured': []
          }
        }],
        guaranteeLiabilityCoverages: [{
          title: 'purchase_policy_owner',
          details: [
            'purchase_same_person_insured'
          ],
          image: '/assets/images/coverage-policy-owner.png'
        },{
          title: 'purchase_spouse',
          details: [
            'purchase_spouse_insured'
          ],
          image: '/assets/images/coverage-spouse.png'
        },{
          title: 'purchase_insured_individuals_relatives',
          details: [
            'purchase_family_insured'
          ],
          image: '/assets/images/coverage-other-relatives.png'
        }],
        apply: 'purchase_apply_for_family_plan',
        coverage: 3
      }
    };

    vm.planTypes = [{
      id: 1,
      code: 'Plan1',
      title: 'purchase_basic',
      description: 'purchase_one_year_insurance_period',
      price: 'purchase_price_loading'
    },{
      id: 2,
      code: 'Plan2',
      title: 'purchase_relief',
      description: 'purchase_one_year_insurance_period',
      price: 'purchase_price_loading'
    },{
      id: 3,
      code: 'Plan3',
      title: 'purchase_complete',
      description: 'purchase_one_year_insurance_period',
      price: 'purchase_price_loading'
    }];

    vm.planTypeComponents = [{
      label: 'purchase_death',
      price: 'purchase_price_loading'
    },{
      label: 'purchase_residual_disability',
      price: 'purchase_price_loading'
    },{
      label: 'purchase_daily_hospitalization',
      price: 'purchase_price_loading'
    },{
      label: 'purchase_surgical_insurance',
      subComponents: [{
        label: 'purchase_in_hospital',
        price: 'purchase_price_loading'
      },{
        label: 'purchase_other_than_in_hospital',
        price: 'purchase_price_loading'
      }]
    },{
      label: 'purchase_liability',
      price: 'purchase_price_loading'
    }];

    return vm;
  }
})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')

    .constant('ACCIDENT_TYPE', 'PA')
    .constant('ACCIDENT_FOLDER', 'HSBCGI')
    .constant('ACCIDENT_PLANS_PAYLOAD', {"Inputs":{"AllocatePremium":66,"BillPeriodEnd":"2022-07-09","BillPeriodStart":"2021-07-09","BrokerID":10013,"CancelAllocatedPremium":3000,"CancellationDate":"2021-08-09","CancelRef":"customer-not required","Channel":"Agent","ClaimAmount":[{"Sno":1,"Benefit":"A3","Amount":7878,"EventStart":"20/11/2028","EventEnd":"21/11/2028","EventType":null,"Claimant":null,"NewClaimLimit":null},{"Sno":2,"Benefit":null,"Amount":11,"EventStart":"20/11/2028","EventEnd":"22/11/2028","EventType":null,"Claimant":null,"NewClaimLimit":null},{"Sno":3,"Benefit":null,"Amount":null,"EventStart":null,"EventEnd":null,"EventType":null,"Claimant":null,"NewClaimLimit":null}],"ClaimApproveAmount":400000,"ClaimHistory":[{"BenefitClaimed":"A3","ClaimDate":null,"EventStart":null,"EventEnd":null,"Amount":100,"Claimant":null}],"ClaimRef":"CLM0001","ClaimRejectAmount":null,"ClaimStatus":"initiate","ClaimToDate":[],"ClmStatus":"Initiate","Cover_Start_Date":"2028-09-07","Coverage":"Insured_1","DOB":"1980-01-01","EventDate":"2021-11-08","Gender":"Male","Optional_Benefits":[{"Option":"Insured_1","Included":"Y"}],"PaymentFrequency":12,"Plan":"Plan2","Policy_Cover_QuoteDate":"2021-07-01","PolicyNo":"RKT-B-21-010190","PostalCode":"064-0806","PremiumBilled":null,"PromoCode":"save","Puchase_Date":null,"Ratings":[{"RatingFactor":"RakutenPoints","Value":20}],"Reference2":"c2f79b84e5d0374db04dc294f0ec93a20ecd88deb623b93e5502eb1fc2d0fbd1","Term":1,"Underwriting_Response":[{"UWSurveyCode":"PA_UW_1","UWSurveyResponse":"Y"},{"UWSurveyCode":"PA_UW_2","UWSurveyResponse":"Y"},{"UWSurveyCode":"PA_UW_3","UWSurveyResponse":null},{"UWSurveyCode":"PA_UW_4","UWSurveyResponse":null},{"UWSurveyCode":"PA_UW_5","UWSurveyResponse":null},{"UWSurveyCode":"PA_UW_6","UWSurveyResponse":null},{"UWSurveyCode":"PA_UW_7","UWSurveyResponse":null},{"UWSurveyCode":"PA_UW_8","UWSurveyResponse":null},{"UWSurveyCode":"PA_UW_9","UWSurveyResponse":null},{"UWSurveyCode":"PA_UW_10","UWSurveyResponse":null},{"UWSurveyCode":"PA_UW_11","UWSurveyResponse":null},{"UWSurveyCode":"PA_UW_12","UWSurveyResponse":null},{"UWSurveyCode":"PA_UW_13","UWSurveyResponse":null},{"UWSurveyCode":"PA_UW_14","UWSurveyResponse":null},{"UWSurveyCode":"PA_UW_15","UWSurveyResponse":null},{"UWSurveyCode":"PA_UW_16","UWSurveyResponse":null},{"UWSurveyCode":"PA_UW_17","UWSurveyResponse":null},{"UWSurveyCode":"PA_UW_18","UWSurveyResponse":null},{"UWSurveyCode":"PA_UW_19","UWSurveyResponse":null},{"UWSurveyCode":"PA_UW_20","UWSurveyResponse":null}]},"TransactionDate":"2022-03-23T15:49:40.911Z","EngineType":"Type3","Images":[],"Reports":[],"Solves":[]});

})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log, $rootScope, $timeout, $translate, $window) {
    var unregisterState = $rootScope.$on('$stateChangeSuccess', function() {
      $timeout(function () {
        $window.scrollTo(0, 0);
      }, 10);
    });

    $rootScope.$on('$destroy', unregisterState);

    $log.debug('runBlock end');
  }

})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $locationProvider, $urlRouterProvider) {
    $locationProvider.html5Mode(true);

    $stateProvider
      .state('main', {
        url: '/',
        templateUrl: 'app/main/main.html',
        controller: 'MainController',
        controllerAs: 'main'
      });
      
    $stateProvider
      .state('products', {
        url: '/products',
        templateUrl: 'app/products/products.html',
        controller: 'ProductsController',
        controllerAs: 'products'
      });

    $stateProvider
      .state('purchase-get-started', {
        url: '/get-started',
        templateUrl: 'app/purchase/purchase-getstarted.html',
        controller: 'PurchaseGetStartedController',
        controllerAs: 'purchase'
      })
      .state('purchase-1-viber', {
        url: '/purchases/1?vid&agent',
        templateUrl: 'app/purchase/purchase-1.html',
        controller: 'Purchase1Controller',
        controllerAs: 'purchase'
      })
      .state('purchase-1', {
        url: '/purchases/1',
        templateUrl: 'app/purchase/purchase-1.html',
        controller: 'Purchase1Controller',
        controllerAs: 'purchase'
      })
      .state('purchase-embedded', {
        url: '/purchases/embedded',
        templateUrl: 'app/purchase/purchase-embedded.html',
        controller: 'PurchaseEmbeddedController',
        controllerAs: 'purchase'
      })
      // .state('purchase-1-agent', {
      //   url: '/purchases/1/:agent',
      //   templateUrl: 'app/purchase/purchase-1.html',
      //   controller: 'Purchase1Controller',
      //   controllerAs: 'purchase'
      // })
      .state('purchase-2', {
        url: '/purchases/2',
        templateUrl: 'app/purchase/purchase-2.html',
        controller: 'Purchase2Controller',
        controllerAs: 'purchase'
      })
      .state('purchase-3', {
        url: '/purchases/3',
        templateUrl: 'app/purchase/purchase-3.html',
        controller: 'Purchase3Controller',
        controllerAs: 'purchase'
      })
      .state('purchase-4', {
        url: '/purchases/4',
        templateUrl: 'app/purchase/purchase-4.html',
        controller: 'Purchase4Controller',
        controllerAs: 'purchase'
      })
      .state('purchase-5', {
        url: '/purchases/5',
        templateUrl: 'app/purchase/purchase-5.html',
        controller: 'Purchase5Controller',
        controllerAs: 'purchase'
      })
      .state('purchase-6', {
        url: '/purchases/6',
        templateUrl: 'app/purchase/purchase-6.html',
        controller: 'Purchase6Controller',
        controllerAs: 'purchase'
      })
      .state('purchase-7', {
        url: '/purchases/7',
        templateUrl: 'app/purchase/purchase-7.html',
        controller: 'Purchase7Controller',
        controllerAs: 'purchase'
      })
      .state('purchase-8', {
        url: '/purchases/8',
        templateUrl: 'app/purchase/purchase-8.html',
        controller: 'Purchase8Controller',
        controllerAs: 'purchase'
      })
      .state('purchase-9', {
        url: '/purchases/9',
        templateUrl: 'app/purchase/purchase-9.html',
        controller: 'Purchase9Controller',
        controllerAs: 'purchase'
      })
      .state('purchase-91', {
        url: '/purchases/91',
        templateUrl: 'app/purchase/purchase-9.1.html',
        controller: 'Purchase91Controller',
        controllerAs: 'purchase'
      })
      .state('purchase-92', {
        url: '/purchases/92',
        templateUrl: 'app/purchase/purchase-9.2.html',
        controller: 'Purchase92Controller',
        controllerAs: 'purchase'
      })
      .state('purchase-10', {
        url: '/purchases/10',
        templateUrl: 'app/purchase/purchase-10.html',
        controller: 'Purchase10Controller',
        controllerAs: 'purchase'
      })
      .state('purchase-11', {
        url: '/purchases/11',
        templateUrl: 'app/purchase/purchase-11.html',
        controller: 'Purchase11Controller',
        controllerAs: 'purchase'
      })
      .state('purchase-12', {
        url: '/purchases/12',
        templateUrl: 'app/purchase/purchase-12.html',
        controller: 'Purchase12Controller',
        controllerAs: 'purchase'
      })
      .state('purchase-13', {
        url: '/purchases/13',
        templateUrl: 'app/purchase/purchase-13.html',
        controller: 'Purchase13Controller',
        controllerAs: 'purchase'
      });

      $stateProvider
      .state('common-purchase-1', {
        url: '/sign-in',
        templateUrl: 'app/common-purchase/step-1.html',
        controller: 'CommonPurchase1Controller',
        controllerAs: 'purchase'
      })
      .state('common-purchase-2', {
        url: '/update-your-information',
        templateUrl: 'app/common-purchase/step-2.html',
        controller: 'CommonPurchase2Controller',
        controllerAs: 'purchase'
      })
      .state('common-purchase-3', {
        url: '/notice',
        templateUrl: 'app/common-purchase/step-3.html',
        controller: 'CommonPurchase3Controller',
        controllerAs: 'purchase'
      })
      .state('common-purchase-4', {
        url: '/update-insured-information',
        templateUrl: 'app/common-purchase/step-4.html',
        controller: 'CommonPurchase4Controller',
        controllerAs: 'purchase'
      })
      .state('common-purchase-5', {
        url: '/checkout',
        templateUrl: 'app/common-purchase/step-5.html',
        controller: 'CommonPurchase5Controller',
        controllerAs: 'purchase'
      })
      .state('common-purchase-6', {
        url: '/payment',
        templateUrl: 'app/common-purchase/step-6.html',
        controller: 'CommonPurchase6Controller',
        controllerAs: 'purchase'
      })
      .state('common-purchase-7', {
        url: '/payment/success',
        templateUrl: 'app/common-purchase/step-7.html',
        controller: 'CommonPurchase7Controller',
        controllerAs: 'purchase'
      });

      $stateProvider
      .state('travel-purchase-1', {
        url: '/products/travel/purchase/step-1',
        templateUrl: 'app/travel-purchase/step-1.html',
        controller: 'TravelPurchase1Controller',
        controllerAs: 'travelPurchase'
      })
      .state('travel-purchase-2', {
        url: '/products/travel/purchase/step-2',
        templateUrl: 'app/travel-purchase/step-2.html',
        controller: 'TravelPurchase2Controller',
        controllerAs: 'travelPurchase'
      })
      .state('travel-purchase-3', {
        url: '/products/travel/purchase/step-3',
        templateUrl: 'app/travel-purchase/step-3.html',
        controller: 'TravelPurchase3Controller',
        controllerAs: 'travelPurchase'
      })

    $stateProvider
      .state('home-purchase-1', {
        url: '/products/home/purchase/step-1',
        templateUrl: 'app/home-purchase/step-1.html',
        controller: 'HomePurchase1Controller',
        controllerAs: 'homePurchase'
      })
      .state('home-purchase-2', {
        url: '/products/home/purchase/step-2',
        templateUrl: 'app/home-purchase/step-2.html',
        controller: 'HomePurchase2Controller',
        controllerAs: 'homePurchase'
      })
      .state('home-purchase-3', {
        url: '/products/home/purchase/step-3',
        templateUrl: 'app/home-purchase/step-3.html',
        controller: 'HomePurchase3Controller',
        controllerAs: 'homePurchase'
      })

      $stateProvider
      .state('embedded-dbs-1', {
        url: '/embedded/dbs-1',
        templateUrl: 'app/embedded/embedded-dbs-1.html',
        controller: 'EmbeddedDBS1Controller',
        controllerAs: 'cont'
      })
      .state('embedded-dbs-2', {
        url: '/embedded/dbs-2',
        templateUrl: 'app/embedded/embedded-dbs-2.html',
        controller: 'EmbeddedDBS2Controller',
        controllerAs: 'cont'
      })  
      .state('embedded-flex-1', {
        url: '/embedded/flex-1',
        templateUrl: 'app/embedded/embedded-flex-1.html',
        controller: 'EmbeddedFlex1Controller',
        controllerAs: 'cont'
      })
      .state('embedded-flex-2', {
        url: '/embedded/flex-2',
        templateUrl: 'app/embedded/embedded-flex-2.html',
        controller: 'EmbeddedFlex2Controller',
        controllerAs: 'cont'
      })
      .state('embedded-flex-3', {
        url: '/embedded/flex-3',
        templateUrl: 'app/embedded/embedded-flex-3.html',
        controller: 'EmbeddedFlex3Controller',
        controllerAs: 'cont'
      })
      .state('embedded-flex-invest', {
        url: '/embedded/flex-invest',
        templateUrl: 'app/embedded/embedded-flex-invest.html',
        controller: 'EmbeddedFlexInvestController',
        controllerAs: 'cont'
      })
      .state('embedded-landing', {
        url: '/embedded/landing',
        templateUrl: 'app/embedded/landing.html',
        controller: 'LandingController',
        controllerAs: 'cont'
      });

    $stateProvider
      .state('micro-1', {
        url: '/micro/1/:policyNumber',
        templateUrl: 'app/micro/micro-1.html',
        controller: 'Micro1Controller',
        controllerAs: 'micro'
      })
      .state('micro-2', {
        url: '/micro/2',
        templateUrl: 'app/micro/micro-2.html',
        controller: 'Micro2Controller',
        controllerAs: 'micro'
      })
      .state('micro-3', {
        url: '/micro/3',
        templateUrl: 'app/micro/micro-3.html',
        controller: 'Micro3Controller',
        controllerAs: 'micro'
      })
      .state('micro-4', {
        url: '/micro/4/:policyNumberCI',
        templateUrl: 'app/micro/micro-4.html',
        controller: 'Micro4Controller',
        controllerAs: 'micro'
      });

    $stateProvider
      .state('reward-1', {
        url: '/reward/1',
        templateUrl: 'app/reward/reward-1.html',
        controller: 'Reward1Controller',
        controllerAs: 'reward'
      })
      .state('reward-2', {
        url: '/reward/2',
        templateUrl: 'app/reward/reward-2.html',
        controller: 'Reward2Controller',
        controllerAs: 'reward'
      })
      .state('reward-landing', {
        url: '/reward/landing',
        templateUrl: 'app/reward/reward-landing.html',
        controller: 'RewardLandingController',
        controllerAs: 'reward'
      })

    $stateProvider
      .state('policy-login', {
        url: '/policy/login',
        templateUrl: 'app/policy/policy-login.html',
        controller: 'PolicyLoginController',
        controllerAs: 'policy'
      })
      .state('policy-1', {
        url: '/policies-1/:policyNumber',
        templateUrl: 'app/policy/policy-1.html',
        controller: 'Policy1Controller',
        controllerAs: 'policy'
      })
      .state('policy-detail', {
        url: '/policy-detail',
        templateUrl: 'app/policy/policy-detail.html',
        controller: 'PolicyDetailController',
        controllerAs: 'policy'
      })
      .state('policy-edit-details', {
        url: '/policy-edit-details',
        templateUrl: 'app/policy/policy-edit-details.html',
        controller: 'PolicyEditDetailController',
        controllerAs: 'policy'
      })
      .state('policy-confirmation', {
        url: '/policy-confirmation',
        templateUrl: 'app/policy/policy-confirmation.html',
        controller: 'PolicyConfirmationController',
        controllerAs: 'policy'
      })
      .state('policy-renew', {
        url: '/policy-renew',
        templateUrl: 'app/policy/policy-renew.html',
        controller: 'PolicyRenewController',
        controllerAs: 'policy'
      })
      .state('policy-cancel', {
        url: '/policy-cancel',
        templateUrl: 'app/policy/policy-cancel.html',
        controller: 'PolicyCancelController',
        controllerAs: 'policy'
      });

    $stateProvider
      .state('claim-2', {
        url: '/claims/2',
        templateUrl: 'app/claim/claim-2.html',
        controller: 'Claim2Controller',
        controllerAs: 'claim'
      })
      .state('claim-3', {
        url: '/claims/3',
        templateUrl: 'app/claim/claim-3.html',
        controller: 'Claim3Controller',
        controllerAs: 'claim'
      })
      .state('claim-4', {
        url: '/claims/4?id',
        templateUrl: 'app/claim/claim-4.html',
        controller: 'Claim4Controller',
        controllerAs: 'claim'
      })
      .state('claim-5', {
        url: '/claims/5?id',
        templateUrl: 'app/claim/claim-5.html',
        controller: 'Claim5Controller',
        controllerAs: 'claim'
      })
      .state('claim-51', {
        url: '/claims/51?id',
        templateUrl: 'app/claim/claim-5.1.html',
        controller: 'Claim51Controller',
        controllerAs: 'claim'
      })
      .state('claim-6', {
        url: '/claims/6?id',
        templateUrl: 'app/claim/claim-6.html',
        controller: 'Claim6Controller',
        controllerAs: 'claim'
      })
      .state('claim-7', {
        url: '/claims/7?id',
        templateUrl: 'app/claim/claim-7.html',
        controller: 'Claim7Controller',
        controllerAs: 'claim'
      })
      .state('claim-8', {
        url: '/claims/8?id',
        templateUrl: 'app/claim/claim-8.html',
        controller: 'Claim8Controller',
        controllerAs: 'claim'
      })
      .state('claim-9', {
        url: '/claims/9',
        templateUrl: 'app/claim/claim-9.html',
        controller: 'Claim9Controller',
        controllerAs: 'claim'
      })
      .state('claim-quick-claim', {
        url: '/claims/quickclaim',
        templateUrl: 'app/claim/quick-claim.html',
        controller: 'ClaimQuickClaimController',
        controllerAs: 'claim'
      });

    $stateProvider
      .state('404', {
        url: '/404',
        templateUrl: 'app/404.html'
      });

    $urlRouterProvider.otherwise('/404');
  }

})();

/* global malarkey:false, moment:false */
(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .constant('malarkey', malarkey)
    .constant('moment', moment)
   
    // generic configurations
    .constant('CALENDAR_FORMAT', 'yyyy / MM / dd')
    .constant('DATE_FORMAT', 'YYYY-MM-DD')
    .constant('environment', 'demo')
    .constant('configUrls', {
      eks: {
        keyCloakTokenUrl: 'https://keycloak1.eks.sonic.sit.coherent.com.hk/auth/realms/quick-silver/apikey/token',
        keyCloakApiKey: '2ef30faf-6071-492a-8aaa-96ef207a863a',
        keyCloakPFClient: 'product-factory',
        PFUrl: 'https://excelengine.eks.sonic.sit.coherent.com.hk/api/v1/product/coherent/engines/Execute/',
        createPolicy: 'https://newbusiness.eks.sonic.sit.coherent.com.hk/v1/newpolicy',
        enquirePolicy: 'https://enquiry.eks.sonic.sit.coherent.com.hk/v1/policy/id/',
        fileUpload: 'https://newbusiness.eks.sonic.sit.coherent.com.hk/v1/s3/fileupload',
        claimInitiate: 'https://claims.eks.sonic.sit.coherent.com.hk/v1/claim/initiate',
        applyPremium: 'https://policyservicing.eks.sonic.sit.coherent.com.hk/v1/applypremium',
        topupPremium: 'https://policyservicing.eks.sonic.sit.coherent.com.hk/v1/topuppremium',
        cancelPolicy: 'https://policyservicing.eks.sonic.sit.coherent.com.hk/v1/cancelpolicy',
        updatePolicy: 'https://policyservicing.eks.sonic.sit.coherent.com.hk/v1/update/email',
        isAuthorizationNeeded: true,
        token: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiZ3JvdXBzIjpbImFkbWluIiwiaGVhbHRoIl0sImlhdCI6MTUxNjIzOTAyMn0.CMEQlrAI3_MbWZJ1RF0qtvoZi6ZOHKduY3zyIXn8N-o'
      },
      demo: {
        keyCloakTokenUrl: 'https://keycloak.demo.sonic.dev.coherent.global/auth/realms/demo-sonic-global/apikey/token',
        keyCloakApiKey: '85e01b68-1c0b-417c-ae58-2078572f111f',
        keyCloakPFClient: 'product-factory',
        PFUrl: 'https://excelengine.demo.sonic.dev.coherent.global/api/v1/product/coherent/engines/Execute/',
        PFUrl1: 'https://excelengine.demo.sonic.dev.coherent.global/api/v1/product/',
        createPolicy: 'https://newbusiness.demo.sonic.dev.coherent.global/v1/newpolicy',
        enquirePolicy: 'https://enquiry.demo.sonic.dev.coherent.global/v1/policy/id/',
        fileUpload: 'https://newbusiness.demo.sonic.dev.coherent.global/v1/s3/fileupload',
        claimInitiate: 'https://claims.demo.sonic.dev.coherent.global/v1/claim/initiate',
        applyPremium: 'https://policyservicing.demo.sonic.dev.coherent.global/v1/applypremium',
        topupPremium: 'https://policyservicing.demo.sonic.dev.coherent.global/v1/topuppremium',
        cancelPolicy: 'https://policyservicing.demo.sonic.dev.coherent.global/v1/cancelpolicy',
        updatePolicy: 'https://policyservicing.demo.sonic.dev.coherent.global/v1/update/email',
        isAuthorizationNeeded: true,
        token: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiZ3JvdXBzIjpbImFkbWluIiwiaGVhbHRoIl0sImlhdCI6MTUxNjIzOTAyMn0.CMEQlrAI3_MbWZJ1RF0qtvoZi6ZOHKduY3zyIXn8N-o'
      }
    });
})();

(function() {
  'use strict';

  angular
    .module('coherentPaDemo')
    .config(config);

  /** @ngInject */
  function config($httpProvider, $logProvider, $translateProvider, toastrConfig) {

    var reqs = {};
    var rejected = 0;

    // Apply interceptors for loader
    $httpProvider.interceptors.push(function($q, $rootScope) {
      return {
        request: function(config) {
          reqs[config.url] = true;

          $rootScope.loading = true;

          return config;
        },

        requestError: function(rejection) {
          rejected++;

          var reqsLeft = Object.keys(reqs).length;
          if (reqsLeft === 0 || reqsLeft === rejected) {
            reqs = {};
            $rootScope.loading = false;
          }

          return $q.reject(rejection);
        },

        response: function(response) {
          if (reqs[response.config.url]) {
            delete reqs[response.config.url];
          }

          var reqsLeft = Object.keys(reqs).length;
          if (reqsLeft === 0 || reqsLeft === rejected) {
            reqs = {};
            $rootScope.loading = false;
          }

          return response;
        },

        responseError: function(rejection) {
          rejected++;

          var reqsLeft = Object.keys(reqs).length;
          if (reqsLeft === 0 || reqsLeft === rejected) {
            reqs = {};
            $rootScope.loading = false;
          }

          return $q.reject(rejection);
        }
      };
    });

    // Enable log
    $logProvider.debugEnabled(true);

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = true;
    toastrConfig.progressBar = true;

    $translateProvider
      .useStaticFilesLoader({
        prefix: '/assets/translations/locale-',
        suffix: '.json'
      })
      .useLoaderCache(true)
      .forceAsyncReload(true)
      .preferredLanguage('en');
  }

})();

angular.module("coherentPaDemo").run(["$templateCache", function($templateCache) {$templateCache.put("app/404.html","404");
$templateCache.put("app/accident-purchase/step-1.html","<div class=\"purchase common-page\"><back-navbar></back-navbar><div class=container><div class=row><div class=col-xs-12><p class=title1 translate=purchase_check_the_following></p><div class=widget><p class=text translate=purchase_personal_accident_reminder></p><p class=foot-note translate=purchase_check_the_following_again></p><div class=checkbox ng-class=\"{ selected: purchase.ui.checkbox }\" ng-click=\"purchase.ui.checkbox = !purchase.ui.checkbox\"><div class=form-check><input type=checkbox class=form-check-input ng-model=purchase.ui.checkbox> <span class=checkmark></span><label class=form-check-label translate=purchase_checked></label></div></div></div><p class=text translate=purchase_select_insurance_start_date></p><p class=input-group><input type=text class=form-control uib-datepicker-popup=\"{{ purchase.opts.calendarFormat }}\" ng-model=purchase.ui.insuranceDate is-open=purchase.ui.isOpen datepicker-options=purchase.opts.datepickerOptions placeholder=\"{{ \'date_placeholder\' | translate }}\" show-button-bar=false> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"purchase.ui.isOpen = !purchase.ui.isOpen\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><p class=\"foot-note bottom-spacing-80\" translate=purchase_insurance_start_date_text></p><p class=text-center><button class=\"btn btn-1\" ng-click=purchase.proceed() ng-disabled=\"!purchase.ui.checkbox || !purchase.ui.insuranceDate\" translate=purchase_continue></button></p></div></div></div></div>");
$templateCache.put("app/accident-purchase/step-2.html","<div class=\"purchase common-page\"><back-navbar remove-margin=yes></back-navbar><div class=container><div class=\"row title2-container purple-siren-bg\"><div class=col-xs-12><p class=title2 translate=purchase_personal_accident></p></div></div></div><div class=purple-border></div><div class=container><div class=row><div class=col-xs-12><p class=title1 translate=purchase_select_range_eligible_for_compensation></p><p class=text-3 translate=purchase_scope_of_coverage_text></p><img class=\"img-responsive float-left\" width=64 src=/assets/images/plan-0.png><div class=text-4-5-6><div translate=purchase_insured_individual></div><div translate=purchase_insured_individuals_spouse></div><div translate=purchase_insured_individuals_relatives></div></div><hr></div></div></div><div class=container><div class=row><div class=col-xs-12 ng-repeat=\"plan in purchase.plans\"><div class=choice ng-class=\"{\'first-choice\': $first}\" ng-click=purchase.proceed(plan)><p class=title><span ng-bind=\"plan.title | translate\"></span> <span class=\"glyphicon glyphicon-menu-right\"></span></p><p class=description ng-bind-html=\"plan.description | translate\"></p><div class=img-container><img class=img-responsive ng-src=\"{{ plan.image }}\"></div></div></div></div></div></div>");
$templateCache.put("app/accident-purchase/step-3.html","<div class=\"purchase common-page\"><back-navbar content=\"Individual Plan\"></back-navbar><div class=container><div class=row><div class=col-xs-12><div class=\"widget widget-white\"><div class=title translate=\"{{ purchase.ui.plan.title }}\"></div><div class=\"text description\" translate=\"{{ purchase.ui.plan.description }}\"></div><div class=img-container><img class=\"float-left img-responsive\" ng-src=\"{{ purchase.ui.plan.image }}\"></div></div></div></div><div class=row><div class=col-xs-12><p class=sub-title translate=purchase_policy_owner></p><p class=sub-description translate=purchase_over_18_can_apply></p><div class=warning-box><div class=img-container><img class=img-responsive src=/assets/images/warning.png></div><p class=text translate=purchase_child_target_for_injury_compensation></p></div></div></div><div class=row><div class=col-xs-12><p class=sub-title translate=purchase_injury_guarantee_coverage></p><p class=sub-description translate=purchase_covered_by_injury_guarantee></p><div><div class=\"widget widget-white widget-rectangle-list\" ng-repeat=\"coverage in purchase.ui.plan.injuryGuaranteeCoverages\"><p class=title translate=\"{{ coverage.title }}\"></p><div class=description><ul><li ng-repeat-start=\"(description, descriptions) in coverage.descriptions\"><p translate=\"{{ description }}\"></p></li><ul ng-if=descriptions><li ng-repeat=\"d in descriptions\"><p translate=\"{{ d }}\"></p></li></ul><span ng-repeat-end ng-if=false></span></ul></div></div></div></div></div><div class=row><div class=col-xs-12><p class=sub-title translate=purchase_guarantee_liability_coverage></p><p class=sub-description translate=purchase_covered_by_guarantee_liability></p><div><div class=\"widget widget-white widget-rectangle widget-list\" ng-repeat=\"coverage in purchase.ui.plan.guaranteeLiabilityCoverages\"><div class=img-container><img class=img-responsive ng-src=\"{{ coverage.image }}\"></div><div class=widget-content><p class=title ng-bind=\"coverage.title | translate\"></p><div class=details><ul><li ng-repeat=\"detail in coverage.details\" ng-bind=\"detail | translate\"></li></ul></div></div></div></div></div></div><div class=row><div class=\"col-xs-12 text-center\"><button class=\"btn btn-1\" ng-click=purchase.proceed() ng-bind=\"purchase.ui.plan.apply | translate\"></button></div></div></div></div>");
$templateCache.put("app/accident-purchase/step-4.html","<div class=\"purchase common-page\"><back-navbar remove-margin=yes content=\"Plan Level\"></back-navbar><div class=container><div class=\"row title2-container purple-siren-bg\"><div class=col-xs-12><p class=title2 translate=purchase_personal_accident></p></div></div></div><div class=purple-border></div><div class=container><div class=row><div class=col-xs-12><p class=title1 translate=purchase_choose_desired_plan></p><p class=text-3 translate=purchase_desired_plan_description></p><div class=\"panel panel-default panel-purple plan-option\" ng-class=\"{\'panel-selected\': purchase.ui.planTypeId === planType.id}\" ng-repeat=\"planType in purchase.ui.planTypes\" ng-click=purchase.select(planType)><div class=panel-heading><p class=title ng-bind=\"planType.title | translate\"></p><p class=description ng-bind=\"planType.description | translate\"></p><div class=price ng-bind=\"planType.price | translate | number\"></div></div><table class=table><tr ng-if=false ng-repeat-start=\"component in planType.components\"></tr><tr><td ng-bind=\"component.label | translate\"></td><td class=text-right ng-bind=\"component.price | translate | number\"></td></tr><tr ng-repeat=\"subComponent in component.subComponents\"><td class=pl32 ng-bind=\"subComponent.label | translate\"></td><td class=text-right ng-bind=\"subComponent.price | translate | number\"></td></tr><tr ng-if=false ng-repeat-end></tr></table></div></div><div class=col-xs-12><div class=payment-methods><img src=/assets/images/visa.png> <img src=/assets/images/mastercard.png> <img src=/assets/images/diners-club.png> <img src=/assets/images/jcb.png> <img src=/assets/images/rakuten-card.png></div><p class=\"description text-muted\" translate=purchase_paid_by_credit_card></p><p class=description translate=purchase_automatic_renewal></p><p class=text-center><button ng-disabled=!purchase.ui.planType class=\"btn btn-1\" ng-click=purchase.proceed() translate=purchase_select_this_plan></button></p></div></div></div></div>");
$templateCache.put("app/common-purchase/step-1.html","<div class=\"purchase common-page\"><back-navbar content=\"{{ \'sign_in\' | translate }}\"></back-navbar><div class=container><div class=row><div class=col-xs-12><p class=title1 translate=purchase_sign_in_coherent></p><form ng-submit=purchase.signIn()><input type=email class=form-control placeholder=\"{{ \'purchase_email\' | translate }}\" ng-model=purchase.ui.email required> <input type=password class=form-control placeholder=\"{{ \'purchase_password\' | translate }}\" ng-model=purchase.ui.password required><p class=text-center><button class=\"btn btn-1\" translate=sign_in ng-click=purchase.signIn()></button></p></form><p class=\"text-center skip\"><a ng-click=purchase.skip() translate=purchase_skip_this_step></a></p></div></div></div></div>");
$templateCache.put("app/common-purchase/step-2.html","<div class=\"purchase common-page\"><back-navbar content=\"Update Your Information\n\"></back-navbar><div class=container><div class=row><div class=col-xs-12><div class=form-group><label for=name translate=purchase_full_name></label><input type=text class=form-control id=name placeholder=\"{{ \'purchase_full_name_placeholder\' | translate }}\" ng-model=purchase.ui.name></div><div class=form-group><label for=birth-date translate=purchase_birth_date></label><p class=input-group><input type=text class=form-control id=birth-date uib-datepicker-popup=\"{{ purchase.opts.calendarFormat }}\" ng-model=purchase.ui.birthDate is-open=purchase.ui.isOpen datepicker-options=purchase.opts.datepickerOptions placeholder=\"{{ \'date_placeholder\' | translate }}\" show-button-bar=false> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"purchase.ui.isOpen = !purchase.ui.isOpen\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"form-group dual-options\"><label for=gender translate=purchase_gender></label><div class=text-center><button class=\"btn btn-option\" ng-class=\"{ \'btn-selected\': purchase.ui.gender === \'F\' }\" translate=purchase_female ng-click=\"purchase.ui.gender = \'F\'\"></button> <button class=\"btn btn-option\" ng-class=\"{ \'btn-selected\': purchase.ui.gender === \'M\' }\" translate=purchase_male ng-click=\"purchase.ui.gender = \'M\'\"></button></div></div><div class=\"form-group postal-code\"><label for=postal-code translate=purchase_japan_postal_code></label><div class=input-group><input type=text class=\"form-control text-center\" placeholder=\"{{ \'purchase_placeholder_3\' | translate }}\" id=postal-code ng-model=purchase.ui.postalCode1><div class=input-group-addon>—</div><input type=text class=\"form-control text-center\" placeholder=\"{{ \'purchase_placeholder_4\' | translate }}\" ng-model=purchase.ui.postalCode2></div></div><div class=\"form-group address\"><label for=address translate=purchase_address></label><textarea class=form-control id=address rows=4 placeholder=\"{{ \'purchase_address_placeholder\' | translate }}\" ng-model=purchase.ui.address></textarea></div><div class=form-group><label for=email translate=purchase_primary_email></label><input type=email class=form-control id=email placeholder=\"{{ \'purchase_email_placeholder\' | translate }}\" ng-model=purchase.ui.email></div><div class=form-group><label for=alternate-email><span translate=purchase_alternate_email></span> <span class=\"text-muted small text-optional\" translate=purchase_optional></span></label><input type=email class=form-control id=alternate-email placeholder=\"{{ \'purchase_alternate_email_placeholder\' | translate }}\" ng-model=purchase.ui.alternateEmail></div><div class=form-group><label for=contact-number translate=purchase_contact_number></label><input type=text class=form-control id=contact-number placeholder=\"{{ \'purchase_contact_number_placeholder\' | translate }}\" ng-model=purchase.ui.contact></div><div class=form-group><label for=alternate-contact-number><span translate=purchase_alternate_contact></span> <span class=\"text-muted small text-optional\" translate=purchase_optional></span></label><input type=text class=form-control id=alternate-contact-number placeholder=\"{{ \'purchase_alternate_contact_placeholder\' | translate }}\" ng-model=purchase.ui.alternateContact></div><div class=\"widget subscribe\"><p class=text translate=purchase_receive_emails></p><div class=checkbox ng-class=\"{ selected: purchase.ui.subscribe }\" ng-click=\"purchase.ui.subscribe = !purchase.ui.subscribe\"><div class=form-check><input type=checkbox class=form-check-input ng-model=purchase.ui.subscribe> <span class=checkmark></span><label class=form-check-label translate=purchase_yes_subscribe></label></div></div></div><p class=\"text-center information1\"><button ng-disabled=\"!purchase.ui.name || !purchase.ui.birthDate || !purchase.ui.gender || !purchase.ui.postalCode1 || !purchase.ui.postalCode2 || !purchase.ui.address || !purchase.ui.email || !purchase.ui.contact\" class=\"btn btn-3\" ng-click=purchase.proceed() translate=travel_purchase_next></button></p></div></div></div></div>");
$templateCache.put("app/common-purchase/step-3.html","<div class=\"purchase common-page\"><back-navbar content=Notice></back-navbar><div class=container><div class=row><div class=col-xs-12><p class=title1 translate=purchase_important></p><hr><p class=title1 translate=purchase_check_all_that_apply></p><div class=checkbox ng-class=\"{ selected: purchase.ui.checkbox1 }\" ng-click=\"purchase.ui.checkbox1 = !purchase.ui.checkbox1\"><div class=form-check><input type=checkbox class=form-check-input ng-model=purchase.ui.checkbox1> <span class=checkmark></span><label class=form-check-label translate=purchase_confirm_amount></label></div></div><div class=\"panel panel-default panel-purple plan-option\"><div class=panel-heading><p class=title translate=purchase_insured_15_and_above></p></div><table class=table><tr><td translate=purchase_daily_hospitalization_insurance></td><td class=text-right translate=purchase_panel2_price1></td></tr><tr><td translate=purchase_following_cases></td><td class=text-right translate=purchase_panel2_price2></td></tr><tr><td translate=purchase_policy_owner_and_insured_differ></td><td class=text-right translate=purchase_panel2_price3></td></tr><tr><td class=padding-left-32 translate=purchase_family_type_contract colspan=2></td></tr><tr><td class=padding-left-32 translate=purchase_not_insured_person colspan=2></td></tr><tr><td translate=purchase_cases_described_below></td><td class=text-right translate=purchase_panel2_price6></td></tr></table></div><div class=checkbox ng-class=\"{ selected: purchase.ui.checkbox2 }\" ng-click=\"purchase.ui.checkbox2 = !purchase.ui.checkbox2\"><div class=form-check><input type=checkbox class=form-check-input ng-model=purchase.ui.checkbox2> <span class=checkmark></span><label class=form-check-label translate=purchase_lives_in_the_country></label></div></div><div class=checkbox ng-class=\"{ selected: purchase.ui.checkbox3 }\" ng-click=\"purchase.ui.checkbox3 = !purchase.ui.checkbox3\"><div class=form-check><input type=checkbox class=form-check-input ng-model=purchase.ui.checkbox3> <span class=checkmark></span><label class=form-check-label translate=purchase_first_time></label></div></div><div class=checkbox ng-class=\"{ selected: purchase.ui.checkbox4 }\" ng-click=\"purchase.ui.checkbox4 = !purchase.ui.checkbox4\"><div class=form-check><input type=checkbox class=form-check-input ng-model=purchase.ui.checkbox4> <span class=checkmark></span><label class=form-check-label translate=purchase_different_persons></label></div></div><div class=checkbox ng-class=\"{ selected: purchase.ui.checkbox5 }\" ng-click=\"purchase.ui.checkbox5 = !purchase.ui.checkbox5\"><div class=form-check><input type=checkbox class=form-check-input ng-model=purchase.ui.checkbox5> <span class=checkmark></span><label class=form-check-label translate=purchase_occupation></label></div></div><div class=\"checkbox checkbox-final\" ng-class=\"{ selected: purchase.ui.checkbox6 }\" ng-click=\"purchase.ui.checkbox6 = !purchase.ui.checkbox6\"><div class=form-check><input type=checkbox class=form-check-input ng-model=purchase.ui.checkbox6> <span class=checkmark></span><label class=form-check-label translate=purchase_confirm></label></div></div><p class=\"text-center information1\"><button class=\"btn btn-3\" ng-disabled=\"!purchase.ui.checkbox1 || !purchase.ui.checkbox2 || !purchase.ui.checkbox3 || !purchase.ui.checkbox4 || !purchase.ui.checkbox5 || !purchase.ui.checkbox6\" ng-click=purchase.proceed() translate=travel_purchase_next></button></p></div></div></div></div>");
$templateCache.put("app/common-purchase/step-4.html","<div class=\"purchase common-page\"><back-navbar content=\"Update Insured Information\"></back-navbar><div class=container><div class=row><div class=col-xs-12><div class=form-group><label for=relationship translate=purchase_relationship_with_owner></label><div class=radio ng-class=\"{ \'selected\': purchase.ui.relationship === relationship.value }\" ng-repeat=\"relationship in purchase.relationships\"><div class=form-radio><label><input type=radio name=relationship value=\"{{ relationship.value }}\" ng-model=purchase.ui.relationship> <span class=radio-button></span> <span translate=\"{{ relationship.display }}\"></label></div></div></div><div ng-if=\"purchase.ui.relationship === \'relative\'\"><div class=form-group><label for=relationship-type translate=purchase_relationship_with_owner></label><select id=relationship-type class=form-control ng-model=purchase.ui.relationshipType><option value=\"\" ng-bind=purchase.placeholder1 disabled ng-selected=!purchase.ui.relationshipType hidden></option><option value=\"{{ relationshipType.value }}\" ng-bind=relationshipType.display ng-repeat=\"relationshipType in purchase.relationshipTypes\" ng-selected=\"purchase.ui.relationshipType === relationshipType.value\"></option></select></div><div class=form-group><label for=name ng-bind=purchase.text3></label><input type=text class=form-control id=name placeholder=\"{{ purchase.placeholder2 }}\" ng-model=purchase.ui.name></div><div class=form-group><label for=birth-date ng-bind=purchase.text4></label><p class=input-group><input type=text class=form-control uib-datepicker-popup=\"{{ purchase.opts.calendarFormat }}\" ng-model=purchase.ui.birthDate is-open=purchase.ui.isOpen datepicker-options=purchase.opts.datepickerOptions placeholder=\"{{ purchase.placeholder3 }}\" show-button-bar=false> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"purchase.ui.isOpen = !purchase.ui.isOpen\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"form-group dual-options\"><label for=gender ng-bind=purchase.text5></label><div class=text-center><button class=\"btn btn-option\" ng-class=\"{ \'btn-selected\': purchase.ui.gender === purchase.btn1 }\" ng-bind=purchase.btn1 ng-click=\"purchase.ui.gender = purchase.btn1\"></button> <button class=\"btn btn-option\" ng-class=\"{ \'btn-selected\': purchase.ui.gender === purchase.btn2 }\" ng-bind=purchase.btn2 ng-click=\"purchase.ui.gender = purchase.btn2\"></button></div></div><div class=\"form-group dual-options\"><label for=living ng-bind=purchase.text6></label><div class=text-center><button class=\"btn btn-option\" ng-class=\"{ \'btn-selected\': purchase.ui.living === purchase.btn1 }\" ng-bind=purchase.btn3 ng-click=\"purchase.ui.living = purchase.btn1\"></button> <button class=\"btn btn-option\" ng-class=\"{ \'btn-selected\': purchase.ui.living === purchase.btn2 }\" ng-bind=purchase.btn4 ng-click=\"purchase.ui.living = purchase.btn2\"></button></div></div></div><p class=\"text-center information2\"><button ng-disabled=\"!(purchase.ui.relationship === \'self\' || (purchase.ui.relationshipType && purchase.ui.name && purchase.ui.birthDate && purchase.ui.gender && purchase.ui.living))\" class=\"btn btn-5\" ng-click=purchase.proceed() translate=purchase_checkout></button></p></div></div></div></div>");
$templateCache.put("app/common-purchase/step-5.html","<div class=\"purchase common-page\"><back-navbar content=Checkout remove-margin=yes></back-navbar><div class=container><div class=\"row title3-container purple-siren-bg\"><div class=col-xs-12><p class=title3 ng-bind=\"purchase.opts.title | translate\"></p></div></div></div><div class=purple-border></div><div class=\"container summary\"><div class=row ng-if=\"purchase.ui.type === puchase.opts.ACCIDENT_TYPE\"><div class=col-xs-12><div class=\"choice first-choice\"><p class=title><span ng-bind=purchase.ui.plan.title></span> <span class=\"glyphicon glyphicon-menu-right\"></span></p><p class=description ng-bind-html=\"purchase.ui.plan.description | translate\"></p><div class=img-container><img class=img-responsive ng-src=\"{{ purchase.planCategory.image }}\"></div></div></div></div><div class=row><div class=col-xs-12><div class=\"panel panel-default panel-purple plan-option\"><div class=panel-heading><p class=title ng-bind=purchase.ui.planDetails.Option></p><div class=row><div class=col-xs-9><p class=description ng-bind=purchase.ui.planDetails.Desc></p></div><div class=col-xs-3><div class=price ng-bind=\"purchase.ui.planDetails.price | translate\"></div></div></div></div><table class=table><tr ng-if=\"purchase.ui.type === puchase.opts.ACCIDENT_TYPE\" ng-repeat-start=\"component in purchase.ui.planDetails.components\"></tr><tr><td ng-bind=\"component.label | translate\"></td><td class=text-right ng-bind=\"component.price | translate\"></td></tr><tr ng-repeat=\"subComponent in component.subComponents\"><td class=pl32 ng-bind=\"subComponent.label | translate\"></td><td class=text-right ng-bind=\"subComponent.price | number\"></td></tr><tr ng-if=\"purchase.ui.type === puchase.opts.ACCIDENT_TYPE\" ng-repeat-end></tr><tr ng-if=\"purchase.ui.type === purchase.opts.TRAVEL_TYPE && benefit.enabled\" ng-repeat=\"benefit in purchase.ui.optionalBenefits\"><td ng-bind=benefit.label></td><td class=text-right ng-bind=\"benefit.value | number\"></td></tr><tr ng-if=\"purchase.ui.type === puchase.opts.HOME_TYPE\" ng-repeat=\"benefit in purchase.ui.benefitSelection\">{{benefit.Option_Name}}</tr></table></div></div></div><div class=row><div class=col-xs-12><div class=\"checkbox checkbox-final\" ng-class=\"{ selected: purchase.ui.checkbox1 }\" ng-click=\"purchase.ui.checkbox1 = !purchase.ui.checkbox1\"><div class=form-check><input type=checkbox class=form-check-input ng-model=purchase.ui.checkbox1> <span class=checkmark></span><label class=form-check-label ng-bind=\"purchase.opts.confirmation | translate\"></label></div></div></div></div><div class=row><div class=col-xs-12><div class=payment-methods><img src=/assets/images/visa.png> <img src=/assets/images/mastercard.png> <img src=/assets/images/diners-club.png> <img src=/assets/images/jcb.png> <img src=/assets/images/rakuten-card.png></div><p class=\"description text-muted\" translate=purchase_insurance_premiums_can_only></p><p class=description translate=purchase_this_contract_is_accompanied></p><p class=text-center><button class=\"btn btn-1\" ng-disabled=!purchase.ui.checkbox1 ng-click=purchase.proceed() translate=purchase_proceed_to_payment></button></p></div></div></div></div>");
$templateCache.put("app/common-purchase/step-6.html","<div class=\"purchase common-page\"><back-navbar content=Payment></back-navbar><div class=container><div class=row><div class=col-xs-12><p class=title1 translate=purchase_credit_card_information></p></div><div class=col-xs-12><div class=payment-methods><img src=/assets/images/visa.png> <img src=/assets/images/mastercard.png> <img src=/assets/images/diners-club.png> <img src=/assets/images/jcb.png> <img src=/assets/images/rakuten-card.png></div><p class=\"description text-muted\" translate=purchase_insurance_premiums_can_only></p><p class=description translate=purchase_this_contract_is_accompanied></p></div><div class=col-xs-12><div class=form-group><label for=card-holder-name translate=purchase_name_on_card></label><input type=text class=form-control id=card-holder-name placeholder=\"\" ng-model=purchase.ui.cardName></div><div class=form-group><label for=card-number translate=purchase_card_number></label><input type=text class=form-control id=dummy-card-number placeholder=XXXX-XXXX-XXXX-XXXX ng-model=purchase.ui.cardNumber></div></div><div class=col-xs-3><div class=form-group><label for=card-expiry translate=purchase_expiry></label><input type=text class=form-control id=card-expiry-month placeholder=MM ng-model=purchase.ui.cardExpiryMM></div></div><div class=col-xs-3><div class=form-group><label for=card-expiry></label><input type=text class=form-control id=card-expiry-year placeholder=YY ng-model=purchase.ui.cardExpiryYY></div></div><div class=col-xs-6><div class=form-group><label for=card-cvv translate=purchase_cvv></label><input type=text class=form-control id=card-cvv placeholder=CVV ng-model=purchase.ui.paymentCvv></div></div><div class=col-xs-12><p class=text-center><button aang-disabled=\"!purchase.ui.cardName || !purchase.ui.cardNumber || !purchase.ui.cardExpiryMM || !purchase.ui.cardExpiryYY || !purchase.ui.cardCvv\" class=\"btn btn-1\" ng-click=purchase.proceed() translate=purchase_complete_payment_with_credit_card></button></p></div></div></div></div>");
$templateCache.put("app/common-purchase/step-7.html","<div class=\"purchase common-page\"><back-navbar icon=glyphicon-menu-down content=\"Policy Payment\" link=main></back-navbar><div class=container><div class=row><div class=\"col-xs-12 text-center paid\"><img class=img-responsive src=/assets/images/check.png><p class=title translate=purchase_payment_succesful></p><div class=description><span translate=purchase_policy_number></span> <a ui-sref=\"policy-2({policyNumber: purchase.ui.policyNumber})\" ng-bind=purchase.ui.policyNumber></a></div></div><div class=col-xs-12><p class=text-center><button ui-sref=products class=\"btn btn-1\" translate=purchase_back_to_home_screen></button></p></div></div></div></div>");
$templateCache.put("app/claim/claim-2.html","<div class=\"claim common-page\"><back-navbar content=\"Select Policy\"></back-navbar><div class=container><div class=row><div class=col-xs-12><div class=\"panel panel-default\" ng-repeat=\"policy in claim.policies\"><div class=panel-body><p><input type=checkbox name={{policy.code}} ng-value={{policy.code}}>&nbsp;&nbsp;<span class=\"title {{ policy.color }}\" ng-bind=policy.name></span></p><p class=description ng-bind=policy.number></p><div class=img-holder><img class=img-responsive ng-src=\"{{ policy.img }}\"></div><div class=\"arrow-holder text-right\"><span class=\"glyphicon glyphicon glyphicon-menu-right\"></span></div><div class=\"summary text-right\"><div><div ng-bind=policy.type></div><div ng-bind=policy.amount></div></div></div></div><div class=\"panel-footer panel-{{ policy.color }}\"></div></div><div class=\"btn btn-orange w-100 btn-lg font-14 mb16 mt24\" ui-sref=claim-5 ng-bind=claim.btn1>Continue</div></div></div></div></div>");
$templateCache.put("app/claim/claim-3.html","<div class=\"claim common-page\"><back-navbar content=\"Make a claim\" remove-margin=yes></back-navbar><div class=container><div class=\"row title1-container purple-siren-bg\"><div class=col-xs-12><p class=title1 ng-bind=claim.text1></p><div class=description1 ng-bind=claim.text2></div></div></div></div><div class=purple-border></div><div class=container><div class=row><div class=col-xs-12><p class=title ng-bind=claim.text3></p><div class=widget ng-click=claim.add() ng-if=\"claim.claims.length === 0\"><img class=img-responsive src=/assets/images/inbox.png><p class=description ng-bind=claim.text4></p></div><div class=claim-entries ng-if=\"claim.claims.length > 0\"><div class=claim-entry ng-click=claim.edit($index) ng-repeat=\"c in claim.claims\"><span ng-bind=c.benefit.display></span> <span class=\"btn btn-edit\"><img src=/assets/images/edit.png></span></div><!-- <a ng-click=\"claim.add()\" class=\"add-more button\" ng-bind=\"claim.text5\"></a> --></div></div><div class=col-xs-12><div class=text-center><button class=\"btn btn-1\" ng-disabled=\"claim.claims.length < 1\" ng-click=claim.proceed() ng-bind=claim.btn1></button></div></div></div></div></div>");
$templateCache.put("app/claim/claim-4.html","<div class=\"claim common-page\"><back-navbar content=\"Your Benefits\" remove-margin=yes></back-navbar><div class=grey-bar><div class=\"orange-bar bar-20\"></div></div><div class=container><div class=row><div class=col-xs-12><div class=form-group><label for=benefits ng-bind=claim.text1></label><div class=radio ng-class=\"{ \'selected\': claim.benefit === benefit.value }\" ng-repeat=\"benefit in claim.benefits\"><div class=form-radio><label><input type=radio name=benefits value=\"{{ benefit.value }}\" ng-model=claim.benefit> <span class=radio-button></span> <span ng-bind=benefit.display></label></div></div></div><div class=text-center><button class=\"btn btn-1\" ng-disabled=!claim.benefit ng-click=claim.proceed() ng-bind=claim.btn1></button></div></div></div></div></div>");
$templateCache.put("app/claim/claim-5.1.html","<div class=\"claim common-page\"><back-navbar content=\"Insurance Claim Payee\" remove-margin=yes></back-navbar><div class=grey-bar><div class=\"orange-bar bar-40\"></div></div><div class=container><div class=row><div class=col-xs-12><p translate=claim_select_payment_method class=\"mb8 mt24 text-700\"></p><div class=\"form-group pt8\"><p class=m0><input type=radio id=bankType1 ng-model=claim.bankType value=bankType1><label for=bankType1 translate=claim_bank_transfer></label></p><p class=m0><input type=radio id=bankType2 ng-model=claim.bankType value=bankType2><label for=reason2 translate=claim_credit_bank></label></p><p class=m0><input type=radio id=bankType3 ng-model=claim.bankType value=bankType3><label for=reason3 translate=claim_credit_union></label></p><p class=m0><input type=radio id=bankType4 ng-model=claim.bankType value=bankType4><label for=reason3 translate=claim_ewallet></label></p></div><div class=\"form-group pt16\"><label for=bank-name translate=claim_bank_name></label><input type=text class=form-control id=bank-name ng-model=claim.responses.bankName></div><div class=\"form-group pt16\"><label for=branch-name translate=claim_branch_name></label><input type=etextmail class=form-control id=branch-name ng-model=claim.responses.branchName></div><div class=\"form-group pt16\"><label for=account-number translate=claim_account_number></label><input type=text class=form-control id=account-number ng-model=claim.responses.accountNumber></div><div class=\"form-group pt16\"><label for=account-name translate=claim_account_name></label><input type=text class=form-control id=account-name ng-model=claim.responses.accountName></div><div class=text-center><button class=\"btn btn-1\" ng-disabled=\"\" ng-click=claim.proceed() ng-bind=claim.button1></button></div></div></div></div></div>");
$templateCache.put("app/claim/claim-5.html","<div class=\"claim common-page\"><back-navbar content=事故にあわれた方の情報 remove-margin=yes></back-navbar><div class=grey-bar><div class=\"orange-bar bar-40\"></div></div><div class=container><div class=row><div class=col-xs-12><div class=form-group><label for=name ng-bind=claim.text1></label><input type=text class=form-control id=name placeholder=\"{{ claim.placeholder1 }}\" ng-model=claim.information.name ng-value=claim.value1 disabled></div><!-- 				<div class=\"form-group\">\n					<label for=\"date\" ng-bind=\"claim.text2\"></label>\n\n          <input type=\"date\" name=\"date\" id=\"date\" max=\"moment()\" \n          min=\"{{claim.contractStart}}\" class=\"form-control\" value=\"2021-06-12\" ng-model=\"claim.information.date\">\n				</div> --><label for=date ng-bind=claim.text2></label><p class=input-group><input type=text id=hospitalization-start-date class=form-control uib-datepicker-popup=\"yyyy / MM / dd\" ng-model=claim.information.date is-open=claim.isOpen1 datepicker-options=claim.datepickerOptions placeholder={{claim.calendarFormat}} show-button-bar=false> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"claim.isOpen1 = !claim.isOpen1\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><div class=form-group><label for=location ng-bind=claim.text3></label><input type=text class=form-control id=location placeholder=\"{{ claim.placeholder3 }}\" ng-model=claim.information.location></div><div class=\"form-group how\"><label for=how ng-bind=claim.text4></label><textarea class=form-control id=how rows=4 placeholder=\"{{ claim.placeholder4 }}\" ng-model=claim.information.how></textarea></div><div class=form-group><label for=amount ng-bind=claim.text5></label><input type=text class=form-control id=amount placeholder=\"{{ claim.placeholder5 }}\" ng-model=claim.information.amount></div><div class=text-center><button class=\"btn btn-1\" ng-disabled=\"!claim.information.name || !claim.information.date || !claim.information.location || !claim.information.how || !claim.information.amount\" ng-click=claim.proceed() ng-bind=claim.btn1></button></div></div></div></div></div>");
$templateCache.put("app/claim/claim-6.html","<div class=\"claim common-page\"><back-navbar content=Claim remove-margin=yes></back-navbar><div class=grey-bar><div class=\"orange-bar bar-60\"></div></div><div class=container><div class=row><div class=col-xs-12><div class=\"form-group dual-options\"><label for=receivingTreatment ng-bind=claim.text1></label><div class=text-center><button class=\"btn btn-option\" ng-class=\"{ \'btn-selected\': claim.information.receivingTreatment === claim.btn1 }\" ng-bind=claim.btn1 ng-click=\"claim.information.receivingTreatment = claim.btn1\"></button> <button class=\"btn btn-option\" ng-class=\"{ \'btn-selected\': claim.information.receivingTreatment === claim.btn2 }\" ng-bind=claim.btn2 ng-click=\"claim.information.receivingTreatment = claim.btn2\"></button></div></div></div><div class=col-xs-12><label for=hospitalization-start-date ng-bind=claim.text2></label></div><div class=col-xs-6><div class=form-group><p class=input-group><input type=text id=hospitalization-start-date class=form-control uib-datepicker-popup=\"{{ claim.calendarFormat }}\" ng-model=claim.information.hospitalizationStartDate is-open=claim.isOpen1 datepicker-options=claim.datepickerOptions1 placeholder=\"{{ claim.placeholder2 }}\" show-button-bar=false ng-change=claim.setEndDateOptions()> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"claim.isOpen1 = !claim.isOpen1;\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><div class=col-xs-6><div class=form-group><p class=input-group><input type=text class=form-control uib-datepicker-popup=\"{{ claim.calendarFormat }}\" ng-model=claim.information.hospitalizationEndDate is-open=claim.isOpen2 datepicker-options=claim.datepickerOptions2 placeholder=\"{{ claim.placeholder3 }}\" show-button-bar=false ng-change=claim.setSurgDateOptions()> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"claim.isOpen2 = !claim.isOpen2;\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><div class=col-xs-12><div class=form-group><label for=benefits ng-bind=claim.text3></label><div class=radio ng-class=\"{ \'selected\': claim.information.treatment === treatment.value }\" ng-repeat=\"treatment in claim.treatments\"><div class=form-radio><label><input type=radio name=treatments value=\"{{ treatment.value }}\" ng-model=claim.information.treatment> <span class=radio-button></span> <span ng-bind=treatment.display></label></div></div></div><div class=form-group><label for=surgery ng-bind=claim.text4></label><select id=surgery class=form-control ng-model=claim.information.surgery><option value=\"\" ng-bind=claim.placeholder4 disabled ng-selected=!claim.information.surgery hidden></option><option value=\"{{ surgery.value }}\" ng-bind=surgery.display ng-repeat=\"surgery in claim.surgeries\" ng-selected=\"claim.information.surgery === surgery.value\"></option></select></div><div class=form-group><label for=surgery-date ng-bind=claim.text5></label><p class=input-group><input type=text id=surgery-date class=form-control uib-datepicker-popup=\"{{ claim.calendarFormat }}\" ng-model=claim.information.surgeryDate is-open=claim.isOpen3 datepicker-options=claim.datepickerOptions3 placeholder=\"{{ claim.placeholder5 }}\" show-button-bar=false> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"claim.isOpen3 = !claim.isOpen3\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=text-center><button class=\"btn btn-1\" aang-disabled=\"!claim.information.receivingTreatment || !claim.information.hospitalizationStartDate || !claim.information.hospitalizationEndDate || !claim.information.treatment || !claim.information.surgery || !claim.information.surgeryDate\" ng-click=claim.proceed() ng-bind=claim.btn3></button></div></div></div></div></div>");
$templateCache.put("app/claim/claim-7.html","<div class=\"claim common-page\"><back-navbar content=\"{{ \'claim_upload_supporting_documents\' | translate }}\" remove-margin=yes></back-navbar><div class=grey-bar><div class=orange-bar ng-class=\'{\"bar-80\": claim.information.files.length <= 0, \"bar-90\": claim.information.files.length > 0}\'></div></div><div class=container><div class=row><div class=col-xs-12><div class=\"form-group upload\"><label translate=claim_upload_supporting_documents></label><div class=uploaded-files ng-if=\"claim.information.files.length > 0\"><div class=title translate=claim_document></div><div ng-repeat=\"file in claim.information.files\"><div class=file><img src=/assets/images/document.png> <span ng-bind=file.name></span></div><input type=text class=form-control placeholder=\"{{ \'claim_document_description\' | translate }}\" ng-model=file.description></div></div><div class=\"drop-box text-center\" ngf-select=claim.uploadFiles($files) multiple ngf-drop=claim.uploadFiles($files) ngf-drag-over-class=\"\'dragover\'\" ngf-multiple=true ngf-pattern=\"\'image/*,application/pdf\'\" ng-if=\"claim.information.files.length === 0\"><img class=img-responsive src=/assets/images/inbox.png> <span translate=claim_no_documents></span></div><div class=\"add-more button\" ngf-select=claim.uploadFiles($files) multiple ngf-multiple=true ngf-pattern=\"\'image/*,application/pdf\'\" ng-if=\"claim.information.files.length > 0\"><span translate=claim_add_documents></span></div></div><div class=text-center><button class=\"btn btn-1\" aang-disabled=\"claim.information.files.length === 0\" ng-click=claim.proceed() translate=claim_claim_payment_details></button></div></div></div></div></div>");
$templateCache.put("app/claim/claim-8.html","<div class=\"claim common-page\"><back-navbar content=\"Confirm Details\" remove-margin=yes></back-navbar><div class=grey-bar><div class=\"orange-bar bar-100\"></div></div><div class=container><div class=row><div class=col-xs-12><p class=title ng-bind=claim.text1></p><div class=uploaded-files><p><span ng-bind=claim.startDate></span> - <span ng-bind=claim.endDate></span></p><p ng-bind=claim.information.how></p><p ng-bind=claim.information.location></p><p><strong ng-bind=claim.text2></strong></p><div ng-repeat=\"file in claim.information.files\"><a href=\"{{ file.url }}\" target=_blank><div class=file><img src=/assets/images/document.png> <span ng-bind=file.name></span></div></a></div><p class=total><span ng-bind=claim.text3></span> <span class=pull-right><span ng-bind=claim.information.amount></span> <span ng-bind=claim.text4></span></span></p></div></div><div class=col-xs-12><div class=text-center><button class=\"btn btn-1\" ng-click=claim.proceed() ng-bind=claim.btn1></button></div></div></div></div></div>");
$templateCache.put("app/claim/claim-9.html","<div class=\"claim common-page\"><back-navbar icon=glyphicon-menu-down content=\"Claim Completed\" link=main></back-navbar><div class=container><div class=\"row claimed\"><div class=\"col-xs-12 text-center\"><img class=img-responsive src=/assets/images/check.png><p class=title translate=claim_your_claim_has_been_submitted></p><div class=\"card p16 border\"><div class=\"description mb24\"><span translate=claim_reference_number></span> <span ng-bind=claim.reference></span></div><div class=description ng-repeat=\"Payable in claim.Payable\" ng-bind=\"Payable.BenefitName + \'  \' + Payable.GrossPayable\"></div></div></div><div class=col-xs-12><p class=text-center><button class=\"btn btn-1\" ui-sref=claim-quick-claim translate=claim_back_to_my_account></button></p></div></div></div></div>");
$templateCache.put("app/claim/quick-claim.html","<div class=\"claim common-page\"><back-navbar content=\"{{ \'claim_accident_details\' | translate }}\"></back-navbar><div class=container><div class=row><div class=col-xs-12><div class=form-group><label for=holder-name translate=claim_name_of_policy_owner></label><input type=text class=form-control id=holder-name placeholder=\"{{ \'claim_policy_holder_name\' | translate }}\" ng-model=claim.responses.insuredName ng-value=claim.policyDetails.Cont.Owner.Name></div><div class=form-group><label for=insured-name translate=claim_name_of_insured_party></label><input type=text class=form-control id=insured-name placeholder=\"{{ \'claim_insured_person_name\' | translate }}\" ng-model=claim.responses.insuredName ng-value=\"claim.policyDetails.Cont.Risks[\'1\'].RiskBody.InsuredParty.Name\"></div><div class=\"border-bottom mt40\"></div><div class=\"font-12 text-copy-0 text-500 mb24 mt8 text-uppercase\" translate=claim_accident_details></div><label for=accidentDate translate=claim_when_did_the_accident_happen></label><p class=input-group><input type=text ng-change=claim.setMinHospStart() id=accidentDate class=form-control uib-datepicker-popup=\"yyyy / MM /dd\" ng-model=claim.responses.date is-open=claim.isOpen1 datepicker-options=claim.datepickerOptions1 placeholder={{claim.calendarFormat}} show-button-bar=false> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"claim.isOpen1 = !claim.isOpen1\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><!--         <div class=\"form-group\">\n          <label for=\"holder-name\" ng-bind=\"claim.label4\"></label>\n          <select type=\"text\" class=\"form-control\" id=\"holder-name\" placeholder=\"{{ claim.placeholder2 }}\" ng-model=\"claim.responses.accidentType\" ng-value=\"claim.policyDetails.Cont.Risks[\'1\'].RiskBody.InsuredParty.Name\">\n            <option value=\"Y\" ng-bind=\"claim.input4.option1\"></option>\n            <option value=\"Y\" ng-bind=\"claim.input4.option2\"></option>\n            <option value=\"N\" ng-bind=\"claim.input4.option3\"></option>\n          </select>\n        </div> --><div class=\"border-bottom mt40\" ng-if=claim.responses.date></div><!-- <div class=\"font-12 text-copy-0 text-500 mb24 mt8 text-uppercase\" translate=\"claim_hospitalization\" ng-if=\"claim.responses.date\"></div> --><div class=row ng-if=claim.showHospStart><div class=col-xs-6><label for=hospStart translate=claim_start></label><p class=input-group><input type=text ng-change=claim.setMinHospEnd() id=hospStart class=form-control uib-datepicker-popup=\"yyyy / MM /dd\" ng-model=claim.responses.hospStart is-open=claim.isOpen2 datepicker-options=claim.datepickerOptions2 placeholder={{claim.calendarFormat}} show-button-bar=false> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"claim.isOpen2 = !claim.isOpen2\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div ng-if=claim.showHospEnd><div class=col-xs-6><label for=hospEnd translate=claim_end></label><p class=input-group><input type=text ng-change=claim.setSurg() id=hospEnd class=form-control uib-datepicker-popup=\"yyyy / MM /dd\" ng-model=claim.responses.hospEnd is-open=claim.isOpen3 datepicker-options=claim.datepickerOptions3 placeholder={{claim.calendarFormat}} show-button-bar=false> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"claim.isOpen3 = !claim.isOpen3\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div></div><div class=\"form-group mt8\" ng-if=claim.responses.hospEnd><label for=surgery-type translate=reason_for_claim></label><input type=text ng-change=claim.setSurg() id=hospEnd class=form-control ng-model=claim.responses.hospStatus><!-- <select type=\"text\" class=\"form-control\" id=\"surgery-type\" placeholder=\"{{ claim.placeholder2 }}\" ng-model=\"claim.responses.hospStatus\" ng-value=\"claim.policyDetails.Cont.Risks[\'1\'].RiskBody.InsuredParty.Name\">\n            <option value=\"In_Pa\" translate=\"claim_in_hospital\"></option>\n            <option value=\"Out_Pa\" translate=\"claim_out_of_hospital\"></option>\n            <option value=\"Recover\" translate=\"claim_recovering\"></option>\n          </select> --></div><!-- <div class=\"form-group mt8\" ng-if=\"claim.responses.hospEnd\">\n          <label for=\"surgery-type\" translate=\"claim_what_is_the_status_of_your_treatment\"></label>\n          <select type=\"text\" class=\"form-control\" id=\"surgery-type\" placeholder=\"{{ claim.placeholder2 }}\" ng-model=\"claim.responses.hospStatus\" ng-value=\"claim.policyDetails.Cont.Risks[\'1\'].RiskBody.InsuredParty.Name\">\n            <option value=\"In_Pa\" translate=\"claim_in_hospital\"></option>\n            <option value=\"Out_Pa\" translate=\"claim_out_of_hospital\"></option>\n            <option value=\"Recover\" translate=\"claim_recovering\"></option>\n          </select>\n        </div> --><!-- <div ng-if=\"claim.showSurg\">\n          <label for=\"surgDate\" translate=\"claim_date_of_surgery\"></label>\n          <p class=\"input-group\">\n            <input type=\"text\"\n                   id=\"surgDate\"\n                   class=\"form-control\"\n                   uib-datepicker-popup=\"yyyy / MM /dd\"\n                   ng-model=\"claim.responses.surgery\"\n                   is-open=\"claim.isOpen4\"\n                   datepicker-options=\"claim.datepickerOptions4\"\n                   placeholder=\"{{claim.calendarFormat}}\"\n                   show-button-bar=\"false\" />\n            <span class=\"input-group-btn\">\n              <button type=\"button\" class=\"btn btn-default\" ng-click=\"claim.isOpen4 = !claim.isOpen4\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\n            </span>\n          </p>\n        </div> --><div class=\"border-bottom mt40\"></div><div class=\"font-12 text-copy-0 text-500 mb24 mt8 text-uppercase\" translate=claim_third_party_liability></div><div class=form-group><label for=tp-amount translate=claim_claim_amount></label><input type=text class=form-control id=tp-amount ng-model=claim.responses.tpAmt></div><div class=form-group><label for=tp-address translate=claim_third_party_address></label><input type=text class=form-control id=tp-address ng-model=claim.responses.tpAdd></div><div class=\"btn btn-orange w-100 btn-lg font-14 mb16 mt24\" ng-disabled=\"!claim.responses.hospEnd && !claim.responses.surgery && !claim.responses.tpAmt\" ng-click=claim.validate() translate=claim_upload_documents></div></div></div></div></div>");
$templateCache.put("app/home-purchase/step-1.html","<div class=home-purchase><back-navbar remove-margin=yes content=\"Policy and Home Details\"></back-navbar><div class=box-behind-pill-wrapper><div class=box-behind-pill></div></div><div class=container><div class=row><div class=col-xs-12><div class=content><div class=banner><span class=icon><img src=/assets/images/products-home-icon.svg style=\"height: 24px\"></span><div class=\"text page-title\">Home</div></div></div></div><div class=col-xs-12><div class=subtitle translate=\"\">Your Policy</div><div class=\"form-group mb16\"><label for=departure-date translate=\"\">Policy Start Date</label><p class=\"input-group input-box\"><input type=text class=form-control id=insurance-date uib-datepicker-popup=\"{{ homePurchase.opts.calendarFormat }}\" ng-model=homePurchase.ui.insuranceDate is-open=homePurchase.isOpenInsuranceDate datepicker-options=homePurchase.opts.datepickerOptionsForInsuranceDate placeholder=\"{{ \'date_placeholder\' | translate }}\" show-button-bar=false> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"homePurchase.isOpenInsuranceDate = !homePurchase.isOpenInsuranceDate\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=subtitle translate=\"\">Your Property Address</div><!-- <div class=\"form-group mb24 dual-options\">\n          <label for=\"count\" translate=\"\">Who owns the property</label>\n          <div class=\"text-center\">\n            <button class=\"btn btn-option\" ng-class=\"{ \'btn-selected\': homePurchase.ui.propertyOwnership === \'Home Owner\' }\" translate=\"\" ng-click=\"homePurchase.ui.propertyOwnership = \'Home Owner\'\">I am the Owner</button>\n            <button class=\"btn btn-option\" ng-class=\"{ \'btn-selected\': homePurchase.ui.propertyOwnership === \'Tenant\' }\" translate=\"\" ng-click=\"homePurchase.ui.propertyOwnership = \'Tenant\'\">I am a Tenant</button>\n          </div>\n        </div>    --><div class=form-group><label for=unitNumber translate=\"\">Unit Number</label><input type=unitNumber class=form-control id=unitNumber ng-model=homePurchase.ui.propertyAddress.unitNumber></div><div class=form-group><label for=streetAddress translate=\"\">Street Address</label><input type=streetAddress class=form-control id=streetAddress ng-model=homePurchase.ui.propertyAddress.streetAddress></div><div class=form-group><label for=postCode translate=\"\">Post Code</label><input type=postCode class=form-control id=postCode ng-model=homePurchase.ui.propertyAddress.postCode></div><p class=text-center><button ng-disabled=\"\" class=\"btn btn-3\" ng-click=homePurchase.proceed() translate=travel_purchase_next></button></p></div></div></div></div><!--             <img class=\"img-responsive\" src=\"/assets/images/products-travel-icon.svg\"> -->");
$templateCache.put("app/home-purchase/step-2.html","<div class=home-purchase><back-navbar remove-margin=yes content=\"Your Policy\"></back-navbar><div class=box-behind-pill-wrapper><div class=box-behind-pill></div></div><div class=container><div class=row><div class=col-xs-12><div class=content><div class=\"banner flex-row d-flex\"><span class=icon><img src=/assets/images/products-home-icon.svg style=\"height: 24px\"></span><div class=\"flex-fill text page-title\">Home</div><div ng-bind=\"homePurchase.ui.price | currency: homePurchase.ui.DefaultCurrency\" class=\"text-white text-700 font-16\"></div></div></div></div><div class=col-xs-12 style=\"margin-top: 30px\"><div class=form-group><label for=unitNumber translate=\"\">Select Your Plan</label><select class=form-control ng-model=homePurchase.selectedPlan ng-change=homePurchase.loadPrice()><option value=\"All Risks\" ng-selected=true>All Risks</option><option value=\"Named Perils\">Named Perils</option></select></div></div><div class=col-xs-12><div class=form-group><label for=unitNumber translate=\"\">What is your occupancy status?</label><select class=form-control ng-model=homePurchase.ui.OccupancyStatus ng-change=homePurchase.handleSIChange()><option value=\"\" ng-selected=true>Select Occupancy Status</option><option value={{occupancyStatus}} ng-repeat=\"occupancyStatus in homePurchase.ui.OccupancyStatusList\">{{occupancyStatus}}</option></select></div><div class=form-group><label for=unitNumber translate=\"\">Your Property Type</label><select class=form-control ng-model=homePurchase.ui.PropertyType ng-change=homePurchase.handleSIChange()><option value=\"\" ng-selected=true>Select Property Type</option><option value={{propertyType}} ng-repeat=\"propertyType in homePurchase.ui.PropertyTypeList\">{{propertyType}}</option></select></div><!-- <div class=\"form-group\">\n          <label for=\"unitNumber\" translate=\"\">Number of Rooms</label>\n          <select class=\"form-control\" ng-model=\"homePurchase.ui.NumberOfRooms\" ng-change=\"homePurchase.handleSIChange()\">\n            <option value=\"\" ng-selected=\"true\">Select Number of Rooms</option>\n            <option value=\"{{room}}\" ng-repeat=\"room in homePurchase.ui.NumberOfRoomsList\">{{room}}</option>\n          </select>\n        </div>\n        <div class=\"form-group\">\n          <label for=\"unitNumber\" translate=\"\">Endorsement Type</label>\n          <select class=\"form-control\" ng-model=\"homePurchase.ui.EndorsementType\" ng-change=\"homePurchase.handleSIChange()\">\n            <option value=\"\" ng-selected=\"true\">Select Endorsement Type</option>\n            <option value=\"{{endorsement}}\" ng-repeat=\"endorsement in homePurchase.ui.EndorsementTypeList\">{{endorsement}}</option>\n          </select>\n        </div> --></div><div class=col-xs-12 style=overflow:scroll><div class=subtitle translate=\"\">Your Coverages</div><table class=table><thead><th>Benefit</th><th>Sum Insured</th><th>Premium</th></thead><tbody><tr ng-repeat=\"benefit in homePurchase.ui.BenefitList\" ng-if=\"benefit.IncludeOnUI==\'Y\'\"><td><div class=mb8><div class=checkbox ng-class=\"{ selected: benefit.enabled }\" ng-click=\"benefit.enabled = !benefit.enabled; homePurchase.handleSIChange($index, homePurchase.ui.BenefitList[$index].LimitDefault, benefit.Option)\"><div class=form-check><input type=checkbox class=form-check-input ng-model=benefit.enabled ng-hide=\"benefit.Optional==\'N\'\"> <span class=checkmark></span><label class=form-check-label ng-bind=\"benefit.Option + \'-\' + benefit.Desc\"></label></div></div></div></td><td style=\"vertical-align: middle\"><div ng-if=\"benefit.SumInsured == \'F\'\">{{benefit.LimitDefault}}</div><path d=\"M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z\"></path><select ng-if=\"benefit.SumInsured != \'F\'\" ng-disabled=!benefit.enabled class=\"form-control input-box\" ng-model=homePurchase.ui.BenefitList[$index].LimitDefault ng-change=\"homePurchase.handleSIChange($index, homePurchase.ui.BenefitList[$index].LimitDefault, benefit.Option)\"><option value=\"\" translate=home_purchase_select_si ng-selected=!homePurchase.ui.BenefitList[$parent.$index].LimitDefault></option><option value=\"{{ limitVal }}\" ng-repeat=\"limitVal in benefit.LimitInterval.split(\';\')\" ng-bind=limitVal ng-selected=\"limitVal == homePurchase.ui.BenefitList[$parent.$index].LimitDefault\"></option></select></td><td style=\"vertical-align: middle\">{{benefit.Premium | currency: homePurchase.ui.DefaultCurrency }}</td></tr><tr><td colspan=3><div class=amount-box id=amount-box><table class=\"table table-sm amount-table\"><tbody><tr ng-repeat=\"summary in homePurchase.ui.BenefitSummary\"><td><b ng-bind=summary.title></b></td><td ng-bind=\"summary.value | currency: homePurchase.ui.DefaultCurrency\"></td></tr></tbody></table></div></td></tr></tbody></table><!-- <div class=\"mb8\" ng-repeat=\"benefit in homePurchase.ui.benefitSelection\">\n          <div class=\"checkbox\"\n               ng-class=\"{ selected: benefit.enabled }\"\n               ng-click=\"benefit.enabled = !benefit.enabled;homePurchase.loadPrice()\">\n            <div class=\"form-check\">\n              <input type=\"checkbox\"\n                     class=\"form-check-input\"\n                     ng-model=\"benefit.enabled\">\n              <span class=\"checkmark\"></span>  \n            </div>\n          </div>\n        </div> --><p class=\"text-center mt24\"><button ng-disabled=\"\" class=\"btn btn-3\" ng-click=homePurchase.proceed() translate=travel_purchase_next></button></p></div></div></div></div>");
$templateCache.put("app/home-purchase/step-3.html","");
$templateCache.put("app/embedded/embedded-dbs-1.html","<div style=\"background: #9C43FF; height: 30vh; padding-top: 18vh\"><div class=container><div class=row><div class=col-xs-12><img class=img-responsive src=/assets/images/coherent-logo-white.svg style=\"height: 48px\"></div></div></div></div><div class=\"container pt64 pb64\"><div class=row><div class=col-sm-6 ng-repeat=\"tile in cont.productTiles\"><div class=\"border p16 mb16\"><h4 ng-bind=tile.title>Loading...</h4><div ng-bind=tile.desc>Loading...</div><a ng-click=cont.learnMore(tile.name)>Learn More</a></div></div></div></div>");
$templateCache.put("app/embedded/embedded-dbs-2.html","<div style=\"background: #9C43FF; height: 30vh; padding-top: 18vh\"><div class=container><div class=row><div class=col-xs-12><img class=img-responsive src=/assets/images/coherent-logo-white.svg style=\"height: 48px\"></div></div></div></div><div class=container><div class=row><div class=col-xs-12><h1 ng-bind=cont.title></h1><h2 calss=mt16 ng-bind=cont.Premium></h2><p ng-bind=cont.desc></p><a href={{cont.CTAURL}} class=\"btn btn-md btn-primary mt16\">Apply Now</a><p class=\"text-copy-0 mt24\" ng-bind=cont.Disclaimer></p></div></div></div>");
$templateCache.put("app/embedded/embedded-flex-1.html","<div class=embedded><section><div class=container><div class=\"row pt16 pb16 border-bottom\"><div class=\"col-xs-12 font-21\"><div class=\"d-flex flex-row\"><a ui-sref=embedded-flex-1 class=\"flex-fill text-copy-2\">Digibank</a><div class=\"dropdown mr16\"><button class=\"btn btn-secondary dropdown-toggle\" type=button id=dropdownMenuButton data-toggle=dropdown aria-haspopup=true aria-expanded=false ng-bind=cont.activePersona></button><div class=\"dropdown-menu p16 w-100 dropdown-menu-right\" aria-labelledby=dropdownMenuButton style=\"width: 256px\"><a class=\"dropdown-item display-block mb16 text-copy-2 pt16\" ng-repeat=\"persona in cont.personas\" ng-click=\"console.log(\'a-clicked\');cont.setPersona(persona.Persona_ID)\"><div class=\"font-21 pt16\" ng-bind=persona.Name><strong>Vander</strong></div><div><strong>Age: </strong><span ng-bind=persona.Prm_Age></span></div><div><strong>Gender: </strong><span ng-bind=persona.Prm_Gender></span></div><div><strong>Marital Status: </strong><span ng-bind=persona.Prm_Marital_Status></span></div><div><strong>Income: </strong><span ng-bind=persona.Prm_Income></span></div></a></div></div><img src=assets/images/user-icon.svg width=32></div></div></div></div></section><section><div class=container><div class=\"row pt16 pb16 border-bottom bg-gray-1\" ui-sref=embedded-flex-2><div class=\"col-xs-12 font-16\"><div class=\"badge font-14 text-copy-2 bg-white border\">Get a <span ng-bind=cont.discount></span>% Discount</div></div><div class=\"col-xs-12 font-21 mt16\">My Flex Insurance</div><div class=\"col-xs-12 font-14\">Starting at $50/month</div></div><div class=row><div class=\"col-xs-12 font-16\"><div class=\"font-14 mt32\">Balance</div></div><div class=\"col-xs-12 font-40 mt8\" ng-bind=cont.balance></div></div><div class=row><div class=\"col-xs-12 font-16\"><div class=\"font-14 mt32\">Transactions</div></div></div><div class=\"border d-flex flex-row p16 mt32\"><span class=flex-fill>Healthcare</span> <span ng-bind=cont.txn1></span></div><div class=\"border d-flex flex-row p16 mt16\"><span class=flex-fill>Child</span> <span ng-bind=cont.txn2></span></div><div class=\"border d-flex flex-row p16 mt16\"><span class=flex-fill>Retail</span> <span ng-bind=cont.txn3></span></div><div class=\"border d-flex flex-row p16 mt16\"><span class=flex-fill>Auto</span> <span ng-bind=cont.txn4></span></div><div class=\"border d-flex flex-row p16 mt16\"><span class=flex-fill>Rent</span> <span ng-bind=cont.txn5></span></div><div class=\"border d-flex flex-row p16 mt16\"><span class=flex-fill>Travel</span> <span ng-bind=cont.txn6></span></div></div></section></div>");
$templateCache.put("app/embedded/embedded-flex-2.html","<div class=embedded><section><div class=container><div class=\"row pt16 pb16 border-bottom\"><div class=col-xs-12><a ui-sref=embedded-landing>Reset</a></div></div></div></section><section><div class=container><div class=\"row pt16 pb16 border-bottom\"><div class=\"col-xs-12 font-21 d-flex flex-row\"><span class=flex-fill>Total Premium</span> <span ng-bind=cont.totalPrice id=totprice-animate></span></div><div class=\"col-xs-12 d-flex flex-row\"><span class=flex-fill>Multi-Product Discount (<span id=discount-animate ng-bind=cont.discount></span>%)</span> <span><strike><span ng-bind=cont.oldprice></span></strike></span></div></div></div></section><section><div class=container><div class=row><div class=col-xs-12><div class=\"border p16 p8 mt16 bg-gray-2\" ng-repeat=\"plan in cont.recommendedPlans\"><div class=\"checkbox mt0 mb16\" ng-class=\"{ selected: cont.checkbox[plan.ID] }\" ng-click=\"cont.checkbox[plan.ID] = !cont.checkbox[plan.ID];cont.customize()\"><div class=form-check><input type=checkbox class=form-check-input ng-model=cont.checkbox[plan.ID]> <span class=checkmark></span><label class=form-check-label ng-bind=plan.name></label></div></div><div ng-hide=\"plan.Max===1\"><range model=cont.slider[plan.ID].convertedcover min=cont.slider[plan.ID].convertedmin max=cont.slider[plan.ID].convertedmax disabled ng-click=cont.customize()></range><div class=\"d-flex flex-row mt8 font-16 text-700\"><label for=\"\" class=flex-fill>Cover: <span ng-bind=cont.slider[plan.ID].cover></span></label><div>Premium: &nbsp; <span ng-class=\"{ strike: !cont.checkbox[plan.ID] }\" ng-bind=plan.premium></span></div></div></div></div></div><div class=\"col-xs-12 font-24 mt32 mb16\"><a ui-sref=embedded-flex-3><u>Next Step</u></a></div></div></div></section></div>");
$templateCache.put("app/embedded/embedded-flex-3.html","<div class=embedded><section><div class=container><div class=\"row pt16 pb16 border-bottom\"><div class=col-xs-12><a ui-sref=embedded-landing>Reset</a></div></div></div></section><section><div class=container><div class=\"row pt16 pb16 border-bottom\"><div class=\"col-xs-12 font-21\">Total Price: <span ng-bind=cont.totalPrice></span></div><div class=\"col-xs-12 font-14\">Get a <span ng-bind=cont.discount></span>% bundle discount. Old price: <strike><span ng-bind=cont.oldprice></span></strike></div></div></div></section><section><div class=container><div class=row><div class=col-xs-12><div ng-repeat=\"question in cont.UWquestions\"><div class=\"border p16 p8 mt16\" ng-if=\"question.Display == \'Y\'\"><div ng-bind=question.Value></div><div class=\"d-flex flex-row mt8\"><div class=flex-fill>NO</div><div>YES</div></div></div></div></div></div></div></section></div>");
$templateCache.put("app/embedded/embedded-flex-invest.html","<div class=\"container-fluid p0 embedded\"><div class=\"d-flex flex-row\"><div class=\"p32 border-right\" style=\"min-height: 100vh; width: 280px\"><!-- <div class=\"mb32\" style=\"border-radius: 50%; height: 128px; width: 128px; margin-left: auto; margin-right: auto; background: #efefef;background-image: url(\'/assets/images/avatars/cassandra.png\')\" ng-style=\"{\'background-image\': \'url(\'/assets/images/purchase-bg-3.png\')\'}\">\n      </div> --><div class=text-center><img src=/assets/images/avatars/{{cont.activePersona}}.png class=mb32 style=\"border-radius: 50%; height: 128px; width: 128px; margin-left: auto; margin-right: auto\"></div><div class=dropdown><button class=\"btn btn-secondary dropdown-toggle font-24 w-100\" type=button id=dropdownMenuButton data-toggle=dropdown aria-haspopup=true aria-expanded=false ng-bind=cont.activePersona></button><div class=\"dropdown-menu p16 w-100 dropdown-menu-left\" aria-labelledby=dropdownMenuButton style=\"width: 256px\"><a class=\"dropdown-item inline-block mb16 text-copy-2\" ng-repeat=\"persona in cont.personas\" ng-click=\"console.log(\'a-clicked\');cont.setPersona(persona.Persona_ID)\"><div class=\"font-21 mb8\" ng-bind=persona.Name><strong></strong></div><div><strong>Age: </strong><span ng-bind=persona.Prm_Age></span></div><div><strong>Gender: </strong><span ng-bind=persona.Prm_Gender></span></div><div><strong>Marital Status: </strong><span ng-bind=persona.Prm_Marital_Status></span></div><div><strong>Income: </strong><span ng-bind=persona.Prm_Income></span></div></a></div></div><div class=\"border border-radius-md bg-gray-2 p16 mt24\"><p class=pb8><strong>Age: </strong><span ng-bind=cont.psn1></span></p><p class=pb8><strong>Gender: </strong><span ng-bind=cont.psn2></span></p><p class=pb8><strong>Marital Status: </strong><span ng-bind=cont.psn3></span></p><p class=pb8><strong>Income: </strong><span ng-bind=cont.psn4></span></p><p class=\"pb8 pt16\"><strong>Transactions </strong></p><p class=pb8><strong>Health: </strong><span ng-bind=cont.txn1></span></p><p class=pb8><strong>Child: </strong><span ng-bind=cont.txn2></span></p><p class=pb8><strong>Retail: </strong><span ng-bind=cont.txn3></span></p><p class=pb8><strong>Auto: </strong><span ng-bind=cont.txn4></span></p><p class=pb8><strong>Rent: </strong><span ng-bind=cont.txn5></span></p><p class=pb8><strong>Travel: </strong><span ng-bind=cont.txn6></span></p><p class=pb8><strong>Crypto: </strong><span ng-bind=cont.txn7></span></p><p class=\"pb8 pt16\"><strong>Risk Appetite: </strong>High</p></div></div><div class=flex-fill><div class=\"border-bottom p32 font-32 text-700\">My Wealth and Protection Plan</div><div class=p32><div class=\"card p24 box-shadow border border-radius-md mb32\"><div class=\"d-flex flex-row\"><p class=\"font-21 mb32 flex-fill\"><strong>Summary</strong></p><img src=/assets/images/ftgo-logo.png height=40></div><p>Wealth plan portfolio alocation</p><div class=\"bg-gray-2 border-radius mb32\"><div class=\"p16 border-bottom\"><p class=mb24><strong>Overview</strong></p><div class=\"d-flex flex-row\"><div class=flex-fill><p><strong>Goal Importance</strong><br>Want</p><p><strong>Initial Investment</strong><br>$35,000</p></div><div class=flex-fill><p><strong>Goal Date</strong><br>January 2035</p><p><strong>Target Portfoio Value</strong><br>$350,000</p></div><div class=flex-fill><p class=opacity-0><strong>.</strong><br>.</p><p><strong>Contributions</strong><br>$15,000 Annually</p></div></div></div><div class=p16><p class=mb24><strong>Allocation</strong></p><div class=\"d-flex flex-row\"><div class=\"flex-fill font-21 text-purple\"><strong>Equity:</strong> <span ng-bind=cont.equity>30</span>%</div><div class=\"flex-fill font-21 text-teal\"><strong>Fixed Income:</strong> <span ng-bind=cont.fixedIncome>70</span>%</div><div class=flex-fill></div></div></div></div><p>To protect your goals and loved ones, we also recommend a bundle of</p><div class=\"bg-gray-2 border-radius p16 mb16 d-flex flex-row\" ng-repeat=\"product in cont.recommendedPlans\"><div class=flex-fill><strong ng-bind=\"product.name + \' Insurance\'\"></strong></div></div></div><div class=\"card box-shadow border border-radius-md mb32 overflow-hidden\"><div class=p24><p class=font-21><strong>Wealth</strong></p></div><div class=bg-gray-2><div class=\"p24 border-bottom\"><p class=mb24><strong>Overview</strong></p><div class=\"d-flex flex-row\"><div class=flex-fill><p><strong>Goal Importance</strong><br>Want</p><p><strong>Initial Investment</strong><br>$35,000</p></div><div class=flex-fill><p><strong>Goal Date</strong><br>January 2035</p><p><strong>Target Portfoio Value</strong><br>$350,000</p></div><div class=flex-fill><p class=opacity-0><strong>.</strong><br>.</p><p><strong>Contributions</strong><br>$15,000 Annually</p></div></div></div><div class=p24><p class=mb24><strong>Allocation</strong></p><div class=\"d-flex flex-row\"><div class=\"flex-fill font-21 text-purple\"><strong>Equity:</strong> <span ng-bind=cont.equity>30</span>%</div><div class=\"flex-fill font-21 text-teal\"><strong>Fixed Income:</strong> <span ng-bind=cont.fixedIncome>70</span>%</div><div class=flex-fill></div></div></div></div><div class=\"p24 pt24 pb24 bg-purple d-flex flex-row text-white font-16 text-700\"><div class=flex-fill>Equity</div><div>Recommended %</div></div><div class=\"p24 pt16 pb16 border-bottom\" ng-if=\"equity.AssetType == \'EQ\'\" ng-repeat=\"equity in cont.recommendedEquity\"><div class=\"d-flex flex-row\"><div class=flex-fill ng-bind=equity.ProductName></div><div ng-bind=\"(equity[\'Recommend Coverage\'] * 100 | number: 2) + \'%\'\"></div></div></div><div class=\"p24 pt24 pb24 bg-teal d-flex flex-row text-white font-16 text-700\"><div class=flex-fill>Fixed Income</div><div>Recommended %</div></div><div class=\"p24 pt16 pb16 border-bottom\" ng-if=\"equity.AssetType == \'FIX\'\" ng-repeat=\"equity in cont.recommendedEquity\"><div class=\"d-flex flex-row\"><div class=flex-fill ng-bind=equity.ProductName></div><div ng-bind=\"(equity[\'Recommend Coverage\'] * 100 | number: 2) + \'%\'\"></div></div></div></div><div class=\"card box-shadow border border-radius-md mb32 overflow-hidden\"><div class=p24><p class=font-21><strong>Protection</strong></p></div><div class=bg-gray-2><div class=p24><div class=\"font-21 d-flex flex-row\"><span class=flex-fill>Total Premium</span> <span ng-bind=\"\'$\' + cont.totalPrice\" id=totprice-animate></span></div><div class=\"d-flex flex-row\"><span class=flex-fill>Multi-Product Discount (<span id=discount-animate ng-bind=cont.discount></span>%)</span> <span><strike><span ng-bind=\"\'$\' + cont.oldprice\"></span></strike></span></div></div></div><div class=p24><div class=\"border p16 p8 mt16 bg-gray-2\" ng-repeat=\"plan in cont.recommendedPlans\"><div class=\"checkbox mt0 mb16\" ng-class=\"{ selected: cont.checkbox[plan.ID] }\" ng-click=\"cont.checkbox[plan.ID] = !cont.checkbox[plan.ID];cont.customize()\"><div class=form-check><input type=checkbox class=form-check-input ng-model=cont.checkbox[plan.ID]> <span class=checkmark></span><label class=form-check-label ng-bind=\"plan.name + \' Insurance\'\"></label></div></div><div ng-hide=\"plan.Max===1\"><range model=cont.slider[plan.ID].convertedcover min=cont.slider[plan.ID].convertedmin max=cont.slider[plan.ID].convertedmax disabled ng-click=cont.customize()></range><div class=\"d-flex flex-row mt8 font-16 text-700\"><label for=\"\" class=flex-fill>Cover: <span ng-bind=\"\'$\' + cont.slider[plan.ID].cover\"></span></label><div>Premium: &nbsp; <span ng-class=\"{ strike: !cont.checkbox[plan.ID] }\" ng-bind=\"\'$\' + plan.premium\"></span></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/embedded/landing.html","<div class=embedded><section><div class=container><div class=\"row pt16 pb16 border-bottom\"><div class=\"col-xs-12 font-21\"><div class=\"d-flex flex-row\"><a ui-sref=embedded-flex-1 class=\"flex-fill text-copy-2\">Digibank</a><div class=\"dropdown mr16\"><button class=\"btn btn-secondary dropdown-toggle\" type=button id=dropdownMenuButton data-toggle=dropdown aria-haspopup=true aria-expanded=false ng-bind=cont.activePersona></button><div class=\"dropdown-menu p16 w-100 dropdown-menu-right\" aria-labelledby=dropdownMenuButton style=\"width: 256px\"><a class=\"dropdown-item inline-block mb16 text-copy-2\" ng-repeat=\"persona in cont.personas\" ng-click=\"console.log(\'a-clicked\');cont.setPersona(persona.Persona_ID)\"><div class=font-21 ng-bind=persona.Name><strong>Vander</strong></div><div><strong>Age: </strong><span ng-bind=persona.Prm_Age></span></div><div><strong>Gender: </strong><span ng-bind=persona.Prm_Gender></span></div><div><strong>Marital Status: </strong><span ng-bind=persona.Prm_Marital_Status></span></div><div><strong>Income: </strong><span ng-bind=persona.Prm_Income></span></div></a></div></div><img src=assets/images/user-icon.svg width=32></div></div></div></div></section><section><div class=container><div class=\"row pt16 pb16 border-bottom bg-gray-1\" ui-sref=embedded-flex-2><div class=\"col-xs-12 font-16\"><div class=\"badge font-14 text-copy-2 bg-white border\">Get a <span ng-bind=cont.discount></span>% Discount</div></div><div class=\"col-xs-12 font-21 mt16\">My Flex Isurance</div><div class=\"col-xs-12 font-14\">Starting at $50/month</div></div><div class=row><div class=\"col-xs-12 font-16\"><div class=\"font-14 mt32\">Balance</div></div><div class=\"col-xs-12 font-40 mt8\" ng-bind=cont.balance></div></div><div class=\"font-14 mt32\">Transactions</div><div class=\"border d-flex flex-row p16 mt16 bg-gray-1\"><span class=flex-fill>Healthcare</span> <span ng-bind=cont.txn1></span></div><div class=\"border d-flex flex-row p16 mt16 bg-gray-1\"><span class=flex-fill>Child</span> <span ng-bind=cont.txn2></span></div><div class=\"border d-flex flex-row p16 mt16 bg-gray-1\"><span class=flex-fill>Retail</span> <span ng-bind=cont.txn3></span></div><div class=\"border d-flex flex-row p16 mt16 bg-gray-1\"><span class=flex-fill>Auto</span> <span ng-bind=cont.txn4></span></div><div class=\"border d-flex flex-row p16 mt16 bg-gray-1\"><span class=flex-fill>Rent</span> <span ng-bind=cont.txn5></span></div><div class=\"border d-flex flex-row p16 mt16 bg-gray-1\"><span class=flex-fill>Travel</span> <span ng-bind=cont.txn6></span></div><div class=\"border d-flex flex-row p16 mt16 mb16 bg-gray-1\"><span class=flex-fill>Crypto</span> <span ng-bind=cont.txn7></span></div></div></section></div>");
$templateCache.put("app/main/main.html","<div class=products><div class=banner><img class=\"img-responsive logo\" src=/assets/images/coherent-white-icon.svg> <img class=\"img-responsive full-width\" src=/assets/images/products-storefront.png></div><div class=container><div class=row><div class=col-xs-12><div class=content>&nbsp;</div></div></div></div><div class=container><div class=row><div class=col-xs-12><div class=content><div ui-sref=purchase-8 class=\"product-button mb32\"><img class=img-responsive style=\"height: 24px; float:left\" src=/assets/images/avatars/adam.png> <span class=\"glyphicon glyphicon-menu-right\"></span><div class=title style=\"margin: 12px 15px; padding-left: 30px\">Continue as an Agent</div></div><div ui-sref=purchase-get-started class=\"product-button mb32\"><img class=img-responsive style=\"height: 24px;  float:left\" src=/assets/images/user.svg> <span class=\"glyphicon glyphicon-menu-right\"></span><div class=title style=\"margin: 12px 15px; padding-left: 30px\">Continue as a Customer</div></div></div></div></div></div></div>");
$templateCache.put("app/micro/micro-1.html","<div class=micro><div class=\"container bg-black\"><div class=row><div class=col-xs-12><div class=\"text-right pt24 pb24 pl8 pr8\"><a ui-sref=micro-4><img src=assets/images/performance.svg class=pr16></a><a ui-sref=micro-3><img src=assets/images/user.svg class=pr16></a><a ui-sref=micro-1><img src=assets/images/shield-user-line.svg class=pr16></a><a ui-sref=micro-2><img src=assets/images/car-fill.svg></a></div></div></div></div><div class=container><div class=\"row pl8 pr8 pb40\"><div class=col-xs-12><div class=\"font-40 pt40 pb24\"><strong>Driver</strong> Protect</div><div class=pb32>Optional Injury Protection insurance is designed to help provide people driving or delivering with Uber with peace of mind in case the unexpected happens. We believe that drivers deserve the opportunity to be protected if they’re in an accident and are unable to drive or deliver—and are therefore unable to make money—or have to pay for medical expenses.</div><div class=\"border bg-gray-1 br-8\"><div class=\"checkbox p16 m0\" ng-class=\"{ selected: micro.checkbox }\" ng-click=\"micro.checkbox = !micro.checkbox;micro.loadPolicy()\"><div class=form-check><input type=checkbox class=form-check-input ng-model=micro.checkbox> <span class=checkmark></span><label class=form-check-label>Activate Driver Protect</label></div></div><div ng-if=micro.checkbox class=\"p16 border-top\"><div class=text-center ng-if=micro.loading><!-- <img src=\"/assets/images/spinner-black.svg\" height=\"40\" class=\"m32\"> --></div><div ng-if=micro.loaded><p>Policy Number: <span ng-bind=micro.PolNo></span></p><p>Your Plan:</p><div class=row><div class=\"col-xs-4 pr8 text-center\"><div class=\"bg-white box-shadow br-4 p8\"><p class=m0>₹0.2 / trip</p><p class=\"font-24 pt8 pb8 text-700 m0\">₹300</p><p class=\"font-12 text-copy-0 m0\">COVER</p></div></div><div class=\"col-xs-4 pr8 pl8 text-center\"><div class=\"bg-white box-shadow br-4 p8\" style=\"border: 2px solid black\"><p class=m0>₹0.3 / trip</p><p class=\"font-24 pt8 pb8 text-700 m0\">₹450</p><p class=\"font-12 text-copy-0 m0\">COVER</p></div></div><div class=\"col-xs-4 pl8 text-center\"><div class=\"bg-white box-shadow br-4 p8\"><p class=m0>₹0.5 / trip</p><p class=\"font-24 pt8 pb8 text-700 m0\">₹900</p><p class=\"font-12 text-copy-0 m0\">COVER</p></div></div></div><p class=pt24>Your Total Cover Today:</p><p class=\"font-32 text-700\" ng-bind=micro.cover>700</p></div></div></div></div></div></div></div>");
$templateCache.put("app/micro/micro-2.html","<div class=\"container bg-black\"><div class=row><div class=col-xs-12><div class=\"text-right pt24 pb24 pl8 pr8\"><a ui-sref=micro-4><img src=assets/images/performance.svg class=pr16></a><a ui-sref=micro-3><img src=assets/images/user.svg class=pr16></a><a ui-sref=micro-1><img src=assets/images/shield-user-line.svg class=pr16></a><a ui-sref=micro-2><img src=assets/images/car-fill.svg></a></div></div></div></div><div class=container><div class=row><div class=col-xs-12><div class=p8><div class=\"btn btn-teal btn-lg w-100 text-700\" ng-click=micro.addCover()>BEGIN TRIP</div></div></div></div></div><a style=\"display: inline-block\"><img src=assets/images/trip-add-premium.png></a><div ng-if=micro.modal><div style=\"position: fixed; background: rgba(0,0,0,0.6); top: 0; left: 0; height: 100vh; width: 100vw; overflow: hidden\"><div class=\"bg-white br-12 p24\" style=\"z-index: 999; top: 30vh; width: 80vw; margin-left: 10vw; height: 40vh; position: relative\"><p class=\"font-32 text-700 pb8\">Your Trip has Ended</p><p class=pb56>You added ₹450 cover and ₹0.3 was deducted from your wallet.</p><div class=\"btn btn-teal btn-lg w-100 text-700 mb8\" ng-click=\"micro.modal=!micro.modal\">TAKE NEW PASSENGER</div><a class=\"text-center display-block\" ng-click=micro.viewPolicy()>View my Policy</a></div></div></div>");
$templateCache.put("app/micro/micro-3.html","<div class=\"container bg-black\"><div class=row><div class=col-xs-12><div class=\"text-right pt24 pb24 pl8 pr8\"><a ui-sref=micro-4><img src=assets/images/performance.svg class=pr16></a><a ui-sref=micro-3><img src=assets/images/user.svg class=pr16></a><a ui-sref=micro-1><img src=assets/images/shield-user-line.svg class=pr16></a><a ui-sref=micro-2><img src=assets/images/car-fill.svg></a></div></div></div></div><div class=container><div class=\"row p8\"><div class=col-xs-12><div class=\"pt32 pb32 font-24 text-700\">My Profile</div><div class=form-group><label for=contact-number>Name</label><input type=text class=form-control id=contact-number value=Mark></div><div class=form-group><label for=contact-number>DOB</label><input type=text class=form-control id=contact-number placeholder=\"\" value=1996-02-16></div><div class=form-group><label for=contact-number>Phone</label><input type=text class=form-control id=contact-number placeholder=\"\" value=659123123></div><div class=form-group><label for=contact-number>Email</label><input type=text class=form-control id=contact-number placeholder=\"\" value=Mark@email.com></div><div class=form-group><label for=contact-number>Address 1</label><input type=text class=form-control id=contact-number placeholder=\"\" value=\"10 Road St.\"></div><div class=form-group><label for=contact-number>Address 2</label><input type=text class=form-control id=contact-number placeholder=\"\" value=\"District 3\"></div></div></div></div>");
$templateCache.put("app/micro/micro-4.html","<div class=micro><div class=\"container bg-black\"><div class=row><div class=col-xs-12><div class=\"text-right pt24 pb24 pl8 pr8\"><a ui-sref=micro-4><img src=assets/images/performance.svg class=pr16></a><a ui-sref=micro-3><img src=assets/images/user.svg class=pr16></a><a ui-sref=micro-1><img src=assets/images/shield-user-line.svg class=pr16></a><a ui-sref=micro-2><img src=assets/images/car-fill.svg></a></div></div></div></div><div class=container><div class=\"row pl8 pr8 pb40\"><div class=col-xs-12><div class=\"font-40 pt40 pb24\"><strong>Driver</strong> UBI</div><div class=pb32>A health insurance that earns discounts based on your mileage and safe driving habits</div><div class=\"border bg-gray-1 br-8 mb24\"><div class=\"checkbox p16 m0\" ng-class=\"{ selected: micro.checkbox }\" ng-click=\"micro.checkbox = !micro.checkbox;micro.loadPolicy()\"><div class=form-check><input type=checkbox class=form-check-input ng-model=micro.checkbox> <span class=checkmark></span><label class=form-check-label>Activate Driver UBI</label></div></div><div ng-if=micro.checkbox class=\"p16 border-top\"><div class=text-center ng-if=micro.loading><!-- <img src=\"/assets/images/spinner-black.svg\" height=\"40\" class=\"m32\"> --></div><!-- <div ng-if=\"micro.loaded\"> --><div><p class=mb24><strong>Policy Number: <span ng-bind=micro.PolNoCI></span></strong></p><p>Your Mileage: <span ng-bind=micro.mileage></span></p><input class=slider-flat type=range name=mileage min=0 max=20000 ng-model=micro.mileage ng-change=micro.price()><p class=pt16>Your Safe Driving Points: <span ng-bind=micro.points></span></p><input class=slider-flat type=range name=points min=0 max=99 ng-model=micro.points ng-change=micro.price()></div></div></div><div ng-if=micro.checkbox class=\"border bg-gray-1 br-8\"><div class=p16><div class=\"d-flex flex-row mb0\"><div class=flex-fill>Your Next Premium</div><div class=\"text-copy-2 text-700\" ng-bind=micro.renewalDate>2021/10/19</div></div></div><div class=\"border-top p16\"><div class=\"d-flex flex-row\"><div class=flex-fill>Base Premium</div><div>100</div></div><div class=\"d-flex flex-row\"><div class=flex-fill>Discount</div><div ng-bind=micro.discount>-0</div></div><div class=\"d-flex flex-row mt24\"><div class=flex-fill>Net Premium</div><div ng-bind=micro.netPrice>100</div></div></div></div><div ng-if=micro.checkbox class=\"btn btn-teal mt24\" ng-click=micro.renew()>RENEW NOW</div></div></div></div></div>");
$templateCache.put("app/products/products.html","<div class=products><div class=banner><img class=\"img-responsive logo\" src=/assets/images/coherent-white-icon.svg> <img class=\"img-responsive full-width\" src=/assets/images/products-storefront.png></div><div class=container><div class=row><div class=col-xs-12><div class=content><p class=text translate=products_choose_a_product></p></div></div></div></div><div class=container><div class=row><div class=col-xs-12><div class=content><div ui-sref=purchase-1 class=product-button><img class=img-responsive src=/assets/images/products-personal-accident-icon.svg> <span class=\"glyphicon glyphicon-menu-right\"></span><div class=title translate=products_personal_accident></div><div class=sub-title><b>Starts at $3,000</b></div><div class=description>Get up to $100,000 in the case of serious injury</div></div><div ui-sref=travel-purchase-1 class=product-button><img class=img-responsive src=/assets/images/products-travel-icon.svg> <span class=\"glyphicon glyphicon-menu-right\"></span><div class=title translate=products_travel></div><div class=sub-title><b>Starts at $400</b></div><div class=description>Protect against loss of bagage, medical needs and flight delay</div></div><div ui-sref=home-purchase-1 class=\"product-button mb32\"><img class=img-responsive style=\"height: 24px\" src=/assets/images/products-home-icon.svg> <span class=\"glyphicon glyphicon-menu-right\"></span><div class=title>Home</div><div class=sub-title><b>Starts at $9,000</b></div><div class=description>Basic home insurance at an easy price</div></div><div ui-sref=embedded-dbs-1 class=\"product-button mb32\"><img class=img-responsive style=\"height: 24px\" src=/assets/images/products-personal-accident-icon.svg> <span class=\"glyphicon glyphicon-menu-right\"></span><div class=title>CMS</div></div><div ui-sref=micro-1 class=\"product-button mb32\"><img class=img-responsive style=\"height: 24px\" src=/assets/images/products-personal-accident-icon.svg> <span class=\"glyphicon glyphicon-menu-right\"></span><div class=title>Micro Insurance</div></div><div ui-sref=reward-landing class=\"product-button mb32\"><img class=img-responsive style=\"height: 24px\" src=/assets/images/products-personal-accident-icon.svg> <span class=\"glyphicon glyphicon-menu-right\"></span><div class=title>Free Insurance</div></div><div ui-sref=embedded-landing class=\"product-button mb32\"><img class=img-responsive style=\"height: 24px\" src=/assets/images/products-personal-accident-icon.svg> <span class=\"glyphicon glyphicon-menu-right\"></span><div class=title>Flex</div></div><div ui-sref=embedded-flex-invest class=\"product-button mb32\"><img class=img-responsive style=\"height: 24px\" src=/assets/images/products-personal-accident-icon.svg> <span class=\"glyphicon glyphicon-menu-right\"></span><div class=title>Invest</div></div></div></div></div></div></div>");
$templateCache.put("app/policy/policy-1-bk.html","<div class=\"policy front-page\"><div class=cover><div class=container><div class=row><div class=col-xs-12><div class=logo><img class=img-responsive src=/assets/images/coherent-logo.svg><div class=profile-holder><a href=#><img src=/assets/images/user-icon.svg></a></div></div><div class=welcome><div translate=policy_welcome_back></div><div ng-bind=policy.text2></div></div></div></div></div></div><div class=container><div class=row><div class=col-xs-12><div class=\"panel panel-default\" ng-repeat=\"policy in policy.policies\" ng-if=policy.riskType><div class=panel-body ui-sref=policy-detail><div class=row><div class=\"col-xs-1 img-holder-container\"><div class=img-holder><img class=img-responsive ng-src=\"{{ policy.img }}\"></div></div><div class=col-xs-3><p class=\"title {{ policy.color }}\" translate=\"{{ policy.name }}\"></p></div><div class=\"col-xs-8 pull-right\"><div class=arrow-holder><span class=\"glyphicon glyphicon glyphicon-menu-right\"></span></div></div></div><div class=row><div class=col-xs-6 style=\"padding-top: 15px\"><p class=description><span translate=policy_policy_number></span>: <span ng-bind=policy.number></span></p></div><div class=col-xs-6><div class=\"summary text-right\"><div><div translate=\"{{ policy.type }}\"></div><div ng-bind=policy.amount></div></div></div></div></div></div><div class=\"panel-footer panel-{{ policy.color }}\"></div></div><!-- <div class=\"text-center\">\n          <button class=\"btn btn-1\" ui-sref=\"policy-login\" translate=\"policy_add_a_policy\"></button>\n        </div> --></div></div></div><div class=\"mt16 pb32 text-center\"><button class=\"btn btn-2\" ui-sref=claim-quick-claim translate=policy_make_a_claim></button></div></div>");
$templateCache.put("app/policy/policy-1.html","<div id=policy-detail-page class=\"policy common-page\"><back-navbar color=green content=\"Personal Accident\" remove-margin=yes></back-navbar><div class=container><div class=row><div class=col-xs-12><div class=\"d-flex flex-row mt24\"><div class=p0><div><img class=ml16 src={{policy.ProductImg}} width=28></div></div><div class=\"text-copy-1 font-12 flex-fill pt8 pl8\"><span translate=policy_policy_number></span> <span ng-bind=policy.polNo></span></div><div class=\"text-copy-1 font-12 pb16\"><div><div class=pb8 ng-bind=policy.plantype></div><div><strong ng-bind=policy.price></strong></div></div></div></div></div><div class=\"col-xs-12 p0\"><div class=\"bg-purple pb16\"></div></div></div><div class=row><div class=col-xs-12><div class=\"panel mt32 panel-default plan-option\"><div class=\"panel-heading pink\"><div class=\"flex-row d-flex\"><div class=\"title flex-fill\" ng-bind=policy.plantype></div><div class=price ng-bind=policy.price></div></div></div><table class=\"table text-copy-1\"><tr><td translate=policy_death_residual_disability></td><td class=text-right ng-bind=policy.panel1.price1></td></tr><tr><td translate=policy_daily_hospitalization_insurance></td><td class=text-right ng-bind=policy.panel1.price2></td></tr><tr><td translate=policy_surgical_insurance colspan=2></td></tr><tr><td translate=policy_in_hospital></td><td class=text-right ng-bind=policy.panel1.price4></td></tr><tr><td translate=policy_other_than_in_hospital></td><td class=text-right ng-bind=policy.panel1.price5></td></tr><tr><td translate=policy_liability_no_self_pay></td><td class=text-right ng-bind=policy.panel1.price6></td></tr></table></div></div></div><div class=row><div class=\"col-xs-12 mt24 mb24\"><div class=\"font-12 text-copy-1\" translate=policy_contract_date></div><div class=\"font-16 text-copy-2\" ng-bind=policy.contractDate></div></div><div class=\"col-xs-12 mb24\"><div class=\"font-12 text-copy-1\" translate=policy_policy_owner></div><div class=\"font-16 text-copy-2\" ng-bind=policy.name></div></div><div class=\"col-xs-12 mb24\"><div class=\"font-12 text-copy-1\" translate=policy_birth_date></div><div class=\"font-16 text-copy-2\" ng-bind=policy.dob></div></div><div class=\"col-xs-12 mb24\"><div class=\"font-12 text-copy-1\" translate=policy_gender></div><div class=\"font-16 text-copy-2\" ng-bind=policy.gender></div></div><div class=\"col-xs-12 mb24\"><div class=\"font-12 text-copy-1\" translate=policy_postal_code></div><div class=\"font-16 text-copy-2\" ng-bind=policy.pcode></div></div><div class=\"col-xs-12 mb24\"><div class=\"font-12 text-copy-1\" translate=policy_address></div><div class=\"font-16 text-copy-2\" ng-bind=policy.add></div></div><div class=\"col-xs-12 mb24\"><div class=\"font-12 text-copy-1\" translate=policy_primary_email_address></div><div class=\"font-16 text-copy-2\" ng-bind=policy.email></div></div><div class=\"col-xs-12 mb24\"><div class=\"font-12 text-copy-1\" translate=policy_alternate_email_address></div><div class=\"font-16 text-copy-2\">--</div></div><div class=\"col-xs-12 mb24\"><div class=\"font-12 text-copy-1\" translate=policy_contact_number></div><div class=\"font-16 text-copy-2\" ng-bind=policy.phone></div></div><div class=\"col-xs-12 mb24\"><div class=\"font-12 text-copy-1\" translate=policy_alternate_contact_number></div><div class=\"font-16 text-copy-2\">--</div></div><div class=\"col-xs-12 mb24 border-bottom\"></div><div class=\"col-xs-12 mb24\"><div class=\"font-12 text-copy-1\" translate=policy_insured></div><div class=\"font-16 text-copy-2\" ng-bind=policy.insuredName>--</div></div><div class=\"col-xs-12 mb24\"><div class=\"font-12 text-copy-1\" translate=policy_relation_to_owner>Relationship</div><div class=\"font-16 text-copy-2\" ng-bind=policy.insuredKinship>--</div></div><div class=\"col-xs-12 mb24\"><div class=\"font-12 text-copy-1\" translate=policy_insured_birth_date></div><div class=\"font-16 text-copy-2\" ng-bind=policy.insuredDob>--</div></div><div class=\"col-xs-12 mb24\"><div class=\"font-12 text-copy-1\" translate=policy_insured_gender></div><div class=\"font-16 text-copy-2\" ng-bind=policy.insuredGender>--</div></div><div class=\"col-xs-12 mb24 border-bottom\"></div><div class=\"col-xs-12 mb24\"><div class=\"font-12 text-copy-1\" translate=policy_payment_details></div><div><div class=\"inline-block mr8\"><img src=/assets/images/visa.png></div><div class=\"font-16 text-copy-2 inline-block\" ng-bind=policy.paymentDetails>--</div></div></div><div class=\"col-xs-12 mb24 border-bottom\"></div><div class=\"col-xs-12 mb24\"><div class=\"font-12 text-copy-1\" translate=policy_next_renewal></div><div class=\"font-16 text-copy-2\" ng-bind=policy.nextRenewalDate>--</div><a class=\"font-14 text-copy-0\" ng-click=policy.stopRenew() translate=policy_cancel_renewal>--</a></div><div class=\"col-xs-12 mb24 border-bottom\"></div></div><div class=row><div class=col-xs-12><div class=\"btn btn-orange btn-lg font-14 mb16 mt24 col-xs-6 mr4\" ui-sref=policy-renew ng-bind=policy.RenewBtn>Renew</div><div class=\"btn btn-orange btn-lg font-14 mb16 mt24 col-xs-6 mr4\" ui-sref=policy-edit-details><i class=\"zmdi zmdi-edit float-right font-16\"></i><span ng-bind=policy.link1></span></div></div></div><div class=row><div class=col-xs-12><div class=\"btn btn-orange btn-lg font-14 mb16 mt24 col-xs-6 ml4\" ui-sref=claim-quick-claim translate=policy_make_a_claim></div><div class=\"btn btn-orange btn-lg font-14 mb16 mt24 col-xs-6 ml4\" ui-sref=policy-cancel translate=policy_cancel_policy>Cancel this Policy</div></div></div><!-- <div class=\"row\">\n      <div class=\"col-xs-12\">\n      <div class=\"btn btn-orange w-100 btn-lg font-14 mb16 mt24\" ui-sref=\"policy-renew\" ng-bind=\"policy.RenewBtn\">Renew</div>\n      <div class=\"btn btn-alternate w-100 text-copy-1\" ui-sref=\"policy-cancel\" translate=\"policy_cancel_policy\">Cancel this Policy</div>\n      </div>\n    </div> --></div></div>");
$templateCache.put("app/policy/policy-cancel.html","<div class=\"policy common-page\"><back-navbar content=\"Cancel Policy\" remove-margin=yes></back-navbar><div class=container><div class=row><div class=col-xs-12><div class=\"d-flex flex-row mt24\"><div class=p0><div><img class=ml16 src={{policy.ProductImg}} width=28></div></div><div class=\"text-copy-1 font-12 flex-fill pt8 pl8\" ng-bind=policy.polNoText></div><div class=\"text-copy-1 font-12 pb16\"><div><div class=pb8 ng-bind=policy.plantype></div><div><strong ng-bind=policy.price></strong></div></div></div></div></div><div class=\"col-xs-12 p0\"><div class=\"bg-purple pb16\"></div></div></div><div class=row><div class=col-xs-12><div class=\"form-group mt24\"><label for=cancel-date translate=policy_date_of_cancellation></label><input type=date name=cancel-date id=cancel-date max=3000-12-31 min=1900-01-01 class=form-control value=2021-06-12 ng-model=policy.cancelDate ng-change=policy.getPrice()></div><div class=\"form-group pt16\"><label for=refund translate=policy_refund_value></label><input type=refund class=form-control id=refund ng-model=policy.refund disabled ng-value=policy.refundInitial></div><div class=\"form-group pt16\"><p translate=policy_reason_for_cancellation class=\"mb8 text-700\"></p><p class=m0><input type=radio id=reason1 ng-model=policy.reason value=\"{{ \'policy_cannot_commit_to_monthy_payments\' | translate }}\"><label for=reason1 translate=policy_cannot_commit_to_monthy_payments></label></p><p class=m0><input type=radio id=reason2 ng-model=policy.reason value=\"{{ \'policy_change_of_plans\' | translate }}\"><label for=reason2 translate=policy_change_of_plans></label></p><p class=m0><input type=radio id=reason3 ng-model=policy.reason value=\"{{ \'policy_other\' | translate }}\"><label for=reason3 translate=policy_other></label></p></div><p translate=policy_payment_infromation class=\"mb8 mt24 text-700\"></p><p translate=policy_refunds_will_be_processed class=text-copy-1></p><div class=\"form-group pt8\"><p class=m0><input type=radio id=bankType1 ng-model=policy.bankType value=policy.bankType1><label for=bankType1 translate=policy_bank_transfer></label></p><p class=m0><input type=radio id=bankType2 ng-model=policy.bankType value=policy.bankType2><label for=reason2 translate=policy_credit_bank></label></p><p class=m0><input type=radio id=bankType3 ng-model=policy.bankType value=policy.bankType3><label for=reason3 translate=policy_credit_union></label></p><p class=m0><input type=radio id=bankType4 ng-model=policy.bankType value=policy.bankType4><label for=reason3 translate=policy_ewallet></label></p></div><div class=\"form-group pt16\"><label for=bank-name translate=policy_bank_name></label><input type=text class=form-control id=bank-name ng-model=policy.bankName></div><div class=\"form-group pt16\"><label for=branch-name translate=policy_branch_name></label><input type=etextmail class=form-control id=branch-name ng-model=policy.branchName></div><div class=\"form-group pt16\"><label for=account-number translate=policy_account_number></label><input type=text class=form-control id=account-number ng-model=policy.accountNumber></div><div class=\"form-group pt16\"><label for=account-name translate=policy_account_name></label><input type=text class=form-control id=account-name ng-model=policy.accountName></div><p class=\"text-center information1\"><button class=\"btn btn-orange btn-md w-100\" ng-click=policy.proceed() translate=policy_cancel_this_policy></button></p></div></div></div></div>");
$templateCache.put("app/policy/policy-confirmation.html","<div class=\"purchase policy common-page\"><back-navbar icon=glyphicon-menu-down content=\"{{ \'policy_policy_update\' | translate }}\" link=main></back-navbar><div class=container><div class=\"row paid\"><div class=\"col-xs-12 text-center\"><img class=img-responsive src=/assets/images/check.png><p class=title translate=policy_policy_update></p><div class=description ng-bind=policy.text2></div></div><div class=col-xs-12><p class=text-center><a class=\"btn btn-1\" href=\"{{\'/policies-1/\' + purchase.polNo}}\" translate=policy_back_to_account></a></p></div></div></div></div>");
$templateCache.put("app/policy/policy-detail.html","<div id=policy-detail-page class=\"policy common-page\"><back-navbar color=green content=\"Personal Accident\" remove-margin=yes></back-navbar><div class=container><div class=row><div class=col-xs-12><div class=\"d-flex flex-row mt24\"><div class=p0><div><img class=ml16 src={{policy.ProductImg}} width=28></div></div><div class=\"text-copy-1 font-12 flex-fill pt8 pl8\"><span translate=policy_policy_number></span> <span ng-bind=policy.polNo></span></div><div class=\"text-copy-1 font-12 pb16\"><div><div class=pb8 ng-bind=policy.plantype></div><div><strong ng-bind=policy.price></strong></div></div></div></div></div><div class=\"col-xs-12 p0\"><div class=\"bg-purple pb16\"></div></div></div><div class=row><div class=col-xs-12><div class=\"panel mt32 panel-default plan-option\"><div class=\"panel-heading pink\"><div class=\"flex-row d-flex\"><div class=\"title flex-fill\" ng-bind=policy.plantype></div><div class=price ng-bind=policy.price></div></div></div><table class=\"table text-copy-1\"><tr><td translate=policy_death_residual_disability></td><td class=text-right ng-bind=policy.panel1.price1></td></tr><tr><td translate=policy_daily_hospitalization_insurance></td><td class=text-right ng-bind=policy.panel1.price2></td></tr><tr><td translate=policy_surgical_insurance colspan=2></td></tr><tr><td translate=policy_in_hospital></td><td class=text-right ng-bind=policy.panel1.price4></td></tr><tr><td translate=policy_other_than_in_hospital></td><td class=text-right ng-bind=policy.panel1.price5></td></tr><tr><td translate=policy_liability_no_self_pay></td><td class=text-right ng-bind=policy.panel1.price6></td></tr></table></div></div></div><div class=row><div class=\"col-xs-12 mt24 mb24\"><div class=row><div class=col-xs-12><div class=\"btn btn-orange btn-lg font-14 mb16 mt24 col-xs-4\" ui-sref=policy-renew ng-bind=policy.RenewBtn>Renew</div><div class=\"btn btn-orange btn-lg font-14 mb16 mt24 col-xs-4\" ui-sref=policy-cancel translate=policy_cancel_policy>Cancel this Policy</div><div class=\"btn btn-orange btn-lg font-14 mb16 mt24 col-xs-4\" ui-sref=policy-edit-details><i class=\"zmdi zmdi-edit float-right font-16\"></i><span ng-bind=policy.link1></span></div></div></div><div class=\"font-12 text-copy-1\" translate=policy_contract_date></div><div class=\"font-16 text-copy-2\" ng-bind=policy.contractDate></div></div><div class=\"col-xs-12 mb24\"><div class=\"font-12 text-copy-1\" translate=policy_policy_owner></div><div class=\"font-16 text-copy-2\" ng-bind=policy.name></div></div><div class=\"col-xs-12 mb24\"><div class=\"font-12 text-copy-1\" translate=policy_birth_date></div><div class=\"font-16 text-copy-2\" ng-bind=policy.dob></div></div><div class=\"col-xs-12 mb24\"><div class=\"font-12 text-copy-1\" translate=policy_gender></div><div class=\"font-16 text-copy-2\" ng-bind=policy.gender></div></div><div class=\"col-xs-12 mb24\"><div class=\"font-12 text-copy-1\" translate=policy_postal_code></div><div class=\"font-16 text-copy-2\" ng-bind=policy.pcode></div></div><div class=\"col-xs-12 mb24\"><div class=\"font-12 text-copy-1\" translate=policy_address></div><div class=\"font-16 text-copy-2\" ng-bind=policy.add></div></div><div class=\"col-xs-12 mb24\"><div class=\"font-12 text-copy-1\" translate=policy_primary_email_address></div><div class=\"font-16 text-copy-2\" ng-bind=policy.email></div></div><div class=\"col-xs-12 mb24\"><div class=\"font-12 text-copy-1\" translate=policy_alternate_email_address></div><div class=\"font-16 text-copy-2\">--</div></div><div class=\"col-xs-12 mb24\"><div class=\"font-12 text-copy-1\" translate=policy_contact_number></div><div class=\"font-16 text-copy-2\" ng-bind=policy.phone></div></div><div class=\"col-xs-12 mb24\"><div class=\"font-12 text-copy-1\" translate=policy_alternate_contact_number></div><div class=\"font-16 text-copy-2\">--</div></div><div class=\"col-xs-12 mb24 border-bottom\"></div><div class=\"col-xs-12 mb24\"><div class=\"font-12 text-copy-1\" translate=policy_insured></div><div class=\"font-16 text-copy-2\" ng-bind=policy.insuredName>--</div></div><div class=\"col-xs-12 mb24\"><div class=\"font-12 text-copy-1\" translate=policy_relation_to_owner>Relationship</div><div class=\"font-16 text-copy-2\" ng-bind=policy.insuredKinship>--</div></div><div class=\"col-xs-12 mb24\"><div class=\"font-12 text-copy-1\" translate=policy_insured_birth_date></div><div class=\"font-16 text-copy-2\" ng-bind=policy.insuredDob>--</div></div><div class=\"col-xs-12 mb24\"><div class=\"font-12 text-copy-1\" translate=policy_insured_gender></div><div class=\"font-16 text-copy-2\" ng-bind=policy.insuredGender>--</div></div><div class=\"col-xs-12 mb24 border-bottom\"></div><div class=\"col-xs-12 mb24\"><div class=\"font-12 text-copy-1\" translate=policy_payment_details></div><div><div class=\"inline-block mr8\"><img src=/assets/images/visa.png></div><div class=\"font-16 text-copy-2 inline-block\" ng-bind=policy.paymentDetails>--</div></div></div><div class=\"col-xs-12 mb24 border-bottom\"></div><div class=\"col-xs-12 mb24\"><div class=\"font-12 text-copy-1\" translate=policy_next_renewal></div><div class=\"font-16 text-copy-2\" ng-bind=policy.nextRenewalDate>--</div><a class=\"font-14 text-copy-0\" ng-click=policy.stopRenew() translate=policy_cancel_renewal>--</a></div><div class=\"col-xs-12 mb24 border-bottom\"></div></div><!-- <div class=\"row\">\n      <div class=\"col-xs-12\">\n      <div class=\"btn btn-orange w-100 btn-lg font-14 mb16 mt24\" ui-sref=\"policy-renew\" ng-bind=\"policy.RenewBtn\">Renew</div>\n      <div class=\"btn btn-alternate w-100 text-copy-1\" ui-sref=\"policy-cancel\" translate=\"policy_cancel_policy\">Cancel this Policy</div>\n      </div>\n    </div> --></div></div>");
$templateCache.put("app/policy/policy-edit-details.html","<div id=policy-detail-page><back-navbar content=\"Edit Policy\" remove-margin=yes></back-navbar><div class=container><div class=row><div class=col-xs-12><div class=\"d-flex flex-row mt24\"><div class=\"text-copy-1 font-12 flex-fill\" ng-bind=policy.polNoText></div><div class=\"text-copy-1 font-12 pb16\"><div><div class=pb8 ng-bind=policy.plantype></div><div><strong ng-bind=policy.price></strong></div></div></div></div></div><div class=\"col-xs-12 p0 mb24\"><div style=\"margin-top: -32px\"><img class=ml16 src=assets/images/purple-siren.png width=38></div><div class=\"bg-purple pb16\"></div></div></div><div class=row><div class=col-xs-12><div class=\"font-16 text-copy-2 text-700 mb24\" translate=policy_edit_policy_owner_details></div><div class=form-group><label for=name translate=policy_full_name></label><input type=text class=form-control id=name placeholder=\"{{ \'policy_your_full_name\' | translate }}\" ng-model=policy.information.name ng-value=policy.name disabled></div><div class=form-group><label for=birth-date translate=policy_birth_date></label><p class=input-group><input type=text class=form-control id=birth-date uib-datepicker-popup=\"{{ policy.calendarFormat }}\" ng-model=policy.information.birthDate is-open=policy.isOpen datepicker-options=policy.datepickerOptions placeholder=\"{{ \'policy_yyyy_mm_dd\' | translate }}\" show-button-bar=false ng-value=policy.dob disabled> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"policy.isOpen = !policy.isOpen\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"form-group postal-code\"><label for=postal-code translate=policy_postal_code></label><div class=input-group><input type=text class=\"form-control text-center\" placeholder=XXXX id=postal-code ng-model=policy.information.postalCode1 ng-value=policy.pcode1><div class=input-group-addon>—</div><input type=text class=\"form-control text-center\" placeholder=XXXX ng-model=policy.information.postalCode2 ng-value=policy.pcode2></div></div><div class=\"form-group address\"><label for=address translate=policy_address></label><input type=text class=form-control id=address placeholder=\"{{ \'policy_address\' | translate }}\" ng-model=policy.information.address ng-value=policy.add></div><div class=form-group><label for=email translate=policy_primary_email_address></label><input type=email class=form-control id=email placeholder=\"{{ \'policy_your_main_email_address\' | translate }}\" ng-model=policy.information.email ng-value=policy.email></div><div class=form-group><label for=alternate-email translate=policy_alternate_email_address></label><input type=email class=form-control id=alternate-email placeholder=\"{{ \'policy_another_email_address\' | translate }}\" ng-model=policy.information.altEmail disabled></div><div class=form-group><label for=contact-number translate=policy_contact_number></label><input type=text class=form-control id=contact-number placeholder=\"+81 XXX XXXX\" ng-model=policy.information.contact ng-value=policy.phone></div><div class=form-group><label for=alternate-contact-number><span translate=policy_alternate_contact_number></span> <span class=\"text-muted small text-optional\" translate=policy_optional></span></label><input type=text class=form-control id=alternate-contact-number placeholder=\"{{ \'policy_another_contact_number\' | translate }}\" ng-model=policy.information.altContact disabled></div><p class=\"text-center information1\"><button class=\"btn btn-orange btn-md w-100\" class=\"btn btn-3\" ng-disabled=\"!policy.information.postalCode1 && !policy.information.postalCode2 && !policy.information.address && !policy.information.email && !policy.information.contact\" ng-click=policy.proceed() translate=policy_update_details></button></p></div></div></div></div>");
$templateCache.put("app/policy/policy-login.html","<div class=\"policy common-page\"><div class=\"d-flex flex-column\" style=\"height: 90vh\"><div><div class=container><div class=\"row border-bottom\"><div class=col-xs-12><img src=/assets/images/coherent-logo.svg class=\"mt64 mb40\"><div class=\"font-32 mt40 mb32\">Sign In</div></div></div></div></div><div class=\"flex-fill bg-gray-1\"><div class=container><div class=row><div class=col-xs-12><div class=\"form-group mt32 border-bottom pb48 mb48\"><label class=\"text-700 mb8\" for=\"\" translate=policy_sign_in_with_coherent_id></label><input type=email class=\"form-control mb8\" placeholder=\"username or email\" disabled> <input type=email class=form-control placeholder=password disabled></div><div class=\"form-group mt32\"><label class=\"text-700 mb8\" for=policy-number translate=policy_sign_in_with_policy_number></label><input type=text class=form-control id=policy-number placeholder=057075 ng-model=policy.number></div></div></div></div></div><div><div class=\"container bg-gray-1\"><div class=row><div class=col-xs-12><div class=\"btn btn-orange w-100 btn-lg font-14 mb16 mt24\" ng-disabled=!policy.number ng-click=policy.signIn() translate=policy_proceed></div></div></div></div></div></div></div>");
$templateCache.put("app/policy/policy-renew.html","<div class=\"policy common-page\"><back-navbar content=\"Continue Renewal\" remove-margin=yes></back-navbar><div class=container><div class=row><div class=col-xs-12><div style=\"background-image: url(\'assets/images/renew-bg.png\')\"><p class=\"font-32 mb64 mt64\" ng-bind=policy.text1></p></div><div class=\"btn btn-orange w-100 btn-lg font-14 mb16 mt24\" ng-click=policy.extend() ng-bind=policy.btn1>Extend this Policy</div><div class=\"btn btn-alternate w-100 text-copy-1\" ng-click=policy.new() ng-bind=policy.btn2>Select a New Plan</div></div></div></div></div>");
$templateCache.put("app/purchase/purchase-1.html","<div class=\"purchase front-page\"><div class=container><div class=row><div class=col-xs-12><div class=logo><img class=img-responsive src=/assets/images/coherent-logo.svg></div></div></div></div><img class=\"img-responsive center-block\" src=/assets/images/purchase-bg-3.png><div class=container><div class=row><div class=col-xs-12><div class=\"text-center content\"><p class=text-1 translate=purchase_personal_accident_insurance></p><p class=text-2 ng-bind=purchase.text_folder></p><input class=\"textbox form-control\" type=text name=folder ng-change=purchase.handleFolderChange() ng-model=purchase.folder id=folder><p class=text-2 ng-bind=purchase.text1_1></p><input class=\"textbox form-control\" type=text name=product ng-change=purchase.handleValueChange() ng-model=purchase.text1_1_product id=product><!-- <p class=\"text-2\" translate=\"purchase_straight_through_purchase\"></p> --> <button class=\"btn btn-1\" ui-sref=purchase-2>Proceed</button></div></div></div></div><hr></div>");
$templateCache.put("app/purchase/purchase-10.html","<div class=\"purchase common-page\"><back-navbar content=\"Update Insured Information\"></back-navbar><div class=container><div class=row><div class=col-xs-12><div class=form-group><label for=relationship translate=purchase_relationship_with_owner></label><div class=radio ng-class=\"{ \'selected\': purchase.information.relationship === relationship.value }\" ng-repeat=\"relationship in purchase.relationships\"><div class=form-radio><label><input type=radio name=relationship value=\"{{ relationship.value }}\" ng-model=purchase.information.relationship> <span class=radio-button style=\"margin-top: 3px\"></span> <span translate=\"{{ relationship.display }}\"></label></div></div></div><div ng-if=\"purchase.information.relationship === \'relative\'\"><div class=form-group><label for=relationship-type translate=purchase_relationship_with_owner></label><select id=relationship-type class=form-control ng-model=purchase.information.relationshipType><option value=\"\" ng-bind=purchase.placeholder1 disabled ng-selected=!purchase.information.relationshipType hidden></option><option value=\"{{ relationshipType.value }}\" ng-bind=relationshipType.display ng-repeat=\"relationshipType in purchase.relationshipTypes\" ng-selected=\"purchase.information.relationshipType === relationshipType.value\"></option></select></div><div class=form-group><label for=name ng-bind=purchase.text3></label><input type=text class=form-control id=name placeholder=\"{{ purchase.placeholder2 }}\" ng-model=purchase.information.name></div><div class=form-group><label for=birth-date ng-bind=purchase.text4></label><p class=input-group><input type=text class=form-control uib-datepicker-popup=\"{{ purchase.calendarFormat }}\" ng-model=purchase.information.birthDate is-open=purchase.isOpen datepicker-options=purchase.datepickerOptions placeholder=\"{{ purchase.placeholder3 }}\" show-button-bar=false> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"purchase.isOpen = !purchase.isOpen\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"form-group dual-options\"><label for=gender ng-bind=purchase.text5></label><div class=text-center><button class=\"btn btn-option\" ng-class=\"{ \'btn-selected\': purchase.information.gender === purchase.btn1 }\" ng-bind=purchase.btn1 ng-click=\"purchase.information.gender = purchase.btn1\"></button> <button class=\"btn btn-option\" ng-class=\"{ \'btn-selected\': purchase.information.gender === purchase.btn2 }\" ng-bind=purchase.btn2 ng-click=\"purchase.information.gender = purchase.btn2\"></button></div></div><div class=\"form-group dual-options\"><label for=living ng-bind=purchase.text6></label><div class=text-center><button class=\"btn btn-option\" ng-class=\"{ \'btn-selected\': purchase.information.living === purchase.btn3 }\" ng-bind=purchase.btn3 ng-click=\"purchase.information.living = purchase.btn3\"></button> <button class=\"btn btn-option\" ng-class=\"{ \'btn-selected\': purchase.information.living === purchase.btn4 }\" ng-bind=purchase.btn4 ng-click=\"purchase.information.living = purchase.btn4\"></button></div></div><div ng-if=\"purchase.information.living == purchase.btn4\"><div class=\"form-group postal-code\"><label for=postal-code translate=purchase_address></label><div class=input-group><input type=text class=form-control placeholder=\"{{ \'purchase_placeholder_5\' | translate }}\" ng-model=purchase.information.country><div class=input-group-addon></div><input type=text class=form-control placeholder=\"{{ \'purchase_placeholder_3\' | translate }}\" id=postal-code ng-model=purchase.information.postalCode1></div></div><div class=\"form-group postal-code\"><div class=input-group><input type=text class=form-control placeholder=\"{{ \'purchase_placeholder_6\' | translate }}\" ng-model=purchase.information.add1><div class=input-group-addon></div><input type=text class=form-control placeholder=\"{{ \'purchase_placeholder_7\' | translate }}\" ng-model=purchase.information.add2></div></div><div class=\"form-group address\"><input type=text class=form-control placeholder=\"{{ \'purchase_placeholder_8\' | translate }}\" id=address ng-model=purchase.information.city></div><div class=form-group><label for=email translate=purchase_primary_email></label><input type=email class=form-control id=email placeholder=\"{{ \'purchase_email_placeholder\' | translate }}\" ng-model=purchase.information.email></div><div class=form-group><label for=contact-number translate=purchase_contact_number></label><input type=text class=form-control id=contact-number placeholder=\"{{ \'purchase_contact_number_placeholder\' | translate }}\" ng-model=purchase.information.contact></div></div></div><p class=\"text-center information2\"><button ng-disabled=\"!(purchase.information.relationship === \'self\' || (purchase.information.relationshipType && purchase.information.name && purchase.information.birthDate && purchase.information.gender && purchase.information.living))\" class=\"btn btn-1\" ng-click=purchase.proceed() translate=travel_purchase_next></button></p></div></div></div></div>");
$templateCache.put("app/purchase/purchase-11.html","<div class=\"purchase common-page\"><back-navbar content=Checkout remove-margin=yes></back-navbar><div class=container><div class=\"row title3-container purple-siren-bg\"><div class=col-xs-12><p ng-if=\"purchase.ui.PlanType == \'PA\'\" class=title3 translate=purchase_personal_accident></p><p ng-if=\"purchase.ui.PlanType == \'TRAVEL\'\" class=title3 translate=purchase_travel_insurance></p><p ng-if=\"purchase.ui.PlanType != \'HOME\'\" class=title3>Home Insurance</p></div></div></div><div class=purple-border></div><div class=\"container summary\"><div class=row ng-if=\"purchase.ui.PlanType == \'Travel\'\"><div class=col-xs-12><div class=\"panel panel-default panel-purple plan-option\"><div class=panel-heading><p class=\"title panel-title\" ng-bind=purchase.ui.planDetails.Option></p><div class=row><div class=col-xs-9><p class=\"description panel-description\" ng-bind=purchase.ui.planDetails.Desc></p></div><div class=col-xs-3><div class=\"price panel-price\" ng-bind=\"purchase.ui.planDetails.price | currency: purchase.DefaultCurrency\"></div></div></div></div><table class=table><tr ng-if=\"purchase.ui.type === purchase.opts.ACCIDENT_TYPE\" ng-repeat-start=\"component in purchase.ui.planDetails.components\"></tr><tr><td ng-bind=\"component.label | translate\"></td><td class=text-right ng-bind=\"component.price | translate\"></td></tr><tr ng-repeat=\"subComponent in component.subComponents\"><td class=pl32 ng-bind=\"subComponent.label | translate\"></td><td class=text-right ng-bind=\"subComponent.price | currency: purchase.DefaultCurrency\"></td></tr><tr ng-if=\"purchase.ui.type === purchase.opts.ACCIDENT_TYPE\" ng-repeat-end></tr><tr ng-if=\"purchase.ui.type === purchase.opts.TRAVEL_TYPE && benefit.enabled\" ng-repeat=\"benefit in purchase.ui.optionalBenefits\"><td ng-bind=\"\'(\'+ ($index+1) + \') - \' + benefit.label\"></td><td class=text-right ng-bind=\"benefit.value | currency: purchase.DefaultCurrency\"></td></tr><tr ng-if=\"purchase.ui.type === purchase.opts.HOME_TYPE\" ng-repeat=\"benefit in purchase.ui.benefitSelection\">{{benefit.Option_Name}}</tr></table></div></div></div><div class=row ng-if=\"purchase.ui.PlanType == \'PA\'\"><div class=col-xs-12><div class=\"choice first-choice\"><p class=title><span ng-bind=\"purchase.planCategory.title | translate\"></span> <span class=\"glyphicon glyphicon-menu-right\"></span></p><p class=description ng-bind-html=\"purchase.planCategory.description | translate\"></p><div class=img-container><img class=img-responsive ng-src=\"{{ purchase.planCategory.image }}\"></div></div></div></div><div class=row ng-if=\"purchase.ui.PlanType == \'Home\'\"><div class=col-xs-12><div class=\"panel panel-default panel-purple plan-option\"><div class=\"panel-heading d-flex flex-row\"><div class=flex-fill><p class=\"title panel-title\" ng-bind=purchase.ui.HomePlanType></p><p class=\"description panel-description\">Policy starts from <b>{{purchase.PolicyInfo.Header.StartDate.split(\"T\")[0]}}</b></p></div><div><p class=\"title panel-title\" ng-bind=\"purchase.ui.price | currency: purchase.DefaultCurrency\"></p></div><div class=\"price panel-price\" ng-bind=\"purchase.ui.HomePlanType.price | currency: purchase.DefaultCurrency\"></div></div><table class=table><tr ng-repeat=\"benefit in purchase.ui.benefitSelection\" ng-if=\"benefit.Included == \'Y\' && benefit.Show ==\'Y\'\"><td>{{benefit.Desc}}</td><td class=text-right ng-bind=\"benefit.SumInsured | currency: purchase.DefaultCurrency\"></td></tr></table></div></div></div><div class=row ng-if=\"purchase.ui.PlanType == \'PA\'\"><div class=col-xs-12><div class=\"panel panel-default panel-{{ purchase.planType.color }} plan-option\"><div class=panel-heading><p class=title ng-bind=\"purchase.planType.heading.title | translate\"></p><p class=description>{{purchase.planType.heading.description | translate}}, starts from <b>{{purchase.PolicyInfo.Header.StartDate.split(\"T\")[0]}}</b></p><div class=price ng-bind=\"purchase.planType.heading.price | currency: purchase.DefaultCurrency\"></div></div><table class=table><tr ng-repeat=\"plan in purchase.PlanList[\'Plan\' + (purchase.planType.id)]\"><td>{{plan.Cover}} - {{plan.Descr}}</td><td class=text-right ng-bind=\"plan.ClaimLimit | currency: purchase.DefaultCurrency\"></td></tr><!-- <tr ng-repeat=\"c in purchase.planTypeCategories\">\n              <td translate=\"{{ c }}\"></td>\n              <td class=\"text-right\" ng-bind=\"purchase.planType.prices[$index]\"></td>\n            </tr> --></table></div></div></div><div class=row><div class=col-xs-12><div class=\"panel panel-default plan-option\"><div class=panel-heading><p class=title>Owner Details</p><!-- <p class=\"description\" ng-bind=\"purchase.planType.heading.description | translate\"></p>\n            <div class=\"price\" ng-bind=\"purchase.planType.heading.price | currency: purchase.DefaultCurrency\"></div> --></div><table class=table><tr><td>Name</td><td ng-bind=purchase.PolicyInfo.Header.Owner.Name></td></tr><tr><td>Date of Birth</td><td ng-bind=purchase.PolicyInfo.Header.Owner.Dob></td></tr><tr><td>Gender</td><td ng-bind=purchase.PolicyInfo.Header.Owner.Gender></td></tr><tr><td>Address</td><td ng-bind=purchase.PolicyInfo.Header.Owner.Contact.Add.Add1></td></tr><tr><td>Email</td><td ng-bind=purchase.PolicyInfo.Header.Owner.Contact.Email></td></tr><tr><td>Phone Number</td><td ng-bind=purchase.PolicyInfo.Header.Owner.Contact.Phone></td></tr></table></div></div></div><div class=row ng-if=!purchase.ui.OwnerSameAsInsured><div class=col-xs-12><div class=\"panel panel-default plan-option\"><div class=panel-heading><p class=title>Insured Details</p><!-- <p class=\"description\" ng-bind=\"purchase.planType.heading.description | translate\"></p>\n            <div class=\"price\" ng-bind=\"purchase.planType.heading.price | currency: purchase.DefaultCurrency\"></div> --></div><table class=table><tr><td>Name</td><td ng-bind=purchase.PolicyInfo.Risks[0].RiskBody.InsuredParty.Name></td></tr><tr><td>Date of Birth</td><td ng-bind=purchase.PolicyInfo.Risks[0].RiskBody.InsuredParty.Dob></td></tr><tr><td>Gender</td><td ng-bind=purchase.PolicyInfo.Risks[0].RiskBody.InsuredParty.Gender></td></tr><tr><td>Address</td><td ng-bind=purchase.PolicyInfo.Risks[0].RiskBody.InsuredParty.Contact.Add.Add1></td></tr><tr><td>City</td><td ng-bind=purchase.PolicyInfo.Risks[0].RiskBody.InsuredParty.Contact.Add.City></td></tr><tr><td>Country</td><td ng-bind=purchase.PolicyInfo.Risks[0].RiskBody.InsuredParty.Contact.Add.Country></td></tr><tr><td>Email</td><td ng-bind=purchase.PolicyInfo.Risks[0].RiskBody.InsuredParty.Contact.Email></td></tr><tr><td>Phone Number</td><td ng-bind=purchase.PolicyInfo.Risks[0].RiskBody.InsuredParty.Contact.Phone></td></tr></table></div></div></div><div class=row ng-if=\"purchase.ui.PlanType == \'Travel\'\"><div class=col-xs-12><div class=\"bg-gray-1 border p16 mb24\"><label class=\"d-flex flex-row\"><div class=mr16><input type=checkbox name=\"\" ng-model=purchase.check1></div><div class=flex-fill translate=purchase_travel_is_a_product></div></label></div></div></div><div class=row><div class=col-xs-12><div class=\"form-group dual-options mt-40\"><div class=text-center><button class=\"btn btn-option\" ng-class=\"{ \'btn-selected\': purchase.submit_type === \'save_quote\' }\" translate=purchase_save_quote ng-click=\"purchase.submit_type = \'save_quote\'\"></button> <button class=\"btn btn-option\" ng-class=\"{ \'btn-selected\': purchase.submit_type === \'submit\' }\" translate=purchase_save_as_contract ng-click=\"purchase.submit_type = \'submit\'\"></button></div></div><div ng-if=\"purchase.submit_type === \'submit\'\" class=payment-methods><img src=/assets/images/visa.png> <img src=/assets/images/mastercard.png> <img src=/assets/images/diners-club.png> <img src=/assets/images/jcb.png> <img src=/assets/images/rakuten-card.png></div><p ng-if=\"purchase.submit_type === \'submit\'\" class=\"description text-muted\" translate=purchase_insurance_premiums_can_only></p><p ng-if=\"purchase.submit_type === \'submit\'\" class=description translate=purchase_this_contract_is_accompanied></p><p class=text-center><button ng-disabled=!purchase.submit_type class=\"btn btn-1\" ng-click=purchase.proceed() translate=travel_purchase_next></button><!-- <button class=\"btn btn-1\" ng-disabled=\"!purchase.check1\" ng-click=\"purchase.SaveQuote(\'New\')\" translate=\"purchase_save_quote\"></button>\n          <button class=\"btn btn-1\" ng-disabled=\"!purchase.check1\" ui-sref=\"purchase-12\" translate=\"purchase_submit_proposal\"></button>         --></p></div></div></div></div>");
$templateCache.put("app/purchase/purchase-12.html","<div class=\"purchase common-page\"><back-navbar content=Payment></back-navbar><div class=container><div class=row><div class=col-xs-12><p class=title1 translate=purchase_credit_card_information></p></div><div class=col-xs-12><div class=payment-methods><img src=/assets/images/visa.png> <img src=/assets/images/mastercard.png> <img src=/assets/images/diners-club.png> <img src=/assets/images/jcb.png> <img src=/assets/images/rakuten-card.png></div><p class=\"description text-muted\" translate=purchase_insurance_premiums_can_only></p><p class=description translate=purchase_this_contract_is_accompanied></p></div><!--       <div class=\"col-xs-12\">\n        <div class=\"form-group dual-options\">\n          <label for=\"schedule\" translate=\"purchase_schedule\"></label>\n          <div class=\"text-center\">\n            <button class=\"btn btn-option\" ng-class=\"{ \'btn-selected\': purchase.schedule === \'monthly\' }\" translate=\"purchase_monthly\" ng-click=\"purchase.schedule = \'monthly\'\"></button>\n            <button class=\"btn btn-option\" ng-class=\"{ \'btn-selected\': purchase.schedule === \'yearly\' }\" translate=\"purchase_yearly\" ng-click=\"purchase.schedule = \'yearly\'\"></button>\n          </div>\n        </div>\n      </div> --><div class=col-xs-12><div class=form-group><label for=card-holder-name translate=purchase_name_on_card></label><input type=text class=form-control id=card-holder-name placeholder=\"\" ng-model=purchase.payment.name></div><div class=form-group><label for=card-number translate=purchase_card_number></label><input type=text class=form-control id=dummy-card-number placeholder=XXXX-XXXX-XXXX-XXXX ng-model=purchase.payment.number></div></div><div class=col-xs-3><div class=form-group><label for=card-expiry translate=purchase_expiry></label><input type=text class=form-control id=card-expiry-month placeholder=MM ng-model=purchase.payment.expirym></div></div><div class=col-xs-3><div class=form-group><label for=card-expiry></label><input type=text class=form-control id=card-expiry-year placeholder=YY ng-model=purchase.payment.expiryy></div></div><div class=col-xs-6><div class=form-group><label for=card-cvv translate=purchase_cvv></label><input type=text class=form-control id=card-cvv placeholder=CVV ng-model=purchase.payment.cvv></div></div><div class=col-xs-12><p class=text-center><button aang-disabled=\"!purchase.payment.name || !purchase.payment.number || !purchase.payment.expiry || !purchase.payment.cvv\" class=\"btn btn-1\" ng-click=purchase.proceed() ng-bind=purchase.button1></button></p></div></div></div></div>");
$templateCache.put("app/purchase/purchase-13.html","<div class=\"purchase common-page\"><back-navbar icon=glyphicon-menu-down content=\"Policy Payment\" link=main></back-navbar><div class=container><div class=\"row paid\"><div class=\"col-xs-12 text-center\"><img class=img-responsive src=/assets/images/check.png><p ng-if=\"purchase.ProductType == \'Policy\'\" class=title translate=purchase_payment_succesful></p><p ng-if=\"purchase.ProductType == \'Quote\'\" class=title translate=quote_generated_succesful></p><div><a class=description><span ng-if=\"purchase.ProductType == \'Policy\'\" translate=purchase_policy_number></span> <span ng-if=\"purchase.ProductType == \'Quote\'\" translate=generated_quote_number></span> :&nbsp;<span ng-bind=purchase.polNo></span></a></div></div><div class=col-xs-12><div ng-if=\"purchase.ProductType == \'Quote\'\" class=\"form-group dual-options\" style=\"margin-top: 30px\"><div class=text-center><button class=\"btn btn-option\" ng-class=\"{ \'btn-selected\': purchase.submit_type === \'view_quote\' }\" translate=purchase_view_my_quote ng-click=\"purchase.submit_type = \'view_quote\'\"></button> <button class=\"btn btn-option\" ng-class=\"{ \'btn-selected\': purchase.submit_type === \'submit\' }\" translate=purchase_save_as_proposal ng-click=\"purchase.submit_type = \'submit\'\"></button></div></div><p class=text-center><a ng-if=\"purchase.ProductType == \'Policy\'\" class=\"btn btn-1 pt8\" href=\"{{\'/policies-1/\' + purchase.polNo}}\" translate=purchase_view_my_policy></a> <button ng-if=\"purchase.ProductType == \'Quote\'\" ng-disabled=!purchase.submit_type class=\"btn btn-1\" ng-click=purchase.proceed() translate=travel_purchase_next></button><!-- <a ng-if=\"purchase.ProductType == \'Quote\'\" class=\"btn btn-1 pt8\"\n            href=\"https://policy360.demo.sonic.dev.coherent.global/enquiry/policy?policyID={{purchase.polNo}}\"\n            target=\"_blank\" translate=\"purchase_view_my_quote\"></a>\n\n          <a ng-if=\"purchase.ProductType == \'Quote\'\" class=\"btn btn-1 pt8\" ui-sref=\"purchase-12\"\n            translate=\"purchase_save_as_proposal\"></a> --></p></div></div><!-- 		<div class=\"row\">\n			<div class=\"col-xs-12\">\n				<p class=\"text-center mt32\" translate=\"purchase_recommended_for_you\"></p>\n				<div class=\"pr16\">\n					<img class=\"w-100 m0 mb16\" src=\"/assets/images/ip.png\">\n					<img class=\"w-100 m0 mb16\" src=\"/assets/images/ci.png\">\n					<img class=\"w-100 m0 mb16 mt16\" src=\"/assets/images/ww.png\">\n				</div>\n		  </div>\n		</div> --></div></div>");
$templateCache.put("app/purchase/purchase-2.html","<div class=\"purchase common-page\"><back-navbar></back-navbar><div class=container><div class=row><div class=col-xs-12><p class=title1 translate=purchase_check_the_following></p><div class=widget><p class=text translate=purchase_personal_accident_reminder></p><p class=foot-note translate=purchase_check_the_following_again></p><div class=checkbox ng-class=\"{ selected: purchase.checkbox }\" ng-click=\"purchase.checkbox = !purchase.checkbox\"><div class=form-check><input type=checkbox class=form-check-input ng-model=purchase.checkbox> <span class=checkmark></span><label class=form-check-label translate=purchase_checked></label></div></div></div><p class=text translate=purchase_select_insurance_start_date></p><p class=input-group><input type=text class=form-control uib-datepicker-popup=\"{{ purchase.calendarFormat }}\" ng-model=purchase.date is-open=purchase.isOpen datepicker-options=purchase.datepickerOptions placeholder=\"{{ \'purchase_placeholder_date\' | translate }}\" show-button-bar=false> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"purchase.isOpen = !purchase.isOpen\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><p class=foot-note translate=purchase_insurance_start_date_text></p><p class=\"text currency-container\" translate=purchase_select_currency_type></p><select id=currency class=form-control ng-model=purchase.currency><option value=\"\" disabled ng-selected=!purchase.currency>Select Currency</option><option value=\"{{ currency.CurrencyCode }}\" ng-bind=currency.CurrencyCode ng-if=currency.CurrencyCode ng-repeat=\"currency in purchase.Currencies\" ng-selected=\"purchase.information.currency === currency.CurrencyCode\"></option></select><p class=\"text currency-container\" translate=purchase_promo_code></p><select id=PromoCode class=form-control ng-model=purchase.PromoCode><option value=\"\" ng-selected=!purchase.PromoCode>Select Promocode</option><option value=\"{{ promo.PromoCode }}\" ng-if=promo.PromoCode ng-repeat=\"promo in purchase.PromoCodes\" ng-selected=\"purchase.PromoCode === promo.PromoCode\">{{promo.PromoCode}} - {{promo.PromotionDiscount*100}}%</option></select><p class=\"text currency-container\" translate=purchase_occupation_code></p><select id=Occupation class=form-control ng-model=purchase.Occupation><option value=\"\" ng-selected=!purchase.Occupation>Select Occupation</option><option value=\"{{ occ.Occupation }}\" ng-if=occ.Occupation ng-repeat=\"occ in purchase.OccupationList\" ng-selected=\"purchase.Occupation === occ.Occupation\">{{occ.Occupation}}</option></select><p class=\"text currency-container\" translate=purchase_payment_frequency></p><select id=Frequency class=\"form-control bottom-spacing-80\" ng-model=purchase.Frequency><option value=\"\" disabled ng-selected=!purchase.Frequency>Select Frequency</option><option value=\"{{ freq.Option }}\" ng-if=freq.Option ng-repeat=\"freq in purchase.PaymentFreqencyList\" ng-selected=\"purchase.Frequency === freq.Option\">{{freq.Desc}}</option></select><!--    <div class=\"form-group\">\n          <input type=\"date\" name=\"start-date\" id=\"start-date\" max=\"3000-12-31\"\n          min=\"1900-01-01\" class=\"form-control\" value=\"2021-06-12\" ng-model=\"purchase.date\">\n        </div> --><p class=text-center><!-- <p ng-class=\"{visible: true}\" class=\"text-red\">Error Message</p> --> <button class=\"btn btn-1\" ng-click=purchase.proceed() ng-disabled=\"!purchase.checkbox || !purchase.date || !purchase.Frequency\" translate=purchase_continue></button></p></div></div></div></div>");
$templateCache.put("app/purchase/purchase-3.html","<div class=\"purchase common-page\"><back-navbar remove-margin=yes></back-navbar><div class=container><div class=\"row title2-container purple-siren-bg\"><div class=col-xs-12><p class=title2 translate=purchase_personal_accident></p></div></div></div><div class=purple-border></div><div class=container><div class=row><div class=col-xs-12><p class=title1 translate=purchase_select_range_eligible_for_compensation></p><p class=text-3 translate=purchase_scope_of_coverage_text></p><img class=\"img-responsive float-left\" width=64 src=/assets/images/plan-0.png><div class=text-4-5-6><div translate=purchase_insured_individual></div><div translate=purchase_insured_individuals_spouse></div><div translate=purchase_insured_individuals_relatives></div></div><hr></div></div></div><div class=container><div class=row><div class=col-xs-12 ng-repeat=\"category in purchase.planCategories\"><div class=choice ng-class=\"{\'panel-selected\': purchase.PlanCategory.id === category.id}\" ng-click=purchase.chooseCategory(category)><p class=title><span ng-bind=\"category.title | translate\"></span> <span class=\"glyphicon glyphicon-menu-right\"></span></p><p class=description ng-bind-html=\"category.description | translate\"></p><div class=img-container><img class=img-responsive ng-src=\"{{ category.image }}\"></div></div></div></div></div><p class=text-center><button class=\"btn btn-1\" ng-click=purchase.proceed() ng-disabled=!purchase.PlanCategory.id translate=purchase_continue></button></p></div>");
$templateCache.put("app/purchase/purchase-4.html","<div class=\"purchase common-page\"><back-navbar content=\"Individual Plan\"></back-navbar><div class=container><div class=row><div class=col-xs-12><div class=\"widget widget-white\"><div class=title translate=purchase_individual_plan_title></div><div class=\"text description\" translate=purchase_individual_plan_limits_guarantee_of_injury_to_one_person></div><div class=img-container><img class=\"float-left img-responsive\" src=/assets/images/plan-1.png></div></div></div></div><div class=row><div class=col-xs-12><p class=sub-title translate=purchase_policy_owner></p><p class=sub-description translate=purchase_over_18_can_apply></p><div class=warning-box><div class=img-container><img class=img-responsive src=/assets/images/warning.png></div><p class=text translate=purchase_child_target_for_injury_compensation></p></div><p class=sub-title translate=purchase_injury_guarantee_coverage></p><p class=sub-description translate=purchase_covered_by_injury_guarantee></p><div class=\"widget widget-white widget-rectangle\"><p class=title translate=purchase_themselves></p><p class=description translate=purchase_themselves_description></p></div></div></div><div class=row><div class=col-xs-12><p class=sub-title translate=purchase_guarantee_liability_coverage></p><p class=sub-description translate=purchase_covered_by_guarantee></p><div><div class=\"widget widget-white widget-rectangle widget-list\" ng-repeat=\"coverage in purchase.coverages\"><div class=img-container><img class=img-responsive ng-src=\"{{ coverage.image }}\"></div><div class=widget-content><p class=title ng-bind=\"coverage.title | translate\"></p><div class=details><ul><li ng-repeat=\"detail in coverage.details\" ng-bind=\"detail | translate\"></li></ul></div></div></div></div><p class=text-center><button class=\"btn btn-1\" ng-click=\"purchase.select(\'Insured_1\')\" ui-sref=purchase-7 translate=purchase_apply_for_individual_plan></button></p></div></div></div></div>");
$templateCache.put("app/purchase/purchase-5.html","<div class=\"purchase common-page\"><back-navbar content=\"Couple Plan\"></back-navbar><div class=container><div class=row><div class=col-xs-12><div class=\"widget widget-white\"><div class=title ng-bind=purchase.text1></div><div class=\"text description\" ng-bind-html=purchase.text2></div><div class=img-container><img class=\"float-left img-responsive\" src=/assets/images/plan-2.png></div></div></div></div><div class=row><div class=col-xs-12><p class=sub-title ng-bind=purchase.text3></p><p class=\"sub-description bottom-spacing-40\" ng-bind=purchase.text4></p><p class=sub-title ng-bind=purchase.text5></p><p class=sub-description ng-bind=purchase.text6></p><div><div class=\"widget widget-white widget-rectangle-list\"><p class=title ng-bind=purchase.text7></p><p class=description ng-bind-html=purchase.text8></p></div><div class=\"widget widget-white widget-rectangle-list\"><p class=title ng-bind=purchase.text9></p><p class=description ng-bind-html=purchase.text10></p></div></div></div></div><div class=row><div class=col-xs-12><p class=sub-title ng-bind=purchase.text11></p><p class=sub-description ng-bind=purchase.text12></p><div><div class=\"widget widget-white widget-rectangle widget-list\" ng-repeat=\"coverage in purchase.coverages\"><div class=img-container><img class=img-responsive ng-src=\"{{ coverage.image }}\"></div><div class=widget-content><p class=title ng-bind=coverage.title></p><div class=details><ul><li ng-repeat=\"detail in coverage.details\" ng-bind=detail></li></ul></div></div></div></div><p class=text-center><button class=\"btn btn-1\" ng-click=\"purchase.select(\'Insured_2\')\" ui-sref=purchase-7 ng-bind=purchase.btn1></button></p></div></div></div></div>");
$templateCache.put("app/purchase/purchase-6.html","<div class=\"purchase common-page\"><back-navbar content=ファミリープラン></back-navbar><div class=container><div class=row><div class=col-xs-12><div class=\"widget widget-white\"><div class=title ng-bind=purchase.text1></div><div class=\"text description\" ng-bind-html=purchase.text2></div><div class=img-container><img class=\"float-left img-responsive\" src=/assets/images/plan-3.png></div></div></div></div><div class=row><div class=col-xs-12><p class=sub-title ng-bind=purchase.text3></p><p class=\"sub-description bottom-spacing-40\" ng-bind=purchase.text4></p><p class=sub-title ng-bind=purchase.text5></p><p class=sub-description ng-bind=purchase.text6></p><div><div class=\"widget widget-white widget-rectangle-list\"><p class=title ng-bind=purchase.text7></p><p class=description ng-bind-html=purchase.text8></p></div><div class=\"widget widget-white widget-rectangle-list\"><p class=title ng-bind=purchase.text9></p><p class=description ng-bind-html=purchase.text10></p></div><div class=\"widget widget-white widget-rectangle-list\"><p class=title ng-bind=purchase.text11></p><p class=description ng-bind-html=purchase.text12></p></div></div></div></div><div class=row><div class=col-xs-12><p class=sub-title ng-bind=purchase.text13></p><p class=sub-description ng-bind=purchase.text14></p><div><div class=\"widget widget-white widget-rectangle widget-list\" ng-repeat=\"coverage in purchase.coverages\"><div class=img-container><img class=img-responsive ng-src=\"{{ coverage.image }}\"></div><div class=widget-content><p class=title ng-bind=coverage.title></p><div class=details><ul><li ng-repeat=\"detail in coverage.details\" ng-bind=detail></li></ul></div></div></div></div><p class=text-center><button class=\"btn btn-1\" ng-click=\"purchase.select(\'Insured_3\')\" ui-sref=purchase-7 ng-bind=purchase.btn1></button></p></div></div></div></div>");
$templateCache.put("app/purchase/purchase-7.html","<div class=\"purchase common-page\"><back-navbar remove-margin=yes content=\"Plan Level\"></back-navbar><div class=container><div class=\"row title2-container purple-siren-bg\"><div class=col-xs-12><p class=title2 translate=purchase_personal_accident></p></div></div></div><div class=purple-border></div><div class=container><div class=row><div class=col-xs-12><p class=title1 translate=purchase_choose_desired_plan></p><p class=text-3 translate=purchase_desired_plan_description></p><div class=\"panel panel-default panel-{{ planType.color }} plan-option\" ng-class=\"{\'panel-selected\': purchase.planType.id === planType.id}\" ng-repeat=\"planType in purchase.planTypes\" ng-click=purchase.select(planType)><div class=panel-heading><p class=title ng-bind=\"planType.heading.title | translate\"></p><p class=description ng-bind=\"planType.heading.description | translate\"></p><div class=price ng-bind=\"planType.heading.price | currency: purchase.DefaultCurrency\"></div></div><table class=table><tr ng-repeat=\"plan in purchase.PlanList[\'Plan\' + ($index + 1)]\"><td>{{plan.Cover}} - {{plan.Descr}}</td><td class=text-right ng-bind=\"plan.ClaimLimit | currency: purchase.DefaultCurrency \"></td></tr><!-- <tr>\n              <td ng-bind=\"purchase.planTypeCategories[0] | translate\"></td>\n              <td class=\"text-right\" ng-bind=\"planType.prices[0] | translate\"></td>\n            </tr>\n            <tr>\n              <td ng-bind=\"purchase.planTypeCategories[1] | translate\"></td>\n              <td class=\"text-right\" ng-bind=\"planType.prices[1] | translate\"></td>\n            </tr>\n            <tr>\n              <td ng-bind=\"purchase.planTypeCategories[2] | translate\" colspan=\"2\"></td>\n            </tr>\n            <tr>\n              <td class=\"padding-left-32\" ng-bind=\"purchase.planTypeCategories[3] | translate\"></td>\n              <td class=\"text-right\" ng-bind=\"planType.prices[2] | translate\"></td>\n            </tr>\n            <tr>\n              <td class=\"padding-left-32\" ng-bind=\"purchase.planTypeCategories[4] | translate\"></td>\n              <td class=\"text-right\" ng-bind=\"planType.prices[3] | translate\"></td>\n            </tr>\n            <tr>\n              <td ng-bind=\"purchase.planTypeCategories[5] | translate\"></td>\n              <td class=\"text-right\" ng-bind=\"planType.prices[4] | translate\"></td>\n            </tr> --></table></div></div><div class=col-xs-12><div class=payment-methods><img src=/assets/images/visa.png> <img src=/assets/images/mastercard.png> <img src=/assets/images/diners-club.png> <img src=/assets/images/jcb.png> <img src=/assets/images/rakuten-card.png></div><p class=\"description text-muted\" translate=purchase_paid_by_credit_card></p><p class=description translate=purchase_automatic_renewal></p><p class=text-center><button ng-disabled=\"!purchase.planType || !purchase.proceed\" class=\"btn btn-1\" ui-sref=purchase-9 ng-bind=purchase.btn1></button></p></div></div></div></div>");
$templateCache.put("app/purchase/purchase-8.html","<div class=\"purchase common-page\"><back-navbar content=\"{{ \'purchase_sign_in\' | translate }}\"></back-navbar><div class=container><div class=row><div class=col-xs-12><p class=title1 translate=purchase_sign_in_coherent></p><input type=email class=form-control placeholder=\"{{ \'purchase_email\' | translate }}\" ng-model=purchase.email> <input type=password class=form-control placeholder=\"{{ \'purchase_password\' | translate }}\" ng-model=purchase.password><p class=text-center><button ng-disabled=\"!purchase.email || !purchase.password\" class=\"btn btn-1\" translate=purchase_sign_in ng-click=purchase.signIn()></button></p><!--         <div class=\"separator text-uppercase\" ng-bind=\"purchase.text2\"></div>\n\n        <p class=\"text-center sign-in-buttons\">\n          <button class=\"btn btn-2\">\n            <img src=\"/assets/images/google.png\" />\n            <span ng-bind=\"purchase.btn2\"></span>\n          </button>\n        </p>\n        <p class=\"text-center sign-in-buttons\">\n          <button class=\"btn btn-3\">\n            <img src=\"/assets/images/fb.png\" />\n            <span ng-bind=\"purchase.btn3\"></span>\n          </button>\n        </p>\n        <p class=\"text-center sign-in-buttons\">\n          <button class=\"btn btn-4\">\n            <img src=\"/assets/images/apple.png\" />\n            <span ng-bind=\"purchase.btn4\"></span>\n          </button>\n        </p> --><p class=\"text-center skip\"><a ui-sref=purchase-9 translate=purchase_skip_this_step></a></p></div></div></div></div>");
$templateCache.put("app/purchase/purchase-9.1.html","<div class=\"purchase common-page\"><back-navbar content=Notice></back-navbar><div class=container><div class=row><div class=col-xs-12><p class=\"title1 pb24 border-bottom mb24\" translate=purchase_important></p><p class=\"font-16 text-700 text-copy-2\" translate=purchase_check_all_that_apply></p><label class=\"d-flex flex-row mb24\"><div class=mr16><input type=checkbox name=\"\" ng-model=purchase.check1></div><div class=flex-fill translate=purchase_confirm_amount></div></label><!--         <div class=\"panel panel-default panel-yellow plan-option\">\n          <div class=\"panel-heading\">\n            <p class=\"title\" ng-bind=\"purchase.panel1.title\"></p>\n          </div>\n          <table class=\"table text-copy-1\">\n            <tr>\n              <td ng-bind=\"purchase.panel1.text1\"></td>\n              <td class=\"text-right\" ng-bind=\"purchase.panel1.price1\"></td>\n            </tr>\n            <tr>\n              <td ng-bind=\"purchase.panel1.text2\"></td>\n              <td class=\"text-right\" ng-bind=\"purchase.panel1.price2\"></td>\n            </tr>\n            <tr>\n              <td ng-bind=\"purchase.panel1.text3\"></td>\n              <td class=\"text-right\" ng-bind=\"purchase.panel1.price3\"></td>\n            </tr>\n            <tr>\n              <td ng-bind=\"purchase.panel1.text4\" colspan=\"2\" style=\"padding-left: 40px!important\"></td>\n            </tr>\n            <tr>\n              <td ng-bind=\"purchase.panel1.text5\" colspan=\"2\" style=\"padding-left: 40px!important\"></td>\n            </tr>\n            <tr>\n              <td ng-bind=\"purchase.panel1.text6\"></td>\n              <td class=\"text-right\" ng-bind=\"purchase.panel1.price6\"></td>\n            </tr>\n          </table>\n        </div>  --><div class=\"panel panel-default panel-yellow plan-option\"><div class=panel-heading><p class=title translate=purchase_insured_15_and_above></p></div><table class=\"table text-copy-1\"><tr><td translate=purchase_daily_hospitalization_insurance></td><td class=text-right translate=purchase_panel2_price1></td></tr><tr><td translate=purchase_following_cases></td><td class=text-right translate=purchase_panel2_price2></td></tr><tr><td translate=purchase_policy_owner_and_insured_differ></td><td class=text-right translate=purchase_panel2_price3></td></tr><tr><td translate=purchase_family_type_contract colspan=2 style=\"padding-left: 40px!important\"></td></tr><tr><td translate=purchase_not_insured_person colspan=2 style=\"padding-left: 40px!important\"></td></tr><tr><td translate=purchase_cases_described_below></td><td class=text-right translate=purchase_panel2_price6></td></tr></table></div><label class=\"d-flex flex-row mb24\"><div class=mr16><input type=checkbox name=\"\" ng-model=purchase.check2></div><div class=flex-fill translate=purchase_lives_in_the_country></div></label><label class=\"d-flex flex-row mb24\"><div class=mr16><input type=checkbox name=\"\" ng-model=purchase.check3></div><div class=flex-fill translate=purchase_first_time></div></label><label class=\"d-flex flex-row mb24\"><div class=mr16><input type=checkbox name=\"\" ng-model=purchase.check4></div><div class=flex-fill translate=purchase_different_persons></div></label><label class=\"d-flex flex-row mb24\"><div class=mr16><input type=checkbox name=\"\" ng-model=purchase.check5></div><div class=flex-fill translate=purchase_occupation></div></label><div class=\"bg-gray-1 border p16 mb24\"><label class=\"d-flex flex-row\"><div class=mr16><input type=checkbox name=\"\" ng-model=purchase.check6></div><div class=flex-fill translate=purchase_confirm></div></label></div><p class=\"text-center information1\"><button class=\"btn btn-3\" ng-disabled=\"!purchase.check1 || !purchase.check2 || !purchase.check3 || !purchase.check4 || !purchase.check5 || !purchase.check6\" ui-sref=purchase-10 translate=travel_purchase_next></button></p></div></div></div></div>");
$templateCache.put("app/purchase/purchase-9.2.html","<div class=\"purchase common-page\"><back-navbar content=重要事項説明書></back-navbar><div class=container><div class=row><div class=col-xs-12><div class=\"d-flex flex-column\"><div class=flex-fill><p class=\"font-16 text-700 text-copy-2 mb16\" ng-bind=purchase.title></p><p class=\"text-center information1\"><a class=\"btn btn-3 mb32\" href=/manual.pdf target=_blank ng-bind=purchase.btn1></a></p><div class=\"bg-gray-1 border p16 mb24\"><label class=\"d-flex flex-row\"><div class=mr16><input type=checkbox name=\"\" ng-model=purchase.check1></div><div class=flex-fill ng-bind=purchase.cb1></div></label></div></div><div><p class=\"text-center information1\"><button class=\"btn btn-3\" ui-sref=purchase-10 ng-disabled=!purchase.check1 ng-bind=purchase.btn2></button></p></div></div></div></div></div></div>");
$templateCache.put("app/purchase/purchase-9.html","<div class=\"purchase common-page\"><back-navbar content=\"Update Your Information\n\"></back-navbar><div class=container><div class=row><div class=col-xs-12><div class=form-group><label for=name translate=purchase_full_name></label><input type=text class=form-control id=name placeholder=\"{{ \'purchase_full_name_placeholder\' | translate }}\" ng-model=purchase.information.name></div><div class=form-group><label for=birth-date translate=purchase_birth_date></label><p class=input-group><input type=text class=form-control id=birth-date uib-datepicker-popup=\"{{ \'purchase_calendar_format\' | translate }}\" ng-model=purchase.information.birthDate is-open=purchase.isOpen datepicker-options=purchase.datepickerOptions placeholder=\"{{ \'purchase_birth_date_placeholder\' | translate }}\" show-button-bar=false> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"purchase.isOpen = !purchase.isOpen\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"form-group dual-options\"><label for=gender translate=purchase_gender></label><div class=text-center><button class=\"btn btn-option\" ng-class=\"{ \'btn-selected\': purchase.information.gender === purchase.btn1 }\" translate=purchase_female ng-click=\"purchase.information.gender = \'F\'\"></button> <button class=\"btn btn-option\" ng-class=\"{ \'btn-selected\': purchase.information.gender === purchase.btn2 }\" translate=purchase_male ng-click=\"purchase.information.gender = \'M\'\"></button></div></div><div class=\"form-group postal-code\"><label for=postal-code translate=purchase_address></label><div class=input-group><input type=text class=form-control placeholder=\"{{ \'purchase_placeholder_5\' | translate }}\" ng-model=purchase.information.country><div class=input-group-addon></div><input type=text class=form-control placeholder=\"{{ \'purchase_placeholder_3\' | translate }}\" id=postal-code ng-model=purchase.information.postalCode1></div></div><div class=\"form-group postal-code\"><!-- <label for=\"address\" translate=\"purchase_address\"></label> --><!-- <textarea class=\"form-control\" id=\"address\" rows=\"4\" placeholder=\"{{ \'purchase_address_placeholder\' | translate }}\" ng-model=\"purchase.information.address\"></textarea> --><div class=input-group><input type=text class=form-control placeholder=\"{{ \'purchase_placeholder_6\' | translate }}\" ng-model=purchase.information.add1><div class=input-group-addon></div><input type=text class=form-control placeholder=\"{{ \'purchase_placeholder_7\' | translate }}\" ng-model=purchase.information.add2></div></div><div class=\"form-group address\"><input type=text class=form-control placeholder=\"{{ \'purchase_placeholder_8\' | translate }}\" id=address ng-model=purchase.information.city></div><div class=form-group><label for=email translate=purchase_primary_email></label><input type=email class=form-control id=email placeholder=\"{{ \'purchase_email_placeholder\' | translate }}\" ng-model=purchase.information.email></div><div class=form-group><label for=alternate-email translate=purchase_alternate_email></label><input type=email class=form-control id=alternate-email placeholder=\"{{ \'purchase_alternate_email_placeholder\' | translate }}\" ng-model=purchase.information.altEmail></div><div class=form-group><label for=contact-number translate=purchase_contact_number></label><input type=text class=form-control id=contact-number placeholder=\"{{ \'purchase_contact_number_placeholder\' | translate }}\" ng-model=purchase.information.contact></div><div class=form-group><label for=alternate-contact-number><span translate=purchase_alternate_contact></span> <span class=\"text-muted small text-optional\" translate=purchase_optional></span></label><input type=text class=form-control id=alternate-contact-number placeholder=\"{{ \'purchase_alternate_contact_placeholder\' | translate }}\" ng-model=purchase.information.altContact></div><div ng-if=\"purchase.UWQuestionsList.length > 0\" class=form-group><label><span>Underwriting Questions</span></label></div><div ng-repeat=\"ques in purchase.UWQuestionsList\"><div class=form-group ng-if=\"ques.UWSurveyQuestion !== \'Pre Existing Disease\' && ques.UWSurveyQuestion !== \'Smoking Profile\' && !ques.UWSurveyCode.includes(\'Term_UW_7_\')\"><label for=bmi-height><span ng-bind=ques.UWSurveyQuestion></span></label><input type=text class=form-control id=bmi-height placeholder=\"{{ ques.UWSurveyQuestion }}\" ng-blur=\"purchase.setUWValues(this.value, $index)\" ng-model=purchase.UWQuestionsList[$index].Flag></div><div class=\"widget subscribe mb-15\" ng-if=\"ques.UWSurveyQuestion === \'Smoking Profile\'\"><p class=text ng-bind=ques.UWSurveyQuestion></p><div class=checkbox ng-class=\"{ selected: ques.Flag }\" ng-click=\"ques.Flag = !ques.Flag\"><div class=form-check><input type=checkbox class=form-check-input ng-model=purchase.UWQuestionsList[$index].Flag> <span class=checkmark></span><label class=form-check-label>Smoking</label></div></div></div><div class=\"widget subscribe mb-15\" ng-if=\"ques.UWSurveyQuestion === \'Pre Existing Disease\'\"><p class=text ng-bind=ques.UWSurveyQuestion></p><div class=checkbox ng-class=\"{ selected: ques.Flag }\" ng-click=\"ques.Flag = !ques.Flag; purchase.checkDisease($index, ques.Flag)\"><div class=form-check><input type=checkbox class=form-check-input ng-model=purchase.UWQuestionsList[$index].Flag> <span class=checkmark></span><label class=form-check-label ng-bind=ques.UWSurveyQuestion></label></div></div></div><div class=\"widget subscribe mb-15\" ng-if=\"ques.UWSurveyCode.includes(\'Term_UW_7_\')\"><p class=text ng-bind=ques.UWSurveyQuestion></p><div class=checkbox ng-class=\"{ selected: ques.Flag }\" ng-click=\"ques.Flag = !ques.Flag; purchase.checkDisease($index, ques.Flag, ques.UWSurveyQuestion)\"><div class=form-check><input type=checkbox class=form-check-input ng-model=purchase.UWQuestionsList[$index].Flag> <span class=checkmark></span><label class=form-check-label ng-bind=ques.UWSurveyQuestion></label></div></div></div></div><div class=\"widget subscribe\"><p class=text translate=purchase_receive_emails></p><div class=checkbox ng-class=\"{ selected: purchase.subscribe }\" ng-click=\"purchase.subscribe = !purchase.subscribe\"><div class=form-check><input type=checkbox class=form-check-input ng-model=purchase.subscribe> <span class=checkmark></span><label class=form-check-label translate=purchase_yes_subscribe></label></div></div></div><p class=\"text-center information1\"><button ng-disabled=\"!purchase.information.name || !purchase.information.birthDate || !purchase.information.gender || !purchase.information.postalCode1 || !purchase.information.country || !purchase.information.add1 || !purchase.information.city || !purchase.information.email || !purchase.information.contact\" class=\"btn btn-1\" ng-click=purchase.proceed() translate=travel_purchase_next></button></p></div></div></div></div>");
$templateCache.put("app/purchase/purchase-embedded.html","<div class=\"purchase common-page\"><div class=container><div class=row><div class=col-xs-12><div class=form-group><label for=name ng-bind=purchase.text1></label><input type=text class=form-control id=name placeholder=\"{{ purchase.placeholder1 }}\" ng-model=purchase.information.name></div><div class=form-group><label for=birth-date ng-bind=purchase.text2></label><p class=input-group><input type=text class=form-control id=birth-date uib-datepicker-popup=\"{{ purchase.calendarFormat }}\" ng-model=purchase.information.birthDate is-open=purchase.isOpen datepicker-options=purchase.datepickerOptions placeholder=\"{{ purchase.placeholder2 }}\" show-button-bar=false> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"purchase.isOpen = !purchase.isOpen\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"form-group dual-options\"><label for=gender ng-bind=purchase.text3></label><div class=text-center><button class=\"btn btn-option\" ng-class=\"{ \'btn-selected\': purchase.information.gender === purchase.btn1 }\" ng-bind=purchase.btn1 ng-click=\"purchase.information.gender = purchase.btn1\"></button> <button class=\"btn btn-option\" ng-class=\"{ \'btn-selected\': purchase.information.gender === purchase.btn2 }\" ng-bind=purchase.btn2 ng-click=\"purchase.information.gender = purchase.btn2\"></button></div></div><div class=\"form-group postal-code\"><label for=postal-code ng-bind=purchase.text4></label><div class=input-group><input type=text class=\"form-control text-center\" placeholder=\"{{ purchase.placeholder3 }}\" id=postal-code ng-model=purchase.information.postalCode1><div class=input-group-addon>—</div><input type=text class=\"form-control text-center\" placeholder=\"{{ purchase.placeholder4 }}\" ng-model=purchase.information.postalCode2></div></div><div class=\"form-group address\"><label for=address ng-bind=purchase.text5></label><textarea class=form-control id=address rows=4 placeholder=\"{{ purchase.placeholder5 }}\" ng-model=purchase.information.address></textarea></div><div class=form-group><label for=email ng-bind=purchase.text6></label><input type=email class=form-control id=email placeholder=\"{{ purchase.placeholder6 }}\" ng-model=purchase.information.email></div><div class=form-group><label for=alternate-email ng-bind=purchase.text7></label><input type=email class=form-control id=alternate-email placeholder=\"{{ purchase.placeholder7 }}\" ng-model=purchase.information.altEmail></div><div class=form-group><label for=contact-number ng-bind=purchase.text8></label><input type=text class=form-control id=contact-number placeholder=\"{{ purchase.placeholder8 }}\" ng-model=purchase.information.contact></div><div class=form-group><label for=alternate-contact-number><span ng-bind=purchase.text9></span> <span class=\"text-muted small text-optional\" ng-bind=purchase.text10></span></label><input type=text class=form-control id=alternate-contact-number placeholder=\"{{ purchase.placeholder9 }}\" ng-model=purchase.information.altContact></div><div class=\"widget subscribe\"><p class=text ng-bind=purchase.text11></p><div class=checkbox ng-class=\"{ selected: purchase.subscribe }\" ng-click=\"purchase.subscribe = !purchase.subscribe\"><div class=form-check><input type=checkbox class=form-check-input ng-model=purchase.subscribe> <span class=checkmark></span><label class=form-check-label ng-bind=purchase.checkBox1></label></div></div></div><p class=\"text-center information1\"><button></button></p></div></div></div></div>");
$templateCache.put("app/purchase/purchase-getstarted.html","<div class=\"purchase front-page\"><div class=container><div class=row><div class=col-xs-12><div class=logo><img class=img-responsive src=/assets/images/coherent-logo.svg></div></div></div></div><img class=\"img-responsive center-block\" src=/assets/images/purchase-bg-3.png><div class=container><div class=row><div class=col-xs-12><div class=\"text-center content\"><p class=text-2 translate=purchase_straight_through_purchase></p><button class=\"btn btn-1\" translate=purchase_get_a_quote ui-sref=products></button></div></div></div></div><div class=container><div class=row><div class=col-xs-12><div class=\"text-center content\"><p class=text-2>OR</p><!-- <input  class=\"textbox form-control col-xs-4\" type=\"text\" name=\"quote_id\" id=\"quote_id\"\n            ng-change=\"purchase.handleQuoteIDChange()\" ng-model=\"purchase.quote_id\" placeholder=\"e.g. PA-I-22-00000339\"> --><div class=input-group style=\"width: 88%\"><div class=form-outline><input type=text name=quote_id id=quote_id class=form-control ng-change=purchase.handleQuoteIDChange() ng-model=purchase.quote_id placeholder=\"Search a Quote, e.g. PA-I-22-00000339\"> <button type=button class=\"btn btn-primary\" style=\"position: absolute; width: 13%; background-color: #9C43FF; border-color: #9C43FF\" ng-click=purchase.SearchQuote()><i class=\"fas fa-search\"></i></button></div></div><button class=\"btn btn-1 text-right\" translate=purchase_search_a_quote ng-click=\"purchase.showPopup = true;\"></button><!-- <div class=\"\">\n            <input  class=\"textbox form-control col-xs-4\" type=\"text\" name=\"quote_id\" id=\"quote_id\"\n            ng-change=\"purchase.handleQuoteIDChange()\" ng-model=\"purchase.quote_id\" \n            style=\"width: 25%; display: inline-block; float: none; height: 38px; margin-right: 10px;\">\n            <button class=\"btn btn-1 text-right\" translate=\"purchase_search_a_quote\" ui-sref=\"purchase-2\"></button>\n          </div> --></div></div></div></div><hr><div id=loader-modal class=policy360-modal ng-if=purchase.showPopup><div class=loader-content><div class=container style=\"background-color: #fff\"><div class=row><div class=col-xs-12><span class=close ng-click=\"purchase.showPopup = false\">&times;</span><div class=subtitle translate=\"\">Search Quotation</div><div class=\"form-group dual-options\"><div class=input-group style=\"display: flex\"><select class=\"form-control input-box col-xs-3\" ng-model=purchase.QuoteSearchBy><option value=\"\">Please Select</option><option value=ID>Quotation ID</option><option value=ONAME>Name</option><option value=EMAIL>Email</option><option value=PHONENO>Phone No.</option></select><input type=text class=\"form-control text-center col-xs-3 ml-10\" placeholder=\"Search Quote\" ng-model=purchase.QuoteSearchVal> <button type=button class=\"btn btn-primary ml-10\" style=\"background-color: #9C43FF; border-color: #9C43FF\" ng-click=purchase.SearchQuoteList()>Search</button></div></div><table class=table style=\"height: 150px\"><thead><th>#</th><th>Quotation ID</th><th>Agent</th><th>Email</th><th>Creation Date</th></thead><tbody><tr ng-repeat=\"quote in purchase.QuoteSearchResult\"><td>{{$index + 1}}</td><td><span style=\"cursor: pointer\" ng-click=purchase.goToQuote(quote.QUOTATIONID)>{{quote.QUOTATIONID}}</span></td><td>{{quote.AGENT}}</td><td>{{quote.EMAIL}}</td><td>{{quote.POLICYCREATIONDATE.split(\"T\")[0]}}</td></tr></tbody></table></div></div></div></div></div><!-- <div class=\"container\">\n    <div class=\"row\">\n      <div class=\"col-xs-12\">\n        <div class=\"text-center content\">\n          <p>\n            <span class=\"text-3\" translate=\"purchase_customer_sign_in\"></span>\n            <br>\n            <span class=\"text-4\" translate=\"purchase_login\"></span>\n          </p>\n          <p>\n            <button class=\"btn btn-inline btn-2\" translate=\"purchase_renew_insurance\"></button>\n            <button class=\"btn btn-inline btn-3\" translate=\"purchase_verify_insurance\"></button>\n          </p>\n          <button class=\"btn btn-4\" translate=\"purchase_make_a_claim\"></button>\n          <button class=\"btn btn-4 display-none\" ng-click=\"purchase.test()\">Send Test Message</button>\n        </div>\n      </div>\n    </div>\n  </div> --></div>");
$templateCache.put("app/reward/reward-1.html","<div class=\"purchase common-page\"><div class=\"bg-dd-blue pt56 pb24\"><center><img src=assets/images/coherent-white-icon.svg height=32></center></div><img src=assets/images/redemption-splash-bg.png class=w-100><div class=container><div class=row><div class=col-xs-12><div class=\"ml8 mr8\"><div class=\"font-32 mt32\">Redeem your PA insurance</div><div class=\"form-group mt16\"><label for=name translate=purchase_full_name></label><input type=text class=form-control id=name placeholder=\"{{ \'purchase_full_name_placeholder\' | translate }}\" ng-model=reward.ui.name></div><div class=form-group><label for=birth-date translate=purchase_birth_date></label><p class=input-group><input type=text class=form-control id=birth-date uib-datepicker-popup=\"{{ reward.opts.calendarFormat }}\" ng-model=reward.ui.birthDate is-open=reward.ui.isOpen datepicker-options=reward.opts.datepickerOptions placeholder=\"{{ \'date_placeholder\' | translate }}\" show-button-bar=false> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"reward.ui.isOpen = !reward.ui.isOpen\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=form-group><label for=address translate=purchase_address></label><input type=address class=form-control id=address placeholder=\"{{ \'purchase_address_placeholder\' | translate }}\" ng-model=reward.ui.address \\></div><div class=form-group><label for=contact-number translate=purchase_contact_number></label><input type=text class=form-control id=contact-number placeholder=\"{{ \'purchase_contact_number_placeholder\' | translate }}\" ng-model=reward.ui.contact></div><div class=form-group><label for=email translate=purchase_primary_email></label><input type=email class=form-control id=email placeholder=\"{{ \'purchase_email_placeholder\' | translate }}\" ng-model=reward.ui.email \\></div><div class=\"widget subscribe\"><div class=checkbox ng-class=\"{ selected: reward.ui.subscribe }\" ng-click=\"reward.ui.subscribe = !reward.ui.subscribe\"><div class=form-check><input type=checkbox class=form-check-input ng-model=reward.ui.subscribe> <span class=checkmark></span><label class=\"form-check-label text-copy-1\">Allow Coherent Insurance to send my policy confirmation and other policy transactions on my messaging app.</label></div></div></div><button ng-click=reward.proceed() class=\"btn btn-md mb24 w-100 btn-dd-blue pl16 pr16\" translate=redeem_proceed></button></div></div></div></div></div>");
$templateCache.put("app/reward/reward-2.html","<div class=\"purchase common-page\"><div class=\"bg-dd-blue pt56 pb24\"><center><img src=assets/images/coherent-white-icon.svg height=32></center></div><div class=container><div class=row><div class=\"col-xs-12 text-center paid\"><img class=img-responsive src=/assets/images/check.png><p class=title translate=purchase_redemption_succesful></p><div class=description><span>Your policy is number is: PA-I-21-000000030</span> <a ui-sref=\"policy-2({policyNumber: purchase.ui.policyNumber})\" ng-bind=purchase.ui.policyNumber></a></div></div><!--       <div class=\"col-xs-12\">\n        <p class=\"text-center\">\n          <button ui-sref=\"policy-2({policyNumber: purchase.ui.policyNumber})\" class=\"btn btn-md mt24 btn-dd-blue pl16 pr16\" translate=\"purchase_back_to_home_screen\"></button>\n        </p>\n      </div> --></div></div></div>");
$templateCache.put("app/reward/reward-landing.html","<img src=assets/images/digibank-bg.png class=w-100 ui-sref=reward-1>");
$templateCache.put("app/travel-purchase/step-1.html","<div class=travel-purchase><back-navbar remove-margin=yes content=\"Trip Details\"></back-navbar><div class=box-behind-pill-wrapper><div class=box-behind-pill></div></div><div class=container><div class=row><div class=col-xs-12><div class=content><div class=banner><span class=icon><img src=/assets/images/products-travel-icon.svg></span><div class=\"text page-title\" translate=travel_purchase_travel></div></div></div></div><div class=col-xs-12><div class=subtitle translate=travel_purchase_tell_us_about_your_trip></div><div class=\"form-group mb24 dual-options\"><label for=count translate=travel_purchase_how_many_trips></label><div class=text-center><button class=\"btn btn-option\" ng-class=\"{ \'btn-selected\': travelPurchase.ui.tripCount === \'Single\' }\" translate=travel_purchase_single ng-click=\"travelPurchase.ui.tripCount = \'Single\'\"></button> <button class=\"btn btn-option\" ng-class=\"{ \'btn-selected\': travelPurchase.ui.tripCount === \'Annual\' }\" translate=travel_purchase_multiple ng-click=\"travelPurchase.ui.tripCount = \'Annual\'\"></button></div></div><div class=\"form-group mb24\"><label for=region translate=travel_purchase_where_are_you_going></label><select class=\"form-control input-box\" ng-class=\"{empty: !travelPurchase.ui.whereAreYouGoing}\" id=travel-region ng-model=travelPurchase.ui.whereAreYouGoing><option value=\"\" translate=travel_purchase_select_a_region ng-selected=!travelPurchase.ui.whereAreYouGoing disabled></option><option value=\"{{ c.value }}\" ng-repeat=\"c in travelPurchase.opts.countries\" ng-bind=c.name></option></select></div><div class=\"form-group mb24\"><label for=departure-date translate=travel_purchase_when_are_you_travelling></label><p class=\"input-group input-box\"><input type=text class=form-control id=departure-date uib-datepicker-popup=\"{{ travelPurchase.opts.calendarFormat }}\" ng-model=travelPurchase.ui.departureDate is-open=travelPurchase.isOpenDepartureDate datepicker-options=travelPurchase.opts.datepickerOptionsForDepartureDate placeholder=\"{{ \'date_placeholder\' | translate }}\" show-button-bar=false ng-change=travelPurchase.updateDatePickerOptions()> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"travelPurchase.isOpenDepartureDate = !travelPurchase.isOpenDepartureDate\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"form-group mb24\" ng-if=\"travelPurchase.ui.tripCount != \'Annual\'\"><label for=arrival-date translate=travel_purchase_when_are_you_coming_back></label><p class=\"input-group input-box\"><input type=text class=form-control id=arrival-date uib-datepicker-popup=\"{{ travelPurchase.opts.calendarFormat }}\" ng-model=travelPurchase.ui.arrivalDate is-open=travelPurchase.isOpenArrivalDate datepicker-options=travelPurchase.opts.datepickerOptionsForArrivalDate placeholder=\"{{ \'date_placeholder\' | translate }}\" show-button-bar=false> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=\"travelPurchase.isOpenArrivalDate = !travelPurchase.isOpenArrivalDate\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"form-group mb24\"><label for=insured translate=travel_purchase_who_will_be_insured></label><div class=checkbox ng-class=\"{ selected: travelPurchase.ui.myself }\" ng-click=\"travelPurchase.ui.myself = !travelPurchase.ui.myself\"><div class=form-check><input type=checkbox class=form-check-input ng-model=travelPurchase.ui.myself> <span class=checkmark></span><label class=form-check-label translate=travel_purchase_myself></label></div></div><div class=checkbox ng-class=\"{ selected: travelPurchase.ui.spouse }\" ng-click=\"travelPurchase.ui.spouse = !travelPurchase.ui.spouse\"><div class=form-check><input type=checkbox class=form-check-input ng-model=travelPurchase.ui.spouse> <span class=checkmark></span><label class=form-check-label translate=travel_purchase_spouse></label></div></div></div><div class=\"form-group mb24\"><label for=additional-adults translate=travel_purchase_additional_adults></label><p class=\"input-group input-box\"><button class=\"btn circle minus\" ng-disabled=\"travelPurchase.ui.additionalAdults == 0\" ng-click=travelPurchase.subtractAdults()>-</button> <input type=number class=\"integer-input-box text-center\" ng-model=travelPurchase.ui.additionalAdults> <button class=\"btn circle\" ng-disabled=\"travelPurchase.ui.additionalAdults + travelPurchase.ui.additionalChildren == travelPurchase.opts.maxDependents\" ng-click=travelPurchase.addAdults()>+</button></p></div><div class=\"form-group mb24\"><label for=additional-children translate=travel_purchase_additional_children></label><p class=\"input-group input-box\"><button class=\"btn circle minus\" ng-disabled=\"travelPurchase.ui.additionalChildren == 0\" ng-click=travelPurchase.subtractChildren()>-</button> <input type=number class=\"integer-input-box text-center\" ng-model=travelPurchase.ui.additionalChildren> <button class=\"btn circle\" ng-disabled=\"travelPurchase.ui.additionalAdults + travelPurchase.ui.additionalChildren == travelPurchase.opts.maxDependents\" ng-click=travelPurchase.addChildren()>+</button></p></div><div class=\"form-group mb24\"><p class=\"text currency-container\" translate=purchase_promo_code></p><select id=PromoCode class=form-control ng-model=travelPurchase.ui.PromoCode><option value=\"\" ng-selected=!travelPurchase.ui.PromoCode>Select Promocode</option><option value=\"{{ promo.Option }}\" ng-if=\"promo.Plan === travelPurchase.ui.tripCount\" ng-repeat=\"promo in travelPurchase.ui.PromoCodes\" ng-selected=\"travelPurchase.ui.PromoCode === promo.Option\">{{promo.Desc}}</option></select></div><div class=\"form-group mb24\"><p class=\"text currency-container\" translate=purchase_select_currency_type></p><select id=Currency class=form-control ng-model=travelPurchase.ui.Currency><option value=\"\" ng-selected=!travelPurchase.ui.Currency>Select Currency</option><option value=\"{{ currency.Option }}\" ng-repeat=\"currency in travelPurchase.ui.CurrencyList\" ng-selected=\"travelPurchase.ui.Currency === currency.Option\">{{currency.Desc}}</option></select></div><p class=text-center><button ng-disabled=\"!travelPurchase.ui.tripCount || !travelPurchase.ui.whereAreYouGoing || !travelPurchase.ui.departureDate || !travelPurchase.ui.arrivalDate || !(travelPurchase.ui.myself || travelPurchase.ui.spouse)\" class=\"btn btn-3 btn-3-filled\" ng-click=travelPurchase.proceed() translate=travel_purchase_next></button></p></div></div></div></div><!--             <img class=\"img-responsive\" src=\"/assets/images/products-travel-icon.svg\"> -->");
$templateCache.put("app/travel-purchase/step-2.html","<div class=travel-purchase><back-navbar remove-margin=yes content=\"Plan Selection\"></back-navbar><div class=box-behind-pill-wrapper><div class=\"box-behind-pill with-ticket\"></div></div><div class=container><div class=row><div class=col-xs-12><div class=content><div class=ticket><span class=icon><img src=/assets/images/products-travel-icon-purple.svg></span><div class=\"text page-title\"><span translate=travel_purchase_trip_to></span> <span ng-bind=travelPurchase.ui.whereAreYouGoing></span></div><div class=page-details><div class=details><span class=emphasized ng-bind=travelPurchase.ui.departureDate></span> <span translate=travel_purchase_to></span> <span class=emphasized ng-bind=travelPurchase.ui.arrivalDate></span></div><div class=details><span class=emphasized ng-bind=travelPurchase.ui.totalAdults></span><ng-pluralize count=travelPurchase.ui.totalAdults when=\"{\'0\': (\'travel_purchase_adult\' | translate), \'1\': (\'travel_purchase_adult\' | translate), \'other\': (\'travel_purchase_adults\' | translate)}\"></ng-pluralize>, <span class=emphasized ng-bind=travelPurchase.ui.additionalChildren></span><ng-pluralize count=travelPurchase.ui.additionalChildren when=\"{\'0\': (\'travel_purchase_child\' | translate), \'1\': (\'travel_purchase_child\' | translate), \'other\': (\'travel_purchase_children\' | translate)}\"></ng-pluralize></div></div></div></div><div class=subtitle translate=travel_purchase_select_a_plan></div><!-- ng-if=\"travelPurchase.ui.planType.tripCount != \'Annual\' || planType.name === \'Premium\'\" --><!-- ng-click=\"travelPurchase.proceed(planType)\" --><div ng-click=\"travelPurchase.ui.planType = planType.Option\" ng-repeat=\"planType in travelPurchase.ui.planTypes\"><div class=panel-body ng-class=\"{ \'selected\': travelPurchase.ui.planType === planType.Option }\"><p class=title ng-bind=planType.Option></p><p class=price ng-bind=\"planType.price | currency: travelPurchase.ui.Currency\"></p><p class=description ng-bind=\"planType.Desc | translate\"></p></div><div class=panel-footer></div></div></div><p class=\"text-center information1\"><button ng-disabled=\"\" class=\"btn btn-3 btn-3-filled\" ng-click=travelPurchase.proceed() translate=travel_purchase_next></button></p></div></div></div>");
$templateCache.put("app/travel-purchase/step-3.html","<div class=travel-purchase><back-navbar remove-margin=yes content=Benefits></back-navbar><div class=box-behind-pill-wrapper><div class=\"box-behind-pill with-ticket\"></div></div><div class=container><div class=row><div class=col-xs-12><div class=content><div class=ticket><span class=icon><img src=/assets/images/products-travel-icon-purple.svg></span><div class=\"text page-title\"><span translate=travel_purchase_trip_to></span> <span ng-bind=travelPurchase.ui.whereAreYouGoing></span></div><div class=page-details><div class=details><span class=emphasized ng-bind=travelPurchase.ui.departureDate></span> <span translate=travel_purchase_to></span> <span class=emphasized ng-bind=travelPurchase.ui.arrivalDate></span></div><div class=details><span class=emphasized ng-bind=travelPurchase.ui.totalAdults></span><ng-pluralize count=travelPurchase.ui.totalAdults when=\"{\'0\': (\'travel_purchase_adult\' | translate), \'1\': (\'travel_purchase_adult\' | translate), \'other\': (\'travel_purchase_adults\' | translate)}\"></ng-pluralize>, <span class=emphasized ng-bind=travelPurchase.ui.additionalChildren></span><ng-pluralize count=travelPurchase.ui.additionalChildren when=\"{\'0\': (\'travel_purchase_child\' | translate), \'1\': (\'travel_purchase_child\' | translate), \'other\': (\'travel_purchase_children\' | translate)}\"></ng-pluralize></div></div><span class=dashed></span> <span class=\"details stub-upper\" ng-bind=travelPurchase.ui.planType.Desc></span> <span class=\"details stub-lower\" ng-bind=\"travelPurchase.ui.planType.price | currency: travelPurchase.ui.Currency\"></span></div></div><div class=subtitle translate=travel_purchase_select_additional_benefits></div><div class=\"form-group mb16\" ng-repeat=\"option in travelPurchase.ui.options\"><!-- <div class=\"checkbox\" ng-class=\"{ selected: option.enabled }\" ng-if=\"!option.type\"\n            ng-click=\"option.enabled = !option.enabled;travelPurchase.getPrice()\">\n            <div class=\"form-check\">\n              <input type=\"checkbox\" class=\"form-check-input\" ng-model=\"option.enabled\">\n              <span class=\"checkmark\"></span>\n              <label class=\"form-check-label\" ng-bind=\"option.label\"></label>\n            </div>\n          </div> --><div class=checkbox ng-class=\"{ selected: option.enabled }\" ng-if=\"option.type != 0\"><div class=form-check ng-click=\"option.enabled = !option.enabled; travelPurchase.getPrice()\"><input type=checkbox class=form-check-input ng-model=option.enabled> <span class=checkmark></span><label class=form-check-label ng-bind=option.label></label></div><!-- ng-if=\"option.type === \'range\'\" --><!-- option.max --><!-- <div class=\"row row-flex\">\n               <div class=\"col-xs-8 col-flex\"> \n                <range model=\"option.value\" min=\"option.min\" max=\"10000\" disabled=\"!option.enabled\"\n                  change=\"travelPurchase.getPrice()\"></range>\n              </div>\n              <div class=\"col-xs-4 col-flex flex-fill\">\n                <input class=\"form-control input-box\" ng-model=\"option.value\" ng-disabled=\"!option.enabled\"\n                  ng-change=\"travelPurchase.getPrice()\" />\n              </div>\n            </div> --></div></div><p class=text-center><button class=\"btn btn-3 btn-3-filled\" ng-click=travelPurchase.proceed() translate=travel_purchase_next></button></p></div></div></div></div>");
$templateCache.put("app/components/backNavbar/backNavbar.html","<div class=\"container back-navbar\" ng-class=\"{\'with-bottom-margin\': !vm.removeMargin}\"><a href=# ng-click=vm.back()><span class=\"glyphicon {{ vm.icon }}\" ng-class=\"{ \'glyphicon-menu-left\': !vm.icon }\"></span> <img ng-if=!vm.content class=\"img-responsive m0\" src=/assets/images/coherent-logo-white.svg> </a><span class=content ng-if=vm.content ng-bind=vm.content></span></div>");
$templateCache.put("app/components/footer/footer.html","<div class=footer><div class=text-center><button class=\"btn btn-default\" ng-click=\"vm.translate(\'en\')\">English</button> <button class=\"btn btn-default\" ng-click=\"vm.translate(\'jp\')\">Japanese</button></div></div>");
$templateCache.put("app/components/loader/loader.html","<div class=loader ng-show=vm.loading><div class=sk-chase><div class=sk-chase-dot></div><div class=sk-chase-dot></div><div class=sk-chase-dot></div><div class=sk-chase-dot></div><div class=sk-chase-dot></div><div class=sk-chase-dot></div></div></div>");
$templateCache.put("app/components/navbar/navbar.html","<nav class=\"navbar navbar-static-top navbar-inverse\"><div class=container-fluid><div class=navbar-header><button type=button class=\"navbar-toggle collapsed\" data-toggle=collapse data-target=#nav-bar-1 aria-expanded=false><span class=sr-only>Toggle navigation</span> <span class=icon-bar></span> <span class=icon-bar></span> <span class=icon-bar></span></button> <a class=navbar-brand ui-sref=main><!-- <img class=\"img-responsive\" src=\"/assets/images/coherent-logo.svg\" /> --><div class=text-copy-0>Coherent Play</div></a></div><div class=\"collapse navbar-collapse\" id=nav-bar-1><ul class=\"nav navbar-nav\"><!-- <li data-toggle=\"collapse\" data-target=\"#nav-bar-1\" ng-class=\"{active: vm.$state.includes(\'products\')}\"><a ui-sref=\"main\">Home</a></li> --><li data-toggle=collapse data-target=#nav-bar-1 ng-class=\"{active: vm.$state.includes(\'products\')}\"><a ui-sref=purchase-get-started>Products Store</a></li><!-- <li data-toggle=\"collapse\" data-target=\"#nav-bar-1\" ng-class=\"{active: vm.$state.includes(\'purchase\')}\"><a ui-sref=\"purchase-1\">Personal Accident</a></li> --><li data-toggle=collapse data-target=#nav-bar-1 ng-class=\"{active: vm.$state.includes(\'policy\')}\"><a ui-sref=policy-login>Policy Management + Claim</a></li><!-- <li data-toggle=\"collapse\" data-target=\"#nav-bar-1\" ng-class=\"{active: vm.$state.includes(\'policy\')}\"><a ui-sref=\"embedded-dbs-1\">CMS</a></li>\n        <li data-toggle=\"collapse\" data-target=\"#nav-bar-1\" ng-class=\"{active: vm.$state.includes(\'policy\')}\"><a ui-sref=\"micro-1\">Micro Insurance</a></li>\n        <li data-toggle=\"collapse\" data-target=\"#nav-bar-1\" ng-class=\"{active: vm.$state.includes(\'policy\')}\"><a ui-sref=\"reward-landing\">Free Insurance</a></li>\n        <li data-toggle=\"collapse\" data-target=\"#nav-bar-1\" ng-class=\"{active: vm.$state.includes(\'policy\')}\"><a ui-sref=\"embedded-flex-1\">Flex</a></li> --><!-- <li data-toggle=\"collapse\" data-target=\"#nav-bar-1\" ng-class=\"{active: vm.$state.includes(\'claim\')}\"><a ui-sref=\"claim-1\">Claim Submission</a></li> --></ul></div></div></nav>");
$templateCache.put("app/components/range/range.html","<input type=range ng-model=vm.model min=\"{{ vm.min }}\" max=\"{{ vm.max }}\" step=1 ng-disabled=vm.disabled>");}]);